// @ts-nocheck
/// <reference path="../../../../../rcwebmodels/reeferstatus.cs.d.ts" />
/// <reference path="../../../../../rcwebmodels/dryassetsmgmtmodel.cs.d.ts" />
/// <reference path="../../../../../rcwebmodels/drystatus.cs.d.ts" />
/// <reference path="../../../../../RcWebModels/RCUserModel.cs.d.ts" />
import * as React from 'react';
import { RouteComponentProps } from 'react-router-dom';
//import { RouteComponentProps } from 'react-router';
import * as Highcharts from 'highcharts';
//import * as ReactGridLayout from "react-grid-layout"
import { Responsive, WidthProvider } from 'react-grid-layout';
import 'react-grid-layout/css/styles.css';
import 'react-resizable/css/styles.css';
import { ReeferMap } from '../childcomponents/ReeferMap';
import { ReeferHistoryGrid } from '../childcomponents/ReeferHistoryGrid';
import { PTResultGrid } from '../childcomponents/PTResults';
import { ReeferStatusGrid } from '../childcomponents/ReeferStatusGrid';
import { ReeferStatusSSRMGrid } from '../childcomponents/ReeferStatusSSRMGrid';
import { GensetStatusGrid } from '../childcomponents/GensetStatusGrid';
import { ReeferToggleButtonsFilter } from '../childcomponents/ReeferToggleButtonsFilter';
import { PopupWindow } from '../sharedcomponents/PopupWindow';
import UserRights from '../../actions/UserRights';
//import '@progress/kendo-theme-default/dist/all.css';
//import { Grid } from '@progress/kendo-grid-react-wrapper'; 
import { connect } from 'react-redux';
import { ApplicationState } from '../../store';
import * as HomeStore from '../../store/Home';
import * as UserDetailState from '../../store/UserDetails';
import $ from 'jquery';
import Switch from 'react-toggle-switch';
import uniq from 'lodash/uniq';
import forEach from 'lodash/forEach';
import reject from 'lodash/reject';
import find from 'lodash/find';
import indexOf from 'lodash/indexOf';
import map from 'lodash/map';
import isEqual from 'lodash/isEqual';
//import { ReeferHistory } from './widgets/ReeferHistory';
//import { ReeferGrid } from "./widgets/ReeferGrid";
import { NavMenu } from '../NavMenu';
import { AdvanceSearch } from '../childcomponents/AdvanceSearch';
import { GensetHistoryGrid } from '../childcomponents/GensetHistoryGrid';
import { SharedEmailPopUp } from '../sharedcomponents/SharedEmailPopUp';
import { GridPreferenceControl } from '../sharedcomponents/GridPreferenceControl';
import { GridColumnPreferences } from '../sharedcomponents/GridColumnPreferences';
import { SearchPreferenceControl } from '../sharedcomponents/SearchPreferenceControl';
import { AddGeofence } from '../sharedcomponents/AddGeofence';
import { EditGeofence } from '../sharedcomponents/AddGeofence';
import ReeferCallout from '../../actions/ReeferCallout';
import { RCUtils } from './../../RCUtils';
import difference from 'lodash/difference';
import { ReeferTemperatureGraph } from '../childcomponents/ReeferTemperatureGraph';
import { TemperatureGraph } from '../childcomponents/TemperatureGraph';
import { GensetMonitorGraph } from '../childcomponents/GensetMonitorGraph';
// Imports for Dry
import { DryStatusSSRMGrid } from '../childcomponents/DryStatusSSRMGrid';
//import { DryStatusGrid } from '../childcomponents/DryStatusGrid';
import { DryHistoryGrid } from '../childcomponents/DryHistoryGrid';
import { ChassisStatusGrid } from '../childcomponents/ChassisStatusGrid';
import { ChassisHistoryGrid } from '../childcomponents/ChassisHistoryGrid';
// WI-23795
import { ExportToExcelConfirmationWindow } from '../sharedcomponents/ExportToExcelConfirmationWindow';
import { EmailControlExcelPreference } from '../sharedcomponents/EmailControlExcelPreference';

import { SaveSearch } from '../childcomponents/SaveSearch';
import { isNullOrUndefined } from 'util';
import ReactSwitch from 'react-switch';
import GRPO from '../../images/Total GRD/GRPO.png';
import GLON from '../../images/Total GRD/GLON.png';
import GRPOFF from '../../images/Total GRD/GRPOFF.png';
import GLPO from '../../images/Total GRD/GLPO.png';
import DryNotReporting from '../../images/Total GRD/DryNotReporting.png';
import DrytReporting from '../../images/Total GRD/DrytReporting.png';
import animatedloader from '../../images/animated-loader.gif';
import DrySettings from '../../images/DrySettings.png';
import GensetSettings from '../../images/GensetSettings.png';
import ReeferSettings from '../../images/ReeferSettings.png';
import Chassis from '../../images/Chassis.svg';
import NotPoweredInGeofence from '../../images/TotalChassis/NotPoweredInGeofence.svg';
import NotPoweredNotInGeofence from '../../images/TotalChassis/NotPoweredNotInGeofence.svg';
import PoweredInGeofence from '../../images/TotalChassis/PoweredInGeofence.svg';
import PoweredNotInGeofence from '../../images/TotalChassis/PoweredNotInGeofence.svg';
import TotalDryInsideGeofence from '../../images/TotalChassis/TotalDryInsideGeofence.svg';
import TotalDryOutSideGeofence from '../../images/TotalChassis/TotalDryOutSideGeofence.svg';

import { GensetToggleButtonsFilter } from '../childcomponents/GensetToggleButtonsFilter';
import { ChassisStatusToggleButtonsFilter } from '../childcomponents/ChassisStatusToggleButtonsFilter';
import { DryStatusToggleButtonsFilter } from '../childcomponents/DryStatusToggleButtonsFilter';
import * as RCNGConfirmWindow from '../sharedcomponents/ConfirmationWindow';
import Select from 'react-select';
import ReactTooltip from 'react-tooltip';
import { CargoCareProfiles } from './CargoCareProfiles';
import { debug } from 'console';
const deletepng = require('../../images/delete.png');



const ResponsiveReactGridLayout = WidthProvider(Responsive);

var Config: any = require('../../Config.json');
var enableReeferStatusGrid = false;
var isLastSearchAdvanced = false;
var gridHeight: any;
var isSaved: boolean = false;
export interface HomeState {
    loading: boolean;
    contents: any;
    date: Date;
    Reefersummary: server.ReeferStatusSummaryModel;
    ColdTreatmentSummary: server.CTUnitSummaryModel;
    CargoCareProfileAlertssummary: server.USP_GetCargocareProfileAlerts_Result[];
    DefaultCargoCareProfileAlertssummary: server.USP_GetCargocareProfileAlerts_Result[];
    Gensetsummary: server.GensetStatusSummaryModel;
    Drysummary: server.DryStatusSummaryModel;
    Chassissummary: server.ChassisStatusSummaryModel;
    selectedValue: string;
    Filters: server.ReeferSearchFilters;
    breakpoint: any;
    layouts: {};
    Defaultlayouts: {};
    DashBoardItems: Array<DashBoardItem>;
    WGSwitchAll: WGSwitch;
    Oldlayouts: {};
    isFullscreen: boolean;
    FullscreenItem: DashBoardItem;
    EmailFilters: EmailFields;
    isLayoutUpdated: boolean;
    isLayoutLoaded: boolean;
    ExtensionForGridHeader: string;
    ExtensionForGraphHeader: string;
    ExtensionForGensetGridHeader: string;
    ExtensionForDryGridHeader: string;
    ExtensionForChassisGridHeader: string;
    modelTitle: string;
    popUpHtml: any;
    selectedItems: any[];
    lastWidgetName: string;
    emailPopUpHtml: any;
    modelTitleReport: string;
    popUpHtmlReport: any;
    ReportReeferId: string;
    PTReport: string;
    EmailData: any;
    ColumnDefs: any;
    SourceForm: string;
    ParentOrChild: string;
    temperatureGraphHtml: any;
    gensetMonitorGraphHtml: any;
    gridPreferenceHtml: any;
    formName: any;
    searchPreferenceHtml: any;
    addGeofenceHtml: any;
    addGeofenceTitle: string;
    geofenceData: any[];
    graphReeferId: string;
    graphGensetId: string;
    CurrentReeferGridRows: number;
    CurrentDryGridRows: number;
    CustomAttributes: server.CustomAttributes[];
    CustomerDeviceTypeSensor: any[];
    SaveSearchHtml: any;//WI-23795
    ExportToExcelHTML: any;
    FunctionID: any;
    ColumnDefs2: any;
    gridApiParams: any;
    isIncludeRowGroup: boolean;
    assetTypeSensors: any[];
    TWReport: string;
    EnableServerSide: boolean;
    isFenceAssets: boolean;
    PrevReeferFilters: server.ReeferSearchFilters;
    //CurrentUserCustomer: server.CurrentUserCustomer;
    stayOpen: boolean;
    disabled: boolean;
    removeSelected: boolean;
    rtl: boolean;
    AssetStates: any[];
    SelectedAssetStatesCC: string; /* RCNG 14*/
    SelectedAssetStatesMA: string; /* RCNG 13*/
    SelectedAssetStatesPTR: string; /* RCNG 16 */
    SelectedAssetStatesTotalReefers: string; /* RCNG 17 */
    SelectedAssetStatesTotalDrys: string; /* RCNG 863 */
    SelectedAssetStatesTotalGensets: string; /* RCNG 1452 */
    CargoCareProfiles: any[];
    CargoCareProfilesSelected: any[];
    CargoCareProfilesSelectedDefault: any[];
    CargoCareCTProfilesSelected: any[];
    UserPreferenceId: any;
    SearchLoadingIsInProgress: boolean;
    DashboardPreferenceId: any;
    IsReadOnly: any;
    DashboardWidgetsSearch: any[];
    DashboardLayouts: any[];
    LayoutPreference: any[];
    RevisionNum: any;
    WidgetId: any;
    CTStateEnabled: boolean;
}
var self;
var totalWidgetSearch: boolean = false;//WI26412
var loaderState: any = false;
var hasReefers: boolean = false;
var hasGensets: boolean = false;
var hasDrys: boolean = false;
var hasChassis: boolean = false;
var defaultInventory: any;
var CCLabelInformational: any;
var CCLabelMinor: any;
var CCLabelSevere: any;
var ReeferAlarmLabelMinor: any;
var ReeferAlarmLabelSevere: any;
var resizeAdvSearchToggle: boolean = false;
var wgMicroalarms: any
var wgHistogram: any
var wgAllreefers: any
var wgColdTreatment: any
var wgReeferGrid: any
var wgReeferHistory: any
var wgReeferTempGraph: any
var wgPTResult: any
var wgCargoCare: any
var wgGensetHistogram: any
var wgAllGensets: any
var wgGensetGrid: any
var wgGensetHistory: any
var wgDryHistogram: any
var wgAllDrys: any
var wgDryGrid: any
var wgDryHistory: any
var wgChassisHistogram: any
var wgAllChassis: any
var wgChassisGrid: any
var wgChassisHistory: any
var isSOLogedin: boolean = false;
var isSaveLayout: boolean = false;
var filterDefault: server.ReeferSearchFilters = {
    SelectedCountry: null, SelectedAssetTypes: null, SelectedAssetStates: null, SelectedGeofence: null, SelectedGeofenceInside: null, SelectedInterval: null, SelectedOem: null, SelectedReefer: null, SelectedVesselCode: null, StatusFilters: [], CustomAttributeFilters: {}, AllReefers: null,
    SelectedBookingNumber: null, SelectedVesselCD: null, SelectedCall: null, SelectedVoyage: null, SelectedCargoCareProfiles: null,
    SelectedPod: null, SelectedPol: null, SelectedCTProfileIds: []//WI-26881
    
};

type HomeProps =
    HomeStore.HomeState
    & UserDetailState.UserState
    & typeof HomeStore.actionCreators
    & RouteComponentProps<{}>;
// Wire up the React component to the Redux store

const assetStates = [
    { label: "Active", value: 'A' },
    { label: "Disconnected", value: 'D' },
    { label: "Retired", value: 'R' },
];


export class Home extends React.PureComponent<HomeProps, HomeState> {
    refreshInterval: number;
    timer: any;
    gensetTimer: any;
    dryTimer: any;
    chassisTimer: any;
    ptResultsTimer: any;
    CCSummaryTimer: any;//RCNG-60
    MASummaryTimer: any;//RCNG-60
    CTSummaryTimer: any;
    TotalReeferStatusTimer: any;//RCNG-60
    myRequest: any;
    chartHistogram: Highcharts.ChartObject;
    chartmicro: Highcharts.ChartObject;
    chartcargo: Highcharts.ChartObject;
    chartColdtreatment: Highcharts.ChartObject;
    chartGensetHistogram: Highcharts.ChartObject;
    chartDryHistogram: Highcharts.ChartObject;
    chartChassisHistogram: Highcharts.ChartObject;
    lglayout: any;
    allLayouts: any;
    DbItems: any;
    isLayOutLoadingBySetDefault: boolean;

    constructor(props: any) {
        super(props);
        this.refreshInterval = 150000;//300000;
        this.wrapperRef = React.createRef();
        this.handleClickOutside = this.handleClickOutside.bind(this);
        //var sm: server.ReeferStatusSummaryModel = {};
        var filter: server.ReeferSearchFilters = this.props.searchFilters;
        var customer = JSON.parse(sessionStorage.getItem('customerDetails'));
        defaultInventory = JSON.parse(sessionStorage.getItem('customerDetails')).InventoryState;
        CCLabelInformational = customer.preferenceDetails.CCLabelInformational != null ? customer.preferenceDetails.CCLabelInformational != '' ? customer.preferenceDetails.CCLabelInformational : 'Informational' : 'Informational';
        CCLabelMinor = customer.preferenceDetails.CCLabelMinor != null ? customer.preferenceDetails.CCLabelMinor != '' ? customer.preferenceDetails.CCLabelMinor : 'Minor' : 'Minor';
        CCLabelSevere = customer.preferenceDetails.CCLabelSevere != null ? customer.preferenceDetails.CCLabelSevere != '' ? customer.preferenceDetails.CCLabelSevere : 'Severe' : 'Severe';
        ReeferAlarmLabelMinor = customer.preferenceDetails.ReeferAlarmLabelMinor != null ? customer.preferenceDetails.ReeferAlarmLabelMinor != '' ? customer.preferenceDetails.ReeferAlarmLabelMinor : 'Minor' : 'Minor';
        ReeferAlarmLabelSevere = customer.preferenceDetails.ReeferAlarmLabelSevere != null ? customer.preferenceDetails.ReeferAlarmLabelSevere != '' ? customer.preferenceDetails.ReeferAlarmLabelSevere : 'Severe' : 'Severe';
        if (customer != null && customer != undefined) {
            if (customer.GroupsRights != null && customer.GroupsRights != undefined) //RCNG 940 
            {
                if (customer.HasReefer && customer.GroupsRights.includes('Reefers'))
                    hasReefers = true
                if (customer.HasGenset && customer.GroupsRights.includes('Gensets'))
                    hasGensets = true;
                if (customer.HasDry && customer.GroupsRights.includes('Dry'))
                    hasDrys = true;
                if (customer.HasChassis && customer.GroupsRights.includes('Chassis'))
                    hasChassis = true;
                //26495
                if (hasReefers) {
                    clearTimeout(this.ptResultsTimer);
                    //RCNG-60 start
                    clearTimeout(this.CCSummaryTimer);
                    clearTimeout(this.MASummaryTimer);
                    clearTimeout(this.TotalReeferStatusTimer);
                    //RCNG-60 end
                }
            }
            if (customer.CustomerTypeCd == "SO") {
                isSOLogedin = true;
            } else {
                isSOLogedin = false;
            }
        }

        //Loading cache data
        //if (this.props.reeferStatus.length === 0) {
        if (hasReefers) {
            this.props.requestReeferFormatters();
            this.props.requestReeferConfigTypes();
        }
        this.props.requestRefApplicationParams();
        this.props.requestTripWISESupport();
        //}

        this.state = {
            loading: true, contents: "", date: new Date(), Reefersummary: {}, CargoCareProfileAlertssummary: [], Gensetsummary: {}, Drysummary: {}, Chassissummary: {}, selectedValue: "", Filters: filter, breakpoint: {}, Defaultlayouts: {}, layouts: {}, DashBoardItems: new Array<DashBoardItem>(),
            WGSwitchAll: new WGSwitch(), Oldlayouts: {}, isFullscreen: false, FullscreenItem: new DashBoardItem(), EmailFilters: new EmailFields(), isLayoutUpdated: false, isLayoutLoaded: false,
            ExtensionForGridHeader: "", ExtensionForGraphHeader: "", ExtensionForGensetGridHeader: '', ExtensionForDryGridHeader: '', ExtensionForChassisGridHeader: '', modelTitle: '', popUpHtml: '', selectedItems: [], lastWidgetName: '', emailPopUpHtml: '', modelTitleReport: '', popUpHtmlReport: '', ReportReeferId: '', PTReport: '',
            EmailData: '', ColumnDefs: '', SourceForm: '', ParentOrChild: '', temperatureGraphHtml: '', gensetMonitorGraphHtml: '', gridPreferenceHtml: '', formName: '', searchPreferenceHtml: '', addGeofenceHtml: '', addGeofenceTitle: '', geofenceData: [], graphReeferId: '', graphGensetId: '', CurrentReeferGridRows: 0, CurrentDryGridRows: 0, CustomAttributes: []
            , SaveSearchHtml: '', ExportToExcelHTML: '', FunctionID: 0, ColumnDefs2: '', gridApiParams: [], isIncludeRowGroup: false, CustomerDeviceTypeSensor: [], assetTypeSensors: [],
            TWReport: '', EnableServerSide: JSON.parse(sessionStorage.getItem('UserInfo')).IsEnableServerSide, isFenceAssets: false, PrevReeferFilters: filterDefault
            , stayOpen: false, disabled: false, removeSelected: false, rtl: false, AssetStates: assetStates,
            SelectedAssetStatesCC: JSON.parse(sessionStorage.getItem('customerDetails')).InventoryState,///RCNG-70
            SelectedAssetStatesMA: JSON.parse(sessionStorage.getItem('customerDetails')).InventoryState,///RCNG-70
            SelectedAssetStatesPTR: JSON.parse(sessionStorage.getItem('customerDetails')).InventoryState,///RCNG-70
            SelectedAssetStatesTotalReefers: JSON.parse(sessionStorage.getItem('customerDetails')).InventoryState, ///RCNG-70
            SelectedAssetStatesTotalGensets: 'A',
            SelectedAssetStatesTotalDrys: 'A'//JSON.parse(sessionStorage.getItem('customerDetails')).InventoryState ///RCNG-1123
            , CargoCareProfiles: [], DefaultCargoCareProfileAlertssummary: [], CargoCareProfilesSelected: [], CargoCareProfilesSelectedDefault: [], UserPreferenceId: 0
            , SearchLoadingIsInProgress: false, DashboardPreferenceId: 0, DashboardWidgetsSearch: [], LayoutPreference: 'Default', DashboardLayouts: [],
            IsReadOnly: false, RevisionNum: 0, WidgetId: 0, ColdTreatmentSummary: {}, CargoCareCTProfilesSelected: [], CTStateEnabled:true
        };


        if (JSON.parse(sessionStorage.getItem('UserInfo')).IsCustomAttributesEnable) {
            var request = RCUtils.FetchRequest(Config.ApiBaseUrl + '/api/common/GetCustomAttributes');
            fetch(request)
                .then(RCUtils.handleError)
                .then(response => response.json() as Promise<server.CustomAttributes[]>)
                .then(data => {
                    this.setState({ CustomAttributes: data });
                });
        }

        var request = RCUtils.FetchRequest(Config.ApiBaseUrl + '/api/CargoCareProfile/GetCargoCareCustomerProfilesAdvanceSearch');
        fetch(request)
            .then(RCUtils.handleError)
            .then(response => response.json() as Promise<any[]>)
            .then(data => {
                this.setState({ CargoCareProfiles: data });
            });

        var request = RCUtils.FetchRequest(Config.ApiBaseUrl + '/api/common/GetCustomerDeviceTypeSensor');
        fetch(request)
            .then(RCUtils.handleError)
            .then(response => response.json() as Promise<any[]>)
            .then(data => {
                this.setState({ CustomerDeviceTypeSensor: data });
            });

        self = this;

        this.SetLayout = this.SetLayout.bind(this);
        this.setGridHeader = this.setGridHeader.bind(this);
        $('#dashBoardEmailPopUp').hide();
        $('#modal-backdrop-email').hide();
    }

    loadDefaultWGSwitch() {
        this.isLayOutLoadingBySetDefault = true;
        this.state.WGSwitchAll.AdvancedSearch = true;
        this.state.WGSwitchAll.ReeferMaps = true;
        this.state.WGSwitchAll.CargoCare = true;

        if (hasReefers) {
            this.state.WGSwitchAll.ReeferGrid = true;
            this.state.WGSwitchAll.ReeferHistoryGrid = true;
            this.state.WGSwitchAll.ReeferTempGraph = true;
            this.state.WGSwitchAll.PTResultGrid = true;
            this.state.WGSwitchAll.MicroaAlarms = true;
            this.state.WGSwitchAll.Histogram = true;
            this.state.WGSwitchAll.TotalReefers = true;
            this.state.WGSwitchAll.ColdTreatment = true;
        }
        if (hasGensets) {
            this.state.WGSwitchAll.GensetGrid = true;
            this.state.WGSwitchAll.GensetHistoryGrid = true;
            this.state.WGSwitchAll.GensetHistogram = true;
            this.state.WGSwitchAll.TotalGensets = true;
        }
        if (hasDrys) {
            this.state.WGSwitchAll.DryGrid = true;
            this.state.WGSwitchAll.DryHistoryGrid = true;
            this.state.WGSwitchAll.DryHistogram = true;
            this.state.WGSwitchAll.TotalDrys = true;
        }
        if (hasChassis) {
            this.state.WGSwitchAll.ChassisGrid = true;
            this.state.WGSwitchAll.ChassisHistoryGrid = true;
            this.state.WGSwitchAll.ChassisHistogram = true;
            this.state.WGSwitchAll.TotalChassis = true;
        }
        this.isLayOutLoadingBySetDefault = false;
    }

    loadLayoutDefaultValues() {
        //var wgAdvSearch: any = UserRights.checkMenuItemVisibility('225');
        //var wgReeferMap: any = UserRights.checkMenuItemVisibility('226');

        wgMicroalarms = UserRights.checkMenuItemVisibility('245');
        wgHistogram = UserRights.checkMenuItemVisibility('242');
        wgAllreefers = UserRights.checkMenuItemVisibility('239');
        wgColdTreatment = UserRights.checkMenuItemVisibility('271');
        wgReeferGrid = UserRights.checkMenuItemVisibility('240');
        wgReeferHistory = UserRights.checkMenuItemVisibility('241');
        wgReeferTempGraph = UserRights.checkMenuItemVisibility('243');
        wgPTResult = UserRights.checkMenuItemVisibility('244');
        wgCargoCare = UserRights.checkMenuItemVisibility('246');

        wgGensetHistogram = UserRights.checkMenuItemVisibility('238');
        wgAllGensets = UserRights.checkMenuItemVisibility('235');
        wgGensetGrid = UserRights.checkMenuItemVisibility('236');
        wgGensetHistory = UserRights.checkMenuItemVisibility('237');

        wgDryHistogram = UserRights.checkMenuItemVisibility('230');
        wgAllDrys = UserRights.checkMenuItemVisibility('227');
        wgDryGrid = UserRights.checkMenuItemVisibility('228');
        wgDryHistory = UserRights.checkMenuItemVisibility('229');

        wgChassisHistogram = UserRights.checkMenuItemVisibility('234');
        wgAllChassis = UserRights.checkMenuItemVisibility('231');
        wgChassisGrid = UserRights.checkMenuItemVisibility('232');
        wgChassisHistory = UserRights.checkMenuItemVisibility('233');

        var wgHistogramY = 26, wgAllPosY = 0, wgCTPosY = 53, wgStatusPosY = 31, wgHistoryPosY = 46, wgTempGraphPosY = 51;

        var defaulLayout = [
            { "minW": 12, "minH": 7.0, "w": 12, "h": 12.7, "x": 0, "y": 0, "i": "wgAdvSearch", "moved": false, "static": false, "isDraggable": true, "isResizable": true },
            { "minW": 12, "minH": 13.5, "w": 37.5, "h": 14.5, "x": 12, "y": 24, "i": "wgReeferMap", "moved": false, "static": false, "isDraggable": true, "isResizable": true, }
        ];

        //defaulLayout = defaulLayout.filter(x => x.hasRight != 'hidden');

        if (hasReefers && !hasGensets && !hasDrys && !hasChassis) {
            var reeferLayout = [
                { "hasRight": wgMicroalarms[0], "minW": 12, "minH": 10.3, "w": 12, "h": 10.3, "x": 0, "y": wgHistogramY, "i": "wgMicroalarms", "moved": false, "static": false, "isDraggable": true, "isResizable": true },
                { "hasRight": wgHistogram[0], "minW": 12, "minH": 10.8, "w": 12, "h": 10.8, "x": 0, "y": 49, "i": "wgHistogram", "moved": false, "static": false, "isDraggable": true, "isResizable": true },
                { "hasRight": wgAllreefers[0], "minW": 37, "minH": 4.3, "w": 37.5, "h": 4.3, "x": 12, "y": wgAllPosY, "i": "wgAllreefers", "moved": false, "static": false, "isDraggable": true, "isResizable": false },                
                { "hasRight": wgReeferGrid[0], "minW": 28, "minH": 11, "w": 37.5, "h": 14.5, "x": 12, "y": wgStatusPosY, "i": "wgReeferGrid", "moved": false, "static": false, "isDraggable": true, "isResizable": true },
                { "hasRight": wgReeferHistory[0], "minW": 34, "minH": 11, "w": 37.5, "h": 14.5, "x": 12, "y": wgHistoryPosY, "i": "wgReeferHistory", "moved": false, "static": false, "isDraggable": true, "isResizable": true },
                { "hasRight": wgReeferTempGraph[0], "minW": 30, "minH": 16.1, "w": 37.5, "h": 16.1, "x": 12, "y": wgTempGraphPosY, "i": "wgReeferTempGraph", "moved": false, "static": false, "isDraggable": true, "isResizable": false },
                { "hasRight": wgPTResult[0], "minW": 12, "minH": 13.5, "w": 12, "h": 14.5, "x": 0, "y": 55, "i": "wgPTResult", "moved": false, "static": false, "isDraggable": true, "isResizable": true },                
                { "hasRight": wgCargoCare[0], "minW": 12, "minH": isSOLogedin ? 10.3 : 17, "w": 12, "h": isSOLogedin ? 10.3 : 17, "x": 0, "y": 51, "i": "wgCargoCare", "moved": false, "static": false, "isDraggable": true, "isResizable": true },
                { "hasRight": wgColdTreatment[0], "minW": 12, "minH": isSOLogedin ? 10.3 : 13, "w": 12, "h": isSOLogedin ? 10.3 : 13, "x": 0, "y": wgCTPosY, "i": "wgColdTreatment", "moved": false, "static": false, "isDraggable": true, "isResizable": false }
            ];

            reeferLayout = reeferLayout.filter(x => x.hasRight != 'hidden');

            defaulLayout = defaulLayout.concat(reeferLayout);
        }
        else if (!hasReefers && hasGensets && !hasDrys && !hasChassis) {
            var gensetLayout = [
                { "hasRight": wgGensetHistogram[0], "minW": 12, "minH": 10.8, "w": 12, "h": 10.8, "x": 0, "y": wgHistogramY, "i": "wgGensetHistogram", "moved": false, "static": false, "isDraggable": true, "isResizable": true },
                { "hasRight": wgAllGensets[0], "minW": 37, "minH": 4.3, "w": 37.5, "h": 4.3, "x": 12, "y": wgAllPosY, "i": "wgAllGensets", "moved": false, "static": false, "isDraggable": true, "isResizable": false },
                { "hasRight": wgGensetGrid[0], "minW": 21, "minH": 11, "w": 37.5, "h": 14.5, "x": 12, "y": wgStatusPosY, "i": "wgGensetGrid", "moved": false, "static": false, "isDraggable": true, "isResizable": true },
                { "hasRight": wgGensetHistory[0], "minW": 30, "minH": 11, "w": 37.5, "h": 14.5, "x": 12, "y": wgHistoryPosY, "i": "wgGensetHistory", "moved": false, "static": false, "isDraggable": true, "isResizable": true }
            ];

            gensetLayout = gensetLayout.filter(x => x.hasRight != 'hidden');

            defaulLayout = defaulLayout.concat(gensetLayout);
        }
        else if (!hasReefers && !hasGensets && hasDrys && !hasChassis) {
            var dryLayout = [
                { "hasRight": wgDryHistogram[0], "minW": 12, "minH": 9.7, "w": 12, "h": 9.7, "x": 0, "y": wgHistogramY, "i": "wgDryHistogram", "moved": false, "static": false, "isDraggable": true, "isResizable": true },
                { "hasRight": wgAllDrys[0], "minW": 12, "minH": 7.1, "w": 12, "h": 7.1, "x": 0, "y": wgAllPosY, "i": "wgAllDrys", "moved": false, "static": false, "isDraggable": true, "isResizable": false },
                { "hasRight": wgDryGrid[0], "minW": 21, "minH": 11, "w": 37.5, "h": 14.5, "x": 12, "y": wgStatusPosY, "i": "wgDryGrid", "moved": false, "static": false, "isDraggable": true, "isResizable": true },
                { "hasRight": wgDryHistory[0], "minW": 27, "minH": 11, "w": 37.5, "h": 14.5, "x": 12, "y": wgHistoryPosY, "i": "wgDryHistory", "moved": false, "static": false, "isDraggable": true, "isResizable": true }
            ];

            dryLayout = dryLayout.filter(x => x.hasRight != 'hidden');

            defaulLayout = defaulLayout.concat(dryLayout);
        }
        else if (!hasReefers && !hasGensets && !hasDrys && hasChassis) {
            var chassisLayout = [
                { "hasRight": wgChassisHistogram[0], "minW": 12, "minH": 10.8, "w": 12, "h": 10.8, "x": 0, "y": wgHistogramY, "i": "wgChassisHistogram", "moved": false, "static": false, "isDraggable": true, "isResizable": true },
                { "hasRight": wgAllChassis[0], "minW": 37, "minH": 4.3, "w": 37.5, "h": 4.3, "x": 12, "y": wgAllPosY, "i": "wgAllChassis", "moved": false, "static": false, "isDraggable": true, "isResizable": false },
                { "hasRight": wgChassisGrid[0], "minW": 21, "minH": 11, "w": 37.5, "h": 14.5, "x": 12, "y": wgStatusPosY, "i": "wgChassisGrid", "moved": false, "static": false, "isDraggable": true, "isResizable": true },
                { "hasRight": wgChassisHistory[0], "minW": 30, "minH": 11, "w": 37.5, "h": 14.5, "x": 12, "y": wgHistoryPosY, "i": "wgChassisHistory", "moved": false, "static": false, "isDraggable": true, "isResizable": true }
            ];

            chassisLayout = chassisLayout.filter(x => x.hasRight != 'hidden');

            defaulLayout = defaulLayout.concat(chassisLayout);
        }
        else if (hasReefers && hasGensets && hasDrys && !hasChassis) {
            var reeferLayout = [
                { "hasRight": wgMicroalarms[0], "minW": 12, "minH": 10.3, "w": 12, "h": 10.3, "x": 0, "y": wgHistogramY, "i": "wgMicroalarms", "moved": false, "static": false, "isDraggable": true, "isResizable": true },
                { "hasRight": wgHistogram[0], "minW": 12, "minH": 10.8, "w": 12, "h": 10.8, "x": 0, "y": 49, "i": "wgHistogram", "moved": false, "static": false, "isDraggable": true, "isResizable": true },
                { "hasRight": wgAllreefers[0], "minW": 37, "minH": 4.3, "w": 37.5, "h": 4.3, "x": 12, "y": wgAllPosY, "i": "wgAllreefers", "moved": false, "static": false, "isDraggable": true, "isResizable": false },
                { "hasRight": wgReeferGrid[0], "minW": 28, "minH": 11, "w": 37.5, "h": 14.5, "x": 12, "y": wgStatusPosY, "i": "wgReeferGrid", "moved": false, "static": false, "isDraggable": true, "isResizable": true },
                { "hasRight": wgReeferHistory[0], "minW": 34, "minH": 11, "w": 37.5, "h": 14.5, "x": 12, "y": wgHistoryPosY, "i": "wgReeferHistory", "moved": false, "static": false, "isDraggable": true, "isResizable": true },
                { "hasRight": wgReeferTempGraph[0], "minW": 30, "minH": 16.1, "w": 37.5, "h": 16.1, "x": 12, "y": wgTempGraphPosY, "i": "wgReeferTempGraph", "moved": false, "static": false, "isDraggable": true, "isResizable": false },
                { "hasRight": wgPTResult[0], "minW": 12, "minH": 13.5, "w": 12, "h": 14.5, "x": 0, "y": 55, "i": "wgPTResult", "moved": false, "static": false, "isDraggable": true, "isResizable": true },
                { "hasRight": wgCargoCare[0], "minW": 12, "minH": isSOLogedin ? 10.3 : 17, "w": 12, "h": isSOLogedin ? 10.3 : 17, "x": 0, "y": 51, "i": "wgCargoCare", "moved": false, "static": false, "isDraggable": true, "isResizable": true },
                { "hasRight": wgColdTreatment[0], "minW": 12, "minH": isSOLogedin ? 10.3 : 13, "w": 12, "h": isSOLogedin ? 10.3 : 13, "x": 0, "y": wgCTPosY, "i": "wgColdTreatment", "moved": false, "static": false, "isDraggable": true, "isResizable": false }
            ];

            reeferLayout = reeferLayout.filter(x => x.hasRight != 'hidden');

            defaulLayout = defaulLayout.concat(reeferLayout);

            wgHistogramY = wgMicroalarms[0] == "hidden" ? wgHistogramY : wgHistogramY + 35;
            wgAllPosY = wgAllreefers[0] == "hidden" ? wgAllPosY : wgAllPosY + 8;
            wgStatusPosY = wgReeferGrid[0] == "hidden" ? wgStatusPosY : wgStatusPosY + 31;
            wgHistoryPosY = wgReeferHistory[0] == "hidden" ? wgHistoryPosY : wgHistoryPosY + 32;

            var gensetLayout = [
                { "hasRight": wgGensetHistogram[0], "minW": 12, "minH": 10.8, "w": 12, "h": 10.8, "x": 0, "y": wgHistogramY, "i": "wgGensetHistogram", "moved": false, "static": false, "isDraggable": true, "isResizable": true },
                { "hasRight": wgAllGensets[0], "minW": 37, "minH": 4.3, "w": 37.5, "h": 4.3, "x": 12, "y": wgAllPosY, "i": "wgAllGensets", "moved": false, "static": false, "isDraggable": true, "isResizable": false },
                { "hasRight": wgGensetGrid[0], "minW": 21, "minH": 11, "w": 37.5, "h": 14.5, "x": 12, "y": wgStatusPosY, "i": "wgGensetGrid", "moved": false, "static": false, "isDraggable": true, "isResizable": true },
                { "hasRight": wgGensetHistory[0], "minW": 30, "minH": 11, "w": 37.5, "h": 14.5, "x": 12, "y": wgHistoryPosY, "i": "wgGensetHistory", "moved": false, "static": false, "isDraggable": true, "isResizable": true }
            ];

            gensetLayout = gensetLayout.filter(x => x.hasRight != 'hidden');

            defaulLayout = defaulLayout.concat(gensetLayout);

            wgStatusPosY = wgGensetGrid[0] == "hidden" ? wgStatusPosY : wgStatusPosY + 48;
            wgHistoryPosY = wgGensetHistory[0] == "hidden" ? wgHistoryPosY : wgHistoryPosY + 48;

            var dryLayout = [
                { "hasRight": wgDryHistogram[0], "minW": 12, "minH": 9.7, "w": 12, "h": 9.7, "x": 0, "y": wgHistogramY, "i": "wgDryHistogram", "moved": false, "static": false, "isDraggable": true, "isResizable": true },
                { "hasRight": wgAllDrys[0], "minW": 12, "minH": 7.1, "w": 12, "h": 7.1, "x": 0, "y": wgAllPosY, "i": "wgAllDrys", "moved": false, "static": false, "isDraggable": true, "isResizable": false },
                { "hasRight": wgDryGrid[0], "minW": 21, "minH": 11, "w": 37.5, "h": 14.5, "x": 12, "y": wgStatusPosY, "i": "wgDryGrid", "moved": false, "static": false, "isDraggable": true, "isResizable": true },
                { "hasRight": wgDryHistory[0], "minW": 27, "minH": 11, "w": 37.5, "h": 14.5, "x": 12, "y": wgHistoryPosY, "i": "wgDryHistory", "moved": false, "static": false, "isDraggable": true, "isResizable": true }
            ];

            dryLayout = dryLayout.filter(x => x.hasRight != 'hidden');

            defaulLayout = defaulLayout.concat(dryLayout);
        }
        else if (hasReefers && hasGensets && !hasDrys && hasChassis) {
            var reeferLayout = [
                { "hasRight": wgMicroalarms[0], "minW": 12, "minH": 10.3, "w": 12, "h": 10.3, "x": 0, "y": wgHistogramY, "i": "wgMicroalarms", "moved": false, "static": false, "isDraggable": true, "isResizable": true },
                { "hasRight": wgHistogram[0], "minW": 12, "minH": 10.8, "w": 12, "h": 10.8, "x": 0, "y": 49, "i": "wgHistogram", "moved": false, "static": false, "isDraggable": true, "isResizable": true },
                { "hasRight": wgAllreefers[0], "minW": 37, "minH": 4.3, "w": 37.5, "h": 4.3, "x": 12, "y": wgAllPosY, "i": "wgAllreefers", "moved": false, "static": false, "isDraggable": true, "isResizable": false },
                { "hasRight": wgReeferGrid[0], "minW": 28, "minH": 11, "w": 37.5, "h": 14.5, "x": 12, "y": wgStatusPosY, "i": "wgReeferGrid", "moved": false, "static": false, "isDraggable": true, "isResizable": true },
                { "hasRight": wgReeferHistory[0], "minW": 34, "minH": 11, "w": 37.5, "h": 14.5, "x": 12, "y": wgHistoryPosY, "i": "wgReeferHistory", "moved": false, "static": false, "isDraggable": true, "isResizable": true },
                { "hasRight": wgReeferTempGraph[0], "minW": 30, "minH": 16.1, "w": 37.5, "h": 16.1, "x": 12, "y": wgTempGraphPosY, "i": "wgReeferTempGraph", "moved": false, "static": false, "isDraggable": true, "isResizable": false },
                { "hasRight": wgPTResult[0], "minW": 12, "minH": 13.5, "w": 12, "h": 14.5, "x": 0, "y": 55, "i": "wgPTResult", "moved": false, "static": false, "isDraggable": true, "isResizable": true },
                { "hasRight": wgCargoCare[0], "minW": 12, "minH": isSOLogedin ? 10.3 : 17, "w": 12, "h": isSOLogedin ? 10.3 : 17, "x": 0, "y": 51, "i": "wgCargoCare", "moved": false, "static": false, "isDraggable": true, "isResizable": true },
                { "hasRight": wgColdTreatment[0], "minW": 12, "minH": isSOLogedin ? 10.3 : 13, "w": 12, "h": isSOLogedin ? 10.3 : 13, "x": 0, "y": wgCTPosY, "i": "wgColdTreatment", "moved": false, "static": false, "isDraggable": true, "isResizable": false }
            ];

            reeferLayout = reeferLayout.filter(x => x.hasRight != 'hidden');

            defaulLayout = defaulLayout.concat(reeferLayout);

            wgHistogramY = wgMicroalarms[0] == "hidden" ? wgHistogramY : wgHistogramY + 35;
            wgAllPosY = wgAllreefers[0] == "hidden" ? wgAllPosY : wgAllPosY + 8;
            wgStatusPosY = wgReeferGrid[0] == "hidden" ? wgStatusPosY : wgStatusPosY + 31;
            wgHistoryPosY = wgReeferHistory[0] == "hidden" ? wgHistoryPosY : wgHistoryPosY + 32;

            var gensetLayout = [
                { "hasRight": wgGensetHistogram[0], "minW": 12, "minH": 10.8, "w": 12, "h": 10.8, "x": 0, "y": wgHistogramY, "i": "wgGensetHistogram", "moved": false, "static": false, "isDraggable": true, "isResizable": true },
                { "hasRight": wgAllGensets[0], "minW": 37, "minH": 4.3, "w": 37.5, "h": 4.3, "x": 12, "y": wgAllPosY, "i": "wgAllGensets", "moved": false, "static": false, "isDraggable": true, "isResizable": false },
                { "hasRight": wgGensetGrid[0], "minW": 21, "minH": 11, "w": 37.5, "h": 14.5, "x": 12, "y": wgStatusPosY, "i": "wgGensetGrid", "moved": false, "static": false, "isDraggable": true, "isResizable": true },
                { "hasRight": wgGensetHistory[0], "minW": 30, "minH": 11, "w": 37.5, "h": 14.5, "x": 12, "y": wgHistoryPosY, "i": "wgGensetHistory", "moved": false, "static": false, "isDraggable": true, "isResizable": true }
            ];

            gensetLayout = gensetLayout.filter(x => x.hasRight != 'hidden');

            defaulLayout = defaulLayout.concat(gensetLayout);

            wgStatusPosY = wgGensetGrid[0] == "hidden" ? wgStatusPosY : wgStatusPosY + 48;
            wgHistoryPosY = wgGensetHistory[0] == "hidden" ? wgHistoryPosY : wgHistoryPosY + 48;

            var chassisLayout = [
                { "hasRight": wgChassisHistogram[0], "minW": 12, "minH": 10.8, "w": 12, "h": 10.8, "x": 0, "y": wgHistogramY, "i": "wgChassisHistogram", "moved": false, "static": false, "isDraggable": true, "isResizable": true },
                { "hasRight": wgAllChassis[0], "minW": 37, "minH": 4.3, "w": 37.5, "h": 4.3, "x": 12, "y": wgAllPosY, "i": "wgAllChassis", "moved": false, "static": false, "isDraggable": true, "isResizable": false },
                { "hasRight": wgChassisGrid[0], "minW": 21, "minH": 11, "w": 37.5, "h": 14.5, "x": 12, "y": wgStatusPosY, "i": "wgChassisGrid", "moved": false, "static": false, "isDraggable": true, "isResizable": true },
                { "hasRight": wgChassisHistory[0], "minW": 30, "minH": 11, "w": 37.5, "h": 14.5, "x": 12, "y": wgHistoryPosY, "i": "wgChassisHistory", "moved": false, "static": false, "isDraggable": true, "isResizable": true }
            ];

            chassisLayout = chassisLayout.filter(x => x.hasRight != 'hidden');

            defaulLayout = defaulLayout.concat(chassisLayout);
        }
        else if (hasReefers && !hasGensets && hasDrys && hasChassis) {
            var reeferLayout = [
                { "hasRight": wgMicroalarms[0], "minW": 12, "minH": 10.3, "w": 12, "h": 10.3, "x": 0, "y": wgHistogramY, "i": "wgMicroalarms", "moved": false, "static": false, "isDraggable": true, "isResizable": true },
                { "hasRight": wgHistogram[0], "minW": 12, "minH": 10.8, "w": 12, "h": 10.8, "x": 0, "y": 49, "i": "wgHistogram", "moved": false, "static": false, "isDraggable": true, "isResizable": true },
                { "hasRight": wgAllreefers[0], "minW": 37, "minH": 4.3, "w": 37.5, "h": 4.3, "x": 12, "y": wgAllPosY, "i": "wgAllreefers", "moved": false, "static": false, "isDraggable": true, "isResizable": false },
                { "hasRight": wgReeferGrid[0], "minW": 28, "minH": 11, "w": 37.5, "h": 14.5, "x": 12, "y": wgStatusPosY, "i": "wgReeferGrid", "moved": false, "static": false, "isDraggable": true, "isResizable": true },
                { "hasRight": wgReeferHistory[0], "minW": 34, "minH": 11, "w": 37.5, "h": 14.5, "x": 12, "y": wgHistoryPosY, "i": "wgReeferHistory", "moved": false, "static": false, "isDraggable": true, "isResizable": true },
                { "hasRight": wgReeferTempGraph[0], "minW": 30, "minH": 16.1, "w": 37.5, "h": 16.1, "x": 12, "y": wgTempGraphPosY, "i": "wgReeferTempGraph", "moved": false, "static": false, "isDraggable": true, "isResizable": false },
                { "hasRight": wgPTResult[0], "minW": 12, "minH": 13.5, "w": 12, "h": 14.5, "x": 0, "y": 55, "i": "wgPTResult", "moved": false, "static": false, "isDraggable": true, "isResizable": true },
                { "hasRight": wgCargoCare[0], "minW": 12, "minH": isSOLogedin ? 10.3 : 17, "w": 12, "h": isSOLogedin ? 10.3 : 17, "x": 0, "y": 51, "i": "wgCargoCare", "moved": false, "static": false, "isDraggable": true, "isResizable": true },
                { "hasRight": wgColdTreatment[0], "minW": 12, "minH": isSOLogedin ? 10.3 : 13, "w": 12, "h": isSOLogedin ? 10.3 : 13, "x": 0, "y": wgCTPosY, "i": "wgColdTreatment", "moved": false, "static": false, "isDraggable": true, "isResizable": false }
            ];

            reeferLayout = reeferLayout.filter(x => x.hasRight != 'hidden');
            defaulLayout = defaulLayout.concat(reeferLayout);

            wgHistogramY = wgMicroalarms[0] == "hidden" ? wgHistogramY : wgHistogramY + 35;
            wgAllPosY = wgAllreefers[0] == "hidden" ? wgAllPosY : wgAllPosY + 8;
            wgStatusPosY = wgReeferGrid[0] == "hidden" ? wgStatusPosY : wgStatusPosY + 31;
            wgHistoryPosY = wgReeferHistory[0] == "hidden" ? wgHistoryPosY : wgHistoryPosY + 32;

            var dryLayout = [
                { "hasRight": wgDryHistogram[0], "minW": 12, "minH": 9.7, "w": 12, "h": 9.7, "x": 0, "y": wgHistogramY, "i": "wgDryHistogram", "moved": false, "static": false, "isDraggable": true, "isResizable": true },
                { "hasRight": wgAllDrys[0], "minW": 12, "minH": 7.1, "w": 12, "h": 7.1, "x": 0, "y": wgAllPosY, "i": "wgAllDrys", "moved": false, "static": false, "isDraggable": true, "isResizable": false },
                { "hasRight": wgDryGrid[0], "minW": 21, "minH": 11, "w": 37.5, "h": 14.5, "x": 12, "y": wgStatusPosY, "i": "wgDryGrid", "moved": false, "static": false, "isDraggable": true, "isResizable": true },
                { "hasRight": wgDryHistory[0], "minW": 27, "minH": 11, "w": 37.5, "h": 14.5, "x": 12, "y": wgHistoryPosY, "i": "wgDryHistory", "moved": false, "static": false, "isDraggable": true, "isResizable": true }
            ];

            dryLayout = dryLayout.filter(x => x.hasRight != 'hidden');

            defaulLayout = defaulLayout.concat(dryLayout);

            wgStatusPosY = wgDryGrid[0] == "hidden" ? wgStatusPosY : wgStatusPosY + 48;
            wgHistoryPosY = wgDryHistory[0] == "hidden" ? wgHistoryPosY : wgHistoryPosY + 48;

            var chassisLayout = [
                { "hasRight": wgChassisHistogram[0], "minW": 12, "minH": 10.8, "w": 12, "h": 10.8, "x": 0, "y": wgHistogramY, "i": "wgChassisHistogram", "moved": false, "static": false, "isDraggable": true, "isResizable": true },
                { "hasRight": wgAllChassis[0], "minW": 37, "minH": 4.3, "w": 37.5, "h": 4.3, "x": 12, "y": wgAllPosY, "i": "wgAllChassis", "moved": false, "static": false, "isDraggable": true, "isResizable": false },
                { "hasRight": wgChassisGrid[0], "minW": 21, "minH": 11, "w": 37.5, "h": 14.5, "x": 12, "y": wgStatusPosY, "i": "wgChassisGrid", "moved": false, "static": false, "isDraggable": true, "isResizable": true },
                { "hasRight": wgChassisHistory[0], "minW": 30, "minH": 11, "w": 37.5, "h": 14.5, "x": 12, "y": wgHistoryPosY, "i": "wgChassisHistory", "moved": false, "static": false, "isDraggable": true, "isResizable": true }
            ];

            chassisLayout = chassisLayout.filter(x => x.hasRight != 'hidden');

            defaulLayout = defaulLayout.concat(chassisLayout);
        }
        else if (!hasReefers && hasGensets && hasDrys && hasChassis) {
            var gensetLayout = [
                { "hasRight": wgGensetHistogram[0], "minW": 12, "minH": 10.8, "w": 12, "h": 10.8, "x": 0, "y": wgHistogramY, "i": "wgGensetHistogram", "moved": false, "static": false, "isDraggable": true, "isResizable": true },
                { "hasRight": wgAllGensets[0], "minW": 37, "minH": 4.3, "w": 37.5, "h": 4.3, "x": 12, "y": wgAllPosY, "i": "wgAllGensets", "moved": false, "static": false, "isDraggable": true, "isResizable": false },
                { "hasRight": wgGensetGrid[0], "minW": 21, "minH": 11, "w": 37.5, "h": 14.5, "x": 12, "y": wgStatusPosY, "i": "wgGensetGrid", "moved": false, "static": false, "isDraggable": true, "isResizable": true },
                { "hasRight": wgGensetHistory[0], "minW": 30, "minH": 11, "w": 37.5, "h": 14.5, "x": 12, "y": wgHistoryPosY, "i": "wgGensetHistory", "moved": false, "static": false, "isDraggable": true, "isResizable": true }
            ];

            gensetLayout = gensetLayout.filter(x => x.hasRight != 'hidden');

            defaulLayout = defaulLayout.concat(gensetLayout);

            wgHistogramY = wgGensetHistogram[0] == "hidden" ? wgHistogramY : wgHistogramY + 35;
            wgAllPosY = wgAllGensets[0] == "hidden" ? wgAllPosY : wgAllPosY + 8;
            wgStatusPosY = wgGensetGrid[0] == "hidden" ? wgStatusPosY : wgStatusPosY + 31;
            wgHistoryPosY = wgGensetHistory[0] == "hidden" ? wgHistoryPosY : wgHistoryPosY + 32;

            var dryLayout = [
                { "hasRight": wgDryHistogram[0], "minW": 12, "minH": 9.7, "w": 12, "h": 9.7, "x": 0, "y": wgHistogramY, "i": "wgDryHistogram", "moved": false, "static": false, "isDraggable": true, "isResizable": true },
                { "hasRight": wgAllDrys[0], "minW": 12, "minH": 7.1, "w": 12, "h": 7.1, "x": 0, "y": wgAllPosY, "i": "wgAllDrys", "moved": false, "static": false, "isDraggable": true, "isResizable": false },
                { "hasRight": wgDryGrid[0], "minW": 21, "minH": 11, "w": 37.5, "h": 14.5, "x": 12, "y": wgStatusPosY, "i": "wgDryGrid", "moved": false, "static": false, "isDraggable": true, "isResizable": true },
                { "hasRight": wgDryHistory[0], "minW": 27, "minH": 11, "w": 37.5, "h": 14.5, "x": 12, "y": wgHistoryPosY, "i": "wgDryHistory", "moved": false, "static": false, "isDraggable": true, "isResizable": true }
            ];

            dryLayout = dryLayout.filter(x => x.hasRight != 'hidden');

            defaulLayout = defaulLayout.concat(dryLayout);

            wgStatusPosY = wgDryGrid[0] == "hidden" ? wgStatusPosY : wgStatusPosY + 48;
            wgHistoryPosY = wgDryHistory[0] == "hidden" ? wgHistoryPosY : wgHistoryPosY + 48;

            var chassisLayout = [
                { "hasRight": wgChassisHistogram[0], "minW": 12, "minH": 10.8, "w": 12, "h": 10.8, "x": 0, "y": wgHistogramY, "i": "wgChassisHistogram", "moved": false, "static": false, "isDraggable": true, "isResizable": true },
                { "hasRight": wgAllChassis[0], "minW": 37, "minH": 4.3, "w": 37.5, "h": 4.3, "x": 12, "y": wgAllPosY, "i": "wgAllChassis", "moved": false, "static": false, "isDraggable": true, "isResizable": false },
                { "hasRight": wgChassisGrid[0], "minW": 21, "minH": 11, "w": 37.5, "h": 14.5, "x": 12, "y": wgStatusPosY, "i": "wgChassisGrid", "moved": false, "static": false, "isDraggable": true, "isResizable": true },
                { "hasRight": wgChassisHistory[0], "minW": 30, "minH": 11, "w": 37.5, "h": 14.5, "x": 12, "y": wgHistoryPosY, "i": "wgChassisHistory", "moved": false, "static": false, "isDraggable": true, "isResizable": true }
            ];

            chassisLayout = chassisLayout.filter(x => x.hasRight != 'hidden');

            defaulLayout = defaulLayout.concat(chassisLayout);
        }
        else if (hasReefers && hasGensets && !hasDrys && !hasChassis) {
            var reeferLayout = [
                { "hasRight": wgMicroalarms[0], "minW": 12, "minH": 10.3, "w": 12, "h": 10.3, "x": 0, "y": wgHistogramY, "i": "wgMicroalarms", "moved": false, "static": false, "isDraggable": true, "isResizable": true },
                { "hasRight": wgHistogram[0], "minW": 12, "minH": 10.8, "w": 12, "h": 10.8, "x": 0, "y": 49, "i": "wgHistogram", "moved": false, "static": false, "isDraggable": true, "isResizable": true },
                { "hasRight": wgAllreefers[0], "minW": 37, "minH": 4.3, "w": 37.5, "h": 4.3, "x": 12, "y": wgAllPosY, "i": "wgAllreefers", "moved": false, "static": false, "isDraggable": true, "isResizable": false },
                { "hasRight": wgReeferGrid[0], "minW": 28, "minH": 11, "w": 37.5, "h": 14.5, "x": 12, "y": wgStatusPosY, "i": "wgReeferGrid", "moved": false, "static": false, "isDraggable": true, "isResizable": true },
                { "hasRight": wgReeferHistory[0], "minW": 34, "minH": 11, "w": 37.5, "h": 14.5, "x": 12, "y": wgHistoryPosY, "i": "wgReeferHistory", "moved": false, "static": false, "isDraggable": true, "isResizable": true },
                { "hasRight": wgReeferTempGraph[0], "minW": 30, "minH": 16.1, "w": 37.5, "h": 16.1, "x": 12, "y": wgTempGraphPosY, "i": "wgReeferTempGraph", "moved": false, "static": false, "isDraggable": true, "isResizable": false },
                { "hasRight": wgPTResult[0], "minW": 12, "minH": 13.5, "w": 12, "h": 14.5, "x": 0, "y": 55, "i": "wgPTResult", "moved": false, "static": false, "isDraggable": true, "isResizable": true },
                { "hasRight": wgCargoCare[0], "minW": 12, "minH": isSOLogedin ? 10.3 : 17, "w": 12, "h": isSOLogedin ? 10.3 : 17, "x": 0, "y": 51, "i": "wgCargoCare", "moved": false, "static": false, "isDraggable": true, "isResizable": true },
                { "hasRight": wgColdTreatment[0], "minW": 12, "minH": isSOLogedin ? 10.3 : 13, "w": 12, "h": isSOLogedin ? 10.3 : 13, "x": 0, "y": wgCTPosY, "i": "wgColdTreatment", "moved": false, "static": false, "isDraggable": true, "isResizable": false }
            ];

            reeferLayout = reeferLayout.filter(x => x.hasRight != 'hidden');

            defaulLayout = defaulLayout.concat(reeferLayout);

            wgHistogramY = wgMicroalarms[0] == "hidden" ? wgHistogramY : wgHistogramY + 35;
            wgAllPosY = wgAllreefers[0] == "hidden" ? wgAllPosY : wgAllPosY + 8;
            wgStatusPosY = wgReeferGrid[0] == "hidden" ? wgStatusPosY : wgStatusPosY + 31;
            wgHistoryPosY = wgReeferHistory[0] == "hidden" ? wgHistoryPosY : wgHistoryPosY + 32;

            var gensetLayout = [
                { "hasRight": wgGensetHistogram[0], "minW": 12, "minH": 10.8, "w": 12, "h": 10.8, "x": 0, "y": wgHistogramY, "i": "wgGensetHistogram", "moved": false, "static": false, "isDraggable": true, "isResizable": true },
                { "hasRight": wgAllGensets[0], "minW": 37, "minH": 4.3, "w": 37.5, "h": 4.3, "x": 12, "y": wgAllPosY, "i": "wgAllGensets", "moved": false, "static": false, "isDraggable": true, "isResizable": false },
                { "hasRight": wgGensetGrid[0], "minW": 21, "minH": 11, "w": 37.5, "h": 14.5, "x": 12, "y": wgStatusPosY, "i": "wgGensetGrid", "moved": false, "static": false, "isDraggable": true, "isResizable": true },
                { "hasRight": wgGensetHistory[0], "minW": 30, "minH": 11, "w": 37.5, "h": 14.5, "x": 12, "y": wgHistoryPosY, "i": "wgGensetHistory", "moved": false, "static": false, "isDraggable": true, "isResizable": true }
            ];

            gensetLayout = gensetLayout.filter(x => x.hasRight != 'hidden');

            defaulLayout = defaulLayout.concat(gensetLayout);
        }
        else if (hasReefers && !hasGensets && hasDrys && !hasChassis) {
            var reeferLayout = [
                { "hasRight": wgMicroalarms[0], "minW": 12, "minH": 10.3, "w": 12, "h": 10.3, "x": 0, "y": wgHistogramY, "i": "wgMicroalarms", "moved": false, "static": false, "isDraggable": true, "isResizable": true },
                { "hasRight": wgHistogram[0], "minW": 12, "minH": 10.8, "w": 12, "h": 10.8, "x": 0, "y": 49, "i": "wgHistogram", "moved": false, "static": false, "isDraggable": true, "isResizable": true },
                { "hasRight": wgAllreefers[0], "minW": 37, "minH": 4.3, "w": 37.5, "h": 4.3, "x": 12, "y": wgAllPosY, "i": "wgAllreefers", "moved": false, "static": false, "isDraggable": true, "isResizable": false },
                { "hasRight": wgReeferGrid[0], "minW": 28, "minH": 11, "w": 37.5, "h": 14.5, "x": 12, "y": wgStatusPosY, "i": "wgReeferGrid", "moved": false, "static": false, "isDraggable": true, "isResizable": true },
                { "hasRight": wgReeferHistory[0], "minW": 34, "minH": 11, "w": 37.5, "h": 14.5, "x": 12, "y": wgHistoryPosY, "i": "wgReeferHistory", "moved": false, "static": false, "isDraggable": true, "isResizable": true },
                { "hasRight": wgReeferTempGraph[0], "minW": 30, "minH": 16.1, "w": 37.5, "h": 16.1, "x": 12, "y": wgTempGraphPosY, "i": "wgReeferTempGraph", "moved": false, "static": false, "isDraggable": true, "isResizable": false },
                { "hasRight": wgPTResult[0], "minW": 12, "minH": 13.5, "w": 12, "h": 14.5, "x": 0, "y": 55, "i": "wgPTResult", "moved": false, "static": false, "isDraggable": true, "isResizable": true },
                { "hasRight": wgCargoCare[0], "minW": 12, "minH": isSOLogedin ? 10.3 : 17, "w": 12, "h": isSOLogedin ? 10.3 : 17, "x": 0, "y": 51, "i": "wgCargoCare", "moved": false, "static": false, "isDraggable": true, "isResizable": true },
                { "hasRight": wgColdTreatment[0], "minW": 12, "minH": isSOLogedin ? 10.3 : 13, "w": 12, "h": isSOLogedin ? 10.3 : 13, "x": 0, "y": wgCTPosY, "i": "wgColdTreatment", "moved": false, "static": false, "isDraggable": true, "isResizable": false }
            ];

            reeferLayout = reeferLayout.filter(x => x.hasRight != 'hidden');

            defaulLayout = defaulLayout.concat(reeferLayout);

            wgHistogramY = wgMicroalarms[0] == "hidden" ? wgHistogramY : wgHistogramY + 35;
            wgAllPosY = wgAllreefers[0] == "hidden" ? wgAllPosY : wgAllPosY + 8;
            wgStatusPosY = wgReeferGrid[0] == "hidden" ? wgStatusPosY : wgStatusPosY + 31;
            wgHistoryPosY = wgReeferHistory[0] == "hidden" ? wgHistoryPosY : wgHistoryPosY + 32;

            var dryLayout = [
                { "hasRight": wgDryHistogram[0], "minW": 12, "minH": 9.7, "w": 12, "h": 9.7, "x": 0, "y": wgHistogramY, "i": "wgDryHistogram", "moved": false, "static": false, "isDraggable": true, "isResizable": true },
                { "hasRight": wgAllDrys[0], "minW": 12, "minH": 7.1, "w": 12, "h": 7.1, "x": 0, "y": wgAllPosY, "i": "wgAllDrys", "moved": false, "static": false, "isDraggable": true, "isResizable": false },
                { "hasRight": wgDryGrid[0], "minW": 21, "minH": 11, "w": 37.5, "h": 14.5, "x": 12, "y": wgStatusPosY, "i": "wgDryGrid", "moved": false, "static": false, "isDraggable": true, "isResizable": true },
                { "hasRight": wgDryHistory[0], "minW": 27, "minH": 11, "w": 37.5, "h": 14.5, "x": 12, "y": wgHistoryPosY, "i": "wgDryHistory", "moved": false, "static": false, "isDraggable": true, "isResizable": true }
            ];

            dryLayout = dryLayout.filter(x => x.hasRight != 'hidden');

            defaulLayout = defaulLayout.concat(dryLayout);
        }
        else if (hasReefers && !hasGensets && !hasDrys && hasChassis) {
            var reeferLayout = [
                { "hasRight": wgMicroalarms[0], "minW": 12, "minH": 10.3, "w": 12, "h": 10.3, "x": 0, "y": wgHistogramY, "i": "wgMicroalarms", "moved": false, "static": false, "isDraggable": true, "isResizable": true },
                { "hasRight": wgHistogram[0], "minW": 12, "minH": 10.8, "w": 12, "h": 10.8, "x": 0, "y": 49, "i": "wgHistogram", "moved": false, "static": false, "isDraggable": true, "isResizable": true },
                { "hasRight": wgAllreefers[0], "minW": 37, "minH": 4.3, "w": 37.5, "h": 4.3, "x": 12, "y": wgAllPosY, "i": "wgAllreefers", "moved": false, "static": false, "isDraggable": true, "isResizable": false },
                { "hasRight": wgReeferGrid[0], "minW": 28, "minH": 11, "w": 37.5, "h": 14.5, "x": 12, "y": wgStatusPosY, "i": "wgReeferGrid", "moved": false, "static": false, "isDraggable": true, "isResizable": true },
                { "hasRight": wgReeferHistory[0], "minW": 34, "minH": 11, "w": 37.5, "h": 14.5, "x": 12, "y": wgHistoryPosY, "i": "wgReeferHistory", "moved": false, "static": false, "isDraggable": true, "isResizable": true },
                { "hasRight": wgReeferTempGraph[0], "minW": 30, "minH": 16.1, "w": 37.5, "h": 16.1, "x": 12, "y": wgTempGraphPosY, "i": "wgReeferTempGraph", "moved": false, "static": false, "isDraggable": true, "isResizable": false },
                { "hasRight": wgPTResult[0], "minW": 12, "minH": 13.5, "w": 12, "h": 14.5, "x": 0, "y": 55, "i": "wgPTResult", "moved": false, "static": false, "isDraggable": true, "isResizable": true },
                { "hasRight": wgCargoCare[0], "minW": 12, "minH": isSOLogedin ? 10.3 : 17, "w": 12, "h": isSOLogedin ? 10.3 : 17, "x": 0, "y": 51, "i": "wgCargoCare", "moved": false, "static": false, "isDraggable": true, "isResizable": true },
                { "hasRight": wgColdTreatment[0], "minW": 12, "minH": isSOLogedin ? 10.3 : 13, "w": 12, "h": isSOLogedin ? 10.3 : 13, "x": 0, "y": wgCTPosY, "i": "wgColdTreatment", "moved": false, "static": false, "isDraggable": true, "isResizable": false }
            ];

            reeferLayout = reeferLayout.filter(x => x.hasRight != 'hidden');

            defaulLayout = defaulLayout.concat(reeferLayout);

            wgHistogramY = wgMicroalarms[0] == "hidden" ? wgHistogramY : wgHistogramY + 35;
            wgAllPosY = wgAllreefers[0] == "hidden" ? wgAllPosY : wgAllPosY + 8;
            wgStatusPosY = wgReeferGrid[0] == "hidden" ? wgStatusPosY : wgStatusPosY + 31;
            wgHistoryPosY = wgReeferHistory[0] == "hidden" ? wgHistoryPosY : wgHistoryPosY + 32;

            var chassisLayout = [
                { "hasRight": wgChassisHistogram[0], "minW": 12, "minH": 10.8, "w": 12, "h": 10.8, "x": 0, "y": wgHistogramY, "i": "wgChassisHistogram", "moved": false, "static": false, "isDraggable": true, "isResizable": true },
                { "hasRight": wgAllChassis[0], "minW": 37, "minH": 4.3, "w": 37.5, "h": 4.3, "x": 12, "y": wgAllPosY, "i": "wgAllChassis", "moved": false, "static": false, "isDraggable": true, "isResizable": false },
                { "hasRight": wgChassisGrid[0], "minW": 21, "minH": 11, "w": 37.5, "h": 14.5, "x": 12, "y": wgStatusPosY, "i": "wgChassisGrid", "moved": false, "static": false, "isDraggable": true, "isResizable": true },
                { "hasRight": wgChassisHistory[0], "minW": 30, "minH": 11, "w": 37.5, "h": 14.5, "x": 12, "y": wgHistoryPosY, "i": "wgChassisHistory", "moved": false, "static": false, "isDraggable": true, "isResizable": true }
            ];

            chassisLayout = chassisLayout.filter(x => x.hasRight != 'hidden');

            defaulLayout = defaulLayout.concat(chassisLayout);
        }
        else if (!hasReefers && hasGensets && !hasDrys && hasChassis) {
            var gensetLayout = [
                { "hasRight": wgGensetHistogram[0], "minW": 12, "minH": 10.8, "w": 12, "h": 10.8, "x": 0, "y": wgHistogramY, "i": "wgGensetHistogram", "moved": false, "static": false, "isDraggable": true, "isResizable": true },
                { "hasRight": wgAllGensets[0], "minW": 37, "minH": 4.3, "w": 37.5, "h": 4.3, "x": 12, "y": wgAllPosY, "i": "wgAllGensets", "moved": false, "static": false, "isDraggable": true, "isResizable": false },
                { "hasRight": wgGensetGrid[0], "minW": 21, "minH": 11, "w": 37.5, "h": 14.5, "x": 12, "y": wgStatusPosY, "i": "wgGensetGrid", "moved": false, "static": false, "isDraggable": true, "isResizable": true },
                { "hasRight": wgGensetHistory[0], "minW": 30, "minH": 11, "w": 37.5, "h": 14.5, "x": 12, "y": wgHistoryPosY, "i": "wgGensetHistory", "moved": false, "static": false, "isDraggable": true, "isResizable": true }
            ];

            gensetLayout = gensetLayout.filter(x => x.hasRight != 'hidden');

            defaulLayout = defaulLayout.concat(gensetLayout);

            wgHistogramY = wgGensetHistogram[0] == "hidden" ? wgHistogramY : wgHistogramY + 35;
            wgAllPosY = wgAllGensets[0] == "hidden" ? wgAllPosY : wgAllPosY + 8;
            wgStatusPosY = wgGensetGrid[0] == "hidden" ? wgStatusPosY : wgStatusPosY + 31;
            wgHistoryPosY = wgGensetHistory[0] == "hidden" ? wgHistoryPosY : wgHistoryPosY + 32;

            var chassisLayout = [
                { "hasRight": wgChassisHistogram[0], "minW": 12, "minH": 10.8, "w": 12, "h": 10.8, "x": 0, "y": wgHistogramY, "i": "wgChassisHistogram", "moved": false, "static": false, "isDraggable": true, "isResizable": true },
                { "hasRight": wgAllChassis[0], "minW": 37, "minH": 4.3, "w": 37.5, "h": 4.3, "x": 12, "y": wgAllPosY, "i": "wgAllChassis", "moved": false, "static": false, "isDraggable": true, "isResizable": false },
                { "hasRight": wgChassisGrid[0], "minW": 21, "minH": 11, "w": 37.5, "h": 14.5, "x": 12, "y": wgStatusPosY, "i": "wgChassisGrid", "moved": false, "static": false, "isDraggable": true, "isResizable": true },
                { "hasRight": wgChassisHistory[0], "minW": 30, "minH": 11, "w": 37.5, "h": 14.5, "x": 12, "y": wgHistoryPosY, "i": "wgChassisHistory", "moved": false, "static": false, "isDraggable": true, "isResizable": true }
            ];

            chassisLayout = chassisLayout.filter(x => x.hasRight != 'hidden');

            defaulLayout = defaulLayout.concat(chassisLayout);
        }
        else if (!hasReefers && !hasGensets && hasDrys && hasChassis) {
            var dryLayout = [
                { "hasRight": wgDryHistogram[0], "minW": 12, "minH": 9.7, "w": 12, "h": 9.7, "x": 0, "y": wgHistogramY, "i": "wgDryHistogram", "moved": false, "static": false, "isDraggable": true, "isResizable": true },
                { "hasRight": wgAllDrys[0], "minW": 12, "minH": 7.1, "w": 12, "h": 7.1, "x": 0, "y": wgAllPosY, "i": "wgAllDrys", "moved": false, "static": false, "isDraggable": true, "isResizable": false },
                { "hasRight": wgDryGrid[0], "minW": 21, "minH": 11, "w": 37.5, "h": 14.5, "x": 12, "y": wgStatusPosY, "i": "wgDryGrid", "moved": false, "static": false, "isDraggable": true, "isResizable": true },
                { "hasRight": wgDryHistory[0], "minW": 27, "minH": 11, "w": 37.5, "h": 14.5, "x": 12, "y": wgHistoryPosY, "i": "wgDryHistory", "moved": false, "static": false, "isDraggable": true, "isResizable": true }
            ];

            dryLayout = dryLayout.filter(x => x.hasRight != 'hidden');

            defaulLayout = defaulLayout.concat(dryLayout);

            wgHistogramY = wgDryHistogram[0] == "hidden" ? wgHistogramY : wgHistogramY + 35;
            wgAllPosY = wgAllDrys[0] == "hidden" ? wgAllPosY : wgAllPosY + 8;
            wgStatusPosY = wgDryGrid[0] == "hidden" ? wgStatusPosY : wgStatusPosY + 31;
            wgHistoryPosY = wgDryHistory[0] == "hidden" ? wgHistoryPosY : wgHistoryPosY + 32;

            var chassisLayout = [
                { "hasRight": wgChassisHistogram[0], "minW": 12, "minH": 10.8, "w": 12, "h": 10.8, "x": 0, "y": wgHistogramY, "i": "wgChassisHistogram", "moved": false, "static": false, "isDraggable": true, "isResizable": true },
                { "hasRight": wgAllChassis[0], "minW": 37, "minH": 4.3, "w": 37.5, "h": 4.3, "x": 12, "y": wgAllPosY, "i": "wgAllChassis", "moved": false, "static": false, "isDraggable": true, "isResizable": false },
                { "hasRight": wgChassisGrid[0], "minW": 21, "minH": 11, "w": 37.5, "h": 14.5, "x": 12, "y": wgStatusPosY, "i": "wgChassisGrid", "moved": false, "static": false, "isDraggable": true, "isResizable": true },
                { "hasRight": wgChassisHistory[0], "minW": 30, "minH": 11, "w": 37.5, "h": 14.5, "x": 12, "y": wgHistoryPosY, "i": "wgChassisHistory", "moved": false, "static": false, "isDraggable": true, "isResizable": true }
            ];

            chassisLayout = chassisLayout.filter(x => x.hasRight != 'hidden');

            defaulLayout = defaulLayout.concat(chassisLayout);
        }
        else if (!hasReefers && hasGensets && hasDrys && !hasChassis) {
            var gensetLayout = [
                { "hasRight": wgGensetHistogram[0], "minW": 12, "minH": 10.8, "w": 12, "h": 10.8, "x": 0, "y": wgHistogramY, "i": "wgGensetHistogram", "moved": false, "static": false, "isDraggable": true, "isResizable": true },
                { "hasRight": wgAllGensets[0], "minW": 37, "minH": 4.3, "w": 37.5, "h": 4.3, "x": 12, "y": wgAllPosY, "i": "wgAllGensets", "moved": false, "static": false, "isDraggable": true, "isResizable": false },
                { "hasRight": wgGensetGrid[0], "minW": 21, "minH": 11, "w": 37.5, "h": 14.5, "x": 12, "y": wgStatusPosY, "i": "wgGensetGrid", "moved": false, "static": false, "isDraggable": true, "isResizable": true },
                { "hasRight": wgGensetHistory[0], "minW": 30, "minH": 11, "w": 37.5, "h": 14.5, "x": 12, "y": wgHistoryPosY, "i": "wgGensetHistory", "moved": false, "static": false, "isDraggable": true, "isResizable": true }
            ];

            gensetLayout = gensetLayout.filter(x => x.hasRight != 'hidden');

            defaulLayout = defaulLayout.concat(gensetLayout);

            wgHistogramY = wgGensetHistogram[0] == "hidden" ? wgHistogramY : wgHistogramY + 35;
            wgAllPosY = wgAllGensets[0] == "hidden" ? wgAllPosY : wgAllPosY + 8;
            wgStatusPosY = wgGensetGrid[0] == "hidden" ? wgStatusPosY : wgStatusPosY + 31;
            wgHistoryPosY = wgGensetHistory[0] == "hidden" ? wgHistoryPosY : wgHistoryPosY + 32;

            var dryLayout = [
                { "hasRight": wgDryHistogram[0], "minW": 12, "minH": 9.7, "w": 12, "h": 9.7, "x": 0, "y": wgHistogramY, "i": "wgDryHistogram", "moved": false, "static": false, "isDraggable": true, "isResizable": true },
                { "hasRight": wgAllDrys[0], "minW": 12, "minH": 7.1, "w": 12, "h": 7.1, "x": 0, "y": wgAllPosY, "i": "wgAllDrys", "moved": false, "static": false, "isDraggable": true, "isResizable": false },
                { "hasRight": wgDryGrid[0], "minW": 21, "minH": 11, "w": 37.5, "h": 14.5, "x": 12, "y": wgStatusPosY, "i": "wgDryGrid", "moved": false, "static": false, "isDraggable": true, "isResizable": true },
                { "hasRight": wgDryHistory[0], "minW": 27, "minH": 11, "w": 37.5, "h": 14.5, "x": 12, "y": wgHistoryPosY, "i": "wgDryHistory", "moved": false, "static": false, "isDraggable": true, "isResizable": true }
            ];

            dryLayout = dryLayout.filter(x => x.hasRight != 'hidden');

            defaulLayout = defaulLayout.concat(dryLayout);
        }
        else if (hasReefers && hasGensets && hasDrys && hasChassis) {
            var reeferLayout = [
                { "hasRight": wgMicroalarms[0], "minW": 12, "minH": 10.3, "w": 12, "h": 10.3, "x": 0, "y": wgHistogramY, "i": "wgMicroalarms", "moved": false, "static": false, "isDraggable": true, "isResizable": true },
                { "hasRight": wgHistogram[0], "minW": 12, "minH": 10.8, "w": 12, "h": 10.8, "x": 0, "y": 49, "i": "wgHistogram", "moved": false, "static": false, "isDraggable": true, "isResizable": true },
                { "hasRight": wgAllreefers[0], "minW": 37, "minH": 4.3, "w": 37.5, "h": 4.3, "x": 12, "y": wgAllPosY, "i": "wgAllreefers", "moved": false, "static": false, "isDraggable": true, "isResizable": false },
                { "hasRight": wgReeferGrid[0], "minW": 28, "minH": 11, "w": 37.5, "h": 14.5, "x": 12, "y": wgStatusPosY, "i": "wgReeferGrid", "moved": false, "static": false, "isDraggable": true, "isResizable": true },
                { "hasRight": wgReeferHistory[0], "minW": 34, "minH": 11, "w": 37.5, "h": 14.5, "x": 12, "y": wgHistoryPosY, "i": "wgReeferHistory", "moved": false, "static": false, "isDraggable": true, "isResizable": true },
                { "hasRight": wgReeferTempGraph[0], "minW": 30, "minH": 16.1, "w": 37.5, "h": 16.1, "x": 12, "y": wgTempGraphPosY, "i": "wgReeferTempGraph", "moved": false, "static": false, "isDraggable": true, "isResizable": false },
                { "hasRight": wgPTResult[0], "minW": 12, "minH": 13.5, "w": 12, "h": 14.5, "x": 0, "y": 55, "i": "wgPTResult", "moved": false, "static": false, "isDraggable": true, "isResizable": true },
                { "hasRight": wgCargoCare[0], "minW": 12, "minH": isSOLogedin ? 10.3 : 17, "w": 12, "h": isSOLogedin ? 10.3 : 17, "x": 0, "y": 51, "i": "wgCargoCare", "moved": false, "static": false, "isDraggable": true, "isResizable": true },
                { "hasRight": wgColdTreatment[0], "minW": 12, "minH": isSOLogedin ? 10.3 : 13, "w": 12, "h": isSOLogedin ? 10.3 : 13, "x": 0, "y": wgCTPosY, "i": "wgColdTreatment", "moved": false, "static": false, "isDraggable": true, "isResizable": false }
            ];

            reeferLayout = reeferLayout.filter(x => x.hasRight != 'hidden');

            defaulLayout = defaulLayout.concat(reeferLayout);

            wgHistogramY = wgMicroalarms[0] == "hidden" ? wgHistogramY : wgHistogramY + 35;
            wgAllPosY = wgAllreefers[0] == "hidden" ? wgAllPosY : wgAllPosY + 8;
            wgStatusPosY = wgReeferGrid[0] == "hidden" ? wgStatusPosY : wgStatusPosY + 31;
            wgHistoryPosY = wgReeferHistory[0] == "hidden" ? wgHistoryPosY : wgHistoryPosY + 32;

            var gensetLayout = [
                { "hasRight": wgGensetHistogram[0], "minW": 12, "minH": 10.8, "w": 12, "h": 10.8, "x": 0, "y": wgHistogramY, "i": "wgGensetHistogram", "moved": false, "static": false, "isDraggable": true, "isResizable": true },
                { "hasRight": wgAllGensets[0], "minW": 37, "minH": 4.3, "w": 37.5, "h": 4.3, "x": 12, "y": wgAllPosY, "i": "wgAllGensets", "moved": false, "static": false, "isDraggable": true, "isResizable": false },
                { "hasRight": wgGensetGrid[0], "minW": 21, "minH": 11, "w": 37.5, "h": 14.5, "x": 12, "y": wgStatusPosY, "i": "wgGensetGrid", "moved": false, "static": false, "isDraggable": true, "isResizable": true },
                { "hasRight": wgGensetHistory[0], "minW": 30, "minH": 11, "w": 37.5, "h": 14.5, "x": 12, "y": wgHistoryPosY, "i": "wgGensetHistory", "moved": false, "static": false, "isDraggable": true, "isResizable": true }
            ];

            gensetLayout = gensetLayout.filter(x => x.hasRight != 'hidden');

            defaulLayout = defaulLayout.concat(gensetLayout);

            wgStatusPosY = wgGensetGrid[0] == "hidden" ? wgStatusPosY : wgStatusPosY + 48;
            wgHistoryPosY = wgGensetHistory[0] == "hidden" ? wgHistoryPosY : wgHistoryPosY + 48;

            var dryLayout = [
                { "hasRight": wgDryHistogram[0], "minW": 12, "minH": 9.7, "w": 12, "h": 9.7, "x": 0, "y": wgHistogramY, "i": "wgDryHistogram", "moved": false, "static": false, "isDraggable": true, "isResizable": true },
                { "hasRight": wgAllDrys[0], "minW": 12, "minH": 7.1, "w": 12, "h": 7.1, "x": 0, "y": wgAllPosY, "i": "wgAllDrys", "moved": false, "static": false, "isDraggable": true, "isResizable": false },
                { "hasRight": wgDryGrid[0], "minW": 21, "minH": 11, "w": 37.5, "h": 14.5, "x": 12, "y": wgStatusPosY, "i": "wgDryGrid", "moved": false, "static": false, "isDraggable": true, "isResizable": true },
                { "hasRight": wgDryHistory[0], "minW": 27, "minH": 11, "w": 37.5, "h": 14.5, "x": 12, "y": wgHistoryPosY, "i": "wgDryHistory", "moved": false, "static": false, "isDraggable": true, "isResizable": true }
            ];

            dryLayout = dryLayout.filter(x => x.hasRight != 'hidden');

            defaulLayout = defaulLayout.concat(dryLayout);

            wgStatusPosY = wgDryGrid[0] == "hidden" ? wgStatusPosY : wgStatusPosY + 56;
            wgHistoryPosY = wgDryHistory[0] == "hidden" ? wgHistoryPosY : wgHistoryPosY + 56;

            var chassisLayout = [
                { "hasRight": wgChassisHistogram[0], "minW": 12, "minH": 10.8, "w": 12, "h": 10.8, "x": 0, "y": wgHistogramY, "i": "wgChassisHistogram", "moved": false, "static": false, "isDraggable": true, "isResizable": true },
                { "hasRight": wgAllChassis[0], "minW": 37, "minH": 4.3, "w": 37.5, "h": 4.3, "x": 12, "y": wgAllPosY, "i": "wgAllChassis", "moved": false, "static": false, "isDraggable": true, "isResizable": false },
                { "hasRight": wgChassisGrid[0], "minW": 21, "minH": 11, "w": 37.5, "h": 14.5, "x": 12, "y": wgStatusPosY, "i": "wgChassisGrid", "moved": false, "static": false, "isDraggable": true, "isResizable": true },
                { "hasRight": wgChassisHistory[0], "minW": 30, "minH": 11, "w": 37.5, "h": 14.5, "x": 12, "y": wgHistoryPosY, "i": "wgChassisHistory", "moved": false, "static": false, "isDraggable": true, "isResizable": true }
            ];

            chassisLayout = chassisLayout.filter(x => x.hasRight != 'hidden');

            defaulLayout = defaulLayout.concat(chassisLayout);

        }

        this.lglayout = defaulLayout;
        this.allLayouts = { lg: this.lglayout };

        var defaultDbItems = [
            { Key: "wgAdvSearch", Layout: this.GetItemLayout("wgAdvSearch", this.allLayouts), Enabled: false, IsVisible: true, IsFullscreen: false, IsPinned: false },
            { Key: "wgReeferMap", Layout: this.GetItemLayout("wgReeferMap", this.allLayouts), Enabled: false, IsVisible: true, IsFullscreen: false }
        ];

        //defaultDbItems = defaultDbItems.filter(x => x.hasRight != 'hidden');

        var reeferDbItems = [
            { hasRight: wgMicroalarms[0], Key: "wgMicroalarms", Layout: this.GetItemLayout("wgMicroalarms", this.allLayouts), Enabled: false, IsVisible: true, IsFullscreen: false },
            { hasRight: wgHistogram[0], Key: "wgHistogram", Layout: this.GetItemLayout("wgHistogram", this.allLayouts), Enabled: false, IsVisible: true, IsFullscreen: false },
            { hasRight: wgAllreefers[0], Key: "wgAllreefers", Layout: this.GetItemLayout("wgAllreefers", this.allLayouts), Enabled: false, IsVisible: true, IsFullscreen: false },
            { hasRight: wgReeferGrid[0], Key: "wgReeferGrid", Layout: this.GetItemLayout("wgReeferGrid", this.allLayouts), Enabled: false, IsVisible: true, IsFullscreen: false },
            { hasRight: wgReeferHistory[0], Key: "wgReeferHistory", Layout: this.GetItemLayout("wgReeferHistory", this.allLayouts), Enabled: false, IsVisible: true, IsFullscreen: false },
            { hasRight: wgReeferTempGraph[0], Key: "wgReeferTempGraph", Layout: this.GetItemLayout("wgReeferTempGraph", this.allLayouts), Enabled: false, IsVisible: true, IsFullscreen: false },
            { hasRight: wgPTResult[0], Key: "wgPTResult", Layout: this.GetItemLayout("wgPTResult", this.allLayouts), Enabled: false, IsVisible: true, IsFullscreen: false },
            { hasRight: wgCargoCare[0], Key: "wgCargoCare", Layout: this.GetItemLayout("wgCargoCare", this.allLayouts), Enabled: false, IsVisible: true, IsFullscreen: false },
            { hasRight: wgColdTreatment[0], Key: "wgColdTreatment", Layout: this.GetItemLayout("wgColdTreatment", this.allLayouts), Enabled: false, IsVisible: true, IsFullscreen: false }
        ];

        var gensetDbItems = [
            { hasRight: wgGensetHistogram[0], Key: "wgGensetHistogram", Layout: this.GetItemLayout("wgGensetHistogram", this.allLayouts), Enabled: false, IsVisible: true, IsFullscreen: false },
            { hasRight: wgAllGensets[0], Key: "wgAllGensets", Layout: this.GetItemLayout("wgAllGensets", this.allLayouts), Enabled: false, IsVisible: true, IsFullscreen: false },
            { hasRight: wgGensetGrid[0], Key: "wgGensetGrid", Layout: this.GetItemLayout("wgGensetGrid", this.allLayouts), Enabled: false, IsVisible: true, IsFullscreen: false },
            { hasRight: wgGensetHistory[0], Key: "wgGensetHistory", Layout: this.GetItemLayout("wgGensetHistory", this.allLayouts), Enabled: false, IsVisible: true, IsFullscreen: false }
        ];

        var dryDbItems = [
            { hasRight: wgAllDrys[0], Key: "wgAllDrys", Layout: this.GetItemLayout("wgAllDrys", this.allLayouts), Enabled: false, IsVisible: true, IsFullscreen: false },
            { hasRight: wgDryGrid[0], Key: "wgDryGrid", Layout: this.GetItemLayout("wgDryGrid", this.allLayouts), Enabled: false, IsVisible: true, IsFullscreen: false },
            { hasRight: wgDryHistory[0], Key: "wgDryHistory", Layout: this.GetItemLayout("wgDryHistory", this.allLayouts), Enabled: false, IsVisible: true, IsFullscreen: false },
            { hasRight: wgDryHistogram[0], Key: "wgDryHistogram", Layout: this.GetItemLayout("wgDryHistogram", this.allLayouts), Enabled: false, IsVisible: true, IsFullscreen: false }
        ];

        var chassisDbItems = [
            { hasRight: wgAllChassis[0], Key: "wgAllChassis", Layout: this.GetItemLayout("wgAllChassis", this.allLayouts), Enabled: false, IsVisible: true, IsFullscreen: false },
            { hasRight: wgChassisGrid[0], Key: "wgChassisGrid", Layout: this.GetItemLayout("wgChassisGrid", this.allLayouts), Enabled: false, IsVisible: true, IsFullscreen: false },
            { hasRight: wgChassisHistory[0], Key: "wgChassisHistory", Layout: this.GetItemLayout("wgChassisHistory", this.allLayouts), Enabled: false, IsVisible: true, IsFullscreen: false },
            { hasRight: wgChassisHistogram[0], Key: "wgChassisHistogram", Layout: this.GetItemLayout("wgChassisHistogram", this.allLayouts), Enabled: false, IsVisible: true, IsFullscreen: false }
        ];

        if (hasReefers) {
            reeferDbItems = reeferDbItems.filter(x => x.hasRight != 'hidden');
            defaultDbItems = defaultDbItems.concat(reeferDbItems);
        }

        if (hasGensets) {
            gensetDbItems = gensetDbItems.filter(x => x.hasRight != 'hidden');
            defaultDbItems = defaultDbItems.concat(gensetDbItems);
        }

        if (hasDrys) {
            dryDbItems = dryDbItems.filter(x => x.hasRight != 'hidden');
            defaultDbItems = defaultDbItems.concat(dryDbItems);
        }

        if (hasChassis) {
            chassisDbItems = chassisDbItems.filter(x => x.hasRight != 'hidden');
            defaultDbItems = defaultDbItems.concat(chassisDbItems);
        }

        this.DbItems = defaultDbItems;
    }

    setGridHeader(reeferId: string) {
        var headerToBeAppended = '';
        var graphHeaderToBeAppended = '';
        if (reeferId != '' && reeferId != undefined) {
            headerToBeAppended = '- Trace of ' + reeferId.slice(0, 4).concat(' ').concat(reeferId.slice(4, 10)).concat(' ').concat(reeferId.slice(10, 11));
            graphHeaderToBeAppended = '- ' + reeferId.slice(0, 4).concat(' ').concat(reeferId.slice(4, 10)).concat(' ').concat(reeferId.slice(10, 11));
        }
        this.setState({ ExtensionForGridHeader: headerToBeAppended, ExtensionForGraphHeader: graphHeaderToBeAppended });
    }

    setGensetGridHeader(assetId: string) {
        var headerToBeAppended = ''
        if (assetId != '' && assetId != undefined) {
            headerToBeAppended = '- Trace of ' + assetId;
        }
        self.setState({ ExtensionForGensetGridHeader: headerToBeAppended });
    }

    setDryGridHeader(assetId: string) {
        var headerToBeAppended = ''
        if (assetId != '' && assetId != undefined) {
            headerToBeAppended = '- Trace of ' + assetId;
        }
        self.setState({ ExtensionForDryGridHeader: headerToBeAppended });
    }

    setChassisGridHeader(assetId: string) {
        var headerToBeAppended = ''
        if (assetId != '' && assetId != undefined) {
            headerToBeAppended = '- Trace of ' + assetId;
        }
        self.setState({ ExtensionForChassisGridHeader: headerToBeAppended });
    }

    clearHistoryGridHeaders() {
        this.setState({ ExtensionForGridHeader: '', ExtensionForGraphHeader: '', ExtensionForGensetGridHeader: '', ExtensionForDryGridHeader: '', ExtensionForChassisGridHeader: '' });
    }

    clearGridHeaderExtension() {
        this.setState({ ExtensionForGridHeader: '', ExtensionForGraphHeader: '' });
    }

    clearGensetGridHeaderExtension() {
        this.setState({ ExtensionForGensetGridHeader: '' });
    }
    clearDryGridHeaderExtension() {
        this.setState({ ExtensionForDryGridHeader: '' });
    }
    clearChassisGridHeaderExtension() {
        this.setState({ ExtensionForChassisGridHeader: '' });
    }

    handleWidgetCheckTotalReefers(e) {
        //$('.widget-applySettingsTotalReefers').addClass('open');
        $('.widgetbgTotalReefers').parent().addClass('widgetbgZindex');
    }

    handleWidgetCheckTotalGensets(e) {
        //$('.widget-applySettingsTotalReefers').addClass('open');
        $('.widgetbgTotalGensets').parent().addClass('widgetbgZindex');
    }

    //WI RCNG-84 start
    onAllReefersClick(e) {
        isSaveLayout = true;
        $('.widgetbgTotalReefers').parent().addClass('widgetbgZindex');
        $('.widgetbgTotalGensets').parent().removeClass('widgetbgZindex');
        $('[id^=drop-down-inv]').css("display", "none");
        $('#drop-down-inv').css("display", "block");
    }
    onAllReefersClickClose(e) {
        $('#drop-down-inv').css("display", "none");
    }

    onTGWidgetClick(e) {
        isSaveLayout = true;
        $('.widgetbgTotalGensets').parent().addClass('widgetbgZindex');
        $('[id^=drop-down-inv]').css("display", "none");
        $('#drop-down-inv-TG').css("display", "block");
    }
    onTGWidgetClickClose(e) {
        $('#drop-down-inv-TG').css("display", "none");
    }

    onFleetOverviewClick(e) {
        isSaveLayout = true;
        $('[id^=drop-down-inv]').css("display", "none");
        $('#drop-down-inv-fleet-overview').css("display", "block");
    }
    onFleetOverviewClickClose(e) {
        $('#drop-down-inv-fleet-overview').css("display", "none");
    }
    onPTIWidgetClick(e) {
        isSaveLayout = true;
        $('[id^=drop-down-inv]').css("display", "none");
        $('#drop-down-inv-pti').css("display", "block");
    }
    onPTIWidgetClickClose(e) {
        $('#drop-down-inv-pti').css("display", "none");
    }
    onMAWidgetClick(e) {
        isSaveLayout = true;
        $('[id^=drop-down-inv]').css("display", "none");
        $('#drop-down-inv-ma').css("display", "block");
    }
    onMAWidgetClickClose(e) {
        $('#drop-down-inv-ma').css("display", "none");
    }
    onCCWidgetClick(e) {
        isSaveLayout = true;
        $('#CCProfileFilter').css("display", "none");
        $('[id^=drop-down-inv]').css("display", "none");
        $('#drop-down-inv-cc').css("display", "block");
    }
    onCCWidgetClickClose(e) {
        $('#drop-down-inv-cc').css("display", "none");
    }

    onCCProfileFilterClickClose(e) {
        $('#CCProfileFilter').css("display", "none");
    }

    onCCProfileFilterClick(e) {
        isSaveLayout = true;
        //console.log("onCCProfileFilterClick: "+isSaveLayout);
        setTimeout(() => {
            self.BindCargoCareProfileFilters();
            $('[id^=drop-down-inv]').css("display", "none");
            $('#drop-down-inv-cc').css("display", "none");
            $('#CCProfileFilter').css("display", "block");
        }, 100);
    }

    onCTProfileFilterClickClose(e) {
        $('#CTProfileFilter').css("display", "none");
    }

    onCTProfileFilterClick(e) {
        isSaveLayout = true;
        //console.log("onCCProfileFilterClick: "+isSaveLayout);
        setTimeout(() => {
            //self.BindCargoCareProfileFilters(); // Todo
            $('[id^=drop-down-inv]').css("display", "none");
            $('#drop-down-inv-cc').css("display", "none");
            $('#CTProfileFilter').css("display", "block");
        }, 100);
    }

    onDFOWidgetClick(e) {
        isSaveLayout = true;
        $('[id^=drop-down-inv]').css("display", "none");
        $('#drop-down-inv-DFO').css("display", "block");
    }
    onDFOWidgetClickClose(e) {
        $('#drop-down-inv-DFO').css("display", "none");
    }

    onGFOWidgetClick(e) {
        isSaveLayout = true;
        $('[id^=drop-down-inv]').css("display", "none");
        $('#drop-down-inv-GFO').css("display", "block");
    }
    onGFOWidgetClickClose(e) {
        $('#drop-down-inv-GFO').css("display", "none");
    }


    onTDWidgetClick(e) {
        isSaveLayout = true;
        $('[id^=drop-down-inv]').css("display", "none");
        $('#drop-down-inv-TD').css("display", "block");

    }
    onTDWidgetClickClose(e) {
        $('#drop-down-inv-TD').css("display", "none");
    }

    //WI RCNG-84 end
    FromEmailchange(event: React.FormEvent<HTMLInputElement>) {
        var filters = this.state.EmailFilters;
        var Value: string = event.currentTarget.value;
        filters.SelectedFrom = Value;
        this.setState({
            EmailFilters: filters
        });
    }

    updateHomepageGridDimensions() {
        $("#homepage-grid-container").css('min-height', $(window).height() - 49);
        $("#homepage-grid-container").css('height', $(window).height() - 49);
        $("#homepage-grid-container").css('max-height', $(window).height() - 49);
    }

    loadUserDashboardLayout(preferenceData: any, dashboardPreferenceId: any, isReadOnly: any, revisionNum: any) {
        if (isNullOrUndefined(preferenceData)) {
            self.setState({ Defaultlayouts: this.allLayouts, DashBoardItems: this.DbItems, layouts: this.allLayouts, DashboardPreferenceId: dashboardPreferenceId }, () => { this.CreateOrUpdateDashboard(); });
            sessionStorage.setItem('DashboardPreferenceId', dashboardPreferenceId);
        }
        else {
            var genericWidgets = ["wgAdvSearch", "wgReeferMap"];
            var gensetWidgets = ["wgAllGensets", "wgGensetHistogram", "wgGensetGrid", "wgGensetHistory"];
            var reeferWidgets = ["wgAllreefers","wgColdTreatment", "wgHistogram", "wgReeferGrid", "wgReeferHistory", "wgReeferTempGraph", "wgMicroalarms", "wgPTResult"];
            var dryWidgets = ["wgAllDrys", "wgDryHistogram", "wgDryGrid", "wgDryHistory"];
            var chassisWidgets = ["wgAllChassis", "wgChassisHistogram", "wgChassisGrid", "wgChassisHistory"];
            var cargoCareWidgets = ["wgCargoCare"];
            var dashBoardItems = [];
            var UserPreference = JSON.parse(preferenceData);
            var breakpoints = ['lg', 'md', 'sm', 'xs', 'xxs'];
            var userLayouts = { 'lg': '', 'md': '', 'sm': '', 'xs': '', 'xxs': '' };
            forEach(UserPreference.layouts, function (value, key) {
                forEach(breakpoints, function (bv, bk) {
                    if (key == bv) {
                        userLayouts[bv] = UserPreference.layouts[bv];
                    }
                });
            });

            forEach(UserPreference.DashBoardItems, function (value, index) {

                var wgKey: any = self.DbItems.filter(x => x.Key == value.Key);
                if (wgKey.length != 0) {
                    if ($.inArray(value.Key, genericWidgets) !== -1)
                        dashBoardItems.push(value);

                    if (hasGensets) {
                        if ($.inArray(value.Key, gensetWidgets) !== -1)
                            dashBoardItems.push(value);
                    }
                    if (hasReefers) {
                        if ($.inArray(value.Key, reeferWidgets) !== -1)
                            dashBoardItems.push(value);
                    }
                    if (hasDrys) {
                        if ($.inArray(value.Key, dryWidgets) !== -1)
                            dashBoardItems.push(value);
                    }
                    if (hasChassis) {
                        if ($.inArray(value.Key, chassisWidgets) !== -1)
                            dashBoardItems.push(value);
                    }
                    if (wgCargoCare[0] != "hidden") {
                        if ($.inArray(value.Key, cargoCareWidgets) !== -1)
                            dashBoardItems.push(value);
                    }
                }
            });


            if (dashBoardItems.length > 0) {
                dashBoardItems = uniq(dashBoardItems);
                var DbItemsList = self.DbItems;
                var DbItemsKeys = DbItemsList.map(({ Key }) => Key);
                var dashBoardItemsKeys = dashBoardItems.map(({ Key }) => Key);

                var diffFound = difference(DbItemsKeys, dashBoardItemsKeys);

                self.setState({
                    Defaultlayouts: (UserPreference.Defaultlayouts == undefined) ? self.allLayouts : self.allLayouts,
                    DashBoardItems: (UserPreference.DashBoardItems == undefined) ? self.DbItems : dashBoardItems,
                    layouts: (UserPreference.layouts == undefined) ? userLayouts : UserPreference.layouts,
                    WGSwitchAll: (UserPreference.WGSwitchAll == undefined) ? self.state.WGSwitchAll : UserPreference.WGSwitchAll,
                    DashboardPreferenceId: dashboardPreferenceId, IsReadOnly: isReadOnly, RevisionNum: revisionNum
                });
                sessionStorage.setItem('DashboardPreferenceId', dashboardPreferenceId);
                if (diffFound.length > 0) {
                    setTimeout(() => {
                        forEach(diffFound, function (item) {
                            switch (item) {
                                case "wgAdvSearch": self.setState({ WGSwitchAll: { ...self.state.WGSwitchAll, AdvancedSearch: false } });
                                    break;
                                case "wgReeferMap": self.setState({ WGSwitchAll: { ...self.state.WGSwitchAll, ReeferMaps: false } });
                                    break;
                                case "wgAllGensets": self.setState({ WGSwitchAll: { ...self.state.WGSwitchAll, TotalGensets: false } });
                                    break;
                                case "wgGensetHistogram": self.setState({ WGSwitchAll: { ...self.state.WGSwitchAll, GensetHistogram: false } });
                                    break;
                                case "wgGensetGrid": self.setState({ WGSwitchAll: { ...self.state.WGSwitchAll, GensetGrid: false } });
                                    break;
                                case "wgGensetHistory": self.setState({ WGSwitchAll: { ...self.state.WGSwitchAll, GensetHistoryGrid: false } });
                                    break;
                                case "wgAllreefers": self.setState({ WGSwitchAll: { ...self.state.WGSwitchAll, TotalReefers: false } });
                                    break;
                                case "wgColdTreatment": self.setState({ WGSwitchAll: { ...self.state.WGSwitchAll, ColdTreatment: false } });
                                    break;
                                case "wgHistogram": self.setState({ WGSwitchAll: { ...self.state.WGSwitchAll, Histogram: false } });
                                    break;
                                case "wgReeferGrid": self.setState({ WGSwitchAll: { ...self.state.WGSwitchAll, ReeferGrid: false } });
                                    break;
                                case "wgReeferHistory": self.setState({ WGSwitchAll: { ...self.state.WGSwitchAll, ReeferHistoryGrid: false } });
                                    break;
                                case "wgReeferTempGraph": self.setState({ WGSwitchAll: { ...self.state.WGSwitchAll, ReeferTempGraph: false } });
                                    break;
                                case "wgMicroalarms": self.setState({ WGSwitchAll: { ...self.state.WGSwitchAll, MicroaAlarms: false } });
                                    break;
                                case "wgPTResult": self.setState({ WGSwitchAll: { ...self.state.WGSwitchAll, PTResultGrid: false } });
                                    break;
                                case "wgAllDrys": self.setState({ WGSwitchAll: { ...self.state.WGSwitchAll, TotalDrys: false } });
                                    break;
                                case "wgDryHistogram": self.setState({ WGSwitchAll: { ...self.state.WGSwitchAll, DryHistogram: false } });
                                    break;
                                case "wgDryGrid": self.setState({ WGSwitchAll: { ...self.state.WGSwitchAll, DryGrid: false } });
                                    break;
                                case "wgDryHistory": self.setState({ WGSwitchAll: { ...self.state.WGSwitchAll, DryHistoryGrid: false } });
                                    break;
                                case "wgAllChassis": self.setState({ WGSwitchAll: { ...self.state.WGSwitchAll, TotalChassis: false } });
                                    break;
                                case "wgChassisHistogram": self.setState({ WGSwitchAll: { ...self.state.WGSwitchAll, ChassisHistogram: false } });
                                    break;
                                case "wgChassisGrid": self.setState({ WGSwitchAll: { ...self.state.WGSwitchAll, ChassisGrid: false } });
                                    break;
                                case "wgChassisHistory": self.setState({ WGSwitchAll: { ...self.state.WGSwitchAll, ChassisHistoryGrid: false } });
                                    break;
                                case "wgCargoCare": self.setState({ WGSwitchAll: { ...self.state.WGSwitchAll, CargoCare: false } });
                                    break;
                            }
                        });
                    }, 500);

                }
            }
            else {

                self.setState({
                    Defaultlayouts: (UserPreference.Defaultlayouts == undefined) ? self.allLayouts : self.allLayouts,
                    DashBoardItems: (UserPreference.DashBoardItems == undefined) ? self.DbItems : UserPreference.DashBoardItems,
                    layouts: (UserPreference.layouts == undefined) ? userLayouts : UserPreference.layouts,
                    WGSwitchAll: (UserPreference.WGSwitchAll == undefined) ? self.state.WGSwitchAll : UserPreference.WGSwitchAll,
                    DashboardPreferenceId: dashboardPreferenceId, IsReadOnly: isReadOnly, RevisionNum: revisionNum
                });
                sessionStorage.setItem('DashboardPreferenceId', dashboardPreferenceId);
            }
        }
        setTimeout(() => {
            self.setState({ isLayoutLoaded: true }, () => { self.restoreWidgetsLoaders(); });
            if (isReadOnly)
                self.pinAllDashboardWidgets(true);
            else
                self.pinAllDashboardWidgets(false);
        }, 2000);// intial waiting time for layouts load

    }

    applyLayoutPreferences(preferenceData: any, dashboardPreferenceId: any, isReadOnly: any, revisionNum: any) {
        if (isNullOrUndefined(preferenceData)) {
            self.setState({ Defaultlayouts: this.allLayouts, DashBoardItems: this.DbItems, layouts: this.allLayouts, DashboardPreferenceId: dashboardPreferenceId });
            sessionStorage.setItem('DashboardPreferenceId', dashboardPreferenceId);
        }
        else {
            var genericWidgets = ["wgAdvSearch", "wgReeferMap"];
            var gensetWidgets = ["wgAllGensets", "wgGensetHistogram", "wgGensetGrid", "wgGensetHistory"];
            var reeferWidgets = ["wgAllreefers","wgColdTreatment", "wgHistogram", "wgReeferGrid", "wgReeferHistory", "wgReeferTempGraph", "wgMicroalarms", "wgPTResult"];
            var dryWidgets = ["wgAllDrys", "wgDryHistogram", "wgDryGrid", "wgDryHistory"];
            var chassisWidgets = ["wgAllChassis", "wgChassisHistogram", "wgChassisGrid", "wgChassisHistory"];
            var cargoCareWidgets = ["wgCargoCare"];
            var dashBoardItems = [];
            var UserPreference = JSON.parse(preferenceData);
            var breakpoints = ['lg', 'md', 'sm', 'xs', 'xxs'];
            var userLayouts = { 'lg': '', 'md': '', 'sm': '', 'xs': '', 'xxs': '' };
            forEach(UserPreference.layouts, function (value, key) {
                forEach(breakpoints, function (bv, bk) {
                    if (key == bv) {
                        userLayouts[bv] = UserPreference.layouts[bv];
                    }
                });
            });

            forEach(UserPreference.DashBoardItems, function (value, index) {

                var wgKey: any = self.DbItems.filter(x => x.Key == value.Key);
                if (wgKey.length != 0) {
                    if ($.inArray(value.Key, genericWidgets) !== -1)
                        dashBoardItems.push(value);

                    if (hasGensets) {
                        if ($.inArray(value.Key, gensetWidgets) !== -1)
                            dashBoardItems.push(value);
                    }
                    if (hasReefers) {
                        if ($.inArray(value.Key, reeferWidgets) !== -1)
                            dashBoardItems.push(value);
                    }
                    if (hasDrys) {
                        if ($.inArray(value.Key, dryWidgets) !== -1)
                            dashBoardItems.push(value);
                    }
                    if (hasChassis) {
                        if ($.inArray(value.Key, chassisWidgets) !== -1)
                            dashBoardItems.push(value);
                    }
                    if (wgCargoCare[0] != "hidden") {
                        if ($.inArray(value.Key, cargoCareWidgets) !== -1)
                            dashBoardItems.push(value);
                    }
                }
            });


            if (dashBoardItems.length > 0) {
                dashBoardItems = uniq(dashBoardItems);
                var DbItemsList = self.DbItems;
                var DbItemsKeys = DbItemsList.map(({ Key }) => Key);
                var dashBoardItemsKeys = dashBoardItems.map(({ Key }) => Key);

                var diffFound = difference(DbItemsKeys, dashBoardItemsKeys);

                self.setState({
                    Defaultlayouts: (UserPreference.Defaultlayouts == undefined) ? self.allLayouts : self.allLayouts,
                    DashBoardItems: (UserPreference.DashBoardItems == undefined) ? self.DbItems : dashBoardItems,
                    layouts: (UserPreference.layouts == undefined) ? userLayouts : UserPreference.layouts,
                    WGSwitchAll: (UserPreference.WGSwitchAll == undefined) ? self.state.WGSwitchAll : UserPreference.WGSwitchAll,
                    DashboardPreferenceId: dashboardPreferenceId, IsReadOnly: isReadOnly, RevisionNum: revisionNum
                });
                sessionStorage.setItem('DashboardPreferenceId', dashboardPreferenceId);

                if (diffFound.length > 0) {
                    setTimeout(() => {
                        forEach(diffFound, function (item) {
                            switch (item) {
                                case "wgAdvSearch": self.setState({ WGSwitchAll: { ...self.state.WGSwitchAll, AdvancedSearch: false } });
                                    break;
                                case "wgReeferMap": self.setState({ WGSwitchAll: { ...self.state.WGSwitchAll, ReeferMaps: false } });
                                    break;
                                case "wgAllGensets": self.setState({ WGSwitchAll: { ...self.state.WGSwitchAll, TotalGensets: false } });
                                    break;
                                case "wgGensetHistogram": self.setState({ WGSwitchAll: { ...self.state.WGSwitchAll, GensetHistogram: false } });
                                    break;
                                case "wgGensetGrid": self.setState({ WGSwitchAll: { ...self.state.WGSwitchAll, GensetGrid: false } });
                                    break;
                                case "wgGensetHistory": self.setState({ WGSwitchAll: { ...self.state.WGSwitchAll, GensetHistoryGrid: false } });
                                    break;
                                case "wgAllreefers": self.setState({ WGSwitchAll: { ...self.state.WGSwitchAll, TotalReefers: false } });
                                    break;
                                case "wgColdTreatment": self.setState({ WGSwitchAll: { ...self.state.WGSwitchAll, ColdTreatment: false } });
                                    break;
                                case "wgHistogram": self.setState({ WGSwitchAll: { ...self.state.WGSwitchAll, Histogram: false } });
                                    break;
                                case "wgReeferGrid": self.setState({ WGSwitchAll: { ...self.state.WGSwitchAll, ReeferGrid: false } });
                                    break;
                                case "wgReeferHistory": self.setState({ WGSwitchAll: { ...self.state.WGSwitchAll, ReeferHistoryGrid: false } });
                                    break;
                                case "wgReeferTempGraph": self.setState({ WGSwitchAll: { ...self.state.WGSwitchAll, ReeferTempGraph: false } });
                                    break;
                                case "wgMicroalarms": self.setState({ WGSwitchAll: { ...self.state.WGSwitchAll, MicroaAlarms: false } });
                                    break;
                                case "wgPTResult": self.setState({ WGSwitchAll: { ...self.state.WGSwitchAll, PTResultGrid: false } });
                                    break;
                                case "wgAllDrys": self.setState({ WGSwitchAll: { ...self.state.WGSwitchAll, TotalDrys: false } });
                                    break;
                                case "wgDryHistogram": self.setState({ WGSwitchAll: { ...self.state.WGSwitchAll, DryHistogram: false } });
                                    break;
                                case "wgDryGrid": self.setState({ WGSwitchAll: { ...self.state.WGSwitchAll, DryGrid: false } });
                                    break;
                                case "wgDryHistory": self.setState({ WGSwitchAll: { ...self.state.WGSwitchAll, DryHistoryGrid: false } });
                                    break;
                                case "wgAllChassis": self.setState({ WGSwitchAll: { ...self.state.WGSwitchAll, TotalChassis: false } });
                                    break;
                                case "wgChassisHistogram": self.setState({ WGSwitchAll: { ...self.state.WGSwitchAll, ChassisHistogram: false } });
                                    break;
                                case "wgChassisGrid": self.setState({ WGSwitchAll: { ...self.state.WGSwitchAll, ChassisGrid: false } });
                                    break;
                                case "wgChassisHistory": self.setState({ WGSwitchAll: { ...self.state.WGSwitchAll, ChassisHistoryGrid: false } });
                                    break;
                                case "wgCargoCare": self.setState({ WGSwitchAll: { ...self.state.WGSwitchAll, CargoCare: false } });
                                    break;
                            }
                        });
                    }, 500);
                }
                self.applyDashboardWidgetsPreferences(dashboardPreferenceId);
            }
            else {

                self.setState({
                    Defaultlayouts: (UserPreference.Defaultlayouts == undefined) ? self.allLayouts : self.allLayouts,
                    DashBoardItems: (UserPreference.DashBoardItems == undefined) ? self.DbItems : UserPreference.DashBoardItems,
                    layouts: (UserPreference.layouts == undefined) ? userLayouts : UserPreference.layouts,
                    WGSwitchAll: (UserPreference.WGSwitchAll == undefined) ? self.state.WGSwitchAll : UserPreference.WGSwitchAll,
                    DashboardPreferenceId: dashboardPreferenceId, IsReadOnly: isReadOnly, RevisionNum: revisionNum
                });
                sessionStorage.setItem('DashboardPreferenceId', dashboardPreferenceId);
            }
        }

        setTimeout(() => {
            //$('#globalLoader').hide();
            self.setState({ isLayoutLoaded: true }, () => { self.restoreWidgetsLoaders(); });
            if (isReadOnly)
                self.pinAllDashboardWidgets(true);
            else
                self.pinAllDashboardWidgets(false);
            isSaveLayout = false;
        }, 2000);// intial waiting time for layouts load
    }

    applyDashboardWidgetsPreferences(dashboardPreferenceId: any) {
        this.BindCharts();
        this.UpdateCharts(false);
        //if(this.state.WGSwitchAll.CargoCare == true) {
        var request = RCUtils.FetchRequest(Config.ApiBaseUrl + '/api/User/GetDashboardWidgetsSearches?dashboardPreferenceId=' + dashboardPreferenceId);
        fetch(request)
            .then(RCUtils.handleError)
            .then(response => response.json() as Promise<any[]>)
            .then(data => {
                if (data != null && data.length > 0) {
                    self.RefreshDashboardGrids(data);
                    var widgetSearchPreferences: any = data.filter(x => x.DashboardWidgetId == 9);
                    //var ccProfilePreferences: any = widgetSearchPreferences[0].SearchData;
                    var filterCCProfileAlertssummary: any[] = [];
                    var selectedCargoCareProfiles: any = JSON.parse(widgetSearchPreferences[0].SearchData);
                    forEach(selectedCargoCareProfiles, function (value, key) {
                        var selectedCCProfiles = self.state.DefaultCargoCareProfileAlertssummary.filter(x => x.CargoCareCustomerProfileCode == value);
                        if (selectedCCProfiles.length > 0) {
                            filterCCProfileAlertssummary.push(selectedCCProfiles[0]);
                        }
                    });
                    //$('#headerLoader').hide();
                    self.setState({ CargoCareProfileAlertssummary: filterCCProfileAlertssummary, CargoCareProfilesSelected: selectedCargoCareProfiles, DashboardWidgetsSearch: data }, () => {
                        self.UpdateCargoChart();
                        //this.UpdateCharts();
                        self.applyAdvanceSearchPreferences(dashboardPreferenceId);
                        self.setState({ loading: false });
                    });

                }
                else
                    $('#globalLoader').hide();
            });
        //}
    }


    RefreshDashboardGrids(data: any) {
        AdvanceSearch.RestoreAdvanceSearchControls();
        if (this.state.WGSwitchAll.ReeferGrid)
            ReeferStatusGrid.refreshGridReady(data);
        if (this.state.WGSwitchAll.ReeferHistoryGrid)
            ReeferHistoryGrid.refreshGridReady(data);
        if (this.state.WGSwitchAll.GensetGrid)
            GensetStatusGrid.refreshGridReady(data);
        if (this.state.WGSwitchAll.GensetHistoryGrid)
            GensetHistoryGrid.refreshGridReady(data);
        if (this.state.WGSwitchAll.DryGrid)
            DryStatusSSRMGrid.refreshGridReady(data);
        if (this.state.WGSwitchAll.DryHistoryGrid)
            DryHistoryGrid.refreshGridReady(data);
        if (this.state.WGSwitchAll.ChassisGrid)
            ChassisStatusGrid.refreshGridReady(data);
        if (this.state.WGSwitchAll.ChassisHistoryGrid)
            ChassisHistoryGrid.refreshGridReady(data);
        if (this.state.WGSwitchAll.PTResultGrid)
            PTResultGrid.refreshGridReady(data);

    }

    componentDidMount() {

        window.addEventListener("resize", this.updateHomepageGridDimensions.bind(this));
        setTimeout(() => { this.updateHomepageGridDimensions() }, 200);
        document.addEventListener("mousedown", this.handleClickOutside);
        $('#wgheadermenu').html('');
        $("#menuwg").detach().appendTo('#wgheadermenu');
        $('#wglayoutmenu').html('');
        $("#menuLayout").detach().appendTo('#wglayoutmenu');

        var parent = this;
        if (JSON.parse(sessionStorage.getItem('SSRM')) == null && JSON.parse(sessionStorage.getItem('SSRM')) == undefined) {
            sessionStorage.setItem('SSRM', JSON.parse(sessionStorage.getItem('UserInfo')).IsEnableServerSide);
            self.setState({ EnableServerSide: JSON.parse(sessionStorage.getItem('UserInfo')).IsEnableServerSide });
        } else {
            self.setState({ EnableServerSide: JSON.parse(sessionStorage.getItem('SSRM')) });
        }
        this.loadDefaultWGSwitch();
        this.loadLayoutDefaultValues();

        var dashboardPreferenceId: any = sessionStorage.getItem('DashboardPreferenceId');
        var requestUrl: any;
        if (dashboardPreferenceId != null && dashboardPreferenceId != undefined)
            requestUrl = '/api/User/GetUserLayoutByDashboardPreferenceId?DashboardPreferenceId=' + dashboardPreferenceId;
        else
            requestUrl = '/api/User/GetUserDashboardLayouts';

        var request = RCUtils.FetchRequest(Config.ApiBaseUrl + requestUrl);
        fetch(request)
            .then(RCUtils.handleError)
            .then(response => response.json() as Promise<any[]>)
            .then(data => {
                if (data.DashboardLayouts != null && data.DashboardLayouts.length > 0) {
                    var defaultPreferenceName: any;
                    if (dashboardPreferenceId != null && dashboardPreferenceId != undefined)
                        defaultPreferenceName = data.DashboardLayouts.filter(x => x.DashboardPreferenceId == dashboardPreferenceId);
                    else
                        defaultPreferenceName = data.DashboardLayouts.filter(x => x.IsDefault == 1);
                    if (defaultPreferenceName.length > 0) {
                        this.loadUserDashboardLayout(defaultPreferenceName[0].PreferenceData, defaultPreferenceName[0].DashboardPreferenceId, defaultPreferenceName[0].IsReadOnly, defaultPreferenceName[0].RevisionNum);
                        //NavMenu.UpdateLayoutState(defaultPreferenceName[0].PreferenceName, data.DashboardLayouts);
                        this.setState({
                            LayoutPreference: defaultPreferenceName[0].PreferenceName, DashboardLayouts: data.DashboardLayouts,
                            DashboardWidgetsSearch: data.DashboardWidgetsSearch
                        });
                    }
                    else {
                        var dashboardLayouts: any = data.DashboardLayouts;
                        this.loadUserDashboardLayout(dashboardLayouts[0].PreferenceData, dashboardLayouts[0].DashboardPreferenceId, dashboardLayouts[0].IsReadOnly, dashboardLayouts[0].RevisionNum);
                        //NavMenu.UpdateLayoutState(dashboardLayouts[0].PreferenceName, data.DashboardLayouts);
                        this.setState({
                            LayoutPreference: dashboardLayouts[0].PreferenceName, DashboardLayouts: data.DashboardLayouts,
                            DashboardWidgetsSearch: data.DashboardWidgetsSearch
                        });
                    }
                }
                else {

                    this.loadUserDashboardLayout(null, 0, false, 0);
                }
                //this.setState({ DashboardWidgetsSearch: data.DashboardWidgetsSearch });
            });

        if (hasReefers) {
            setTimeout(() => {
                //var myRequest = new Request(Config.ApiBaseUrl + '/api/reeferstatus/ReeferStatusSummary');  
                var selectedAssetStates: any = this.state.SelectedAssetStatesTotalReefers;
                if (selectedAssetStates == null || selectedAssetStates == "")
                    selectedAssetStates = "A,D,R";
                var url = Config.ApiBaseUrl + '/api/reeferstatus/TotalReeferStatusSummary?AssetState=' + selectedAssetStates;
                var request = RCUtils.FetchRequest(url, { method: 'GET', headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' } });
                //var request = RCUtils.FetchRequest(Config.ApiBaseUrl + '/api/reeferstatus/ReeferStatusSummary') //RCNG-70
                RCUtils.fetchRetry(request)
                    .then(RCUtils.handleResponse)
                    .then(response => response.json() as Promise<any>)
                    .then(data => {
                        //$('#headerLoader').hide();
                        this.setState({ Reefersummary: data });
                        var url = Config.ApiBaseUrl + '/api/reeferstatus/CargoCareProfileAlerts?AssetState=' + selectedAssetStates;
                        var request = RCUtils.FetchRequest(url, { method: 'GET', headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' } });
                        //var request = RCUtils.FetchRequest(Config.ApiBaseUrl + '/api/reeferstatus/ReeferStatusSummary') //RCNG-70
                        RCUtils.fetchRetry(request)
                            .then(RCUtils.handleResponse)
                            .then(response => response.json() as Promise<any>)
                            .then(ccdata => {
                                $('#cargoCareLoader').show();//RCNG-3409
                                //$('#headerLoader').hide();
                                this.GetUserProfileFilters(ccdata);

                            });
                        //this.BindCharts();
                        //this.UpdateCharts();
                        // this.setState({ loading: false });
                    });

                // start RCNG-60
                //this.timer = setInterval(
                //    () => this.tick(),
                //    this.refreshInterval
                //);
                //end RCNG-60
                //console.log("SearchLoadingIsInProgress");
                //console.log(this.state.SearchLoadingIsInProgress);
                if (wgPTResult[0] != "hidden") {
                    this.ptResultsTimer = setInterval(
                        () => {
                            if (this.state.SearchLoadingIsInProgress == false) {
                                //console.log("PTR Result setInterval if part, value of SearchLoadingIsInProgress is " + this.state.SearchLoadingIsInProgress);
                                if (this.state.SelectedAssetStatesPTR == null || this.state.SelectedAssetStatesPTR == "")
                                    this.setState({ SelectedAssetStatesPTR: defaultInventory }, () => { this.PTResultsTick() })
                                else {
                                    this.PTResultsTick();
                                }
                            }
                            else {
                                //console.log("PTR Result setInterval else part, value of SearchLoadingIsInProgress is " + this.state.SearchLoadingIsInProgress);
                            }
                        },
                        this.refreshInterval
                    );
                }
                ////RCNG-60
                if (wgCargoCare[0] != "hidden") {
                    this.CCSummaryTimer = setInterval(
                        () => {
                            if (this.state.SearchLoadingIsInProgress == false) {
                                //console.log("CargoCare setInterval if part, value of SearchLoadingIsInProgress is " + this.state.SearchLoadingIsInProgress);

                                if (this.state.SelectedAssetStatesCC == null || this.state.SelectedAssetStatesCC == "")
                                    this.setState({ SelectedAssetStatesCC: defaultInventory }, () => { $('#cargoCareLoader').show(); this.ReeferStatusSummaryCC() })
                                else {
                                    $('#cargoCareLoader').show();
                                    this.ReeferStatusSummaryCC();
                                }
                            }
                            else {
                                //console.log("CargoCare setInterval else part, value of SearchLoadingIsInProgress is " + this.state.SearchLoadingIsInProgress);
                            }
                        },
                        this.refreshInterval
                    );
                }
                if (wgMicroalarms[0] != "hidden") {
                    this.MASummaryTimer = setInterval(
                        () => {
                            if (this.state.SearchLoadingIsInProgress == false) {
                                //console.log("Microalarms setInterval if part, value of SearchLoadingIsInProgress is " + this.state.SearchLoadingIsInProgress);

                                if (this.state.SelectedAssetStatesMA == null || this.state.SelectedAssetStatesMA == "")
                                    this.setState({ SelectedAssetStatesMA: defaultInventory }, () => { $('#microAlarmLoader').show(); this.ReeferStatusSummaryMA(true) })
                                else {
                                    $('#microAlarmLoader').show();
                                    this.ReeferStatusSummaryMA(true);
                                }
                            }
                            else {
                                //console.log("Microalarms setInterval else part, value of SearchLoadingIsInProgress is " + this.state.SearchLoadingIsInProgress);
                            }
                        },
                        this.refreshInterval
                    );
                }
                if (wgColdTreatment[0] != "hidden") {
                    setTimeout(() => {                        
                            $('#CTHeaderLoader').show();
                        var selectedCCProfileId: any = self.state.CargoCareCTProfilesSelected.length > 0 ? self.state.CargoCareCTProfilesSelected : "0";
                            var url = Config.ApiBaseUrl + '/api/reeferstatus/ReeferStatusSummaryCT?CCPProfile=' + selectedCCProfileId;
                            var request = RCUtils.FetchRequest(url, { method: 'GET', headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' } });
                            fetch(request)
                                .then(RCUtils.handleError)
                                .then(response => response.json() as Promise<server.CTUnitSummaryModel>)
                                .then(data => {
                                    $('#globalLoader').hide();
                                    this.setState({ ColdTreatmentSummary: data, loading: false }, () => {
                                        this.BindColdTreatmentChart();
                                        this.UpdateCTCharts();
                                        $('#CTHeaderLoader').hide();
                                    });
                                });

                                this.CTSummaryTimer = setInterval(
                                () => {
                                    if (this.state.SearchLoadingIsInProgress == false) {
                                        //console.log("CT setInterval if part, value of SearchLoadingIsInProgress is " + this.state.SearchLoadingIsInProgress);
                                        this.ColdTreatmentTick();
                                    }
                                    else {
                                        //console.log("CT setInterval else part, value of SearchLoadingIsInProgress is " + this.state.SearchLoadingIsInProgress);
                                    }
                                },
                                this.refreshInterval
                            );
                        }, 200
                    );                    
                }
                //if (wgAllreefers[0] != "hidden") {
                this.TotalReeferStatusTimer = setInterval(
                    () => {
                        if (this.state.SearchLoadingIsInProgress == false) {
                            //console.log("TotalReeferStatus setInterval if part, value of SearchLoadingIsInProgress is " + this.state.SearchLoadingIsInProgress);


                            if (this.state.SelectedAssetStatesTotalReefers == null || this.state.SelectedAssetStatesTotalReefers == "")
                                this.setState({ SelectedAssetStatesTotalReefers: defaultInventory }, () => { 
                                    $('#totalReefersLoader').show();
                                    $('#headerLoader').show();
                                    //$('#CTHeaderLoader').show(); 
                                    this.TotalReeferStatusSummary(false) })
                            else {
                                $('#totalReefersLoader').show();
                                $('#headerLoader').show();
                                //$('#CTHeaderLoader').show();
                                
                                this.TotalReeferStatusSummary(false);
                            }
                        }
                        else {
                            //console.log("TotalReeferStatus setInterval else part, value of SearchLoadingIsInProgress is " + this.state.SearchLoadingIsInProgress);
                        }
                    },
                    this.refreshInterval
                );
                //}
                //end RCNG-60
            }, 200);
        }
        else {
            this.setState({ loading: false });
        }

        if (hasGensets) {
            setTimeout(() => {
                var selectedAssetStates: any = this.state.SelectedAssetStatesTotalGensets;
                if (selectedAssetStates == null || selectedAssetStates == "")
                    selectedAssetStates = "A";
                var request = RCUtils.FetchRequest(Config.ApiBaseUrl + '/api/Asset/GensetStatusSummary?AssetState=' + selectedAssetStates)
                RCUtils.fetchRetry(request)
                    .then(RCUtils.handleResponse)
                    .then(response => response.json() as Promise<any>)
                    .then(data => {
                        //$('#GensetheaderLoader').hide();
                        this.setState({ Gensetsummary: data });
                        this.BindGensetCharts();
                        this.UpdateGensetCharts();
                        this.setState({ loading: false });
                    });

                this.gensetTimer = setInterval(

                    () => {
                        if (this.state.SearchLoadingIsInProgress == false) {
                            //console.log("Genset setInterval if part, value of SearchLoadingIsInProgress is " + this.state.SearchLoadingIsInProgress);

                            this.GensetTick()
                        }
                        else {
                            //console.log("Genset setInterval else part, value of SearchLoadingIsInProgress is " + this.state.SearchLoadingIsInProgress);
                        }
                    },
                    this.refreshInterval
                );
            }, 200);
        }
        else {
            this.setState({ loading: false });
        }

        if (hasDrys) {
            setTimeout(() => {
                var selectedAssetStates: any = this.state.SelectedAssetStatesTotalDrys; //this.state.SelectedAssetStatesCC;
                if (selectedAssetStates == null || selectedAssetStates == "")
                    selectedAssetStates = "A";
                var request = RCUtils.FetchRequest(Config.ApiBaseUrl + '/api/Asset/DryStatusSummary?AssetState=' + selectedAssetStates)

                RCUtils.fetchRetry(request)
                    .then(RCUtils.handleResponse)
                    .then(response => response.json() as Promise<any>)
                    .then(data => {
                        //$('#DryheaderLoader').hide(); 
                        this.setState({ Drysummary: data });
                        this.BindDryCharts();
                        this.UpdateDryCharts();

                        this.setState({ loading: false });
                    });

                this.dryTimer = setInterval(
                    () => {
                        if (this.state.SearchLoadingIsInProgress == false) {
                            //console.log("Dry setInterval if part, value of SearchLoadingIsInProgress is " + this.state.SearchLoadingIsInProgress);

                            this.DryTick();
                        }
                        else {
                            //console.log("Dry setInterval else part, value of SearchLoadingIsInProgress is " + this.state.SearchLoadingIsInProgress);
                        }
                    },
                    this.refreshInterval
                );
            }, 200);
        }
        else {
            this.setState({ loading: false });
        }

        if (hasChassis) {
            setTimeout(() => {

                var request = RCUtils.FetchRequest(Config.ApiBaseUrl + '/api/Asset/ChassisStatusSummary')
                RCUtils.fetchRetry(request)
                    .then(RCUtils.handleResponse)
                    .then(response => response.json() as Promise<any>)
                    .then(data => {
                        //$('#ChassisheaderLoader').hide();
                        this.setState({ Chassissummary: data });
                        this.BindChassisCharts();
                        this.UpdateChassisCharts();
                        this.setState({ loading: false });
                    });

                this.chassisTimer = setInterval(
                    () => {
                        if (this.state.SearchLoadingIsInProgress == false) {
                            //console.log("Chassis setInterval if part, value of SearchLoadingIsInProgress is " + this.state.SearchLoadingIsInProgress);

                            this.ChassisTick();
                        }
                        else {
                            //console.log("Chassis setInterval else part, value of SearchLoadingIsInProgress is " + this.state.SearchLoadingIsInProgress);
                        }
                    },
                    this.refreshInterval
                );
            }, 200);
        }
        else {
            this.setState({ loading: false });
        }

    }

    applyAdvanceSearchPreferences(dashboardPreferenceId: any) {
        var searchPreference: any = "";
        var widgetSearchPreferences: any = [];
        if (this.state.DashboardWidgetsSearch.length > 0)
            widgetSearchPreferences = this.state.DashboardWidgetsSearch.filter(x => x.DashboardWidgetId == 1);
        if (widgetSearchPreferences.length > 0)
            searchPreference = widgetSearchPreferences[0].SearchData;
        if (searchPreference != "") {

            var searchFilters: any = JSON.parse(searchPreference);
            AdvanceSearch.applyAdvanceSearchPreferences(searchFilters, dashboardPreferenceId);
        }
        else {
            setTimeout(() => {
                $("#globalLoader").hide();
            }, 2000);
        }
    }

    GetUserCCPProfileFiltersWhenAllUncheked() {
        var url = Config.ApiBaseUrl + '/api/User/GetUserProfileFilters';
        var request = RCUtils.FetchRequest(url, { method: 'GET', headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' } });
        fetch(request)
            .then(RCUtils.handleError)
            .then(response => response.json())
            .then(data => {
                if (data != "") {
                    var profileFilters: any;
                    profileFilters = JSON.parse(data);
                    this.setState({ CargoCareProfilesSelected: profileFilters }, () => {

                        let CCP: any = self.state.CargoCareProfilesSelected;
                        forEach(CCP, function (value, key) {
                            if (CCP.length > 0) {
                                let chkprofileId: any = 'chk_' + value;
                                $("input[id='" + chkprofileId + "']").prop('checked', true);
                            }
                            else {
                                var chkprofileId: any = 'chk_' + value;
                                $("input[id='" + chkprofileId + "']").prop('checked', false);
                            }
                        });

                        let chkSelectAll = document.getElementById("chkSelectAllProfile");
                        let checkboxes = document.getElementsByName('chkProfile');

                        var numberOfCheckboxes = $("input:checkbox[name=chkProfile]").length;
                        var numberOfCheckboxesChecked = $("input:checkbox[name=chkProfile]:checked").length;

                        if (numberOfCheckboxes == numberOfCheckboxesChecked)
                            chkSelectAll.checked = true;
                        else
                            chkSelectAll.checked = false

                    });
                }
            });
    }

    GetUserProfileFilters(ccdata: any) {
        var ccProfilePreferences: any = "";
        var widgetSearchPreferences: any = [];
        if (this.state.DashboardWidgetsSearch.length > 0)
            widgetSearchPreferences = this.state.DashboardWidgetsSearch.filter(x => x.DashboardWidgetId == 9);
        if (widgetSearchPreferences.length > 0)
            ccProfilePreferences = widgetSearchPreferences[0].SearchData;

        if (ccProfilePreferences == "") {
            var ccProfilesData: any = ccdata.map(x => x.CargoCareCustomerProfileCode);
            this.setState({ CargoCareProfileAlertssummary: ccdata, DefaultCargoCareProfileAlertssummary: ccdata, CargoCareProfilesSelected: ccProfilesData }, () => {
                this.BindCharts();
                this.UpdateCharts(false);
                this.setState({ loading: false });
            });
        }
        else {
            var profileFilters: any = JSON.parse(ccProfilePreferences);
            var filterCCProfileAlertssummary: any[] = [];
            forEach(profileFilters, function (value, key) {
                var selectedCCProfiles = ccdata.filter(x => x.CargoCareCustomerProfileCode == value);
                if (selectedCCProfiles.length > 0) {
                    filterCCProfileAlertssummary.push(selectedCCProfiles[0]);
                }
            });
            this.setState({ CargoCareProfileAlertssummary: filterCCProfileAlertssummary, DefaultCargoCareProfileAlertssummary: ccdata, CargoCareProfilesSelected: profileFilters }, () => {
                this.BindCharts();
                this.UpdateCharts(false);
                this.setState({ loading: false });
            });
        }

    }

    PTResultsTick() {
        if (this.state.WGSwitchAll.PTResultGrid)
            PTResultGrid.RefreshPTResultsGrid();
    }

    componentWillReceiveProps(nextProps: any) {

        if (nextProps.SearchLoadingIsInProgress != null && nextProps.SearchLoadingIsInProgress != undefined) {
            //console.log("In Component will receive props, value of SearchLoadingIsInProgress is " + nextProps.SearchLoadingIsInProgress);
            this.setState({ ...this.state, SearchLoadingIsInProgress: nextProps.SearchLoadingIsInProgress })
        }

        //this.SetDryWidgetState();
    }

    hideWidgetsLoader() {
        $('.loader-bg').hide();
    }

    handleClickOutside(event) {
        if(this.wrapperRef.current !=null && this.wrapperRef.current!=undefined){
            if (this.wrapperRef && !this.wrapperRef.current.contains(event.target)) {
                $("#tooglePopupSettings").hide();
            }    
        }    
        this.CloseInventoryStatePopUp(event);//RCNG-4931
        this.ClosePTRResultsPopUp(event);//RCNG-4112
        this.CloseSettingsPopUp(event); //RCNG-4252
    }
    CloseSettingsPopUp(event) {
        if (event.srcElement.className == 'loader-global'|| event.srcElement.className == 'nav-link btn dropdown-toggle' || event.srcElement.className == 'nav-link btn dropdown-toggle show' || event.srcElement.id == 'Spgear'
            || (event.srcElement.className.includes != undefined && event.srcElement.className.includes('switch'))
            || event.srcElement.className == 'vstack gap-2'
            || event.srcElement.className == 'img-responsive chassis_svg' || event.srcElement.className=='widzetText'
            || event.srcElement.className == 'list-group-item d-flex ' || event.srcElement.className == 'widgetSettingsCircle goldColor'
            || event.srcElement.className == 'fas fa-chart-pie' || event.srcElement.className == 'widgetSettingsCircle purple-color'
            || event.srcElement.className == 'd-flex gap-2 px-2 pb-2' || event.srcElement.className == 'list-group' || event.srcElement.className == 'widgetSettingsCircle blue-color'
            || event.srcElement.className == 'dropdown-menu dropdown-menu-end set-default-layout show' || event.srcElement.className == 'widgetSettingsCircle green-color'
            || event.srcElement.className == 'list-group-item' || event.srcElement.className == 'widgetSettingsCircle black-color' || event.srcElement.className == 'fas fa-search-plus'
            || event.srcElement.className == 'img-responsive' || event.srcElement.className == 'list-group DynamicTotalReefersHeight'
            || event.srcElement.className == 'fas fa-history' || event.srcElement.id == 'btn_DefaultLayOut' 
            || event.srcElement.className == 'fas fa-bell' || event.srcElement.className == 'fas fa-clipboard-check'
            || event.srcElement.className == 'aggrid-icons-bg' || event.srcElement.className == 'fas fa-map-marked-alt'
            || event.srcElement.className == 'fas fa-th' || event.srcElement.className == 'fas fa-bell-plus' || event.srcElement.className == 'fas fa-analytics'|| event.srcElement.className=='') {
            var isToggle = $('#lnktoggle').hasClass('nav-link btn dropdown-toggle show');
            if (isToggle) {
                $('#lnktoggle').removeClass('show');
                $('#divToggle').css("display", "none");
            }
        }
        else {
            $('#lnktoggle').removeClass('show');
            $('#divToggle').removeClass('show');
            $('#divToggle').css("display", "none");

        }
    }
    ClosePTRResultsPopUp(event) {

        if (event.srcElement.className == 'dropdown-menu dropdown-menu-end disable-collapse show' || event.srcElement.className == 'PTI-datetime' ||
            event.srcElement.className == 'col-form-label' || event.srcElement.className == 'Select-placeholder' || event.srcElement.className == 'form-select'
            || event.srcElement.className == 'col-md-10' || event.srcElement.className == 'col-md-12' || event.srcElement.className == 'col-md-12 grid-select-control'
            || event.srcElement.className == 'col-form-label' || event.srcElement.className == 'float-end' || event.srcElement.className == 'date-picker'
            || event.srcElement.className == 'row mt-2' || event.srcElement.className == 'col-md-2 pe-0 text-md-end' || event.srcElement.className == 'Select-option is-focused' || event.srcElement.className == 'Select-clear'
            || event.srcElement.id == 'btn_Search' || event.srcElement.className == 'Select-arrow-zone' || event.srcElement.className == ''
            || event.srcElement.className == 'Select-clear-zone' || event.srcElement.className == 'PTI-datetime react-datepicker-ignore-onclickoutside'
            || event.srcElement.className == 'btn btn-outline-secondary dropdown-toggle btn-sm' || event.srcElement.className == 'btn btn-outline-secondary dropdown-toggle btn-sm show'
            || event.srcElement.className == 'mx-1' || (event.srcElement.className.includes != undefined && event.srcElement.className.includes('react-datepicker__day react-datepicker__day')) || (event.srcElement.className.includes != undefined && event.srcElement.className.includes('react-datepicker'))) {
        }
        else {
            $('#PTRPopUP').removeClass('show');
            $('#PTRPopUP').css("display", "none");
        }
    }
    //RCNG-4931
    CloseInventoryStatePopUp(event) {
        if (event.srcElement.id == 'drop-down-inv-pti' || event.srcElement.id == 'btn_inv-pti' || event.srcElement.className == 'AssetSettinsText'
            || event.srcElement.className == 'inv-state' || event.srcElement.id == 'react-select-7--value' || event.srcElement.className == 'Select-arrow-zone'
            || event.srcElement.className == 'Select-placeholder' || event.srcElement.className == 'Select-control' || event.srcElement.className == 'Select-clear'
            || event.srcElement.id == 'react-select-7--option-0' || event.srcElement.id == 'react-select-7--option-1'
            || event.srcElement.id == 'react-select-7--option-2' || event.srcElement.className == 'Select-value-icon'

            || event.srcElement.id == 'drop-down-inv-TD' || event.srcElement.id == 'btn_inv-TD'
            || event.srcElement.id == 'react-select-15--value'
            || event.srcElement.id == 'react-select-14--option-0' || event.srcElement.id == 'react-select-14--option-1'
            || event.srcElement.id == 'react-select-14--option-2' ||

            event.srcElement.id == 'drop-down-inv-fleet-overview' || event.srcElement.id == 'btn_inv-fleet-overview'
            || event.srcElement.id == 'react-select-3--value'
            || event.srcElement.id == 'react-select-3--option-0' || event.srcElement.id == 'react-select-3--option-1'
            || event.srcElement.id == 'react-select-3--option-2'

            || event.srcElement.id == 'drop-down-inv-DFO' || event.srcElement.id == 'btn_inv-DFO'
            || event.srcElement.id == 'react-select-15--value'
            || event.srcElement.id == 'react-select-15--option-0' || event.srcElement.id == 'react-select-15--option-1'
            || event.srcElement.id == 'react-select-15--option-2'

            || event.srcElement.id == 'drop-down-inv-cc' || event.srcElement.id == 'btn_inv-cc'
            || event.srcElement.id == 'react-select-9--value'
            || event.srcElement.id == 'react-select-9--option-0' || event.srcElement.id == 'react-select-9--option-1'
            || event.srcElement.id == 'react-select-9--option-2'


            || event.srcElement.id == 'drop-down-inv-ma' || event.srcElement.id == 'btn_inv-ma'
            || event.srcElement.id == 'react-select-2--value'
            || event.srcElement.id == 'react-select-2--option-0' || event.srcElement.id == 'react-select-2--option-1'
            || event.srcElement.id == 'react-select-2--option-2'

            || event.srcElement.id == 'drop-down-inv-GFO' || event.srcElement.id == 'btn_inv-GFO'
            || event.srcElement.id == 'react-select-10--value'
            || event.srcElement.id == 'react-select-10--option-0' || event.srcElement.id == 'react-select-10--option-1'
            || event.srcElement.id == 'react-select-10--option-2'

            || event.srcElement.id == 'drop-down-inv' || event.srcElement.id == 'btn_inv-TR'
            || event.srcElement.id == 'react-select-4--value'
            || event.srcElement.id == 'react-select-4--option-0' || event.srcElement.id == 'react-select-4--option-1'
            || event.srcElement.id == 'react-select-4--option-2'

            || event.srcElement.id == 'drop-down-inv-TG' || event.srcElement.id == 'btn_inv-TG'
            || event.srcElement.id == 'react-select-11--value'
            || event.srcElement.id == 'react-select-11--option-0' || event.srcElement.id == 'react-select-11--option-1'
            || event.srcElement.id == 'react-select-11--option-2'
            || (event.srcElement.id.includes != undefined && event.srcElement.id.includes('react-select')) 
        ) {
            //$('#drop-down-inv-pti').css("display", "none");
        }
        else {

            $('#drop-down-inv-pti').css("display", "none");
            $('#drop-down-inv-TD').css("display", "none");
            $('#drop-down-inv-fleet-overview').css("display", "none");
            $('#drop-down-inv-DFO').css("display", "none");
            $('#drop-down-inv-cc').css("display", "none");
            $('#drop-down-inv-ma').css("display", "none");
            $('#drop-down-inv-GFO').css("display", "none");
            $('#drop-down-inv').css("display", "none");
            $('#drop-down-inv-TG').css("display", "none");
        }
    }
    componentWillUnmount() {

        document.removeEventListener("mousedown", this.handleClickOutside);
        $('#wgheadermenu').html('');
        $('#wglayoutmenu').html('');
        clearTimeout(this.timer);
        if (hasGensets)
            clearTimeout(this.gensetTimer);
        if (hasDrys)
            clearTimeout(this.dryTimer);
        if (hasChassis)
            clearTimeout(this.chassisTimer);
        //26495
        if (hasReefers) {
            if (wgPTResult[0] != "hidden") {
                clearTimeout(this.ptResultsTimer);
            }
            // start RCNG-60
            if (wgCargoCare[0] != "hidden") {
                clearTimeout(this.CCSummaryTimer);
            }
            clearTimeout(this.MASummaryTimer);
            //if (wgAllreefers[0] != "hidden") {
            clearTimeout(this.TotalReeferStatusTimer);
            //}
            //end RCNG-60
        }

        window.removeEventListener("resize", this.updateHomepageGridDimensions.bind(this));

    }

    LoadPreferencesToDefault() {
        this.isLayOutLoadingBySetDefault = true;
        this.loadLayoutDefaultValues();
        this.state.WGSwitchAll.AdvancedSearch = true;
        this.state.WGSwitchAll.ReeferMaps = true;
        this.state.WGSwitchAll.CargoCare = true;

        if (hasReefers) {
            this.state.WGSwitchAll.ReeferGrid = true;
            this.state.WGSwitchAll.ReeferHistoryGrid = true;
            this.state.WGSwitchAll.ReeferTempGraph = true;
            this.state.WGSwitchAll.PTResultGrid = true;
            this.state.WGSwitchAll.MicroaAlarms = true;
            this.state.WGSwitchAll.Histogram = true;
            this.state.WGSwitchAll.TotalReefers = true;
            this.state.WGSwitchAll.ColdTreatment = true;
        }
        if (hasGensets) {
            this.state.WGSwitchAll.GensetGrid = true;
            this.state.WGSwitchAll.GensetHistoryGrid = true;
            this.state.WGSwitchAll.GensetHistogram = true;
            this.state.WGSwitchAll.TotalGensets = true;
        }
        if (hasDrys) {
            this.state.WGSwitchAll.DryGrid = true;
            this.state.WGSwitchAll.DryHistoryGrid = true;
            this.state.WGSwitchAll.DryHistogram = true;
            this.state.WGSwitchAll.TotalDrys = true;
        }
        if (hasChassis) {
            this.state.WGSwitchAll.ChassisGrid = true;
            this.state.WGSwitchAll.ChassisHistoryGrid = true;
            this.state.WGSwitchAll.ChassisHistogram = true;
            this.state.WGSwitchAll.TotalChassis = true;
        }
        //this.state.WGSwitchAll.AdvancedGensetSearch = true;

        this.setState({ Defaultlayouts: this.allLayouts, DashBoardItems: this.DbItems, layouts: this.allLayouts });
        this.isLayOutLoadingBySetDefault = false;
        if (hasReefers) {
            this.BindCharts();
            this.BindColdTreatmentChart();
        }
        if (hasGensets)
            this.BindGensetCharts();
        if (hasDrys)
            this.BindDryCharts();
        if (hasChassis)
            this.BindChassisCharts();
        //$('#menuwg').addClass('open');
    }

    static UpdateUserDashboardLayout(layoutType: any, layoutName: any, readOnlyLayout: any, dashboardPreferenceId: any, revisionNum: any) {
        if (layoutName == "" || layoutName == null) {
            PopupWindow.showErrorMessage('Error', "Please enter Dashboard Name.");
            return;
        }
        var userDashboards: any = self.state.DashboardLayouts.filter(x => x.DashboardPreferenceId == dashboardPreferenceId);
        if (userDashboards.length > 0) {
            if (layoutType != userDashboards[0].IsCustomerDashboard) {
                var layouts: any = self.state.DashboardLayouts.filter(x => x.PreferenceName.toLowerCase().trim() == layoutName.toLowerCase().trim() && x.IsCustomerDashboard == layoutType)
                if (layouts.length > 0) {
                    PopupWindow.showErrorMessage('Alert', "Dashboard name " + layoutName + " already exists.");
                    return;
                }
            }
        }

        $('#globalLoader').show();
        var layoutPreference = { LayoutName: layoutName, LayoutType: layoutType, IsReadOnly: readOnlyLayout, DashboardPreferenceId: dashboardPreferenceId, RevisionNum: revisionNum };

        var url = Config.ApiBaseUrl + '/api/User/UpdateDashboardLayout';

        var request = RCUtils.FetchRequest(url, { method: 'POST', body: JSON.stringify(layoutPreference), headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' } });
        fetch(request)
            .then(RCUtils.handleError)
            .then(response => response.json())
            .then(data => {
                if (data == "RevisionNum Invalid") {
                    ($("[data-bs-dismiss=modal]") as any).trigger({ type: "click" });
                    $('#globalLoader').hide();
                    var confirmationMessage = "Your changes cannot be saved because this Dashboard has been modified by another user. Either the latest version of this Dashboard can be reloaded now (and changes can be reapplied) or your changes and any subsequent changes you make can be applied temporarily (without saving) until the Dashboard is reloaded. Reload now?"
                    RCNGConfirmWindow.ConfirmWindow.showConfirmBox(confirmationMessage, self.refreshRevisionNumConfirm.bind(this, dashboardPreferenceId), self.closeRevisionConfirmation.bind(this));
                }
                else if (data == "Success")
                    self.ReloadLayoutsData("Dashboard updated successfully.", dashboardPreferenceId, "Edit");
                else {
                    $('#globalLoader').hide();
                    PopupWindow.showErrorMessage('Error', "Error occured, please try again.");
                    return;
                }
            });
    }

    refreshRevisionNumConfirm(dashboardPreferenceId: any) {
        var DashboardPreferenceId: any = dashboardPreferenceId;
        ($("[data-bs-dismiss=modal]") as any).trigger({ type: "click" });
        $('#globalLoader').show();
        var request = RCUtils.FetchRequest(Config.ApiBaseUrl + '/api/User/GetUserDashboardLayouts');
        fetch(request)
            .then(RCUtils.handleError)
            .then(response => response.json() as Promise<any[]>)
            .then(data => {
                if (data.DashboardLayouts != null && data.DashboardLayouts.length > 0) {
                    var defaultPreferenceName: any = data.DashboardLayouts.filter(x => x.DashboardPreferenceId == DashboardPreferenceId);
                    self.applyLayoutPreferences(defaultPreferenceName[0].PreferenceData, defaultPreferenceName[0].DashboardPreferenceId, defaultPreferenceName[0].IsReadOnly, defaultPreferenceName[0].RevisionNum);
                }
            });
    }

    closeRevisionConfirmation() {
        RCNGConfirmWindow.ConfirmWindow.close();
        isSaved = false;
    }

    static SaveUserDashboardLayout(layoutType: any, layoutName: any, readOnlyLayout: any) {
        if (layoutName.trim() == "" || layoutName == null) {
            PopupWindow.showErrorMessage('Alert', "Please enter Dashboard Name.");
            return;
        }
        var userDashboards: any = self.state.DashboardLayouts;
        if (layoutType == true && userDashboards.length > 0) {
            var layoutCount: any = userDashboards.filter(x => x.IsCustomerDashboard == 1);
            if (layoutCount.length == 20) {
                PopupWindow.showErrorMessage('Alert', "Maritime Platform will support a maximum of 20 Company Dashboards.");
                return;
            }
            var customerLayouts: any = layoutCount.filter(x => x.PreferenceName.toLowerCase().trim() == layoutName.toLowerCase().trim())
            if (customerLayouts.length > 0) {
                PopupWindow.showErrorMessage('Alert', "Dashboard name " + layoutName + " already exists.");
                return;
            }
        }
        if (layoutType == false && userDashboards.length > 0) {
            var layoutCount: any = userDashboards.filter(x => x.IsCustomerDashboard == 0);
            if (layoutCount.length == 20) {
                PopupWindow.showErrorMessage('Alert', "Maritime Platform will support a maximum of 20 User Dashboards.");
                return;
            }
            var userLayouts: any = layoutCount.filter(x => x.PreferenceName.toLowerCase().trim() == layoutName.toLowerCase().trim())
            if (userLayouts.length > 0) {
                PopupWindow.showErrorMessage('Alert', "Dashboard name " + layoutName + " already exists.");
                return;
            }
        }
        $('#globalLoader').show();
        var layoutPreferences: any = self.getLayoutPreferenceData(layoutType, layoutName, readOnlyLayout);
        var searchPreferences: any = AdvanceSearch.getSearchPreferenceData();
        var dashboardGrids: any = self.getDashboardGridsEnabled();
        var cargoCarePreferences: any = self.getCargoCareProfilesData();

        var url = Config.ApiBaseUrl + '/api/User/SaveDashboardLayout';
        var dashBoardLayout: any = { LayoutPreferences: layoutPreferences, SearchPreferences: searchPreferences, DashboardGrids: dashboardGrids, CargoCarePreferences: cargoCarePreferences };

        var request = RCUtils.FetchRequest(url, { method: 'POST', body: JSON.stringify(dashBoardLayout), headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' } });
        fetch(request)
            .then(RCUtils.handleError)
            .then(response => response.json())
            .then(data => {
                var dashboardPreferenceId: any = data;
                if (dashboardPreferenceId != 0)
                    self.ReloadLayoutsData("Dashboard created successfully.", dashboardPreferenceId, "");
                else {
                    PopupWindow.showErrorMessage('Error', "Error occured, please try again.");
                    return;
                }
            });
    }

    ReloadLayoutsData(message: any, dashboardPreferenceId: any, action: any) {
        ($("[data-bs-dismiss=modal]") as any).trigger({ type: "click" });
        self.GetDashboardLayouts(message, dashboardPreferenceId, action);
    }

    GetDashboardLayouts(message: any, dashboardPreferenceId: any, action: any) {
        var request = RCUtils.FetchRequest(Config.ApiBaseUrl + '/api/User/GetUserDashboardLayouts');
        fetch(request)
            .then(RCUtils.handleError)
            .then(response => response.json() as Promise<any[]>)
            .then(data => {
                if (data.DashboardLayouts != null && data.DashboardLayouts.length > 0) {
                    if (dashboardPreferenceId == 0) {
                        var defaultPreferenceName: any = data.DashboardLayouts.filter(x => x.IsDefault == 1);
                        if (defaultPreferenceName.length > 0) {
                            this.setState({ LayoutPreference: defaultPreferenceName[0].PreferenceName, DashboardLayouts: data.DashboardLayouts, RevisionNum: defaultPreferenceName[0].RevisionNum },
                                () => this.applyLayoutPreferences(defaultPreferenceName[0].PreferenceData, defaultPreferenceName[0].DashboardPreferenceId, defaultPreferenceName[0].IsReadOnly, defaultPreferenceName[0].RevisionNum));
                        }
                        else {
                            var dashboardLayouts: any = data.DashboardLayouts;
                            this.setState({ LayoutPreference: dashboardLayouts[0].PreferenceName, DashboardLayouts: data.DashboardLayouts, RevisionNum: dashboardLayouts[0].RevisionNum },
                                () => this.applyLayoutPreferences(dashboardLayouts[0].PreferenceData, dashboardLayouts[0].DashboardPreferenceId, dashboardLayouts[0].IsReadOnly, dashboardLayouts[0].RevisionNum));
                        }
                    }
                    else {
                        var defaultPreferenceName: any = data.DashboardLayouts.filter(x => x.DashboardPreferenceId == dashboardPreferenceId);
                        if (action == "Edit" && dashboardPreferenceId == sessionStorage.getItem('DashboardPreferenceId'))
                            this.setState({ LayoutPreference: defaultPreferenceName[0].PreferenceName, DashboardLayouts: data.DashboardLayouts, RevisionNum: defaultPreferenceName[0].RevisionNum, IsReadOnly: defaultPreferenceName[0].IsReadOnly },
                                () => this.restoreCustomerLayout(defaultPreferenceName[0].IsReadOnly));
                        else
                            this.setState({ LayoutPreference: defaultPreferenceName[0].PreferenceName, DashboardLayouts: data.DashboardLayouts, RevisionNum: defaultPreferenceName[0].RevisionNum },
                                () => this.applyLayoutPreferences(defaultPreferenceName[0].PreferenceData, defaultPreferenceName[0].DashboardPreferenceId, defaultPreferenceName[0].IsReadOnly, defaultPreferenceName[0].RevisionNum));
                    }
                }
                //this.setState({ DashboardLayouts: data.DashboardLayouts });
                //$('#globalLoader').hide();                     
                PopupWindow.showErrorMessage("Alert", message);
            });
    }

    restoreCustomerLayout(isReadOnly: any) {//RCNG-4654
        setTimeout(() => {            
            if (isReadOnly)
                self.pinAllDashboardWidgets(true);
            else
                self.pinAllDashboardWidgets(false);
            isSaveLayout = false;
        }, 200);// intial waiting time for layouts load
        $('#globalLoader').hide(); 
    }

    getLayoutPreferenceData(layoutType: any, layoutName: any, readOnlyLayout: any) {
        var data = { Defaultlayouts: this.state.Defaultlayouts, DashBoardItems: this.state.DashBoardItems, layouts: this.state.layouts, WGSwitchAll: this.state.WGSwitchAll }
        var layoutPreference = { LayoutName: layoutName, LayoutType: layoutType, IsReadOnly: readOnlyLayout, PreferenceData: JSON.stringify(data) };
        return layoutPreference;
    }

    getDashboardGridsEnabled() {
        var data: any = {
            ReeferGrid: self.state.WGSwitchAll.ReeferGrid,
            GensetGrid: self.state.WGSwitchAll.GensetGrid,
            DryGrid: self.state.WGSwitchAll.DryGrid,
            ChassisGrid: self.state.WGSwitchAll.ChassisGrid,
            ReeferHistoryGrid: self.state.WGSwitchAll.ReeferHistoryGrid,
            GensetHistoryGrid: self.state.WGSwitchAll.GensetHistoryGrid,
            DryHistoryGrid: self.state.WGSwitchAll.DryHistoryGrid,
            ChassisHistoryGrid: self.state.WGSwitchAll.ChassisHistoryGrid
        };
        return data;
    }

    getCargoCareProfilesData() {
        var profileFilters = uniq(this.state.CargoCareProfilesSelected);
        var cargoCarePreferences: any = {
            ProfileType: 'CP', PreferenceData: JSON.stringify(profileFilters)
        };

        return cargoCarePreferences;
    }


    SaveCargoCareProfileFilters() {
        //console.log("SaveCargoCareProfileFilters: "+isSaveLayout);
        var userPrefId = 0;
        if (this.state.UserPreferenceId == 0) {
            userPrefId = 0;
        }
        else {
            userPrefId = this.state.UserPreferenceId;
        }
        var url = Config.ApiBaseUrl + '/api/User/SaveUserSearchPreferences';
        var profileFilters = uniq(this.state.CargoCareProfilesSelected);
        var preferencedata = { UserId: 0, FunctionId: 1, WidgetId: 9, DashboardPreferenceId: this.state.DashboardPreferenceId, RevisionNum: this.state.RevisionNum, PreferenceData: JSON.stringify(profileFilters), CopyToHistory: false };

        var request = RCUtils.FetchRequest(url, { method: 'POST', body: JSON.stringify(preferencedata), headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' } });
        fetch(request)
            .then(RCUtils.handleError)
            .then(response => response.json())
            .then(data => {
                if (data == "Success")
                    self.refreshRevisionNum(this.state.DashboardPreferenceId, false);
                else if (data == "RevisionNum Invalid") {
                    $('#globalLoader').hide();
                    var confirmationMessage = "Your changes cannot be saved because this Dashboard has been modified by another user. Either the latest version of this Dashboard can be reloaded now (and changes can be reapplied) or your changes and any subsequent changes you make can be applied temporarily (without saving) until the Dashboard is reloaded. Reload now?"
                    RCNGConfirmWindow.ConfirmWindow.showConfirmBox(confirmationMessage, self.refreshRevisionNum.bind(this, this.state.DashboardPreferenceId, true), self.closeRevisionConfirmation.bind(this));
                }
                else {
                    $('#globalLoader').hide();
                    PopupWindow.showErrorMessage('Error', "Error occured, please try again.");
                    return;
                }
            });
    }

    UpdateDashboardLayout() {
        if (this.state.isFullscreen == false && this.state.isLayoutLoaded == true && !isSaveLayout) {
            //var url = Config.ApiBaseUrl + '/api/User/SaveUserPreference';
            //console.log("UpdateUserLayout: "+isSaveLayout);
            //$('#globalLoader').show();
            if(!isSaved) //RCNG-4253
                this.CreateOrUpdateDashboard();
        }
    }

    CreateOrUpdateDashboard() {
        isSaved = true;
        $('#globalLoader').show();
        var url = Config.ApiBaseUrl + '/api/User/UpdateUserLayout';
        var data = { Defaultlayouts: this.state.Defaultlayouts, DashBoardItems: this.state.DashBoardItems, layouts: this.state.layouts, WGSwitchAll: this.state.WGSwitchAll }
        var preferencedata = { DashboardPreferenceId: this.state.DashboardPreferenceId, RevisionNum: this.state.RevisionNum, PreferenceData: JSON.stringify(data) };
        var request = RCUtils.FetchRequest(url, { method: 'POST', body: JSON.stringify(preferencedata), headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' } });
        fetch(request)
            .then(RCUtils.handleError)
            .then(response => response.json())
            .then(data => {
                if (data == "Success")
                    self.refreshRevisionNum(self.state.DashboardPreferenceId, false);
                else if (data == "RevisionNum Invalid") {
                    $('#globalLoader').hide();
                    var confirmationMessage = "Your changes cannot be saved because this Dashboard has been modified by another user. Either the latest version of this Dashboard can be reloaded now (and changes can be reapplied) or your changes and any subsequent changes you make can be applied temporarily (without saving) until the Dashboard is reloaded. Reload now?"
                    RCNGConfirmWindow.ConfirmWindow.showConfirmBox(confirmationMessage, self.refreshRevisionNum.bind(this, self.state.DashboardPreferenceId, true), self.closeRevisionConfirmation.bind(this));
                }
                else {
                    $('#globalLoader').hide();
                    PopupWindow.showErrorMessage('Error', "Error occured, please try again.");
                    return;
                }
                isSaved = false;
            });

    }

    validateRevisionNum(dashboardPreferenceId: any) {
        var confirmationMessage = "Your changes cannot be saved because this Dashboard has been modified by another user. Either the latest version of this Dashboard can be reloaded now (and changes can be reapplied) or your changes and any subsequent changes you make can be applied temporarily (without saving) until the Dashboard is reloaded. Reload now?"
        RCNGConfirmWindow.ConfirmWindow.showConfirmBox(confirmationMessage, self.refreshRevisionNum.bind(this, dashboardPreferenceId, true), self.closeRevisionConfirmation.bind(this));
    }

    refreshRevisionNum(dashboardPreferenceId: any, isLoader: any) {
        var DashboardPreferenceId: any = dashboardPreferenceId;
        if (isLoader)
            $('#globalLoader').show();
        var request = RCUtils.FetchRequest(Config.ApiBaseUrl + '/api/User/GetUserDashboardLayouts');
        fetch(request)
            .then(RCUtils.handleError)
            .then(response => response.json() as Promise<any[]>)
            .then(data => {
                this.restoreWidgetsLoaders();
                if (data.DashboardLayouts != null && data.DashboardLayouts.length > 0) {
                    if (DashboardPreferenceId == 0 || DashboardPreferenceId == undefined) {
                        var dashboardLayouts: any = data.DashboardLayouts;
                        var dashboardPreferenceId: any = dashboardLayouts[0].DashboardPreferenceId
                        this.setState({
                            LayoutPreference: dashboardLayouts[0].PreferenceName, RevisionNum: dashboardLayouts[0].RevisionNum, DashboardLayouts: data.DashboardLayouts,
                            DashboardWidgetsSearch: data.DashboardWidgetsSearch, DashboardPreferenceId: DashboardPreferenceId
                        });
                        sessionStorage.setItem('DashboardPreferenceId', DashboardPreferenceId);
                    }
                    else {
                        var defaultPreferenceName: any = data.DashboardLayouts.filter(x => x.DashboardPreferenceId == DashboardPreferenceId);
                        this.setState({ RevisionNum: defaultPreferenceName[0].RevisionNum, DashboardLayouts: data.DashboardLayouts, DashboardWidgetsSearch: data.DashboardWidgetsSearch });
                    }
                }
                $('#globalLoader').hide();
                isSaveLayout = false;
                isSaved = false;
            });
    }


    restoreWidgetsLoaders() {
        setTimeout(() => {
            this.hideWidgetsLoader();
        }, 4000);
        //$('.loader-bg').hide();
        //var responseData = data;
        this.setState({ isLayoutUpdated: false });
        var searchWidgetHeight = $('.advance-search').height();
        if (searchWidgetHeight != undefined) {
            var searchBodyHeight = parseInt(searchWidgetHeight.toString()) - 89;
            $('.dashboardSearch-scrollbar').css('height', searchBodyHeight);
        }
    }

    AddDefaultLayout(el) {
        var jsonlayout = JSON.stringify(this.state.layouts);
        var allLayouts = JSON.parse(jsonlayout);
        var JsondefaultLayouts = JSON.stringify(this.state.Defaultlayouts);
        var defaultLayouts = JSON.parse(JsondefaultLayouts);
        $.each(allLayouts, function (i, n) {
            allLayouts[i] = reject(allLayouts[i], { Key: el });
            var defaultitem = find(defaultLayouts[i], { 'i': el });
            if (defaultitem != undefined) {
                allLayouts[i].push(defaultitem);
            }
        });

        this.setState({ layouts: allLayouts });
    }

    toggleSwitch = (el) => {
        //this.setState(prevState => {
        //    return {
        //        WGSwitch:dswitch
        //    };
        //}); 
        isSaveLayout = false;
        if (!this.isLayOutLoadingBySetDefault) {
            this.setState({ isLayoutUpdated: true });
            if (el == "wgAdvSearch") {
                if (this.state.WGSwitchAll.AdvancedSearch == false) {
                    this.AddDefaultLayout(el);
                    var index = indexOf(this.state.DashBoardItems, function (o) { return o.Key = el; });
                    if (index < 0) {
                        var dashboards = this.state.DashBoardItems;
                        dashboards.push({ Key: "wgAdvSearch", Layout: this.GetItemLayout("wgAdvSearch", this.state.layouts), Enabled: false, IsVisible: true, IsFullscreen: false, IsPinned: false });
                        this.setState({ DashBoardItems: dashboards });
                        this.setState({ DashBoardItems: reject(this.state.DashBoardItems, { Key: "" }) });
                    }
                }
                else {
                    this.setState({ DashBoardItems: reject(this.state.DashBoardItems, { Key: el }) });
                }

                this.setState({ WGSwitchAll: { ...this.state.WGSwitchAll, AdvancedSearch: !this.state.WGSwitchAll.AdvancedSearch } });
            }
            else if (el == "wgGensetAdvSearch") {
                if (this.state.WGSwitchAll.AdvancedSearch == false) {
                    this.AddDefaultLayout(el);
                    var index = indexOf(this.state.DashBoardItems, function (o) { return o.Key = el; });
                    if (index < 0) {
                        var dashboards = this.state.DashBoardItems;
                        dashboards.push({ Key: "wgGensetAdvSearch", Layout: this.GetItemLayout("wgGensetAdvSearch", this.state.layouts), Enabled: false, IsVisible: true, IsFullscreen: false, IsPinned: false });
                        this.setState({ DashBoardItems: dashboards });
                        this.setState({ DashBoardItems: reject(this.state.DashBoardItems, { Key: "" }) });
                    }
                }
                else {
                    this.setState({ DashBoardItems: reject(this.state.DashBoardItems, { Key: el }) });
                }

                this.setState({ WGSwitchAll: { ...this.state.WGSwitchAll, AdvancedGensetSearch: !this.state.WGSwitchAll.AdvancedGensetSearch } });
            }
            else if (el == "wgMicroalarms") {
                if (this.state.WGSwitchAll.MicroaAlarms == false) {
                    this.AddDefaultLayout(el);
                    var index = indexOf(this.state.DashBoardItems, function (o) { return o.Key = el; });
                    if (index < 0) {
                        var dashboards = this.state.DashBoardItems;
                        dashboards.push({ Key: "wgMicroalarms", Layout: this.GetItemLayout("wgMicroalarms", this.state.layouts), Enabled: false, IsVisible: true, IsFullscreen: false });
                        this.setState({ DashBoardItems: dashboards });
                        this.setState({ DashBoardItems: reject(this.state.DashBoardItems, { Key: "" }) });
                    }
                }
                else {
                    this.setState({ DashBoardItems: reject(this.state.DashBoardItems, { Key: el }) });
                }

                this.setState({ WGSwitchAll: { ...this.state.WGSwitchAll, MicroaAlarms: !this.state.WGSwitchAll.MicroaAlarms } });
            }
            else if (el == "wgCargoCare") {
                if (this.state.WGSwitchAll.CargoCare == false) {
                    this.AddDefaultLayout(el);
                    var index = indexOf(this.state.DashBoardItems, function (o) { return o.Key = el; });
                    if (index < 0) {
                        var dashboards = this.state.DashBoardItems;
                        dashboards.push({ Key: "wgCargoCare", Layout: this.GetItemLayout("wgCargoCare", this.state.layouts), Enabled: false, IsVisible: true, IsFullscreen: false });
                        this.setState({ DashBoardItems: dashboards });
                        this.setState({ DashBoardItems: reject(this.state.DashBoardItems, { Key: "" }) });
                    }
                }
                else {
                    this.setState({ DashBoardItems: reject(this.state.DashBoardItems, { Key: el }) });
                }

                this.setState({ WGSwitchAll: { ...this.state.WGSwitchAll, CargoCare: !this.state.WGSwitchAll.CargoCare } });
            }
            else if (el == "wgHistogram") {
                if (this.state.WGSwitchAll.Histogram == false) {
                    this.AddDefaultLayout(el);
                    var index = indexOf(this.state.DashBoardItems, function (o) { return o.Key = el; });
                    if (index < 0) {
                        var dashboards = this.state.DashBoardItems;
                        dashboards.push({ Key: "wgHistogram", Layout: this.GetItemLayout("wgHistogram", this.state.layouts), Enabled: false, IsVisible: true, IsFullscreen: false });
                        this.setState({ DashBoardItems: dashboards });
                        this.setState({ DashBoardItems: reject(this.state.DashBoardItems, { Key: "" }) });
                    }
                }
                else {
                    this.setState({ DashBoardItems: reject(this.state.DashBoardItems, { Key: el }) });
                }

                this.setState({ WGSwitchAll: { ...this.state.WGSwitchAll, Histogram: !this.state.WGSwitchAll.Histogram } });
            }
            else if (el == "wgGensetHistogram") {
                if (this.state.WGSwitchAll.GensetHistogram == false) {
                    this.AddDefaultLayout(el);
                    var index = indexOf(this.state.DashBoardItems, function (o) { return o.Key = el; });
                    if (index < 0) {
                        var dashboards = this.state.DashBoardItems;
                        dashboards.push({ Key: "wgGensetHistogram", Layout: this.GetItemLayout("wgGensetHistogram", this.state.layouts), Enabled: false, IsVisible: true, IsFullscreen: false });
                        this.setState({ DashBoardItems: dashboards });
                        this.setState({ DashBoardItems: reject(this.state.DashBoardItems, { Key: "" }) });
                    }
                }
                else {
                    this.setState({ DashBoardItems: reject(this.state.DashBoardItems, { Key: el }) });
                }

                this.setState({ WGSwitchAll: { ...this.state.WGSwitchAll, GensetHistogram: !this.state.WGSwitchAll.GensetHistogram } });
            }
            else if (el == "wgDryHistogram") {
                if (this.state.WGSwitchAll.DryHistogram == false) {
                    this.AddDefaultLayout(el);
                    var index = indexOf(this.state.DashBoardItems, function (o) { return o.Key = el; });
                    if (index < 0) {
                        var dashboards = this.state.DashBoardItems;
                        dashboards.push({ Key: "wgDryHistogram", Layout: this.GetItemLayout("wgDryHistogram", this.state.layouts), Enabled: false, IsVisible: true, IsFullscreen: false });
                        this.setState({ DashBoardItems: dashboards });
                        this.setState({ DashBoardItems: reject(this.state.DashBoardItems, { Key: "" }) });
                    }
                }
                else {
                    this.setState({ DashBoardItems: reject(this.state.DashBoardItems, { Key: el }) });
                }

                this.setState({ WGSwitchAll: { ...this.state.WGSwitchAll, DryHistogram: !this.state.WGSwitchAll.DryHistogram } });
            }
            else if (el == "wgChassisHistogram") {
                if (this.state.WGSwitchAll.ChassisHistogram == false) {
                    this.AddDefaultLayout(el);
                    var index = indexOf(this.state.DashBoardItems, function (o) { return o.Key = el; });
                    if (index < 0) {
                        var dashboards = this.state.DashBoardItems;
                        dashboards.push({ Key: "wgChassisHistogram", Layout: this.GetItemLayout("wgChassisHistogram", this.state.layouts), Enabled: false, IsVisible: true, IsFullscreen: false });
                        this.setState({ DashBoardItems: dashboards });
                        this.setState({ DashBoardItems: reject(this.state.DashBoardItems, { Key: "" }) });
                    }
                }
                else {
                    this.setState({ DashBoardItems: reject(this.state.DashBoardItems, { Key: el }) });
                }

                this.setState({ WGSwitchAll: { ...this.state.WGSwitchAll, ChassisHistogram: !this.state.WGSwitchAll.ChassisHistogram } });
            }
            else if (el == "wgAllreefers") {

                if (this.state.WGSwitchAll.TotalReefers == false) {
                    this.AddDefaultLayout(el);
                    var index = indexOf(this.state.DashBoardItems, function (o) { return o.Key = el; });
                    if (index < 0) {
                        var dashboards = this.state.DashBoardItems;
                        dashboards.push({ Key: "wgAllreefers", Layout: this.GetItemLayout("wgAllreefers", this.state.layouts), Enabled: false, IsVisible: true, IsFullscreen: false });
                        this.setState({ DashBoardItems: dashboards });
                        this.setState({ DashBoardItems: reject(this.state.DashBoardItems, { Key: "" }) });
                    }
                }
                else {
                    this.setState({ DashBoardItems: reject(this.state.DashBoardItems, { Key: el }) });
                }

                this.setState({ WGSwitchAll: { ...this.state.WGSwitchAll, TotalReefers: !this.state.WGSwitchAll.TotalReefers } });
            }
            else if (el == "wgColdTreatment") {

                if (this.state.WGSwitchAll.ColdTreatment == false) {
                    this.AddDefaultLayout(el);
                    var index = indexOf(this.state.DashBoardItems, function (o) { return o.Key = el; });
                    if (index < 0) {
                        var dashboards = this.state.DashBoardItems;
                        dashboards.push({ Key: "wgColdTreatment", Layout: this.GetItemLayout("wgColdTreatment", this.state.layouts), Enabled: false, IsVisible: true, IsFullscreen: false });
                        this.setState({ DashBoardItems: dashboards });
                        this.setState({ DashBoardItems: reject(this.state.DashBoardItems, { Key: "" }) });
                    }
                }
                else {
                    this.setState({ DashBoardItems: reject(this.state.DashBoardItems, { Key: el }) });
                }

                this.setState({ WGSwitchAll: { ...this.state.WGSwitchAll, ColdTreatment: !this.state.WGSwitchAll.ColdTreatment } });
            }
            else if (el == "wgAllDrys") {

                if (this.state.WGSwitchAll.TotalDrys == false) {
                    this.AddDefaultLayout(el);
                    var index = indexOf(this.state.DashBoardItems, function (o) { return o.Key = el; });
                    if (index < 0) {
                        var dashboards = this.state.DashBoardItems;
                        dashboards.push({ Key: "wgAllDrys", Layout: this.GetItemLayout("wgAllDrys", this.state.layouts), Enabled: false, IsVisible: true, IsFullscreen: false });
                        this.setState({ DashBoardItems: dashboards });
                        this.setState({ DashBoardItems: reject(this.state.DashBoardItems, { Key: "" }) });
                    }
                }
                else {
                    this.setState({ DashBoardItems: reject(this.state.DashBoardItems, { Key: el }) });
                }

                this.setState({ WGSwitchAll: { ...this.state.WGSwitchAll, TotalDrys: !this.state.WGSwitchAll.TotalDrys } });
            }
            else if (el == "wgAllChassis") {

                if (this.state.WGSwitchAll.TotalChassis == false) {
                    this.AddDefaultLayout(el);
                    var index = indexOf(this.state.DashBoardItems, function (o) { return o.Key = el; });
                    if (index < 0) {
                        var dashboards = this.state.DashBoardItems;
                        dashboards.push({ Key: "wgAllChassis", Layout: this.GetItemLayout("wgAllChassis", this.state.layouts), Enabled: false, IsVisible: true, IsFullscreen: false });
                        this.setState({ DashBoardItems: dashboards });
                        this.setState({ DashBoardItems: reject(this.state.DashBoardItems, { Key: "" }) });
                    }
                }
                else {
                    this.setState({ DashBoardItems: reject(this.state.DashBoardItems, { Key: el }) });
                }

                this.setState({ WGSwitchAll: { ...this.state.WGSwitchAll, TotalChassis: !this.state.WGSwitchAll.TotalChassis } });
            }
            else if (el == "wgAllGensets") {

                if (this.state.WGSwitchAll.TotalGensets == false) {
                    this.AddDefaultLayout(el);
                    var index = indexOf(this.state.DashBoardItems, function (o) { return o.Key = el; });
                    if (index < 0) {
                        var dashboards = this.state.DashBoardItems;
                        dashboards.push({ Key: "wgAllGensets", Layout: this.GetItemLayout("wgAllGensets", this.state.layouts), Enabled: false, IsVisible: true, IsFullscreen: false });
                        this.setState({ DashBoardItems: dashboards });
                        this.setState({ DashBoardItems: reject(this.state.DashBoardItems, { Key: "" }) });
                    }
                }
                else {
                    this.setState({ DashBoardItems: reject(this.state.DashBoardItems, { Key: el }) });
                }

                this.setState({ WGSwitchAll: { ...this.state.WGSwitchAll, TotalGensets: !this.state.WGSwitchAll.TotalGensets } });
            }
            else if (el == "wgReeferMap") {
                if (this.state.WGSwitchAll.ReeferMaps == false) {
                    this.AddDefaultLayout(el);
                    var index = indexOf(this.state.DashBoardItems, function (o) { return o.Key = el; });
                    if (index < 0) {
                        var dashboards = this.state.DashBoardItems;
                        dashboards.push({ Key: "wgReeferMap", Layout: this.GetItemLayout("wgReeferMap", this.state.layouts), Enabled: false, IsVisible: true, IsFullscreen: false });
                        this.setState({ DashBoardItems: dashboards });
                        this.setState({ DashBoardItems: reject(this.state.DashBoardItems, { Key: "" }) });
                    }
                }
                else {
                    this.setState({ DashBoardItems: reject(this.state.DashBoardItems, { Key: el }) });
                }

                this.setState({ WGSwitchAll: { ...this.state.WGSwitchAll, ReeferMaps: !this.state.WGSwitchAll.ReeferMaps } });
            }
            else if (el == "wgReeferGrid") {
                if (this.state.WGSwitchAll.ReeferGrid == false) {
                    this.AddDefaultLayout(el);
                    var index = indexOf(this.state.DashBoardItems, function (o) { return o.Key = el; });
                    if (index < 0) {
                        var dashboards = this.state.DashBoardItems;
                        dashboards.push({ Key: "wgReeferGrid", Layout: this.GetItemLayout("wgReeferGrid", this.state.layouts), Enabled: false, IsVisible: true, IsFullscreen: false });
                        this.setState({ DashBoardItems: dashboards });
                        this.setState({ DashBoardItems: reject(this.state.DashBoardItems, { Key: "" }) });
                    }
                }
                else {
                    this.setState({ DashBoardItems: reject(this.state.DashBoardItems, { Key: el }) });
                }

                this.setState({ WGSwitchAll: { ...this.state.WGSwitchAll, ReeferGrid: !this.state.WGSwitchAll.ReeferGrid } });
            }
            else if (el == "wgGensetGrid") {
                if (this.state.WGSwitchAll.GensetGrid == false) {
                    this.AddDefaultLayout(el);
                    var index = indexOf(this.state.DashBoardItems, function (o) { return o.Key = el; });
                    if (index < 0) {
                        var dashboards = this.state.DashBoardItems;
                        dashboards.push({ Key: "wgGensetGrid", Layout: this.GetItemLayout("wgGensetGrid", this.state.layouts), Enabled: false, IsVisible: true, IsFullscreen: false });
                        this.setState({ DashBoardItems: dashboards });
                        this.setState({ DashBoardItems: reject(this.state.DashBoardItems, { Key: "" }) });
                    }
                }
                else {
                    this.setState({ DashBoardItems: reject(this.state.DashBoardItems, { Key: el }) });
                }

                this.setState({ WGSwitchAll: { ...this.state.WGSwitchAll, GensetGrid: !this.state.WGSwitchAll.GensetGrid } });
            }
            else if (el == "wgDryGrid") {
                if (this.state.WGSwitchAll.DryGrid == false) {
                    this.AddDefaultLayout(el);
                    var index = indexOf(this.state.DashBoardItems, function (o) { return o.Key = el; });
                    if (index < 0) {
                        var dashboards = this.state.DashBoardItems;
                        dashboards.push({ Key: "wgDryGrid", Layout: this.GetItemLayout("wgDryGrid", this.state.layouts), Enabled: false, IsVisible: true, IsFullscreen: false });
                        this.setState({ DashBoardItems: dashboards });
                        this.setState({ DashBoardItems: reject(this.state.DashBoardItems, { Key: "" }) });
                    }
                }
                else {
                    this.setState({ DashBoardItems: reject(this.state.DashBoardItems, { Key: el }) });
                }

                this.setState({ WGSwitchAll: { ...this.state.WGSwitchAll, DryGrid: !this.state.WGSwitchAll.DryGrid } });
            }
            else if (el == "wgChassisGrid") {
                if (this.state.WGSwitchAll.ChassisGrid == false) {
                    this.AddDefaultLayout(el);
                    var index = indexOf(this.state.DashBoardItems, function (o) { return o.Key = el; });
                    if (index < 0) {
                        var dashboards = this.state.DashBoardItems;
                        dashboards.push({ Key: "wgChassisGrid", Layout: this.GetItemLayout("wgChassisGrid", this.state.layouts), Enabled: false, IsVisible: true, IsFullscreen: false });
                        this.setState({ DashBoardItems: dashboards });
                        this.setState({ DashBoardItems: reject(this.state.DashBoardItems, { Key: "" }) });
                    }
                }
                else {
                    this.setState({ DashBoardItems: reject(this.state.DashBoardItems, { Key: el }) });
                }

                this.setState({ WGSwitchAll: { ...this.state.WGSwitchAll, ChassisGrid: !this.state.WGSwitchAll.ChassisGrid } });
            }
            else if (el == "wgReeferHistory") {
                if (this.state.WGSwitchAll.ReeferHistoryGrid == false) {
                    this.AddDefaultLayout(el);
                    var index = indexOf(this.state.DashBoardItems, function (o) { return o.Key = el; });
                    if (index < 0) {
                        var dashboards = this.state.DashBoardItems;
                        dashboards.push({ Key: "wgReeferHistory", Layout: this.GetItemLayout("wgReeferHistory", this.state.layouts), Enabled: false, IsVisible: true, IsFullscreen: false });
                        this.setState({ DashBoardItems: dashboards });
                        this.setState({ DashBoardItems: reject(this.state.DashBoardItems, { Key: "" }) });
                    }
                }
                else {
                    this.setState({ DashBoardItems: reject(this.state.DashBoardItems, { Key: el }) });
                }

                this.setState({ WGSwitchAll: { ...this.state.WGSwitchAll, ReeferHistoryGrid: !this.state.WGSwitchAll.ReeferHistoryGrid } });
            }
            else if (el == "wgReeferTempGraph") {
                if (this.state.WGSwitchAll.ReeferTempGraph == false) {
                    this.AddDefaultLayout(el);
                    var index = indexOf(this.state.DashBoardItems, function (o) { return o.Key = el; });
                    if (index < 0) {
                        var dashboards = this.state.DashBoardItems;
                        dashboards.push({ Key: "wgReeferTempGraph", Layout: this.GetItemLayout("wgReeferTempGraph", this.state.layouts), Enabled: false, IsVisible: true, IsFullscreen: false });
                        this.setState({ DashBoardItems: dashboards });
                        this.setState({ DashBoardItems: reject(this.state.DashBoardItems, { Key: "" }) });
                    }
                }
                else {
                    this.setState({ DashBoardItems: reject(this.state.DashBoardItems, { Key: el }) });
                }

                this.setState({ WGSwitchAll: { ...this.state.WGSwitchAll, ReeferTempGraph: !this.state.WGSwitchAll.ReeferTempGraph } });
            }
            else if (el == "wgGensetHistory") {
                if (this.state.WGSwitchAll.GensetHistoryGrid == false) {
                    this.AddDefaultLayout(el);
                    var index = indexOf(this.state.DashBoardItems, function (o) { return o.Key = el; });
                    if (index < 0) {
                        var dashboards = this.state.DashBoardItems;
                        dashboards.push({ Key: "wgGensetHistory", Layout: this.GetItemLayout("wgGensetHistory", this.state.layouts), Enabled: false, IsVisible: true, IsFullscreen: false });
                        this.setState({ DashBoardItems: dashboards });
                        this.setState({ DashBoardItems: reject(this.state.DashBoardItems, { Key: "" }) });
                    }
                }
                else {
                    this.setState({ DashBoardItems: reject(this.state.DashBoardItems, { Key: el }) });
                }

                this.setState({ WGSwitchAll: { ...this.state.WGSwitchAll, GensetHistoryGrid: !this.state.WGSwitchAll.GensetHistoryGrid } });
            }
            else if (el == "wgDryHistory") {
                if (this.state.WGSwitchAll.DryHistoryGrid == false) {
                    this.AddDefaultLayout(el);
                    var index = indexOf(this.state.DashBoardItems, function (o) { return o.Key = el; });
                    if (index < 0) {
                        var dashboards = this.state.DashBoardItems;
                        dashboards.push({ Key: "wgDryHistory", Layout: this.GetItemLayout("wgDryHistory", this.state.layouts), Enabled: false, IsVisible: true, IsFullscreen: false });
                        this.setState({ DashBoardItems: dashboards });
                        this.setState({ DashBoardItems: reject(this.state.DashBoardItems, { Key: "" }) });
                    }
                }
                else {
                    this.setState({ DashBoardItems: reject(this.state.DashBoardItems, { Key: el }) });
                }

                this.setState({ WGSwitchAll: { ...this.state.WGSwitchAll, DryHistoryGrid: !this.state.WGSwitchAll.DryHistoryGrid } });
            }
            else if (el == "wgChassisHistory") {
                if (this.state.WGSwitchAll.ChassisHistoryGrid == false) {
                    this.AddDefaultLayout(el);
                    var index = indexOf(this.state.DashBoardItems, function (o) { return o.Key = el; });
                    if (index < 0) {
                        var dashboards = this.state.DashBoardItems;
                        dashboards.push({ Key: "wgChassisHistory", Layout: this.GetItemLayout("wgChassisHistory", this.state.layouts), Enabled: false, IsVisible: true, IsFullscreen: false });
                        this.setState({ DashBoardItems: dashboards });
                        this.setState({ DashBoardItems: reject(this.state.DashBoardItems, { Key: "" }) });
                    }
                }
                else {
                    this.setState({ DashBoardItems: reject(this.state.DashBoardItems, { Key: el }) });
                }

                this.setState({ WGSwitchAll: { ...this.state.WGSwitchAll, ChassisHistoryGrid: !this.state.WGSwitchAll.ChassisHistoryGrid } });
            }
            else if (el == "wgPTResult") {
                if (this.state.WGSwitchAll.PTResultGrid == false) {
                    this.AddDefaultLayout(el);
                    var index = indexOf(this.state.DashBoardItems, function (o) { return o.Key = el; });
                    if (index < 0) {
                        var dashboards = this.state.DashBoardItems;
                        dashboards.push({ Key: "wgPTResult", Layout: this.GetItemLayout("wgPTResult", this.state.layouts), Enabled: false, IsVisible: true, IsFullscreen: false });
                        this.setState({ DashBoardItems: dashboards });
                        this.setState({ DashBoardItems: reject(this.state.DashBoardItems, { Key: "" }) });
                    }
                }
                else {
                    this.setState({ DashBoardItems: reject(this.state.DashBoardItems, { Key: el }) });
                }

                this.setState({ WGSwitchAll: { ...this.state.WGSwitchAll, PTResultGrid: !this.state.WGSwitchAll.PTResultGrid } });
            }
            //var allLayouts = this.state.layouts;
            //this.setState({ layouts: allLayouts });
            //alert(JSON.stringify(this.state.layouts));
            if (hasReefers) {
                this.BindCharts();
                this.BindColdTreatmentChart();
            }
            if (hasGensets)
                this.BindGensetCharts();
            if (hasDrys)
                this.BindDryCharts();
            if (hasChassis)
                this.BindChassisCharts();
            //$('#menuwg').addClass('open');
        }
    };

    ClearFilter(isFromMicroAlarmChart: boolean) {
        var filters = this.state.Filters;
        filters.SelectedCountry = "";
        filters.SelectedAssetTypes = "";
        filters.SelectedAssetStates = "A,D";//RCNG-59
        filters.SelectedGeofence = "";
        filters.SelectedGeofenceInside = "";
        filters.SelectedInterval = "";
        filters.SelectedOem = "";
        filters.SelectedReefer = "";
        filters.SelectedVesselCode = "";
        filters.StatusFilters = [];
        filters.CustomAttributeFilters = {};
        //RCNG-3571-as this need to carry fwd
        if (!isFromMicroAlarmChart)
            filters.SelectedCargoCareProfiles = "";
        filters.SelectedPol = "";
        filters.SelectedPod = "";

        this.setState({
            Filters: filters
        });
        AdvanceSearch.ClearReeferSearchFilters(isFromMicroAlarmChart);
        totalWidgetSearch = false;//WI26412

        if (this.state.WGSwitchAll.ReeferGrid == true) {
            ReeferStatusGrid.ClearReeferStatusGridData();
            ReeferStatusSSRMGrid.ClearReeferStatusGridData();
        }
        if (this.state.WGSwitchAll.GensetGrid == true)
            GensetStatusGrid.ClearGensetStatusGridData();
        if (this.state.WGSwitchAll.DryGrid == true)
            DryStatusSSRMGrid.ClearDryStatusGridData();
        if (this.state.WGSwitchAll.ChassisGrid == true)
            ChassisStatusGrid.ClearChassisStatusGridData();
        if (this.state.WGSwitchAll.ReeferHistoryGrid == true)
            ReeferHistoryGrid.ClearHistoryGridData();
        if (this.state.WGSwitchAll.GensetHistoryGrid == true)
            GensetHistoryGrid.ClearHistoryGridData();
        if (this.state.WGSwitchAll.DryHistoryGrid == true)
            DryHistoryGrid.ClearHistoryGridData();
        if (this.state.WGSwitchAll.ChassisHistoryGrid == true)
            ChassisHistoryGrid.ClearHistoryGridData();
    }


    /* RCNG 13 start */
    ReeferStatusSummaryMA(isglobalLoaderToBeHidden: boolean) {
        if (this.state.WGSwitchAll.MicroaAlarms) {//RCNG-60
            isSaveLayout = true;
            this.setState({ loading: true });
            $('#microAlarmLoader').show();      
            var selectedAssetStates: any = this.state.SelectedAssetStatesMA;
            //if (selectedAssetStates == "")
            //    selectedAssetStates = "A,D,R";
            if (selectedAssetStates == "" || selectedAssetStates == null) {//RCNG-61
                PopupWindow.showErrorMessage('Error', "Please select Inventory State.");//RCNG-61           
                return;
            }
            $('#drop-down-inv-ma').css("display", "none");//WI RCNG-84
            var url = Config.ApiBaseUrl + '/api/reeferstatus/ReeferStatusSummaryMA?AssetState=' + selectedAssetStates;
            var request = RCUtils.FetchRequest(url, { method: 'GET', headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' } });

            fetch(request)
                .then(RCUtils.handleError)
                .then(response => response.json() as Promise<server.ReeferStatusSummaryModel>)
                .then(data => {
                    if (isglobalLoaderToBeHidden)
                        $('#globalLoader').hide();
                    var reeferSummaryMA = this.state.Reefersummary;
                    if (self.state.Filters.SelectedCargoCareProfiles != null && self.state.Filters.SelectedCargoCareProfiles != undefined
                        && self.state.Filters.SelectedCargoCareProfiles == "") {
                        reeferSummaryMA.MAMinor = data.MAMinor;
                        reeferSummaryMA.MASevere = data.MASevere;
                    }
                    this.setState({ Reefersummary: reeferSummaryMA, loading: false }, () => {
                        this.UpdateMAChart();
                        $('#microAlarmLoader').hide();                    });//RCNG-60
                });
        }
    }//RCNG-60
    /* RCNG 13 end */

    /* RCNG 14 start */
    ReeferStatusSummaryCC() {
        if (this.state.WGSwitchAll.CargoCare) {//RCNG-60
            this.setState({ loading: true });
            isSaveLayout = true;
            $('#cargoCareLoader').show();
            var selectedAssetStates: any = this.state.SelectedAssetStatesCC;
            //if (selectedAssetStates == "")
            //    selectedAssetStates = "A,D,R";
            if (selectedAssetStates == "" || selectedAssetStates == null) {//RCNG-61
                PopupWindow.showErrorMessage('Error', "Please select Inventory State.");//RCNG-61           
                return;
            }
            $('#drop-down-inv-cc').css("display", "none");//WI RCNG-84
            $('#CCProfileFilter').css("display", "none");
            //this.setState({ Reefersummary: reeferSummaryCC, loading: false }, () => { this.UpdateCargoChart(); });//RCNG-60
            //this.setState({ Reefersummary: reeferSummaryCC});//RCNG-60
            var url = Config.ApiBaseUrl + '/api/reeferstatus/CargoCareProfileAlerts?AssetState=' + selectedAssetStates;
            var request = RCUtils.FetchRequest(url, { method: 'GET', headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' } });
            RCUtils.fetchRetry(request)
                .then(RCUtils.handleResponse)
                .then(response => response.json() as Promise<any>)
                .then(CCdata => {
                    var filterCCProfileAlertssummary:any[] =[];
                    var selectedCargoCareProfiles: any = self.state.CargoCareProfilesSelected;
                    forEach(selectedCargoCareProfiles, function (value, key) {
                        var selectedCCProfiles = CCdata.filter(x => x.CargoCareCustomerProfileCode == value);
                        if(selectedCCProfiles.length>0){
                            filterCCProfileAlertssummary.push(selectedCCProfiles[0]);
                        }
                    });
                   
                    //$('#headerLoader').hide();
                    this.setState({ CargoCareProfileAlertssummary: filterCCProfileAlertssummary, DefaultCargoCareProfileAlertssummary: CCdata }, () => {
                        this.UpdateCargoChart();
                        //this.UpdateCharts();
                        this.setState({ loading: false }, () => {
                            $('#cargoCareLoader').hide();
                        });
                    });

                });

        }
    }//RCNG-60
    /* RCNG 14 end */
    TotalDryStatusSummary(isFromHistogram: any) {
        if (this.state.WGSwitchAll.TotalDrys || this.state.WGSwitchAll.DryHistogram) {//RCNG-60
            this.setState({ loading: true });  
            isSaveLayout = true;
            if (isFromHistogram == true)
                $('#totalDryFleetLoader').show();
            else
                $('#DryheaderLoader').show();       
            var selectedAssetStates: any = this.state.SelectedAssetStatesTotalDrys;
            if (selectedAssetStates == "" || selectedAssetStates == null) {
                PopupWindow.showErrorMessage('Error', "Please select Inventory State.");
                return;
            }
            //$('#drop-down-inv').css("display", "none");
            //$('#drop-down-inv-fleet-overview').css("display", "none");
            $('#drop-down-inv-TD').css("display", "none");//RCNG-1157
            $('#drop-down-inv-DFO').css("display", "none");//RCNG-1157
            var url = Config.ApiBaseUrl + '/api/Asset/DryStatusSummary?AssetState=' + selectedAssetStates;
            var request = RCUtils.FetchRequest(url, { method: 'GET', headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' } });

            fetch(request)
                .then(RCUtils.handleError)
                .then(response => response.json() as Promise<server.DryStatusSummaryModel>)
                .then(data => {
                    //$('#DryheaderLoader').hide();
                    this.setState({ Drysummary: data, loading: false }, () => {
                        this.UpdateDryCharts();
                        if (isFromHistogram == true)
                            $('#totalDryFleetLoader').hide();
                        else
                            $('#DryheaderLoader').hide();
                    });
                });
        }
    }
    TotalGensetStatusSummary(isFromHistogram: any) {
        if (this.state.WGSwitchAll.TotalGensets || this.state.WGSwitchAll.GensetHistogram) {
            isSaveLayout = true;
            this.setState({ loading: true });
            var selectedAssetStates: any = this.state.SelectedAssetStatesTotalGensets;
            if (selectedAssetStates == "" || selectedAssetStates == null) {
                PopupWindow.showErrorMessage('Error', "Please select Inventory State.");
                return;
            }
            //$('#drop-down-inv').css("display", "none");
            //$('#drop-down-inv-fleet-overview').css("display", "none");
            $('#drop-down-inv-TG').css("display", "none");//RCNG-1157
            $('#drop-down-inv-GFO').css("display", "none");//RCNG-1157
            //$('#globalLoader').show(); //RCNG-1452
            if (isFromHistogram == true)
                $('#totalGensetFleetLoader').show();
            else
                $('#GensetheaderLoader').show();
            
            var url = Config.ApiBaseUrl + '/api/Asset/GensetStatusSummary?AssetState=' + selectedAssetStates;
            var request = RCUtils.FetchRequest(url, { method: 'GET', headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' } });

            fetch(request)
                .then(RCUtils.handleError)
                .then(response => response.json() as Promise<server.GensetStatusSummaryModel>)
                .then(data => {

                    this.setState({ Gensetsummary: data, loading: false }, () => {
                        this.UpdateGensetCharts();
                        $('#globalLoader').hide();//RCNG-1452
                        if (isFromHistogram == true)
                            $('#totalGensetFleetLoader').hide();
                        else
                            $('#GensetheaderLoader').hide();
                    });
                });
        }
    }
    /* RCNG 17 start */
    ColdTreatmentTick(){
        if (this.state.WGSwitchAll.ColdTreatment) {
            $('#CTHeaderLoader').show();
            var selectedCCProfileId: any = self.state.CargoCareCTProfilesSelected.length > 0 ? self.state.CargoCareCTProfilesSelected : "0";
            var url = Config.ApiBaseUrl + '/api/reeferstatus/ReeferStatusSummaryCT?CCPProfile=' + selectedCCProfileId;
            var request = RCUtils.FetchRequest(url, { method: 'GET', headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' } });

            fetch(request)
                .then(RCUtils.handleError)
                .then(response => response.json() as Promise<server.CTUnitSummaryModel>)
                .then(data => {
                    $('#globalLoader').hide();
                    this.setState({ ColdTreatmentSummary: data, loading: false }, () => {
                        this.UpdateCTCharts();
                        $('#CTHeaderLoader').hide();
                    });
                });
        }        
    }
    TotalReeferStatusSummary(isFromHistogram:any) {
        if (this.state.WGSwitchAll.TotalReefers || this.state.WGSwitchAll.Histogram) {//RCNG-60
            isSaveLayout = true;
            this.setState({ loading: true });
            if (isFromHistogram == true)
                $('#totalReefersLoader').show();
            else
                $('#headerLoader').show();
            var selectedAssetStates: any = this.state.SelectedAssetStatesTotalReefers;
            //if (selectedAssetStates == "")
            //    selectedAssetStates = "A,D,R";
            if (selectedAssetStates == "" || selectedAssetStates == null) {//RCNG-61
                PopupWindow.showErrorMessage('Error', "Please select Inventory State.");//RCNG-61           
                return;
            }
            $('#drop-down-inv').css("display", "none");//WI RCNG-84
            $('#drop-down-inv-fleet-overview').css("display", "none");//WI RCNG-84
            var url = Config.ApiBaseUrl + '/api/reeferstatus/TotalReeferStatusSummary?AssetState=' + selectedAssetStates;
            var request = RCUtils.FetchRequest(url, { method: 'GET', headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' } });

            fetch(request)
                .then(RCUtils.handleError)
                .then(response => response.json() as Promise<server.ReeferStatusSummaryModel>)
                .then(data => {
                    $('#globalLoader').hide();
                    //$('#headerLoader').hide();//RCNG-60
                    var totalReeferSummary = this.state.Reefersummary;
                    totalReeferSummary.AllReefer = data.AllReefer;
                    totalReeferSummary.Running = data.Running;
                    totalReeferSummary.Stopped = data.Stopped;
                    totalReeferSummary.MissedRunning = data.MissedRunning;
                    totalReeferSummary.MissedStopped = data.MissedStopped;
                    this.setState({ Reefersummary: totalReeferSummary, loading: false }, () => {
                        this.UpdateHistogramCharts();//RCNG-60
                        if (isFromHistogram == true)
                            $('#totalReefersLoader').hide();
                        else
                            $('#headerLoader').hide();
                        //$('#CTHeaderLoader').hide();
                    });
                });
        }
    }//RCNG-60
    /* RCNG 17 end */

    /* start RCNG 16 */
    GetPTResultsByAssetState() {
        isSaveLayout = true;
        var selectedAssetStates: any = this.state.SelectedAssetStatesPTR;
        if (selectedAssetStates == "" || selectedAssetStates == null) {//RCNG-61
            PopupWindow.showErrorMessage('Error', "Please select Inventory State.");//RCNG-61           
            return;
        }
        $('#drop-down-inv-pti').css("display", "none");//WI RCNG-84
        PTResultGrid.GetPTResultsByAssetState(selectedAssetStates);
    }
    /* end RCNG 16 */

    ApplyChartCargocareFilters(category: any, name: any, color: any, selectedCCProfileCode: any) {
        if (category == undefined) {
            this.clearHistoryGridHeaders();
            this.ClearFilter(false);
            ReeferCallout.ResetMapPushpins(); //WI-26959
            totalWidgetSearch = true;//WI26412

            var statusfilters = [];

            if (name == CCLabelSevere) {
                statusfilters.push(ReeferStatusEnum.CCSevere);
            }
            else if (name == CCLabelMinor) {
                statusfilters.push(ReeferStatusEnum.CCMinor);
            }
            else if (name == CCLabelInformational) {
                statusfilters.push(ReeferStatusEnum.CCInformational);
            }

            var filters = this.state.Filters;
            filters.StatusFilters = statusfilters;
            if (name == CCLabelSevere || name == CCLabelMinor || name == CCLabelInformational)
                filters.SelectedAssetStates = this.state.SelectedAssetStatesCC;

            this.setState({
                Filters: filters
            });

            this.bindingReeferStatusGrid(filters,true);
        } else if (name == undefined) { // clicked on bar 
            this.clearHistoryGridHeaders();
            this.ClearFilter(false);
            ReeferCallout.ResetMapPushpins(); //WI-26959
            totalWidgetSearch = true;//WI26412

            var statusfilters = [];

            if (color == "#ff0000") {
                statusfilters.push(ReeferStatusEnum.CCSevere);
            }
            else if (color == "#2685cb") {
                statusfilters.push(ReeferStatusEnum.CCMinor);
            }
            else if (color == "#efb400") {
                statusfilters.push(ReeferStatusEnum.CCInformational);
            }
            var SelectedCCProfiles = self.state.CargoCareProfileAlertssummary.filter(x => x.CargoCareCustomerProfileCode == category);
            var filters = this.state.Filters;
            if (SelectedCCProfiles != null && SelectedCCProfiles != undefined && SelectedCCProfiles != '' && SelectedCCProfiles.length > 0) {
                filters.SelectedCargoCareProfiles = SelectedCCProfiles[0].CargoCareCustomerProfileID;
            }
            filters.StatusFilters = statusfilters;
            if (color == "#ff0000" || color == "#2685cb" || color == "#efb400")
                filters.SelectedAssetStates = this.state.SelectedAssetStatesCC;

            this.setState({
                Filters: filters
            });

            this.bindingReeferStatusGrid(filters,true);
        }
        else if (category == "CCPSearch") {
            this.clearHistoryGridHeaders();
            this.ClearFilter(false);
            ReeferCallout.ResetMapPushpins(); //WI-26959
            totalWidgetSearch = true;//WI26412

            var statusfilters = [];            
            var filters = this.state.Filters;
            filters.StatusFilters = statusfilters;

            var SelectedCCProfiles = self.state.CargoCareProfileAlertssummary.filter(x => x.CargoCareCustomerProfileCode == selectedCCProfileCode);
            if (SelectedCCProfiles != null && SelectedCCProfiles != undefined && SelectedCCProfiles != '' && SelectedCCProfiles.length > 0) {
                filters.SelectedCargoCareProfiles = SelectedCCProfiles[0].CargoCareCustomerProfileID;
                AdvanceSearch.UpdateAdvanceSearchFilters(SelectedCCProfiles[0].CargoCareCustomerProfileID);
            }            

            this.setState({
                Filters: filters
            });

            this.bindingReeferStatusGrid(filters);
        }
    }

    ApplyChartFilters(value, isFromMicroAlarmChart: boolean) {
        //this.setGridHeader('');
        this.clearHistoryGridHeaders();
        this.ClearFilter(isFromMicroAlarmChart);
        ReeferCallout.ResetMapPushpins(); //WI-26959
        totalWidgetSearch = true;//WI26412
        var filters = this.state.Filters; //RCNG5906-Added Profile Filter

        var statusfilters = [];
        if (value == "Running") {
            statusfilters.push(ReeferStatusEnum.Running);
        }
        else if (value == "Stopped") {
            statusfilters.push(ReeferStatusEnum.Stopped);
        }
        else if (value == "MissedRunning") {
            statusfilters.push(ReeferStatusEnum.MissedRunning);
        }
        else if (value == "MissedStopped") {
            statusfilters.push(ReeferStatusEnum.MissedStopped);
        }
        else if (value == "MASevere") {
            statusfilters.push(ReeferStatusEnum.MASevere);
        }
        else if (value == "MAMinor") {
            statusfilters.push(ReeferStatusEnum.MAMinor);
        }
        else if (value == "CCSevere") {
            statusfilters.push(ReeferStatusEnum.CCSevere);
        }
        else if (value == "CCMinor") {
            statusfilters.push(ReeferStatusEnum.CCMinor);
        }
        else if (value == "CCInformational") {
            statusfilters.push(ReeferStatusEnum.CCInformational);
        }
        else if (value == "OnTrip") {
            statusfilters.push(ReeferStatusEnum.OnTrip);
            filters.SelectedCTProfileIds = self.state.CargoCareCTProfilesSelected; //RCNG5906-Added Profile Filter
        }
        else if (value == "NotStarted") {
            statusfilters.push(ReeferStatusEnum.NotStarted);
            filters.SelectedCTProfileIds = self.state.CargoCareCTProfilesSelected; //RCNG5906-Added Profile Filter
        }
        else if (value == "Started") {
            statusfilters.push(ReeferStatusEnum.Started);
            filters.SelectedCTProfileIds = self.state.CargoCareCTProfilesSelected; //RCNG5906 - Added Profile Filter
        }
        else if (value == "Restarted") {
            statusfilters.push(ReeferStatusEnum.Restarted);
            filters.SelectedCTProfileIds = self.state.CargoCareCTProfilesSelected; //RCNG5906-Added Profile Filter
        }
        else if (value == "Failed") {
            statusfilters.push(ReeferStatusEnum.Failed);
            filters.SelectedCTProfileIds = self.state.CargoCareCTProfilesSelected; //RCNG5906-Added Profile Filter
        }
        else if (value == "Successful") {
            statusfilters.push(ReeferStatusEnum.Successful);
            filters.SelectedCTProfileIds = self.state.CargoCareCTProfilesSelected; //RCNG5906-Added Profile Filter
        }
        else if (value == "PowerOff") {
            statusfilters.push(ReeferStatusEnum.PowerOff);
            filters.SelectedCTProfileIds = self.state.CargoCareCTProfilesSelected; //RCNG5906-Added Profile Filter
        }
        //var filters = this.state.Filters;
        filters.StatusFilters = statusfilters;

        /* start RCNG 13*/
        if (value == "MASevere" || value == "MAMinor")
            filters.SelectedAssetStates = this.state.SelectedAssetStatesMA;
        /* start RCNG 13*/

        /* start RCNG 14*/
        if (value == "CCSevere" || value == "CCMinor" || value == "CCInformational")
            filters.SelectedAssetStates = this.state.SelectedAssetStatesCC;
        /* start RCNG 14*/

        /* start RCNG 17*/
        if (value == "Running" || value == "Stopped" || value == "MissedRunning" || value == "MissedStopped")
            filters.SelectedAssetStates = this.state.SelectedAssetStatesTotalReefers;
        /* start RCNG 17*/

        if (value === "MASevere" || value === "MAMinor")
            filters.SelectedCargoCareProfiles = this.state.Filters.SelectedCargoCareProfiles;



        this.setState({
            Filters: filters
        });

        if (!isFromMicroAlarmChart) {
            this.ReeferStatusSummaryMA(false);
        }

        this.bindingReeferStatusGrid(filters,false);
    }

    ApplyChartFiltersGenset(value, isFromMicroAlarmChart: boolean) {
        //this.setGridHeader('');
        this.clearHistoryGridHeaders();
        this.ClearFilter(isFromMicroAlarmChart);
        ReeferCallout.ResetMapPushpins(); //WI-26959
        var statusfilters = [];
        if (value == "PowerOnReporting") {
            statusfilters.push(ReeferStatusEnum.PowerOnReporting);
        }
        else if (value == "PowerOnNotReporting") {
            statusfilters.push(ReeferStatusEnum.PowerOnNotReporting);
        }
        else if (value == "PowerOffReporting") {
            statusfilters.push(ReeferStatusEnum.PowerOffReporting);
        }
        else if (value == "PowerOffNotReporting") {
            statusfilters.push(ReeferStatusEnum.PowerOffNotReporting);
        }

        var filters = this.state.Filters;
        filters.SelectedAssetStates = this.state.SelectedAssetStatesTotalGensets;//RCNG-1452
        filters.StatusFilters = statusfilters;
        this.setState({
            Filters: filters
        });

        this.bindingGensetStatusGrid(filters);

    }

    ApplyChartFiltersDry(value, isFromMicroAlarmChart: boolean) {
        //this.setGridHeader('');
        this.clearHistoryGridHeaders();
        this.ClearFilter(isFromMicroAlarmChart);
        ReeferCallout.ResetMapPushpins(); //WI-26959
        var statusfilters = [];
        if (value == "DryInGeofence") {
            statusfilters.push(ReeferStatusEnum.DryInGeofence);
        }
        else if (value == "DryOutGeofence") {
            statusfilters.push(ReeferStatusEnum.DryOutGeofence);
        }
        var filters = this.state.Filters;

        if (value == "DryInGeofence" || value == "DryOutGeofence")
            filters.SelectedAssetStates = this.state.SelectedAssetStatesTotalDrys;

        filters.StatusFilters = statusfilters;
        this.setState({
            Filters: filters
        });

        this.bindingDryStatusGrid(filters, false, false);
    }

    ApplyChartFiltersChassis(value, isFromMicroAlarmChart: boolean) {
        //this.setGridHeader('');
        this.clearHistoryGridHeaders();
        this.ClearFilter(isFromMicroAlarmChart);
        ReeferCallout.ResetMapPushpins(); //WI-26959
        var statusfilters = [];
        if (value == "ChassisPwrInGeofence") {
            statusfilters.push(ReeferStatusEnum.ChassisPwrInGeofence);
        }
        else if (value == "ChassisPwrOutGeofence") {
            statusfilters.push(ReeferStatusEnum.ChassisPwrOutGeofence);
        }
        else if (value == "ChassisNotPwrInGeofence") {
            statusfilters.push(ReeferStatusEnum.ChassisNotPwrInGeofence);
        }
        else if (value == "ChassisNotPwrOutGeofence") {
            statusfilters.push(ReeferStatusEnum.ChassisNotPwrOutGeofence);
        }
        var filters = this.state.Filters;
        filters.StatusFilters = statusfilters;
        this.setState({
            Filters: filters
        });

        this.bindingChassisStatusGrid(filters);
    }

    BindCharts() {
        var parent = this;
        setTimeout(function () {
            Highcharts.setOptions({
                lang: {
                    thousandsSep: ""
                },
                exporting: {
                    enabled: false
                }
            });
            //if (parent.chartHistogram != null) {
            //    parent.chartHistogram.destroy();
            //}
            var element = document.getElementById('chartHistogram');
            if (typeof (element) != 'undefined' && element != null) {

                parent.chartHistogram = Highcharts.chart('chartHistogram', {
                    chart: {
                        plotBackgroundColor: null,
                        plotBorderWidth: null,
                        plotShadow: false,
                        type: 'pie',
                        height: 280
                    },
                    title: {
                        text: ''
                    },
                    tooltip: {
                        pointFormat: '{series.name}: <b>{point.percentage:.1f}%</b>'
                    },
                    plotOptions: {
                        series: {
                            cursor: 'pointer',
                            events: {
                                click: function (event) {
                                    if (event.point != undefined) {
                                        parent.ApplyChartFilters(event.point['id'],false);
                                    }
                                }
                            }
                        },
                        pie: {
                            allowPointSelect: true,
                            cursor: 'pointer',
                            dataLabels: {
                                enabled: false
                            },
                            showInLegend: true
                        }
                    },
                    series: [{
                        name: 'Reefers',
                        data: [{ y: 1, id: '' }]
                    }]
                });
            }


            //if (parent.chartmicro != null) {
            //    parent.chartmicro.destroy();
            //}

            var element = document.getElementById('chartmicro');
            if (typeof (element) != 'undefined' && element != null) {
                parent.chartmicro = Highcharts.chart('chartmicro', {
                    chart: {
                        type: 'pie',
                        height: 196,
                        options3d: {
                            enabled: true,
                            alpha: 45,
                            beta: 0,
                        }
                    },
                    title: {
                        text: '',
                        style: {
                            left: '0px',
                            top: '0px',
                        }
                    },
                    plotOptions: {
                        series: {
                            cursor: 'pointer',
                            events: {
                                click: function (event) {
                                    if (event.point != undefined) {
                                        parent.ApplyChartFilters(event.point['id'],false);
                                    }
                                }
                            }
                        },
                        pie: {
                            dataLabels: {
                                enabled: false,
                                distance: -50,
                                style: {
                                    fontWeight: 'bold',
                                    color: 'white'
                                }
                            },
                            innerSize: '60%',
                        }
                    },
                    series: [{
                        name: 'Reefers',
                        data: [{ y: 1, id: '' }]
                    }]
                });
            }

            //check
            //if (parent.chartcargo != null) {
            //    parent.chartcargo.destroy();
            //}
            var element = document.getElementById('chartcargo');
            if (typeof (element) != 'undefined' && element != null) {
                if (isSOLogedin) {
                    parent.chartcargo = Highcharts.chart('chartcargo', {
                        chart: {
                            type: 'pie',
                            height: 196,
                            options3d: {
                                enabled: true,
                                alpha: 45,
                                beta: 0,
                            }
                        },
                        title: {
                            text: '',
                            align: 'center',
                            verticalAlign: 'middle',
                            y: 40
                        },
                        plotOptions: {
                            series: {
                                cursor: 'pointer',
                                events: {
                                    click: function (event) {
                                        if (event.point != undefined) {
                                            parent.ApplyChartCargocareFilters(event.point.category, event.point.name, event.point['color'], "");
                                        }
                                    }
                                }
                            },
                            pie: {
                                dataLabels: {
                                    enabled: false,
                                    distance: -50,
                                    style: {
                                        fontWeight: 'bold',
                                        color: 'white'
                                    }
                                },
                                innerSize: '60%',
                            }
                        },
                        series: [{
                            name: 'Alerts',
                            data: [{
                                name: CCLabelSevere,
                                y: self.GetSumByCCAlertData(self.state.CargoCareProfileAlertssummary.map(x => x.CCSevere)),
                                color: '#ff0000'
                            }, {
                                name: CCLabelMinor,
                                y: self.GetSumByCCAlertData(self.state.CargoCareProfileAlertssummary.map(x => x.CCMinor)), // self.state.Reefersummary.CCMinor,
                                color: '#2685cb'
                            }, {
                                name: CCLabelInformational,
                                y: self.GetSumByCCAlertData(self.state.CargoCareProfileAlertssummary.map(x => x.CCInformational)), //self.state.Reefersummary.CCInformational,
                                color: '#efb400'
                            }]
                        }]
                    });

                } else {

                    if (typeof (self.state.CargoCareProfileAlertssummary) != 'undefined' && self.state.CargoCareProfileAlertssummary != null && self.state.CargoCareProfileAlertssummary.length > 1) {
                        parent.chartcargo = Highcharts.chart('chartcargo', {
                            chart: {
                                renderTo: 'chartcargo',
                                reflow: true
                            },
                            title: {
                                text: '',
                            },
                            xAxis: {
                                categories: self.state.CargoCareProfileAlertssummary.map(x => x.CargoCareCustomerProfileCode)
                            },
                            yAxis: {
                                maxPadding: 1,
                                min: 0,
                                title: {
                                    text: 'Active Alert Counts'
                                },
                            },
                            plotOptions: {
                                column: {
                                    showInLegend: false,
                                    events: {
                                        click: function (event) {
                                            if (event.point != undefined) {
                                                parent.ApplyChartCargocareFilters(event.point.category, event.point.name, event.point['color'], "");
                                            }
                                        }
                                    }
                                },
                                pie: {
                                    dataLabels: {
                                        enabled: false,
                                    },
                                    size: '30%',
                                    showInLegend: false,
                                    center: [100, 60],
                                    events: {
                                        click: function (event) {
                                            if (event.point != undefined) {
                                                parent.ApplyChartCargocareFilters(event.point.category, event.point.name, event.point['color'], "");
                                            }
                                        }
                                    }
                                },
                                series: {
                                    cursor: 'pointer',
                                }
                            },
                            labels: {
                                items: [{
                                    html: 'All Alerts by Severity',
                                    style: {
                                        left: '58px',
                                        top: '0px',
                                        color: 'black'
                                    }
                                }]
                            },
                            series: [{
                                type: 'column',
                                name: CCLabelSevere,
                                color: '#ff0000',
                                data: self.state.CargoCareProfileAlertssummary.map(x => x.CCSevere)
                            }, {
                                type: 'column',
                                name: CCLabelMinor,
                                color: '#2685cb',
                                data: self.state.CargoCareProfileAlertssummary.map(x => x.CCMinor)
                            }, {
                                type: 'column',
                                name: CCLabelInformational,
                                color: '#efb400',
                                data: self.state.CargoCareProfileAlertssummary.map(x => x.CCInformational)
                            },
                            {
                                type: 'pie',
                                name: 'Alerts',
                                data: [{
                                    name: CCLabelSevere,
                                    y: self.GetSumByCCAlertData(self.state.CargoCareProfileAlertssummary.map(x => x.CCSevere)),
                                    color: '#ff0000'
                                }, {
                                    name: CCLabelMinor,
                                    y: self.GetSumByCCAlertData(self.state.CargoCareProfileAlertssummary.map(x => x.CCMinor)), // self.state.Reefersummary.CCMinor,
                                    color: '#2685cb'
                                }, {
                                    name: CCLabelInformational,
                                    y: self.GetSumByCCAlertData(self.state.CargoCareProfileAlertssummary.map(x => x.CCInformational)), //self.state.Reefersummary.CCInformational,
                                    color: '#efb400'
                                }],
                            }]
                        });
                    } else if (typeof (self.state.CargoCareProfileAlertssummary) != 'undefined' && self.state.CargoCareProfileAlertssummary != null && self.state.CargoCareProfileAlertssummary.length == 1) {
                        parent.chartcargo = Highcharts.chart('chartcargo', {
                            chart: {
                                renderTo: 'chartcargo',
                            },
                            title: {
                                text: '',
                            },
                            xAxis: {
                                categories: self.state.CargoCareProfileAlertssummary.map(x => x.CargoCareCustomerProfileCode)
                            },
                            yAxis: {
                                title: {
                                    text: 'Active Alert Counts'
                                },
                            },
                            plotOptions: {
                                column: {
                                    showInLegend: false,
                                    events: {
                                        click: function (event) {
                                            if (event.point != undefined) {
                                                parent.ApplyChartCargocareFilters(event.point.category, event.point.name, event.point['color']);
                                            }
                                        }
                                    }
                                },
                                series: {
                                    cursor: 'pointer',
                                }
                            },

                            series: [{
                                type: 'column',
                                name: CCLabelSevere,
                                color: '#ff0000',
                                data: self.state.CargoCareProfileAlertssummary.map(x => x.CCSevere)
                            }, {
                                type: 'column',
                                name: CCLabelMinor,
                                color: '#2685cb',
                                data: self.state.CargoCareProfileAlertssummary.map(x => x.CCMinor)
                            }, {
                                type: 'column',
                                name: CCLabelInformational,
                                color: '#efb400',
                                data: self.state.CargoCareProfileAlertssummary.map(x => x.CCInformational)
                            },
                            ]
                        });
                        parent.chartcargo.xAxis[0].labelGroup.element.childNodes.forEach(function (label) {
                            label.style.cursor = "pointer";
                            label.onclick = function () {
                                parent.ApplyChartCargocareFilters("CCPSearch", "", "", this.textContent);
                                //alert('You clicked on ' + this.textContent);
                            }
                        });

                    } else {
                        $('#chartcargo').html("<div class='fleet-temp'>No Data Available for CargoCare Alerts - Fleet</div>"); //WI26386 Added Alarms
                    }
                }
            }

            parent.UpdateCharts(true);//Consider this as first tick.
        }, 10);
    }

    /*RCNG 55 start*/
    BindIndividualChart(chartName: any) {
        var parent = this;
        /*  setTimeout(function () RCNG 141{*/
        Highcharts.setOptions({
            lang: {
                thousandsSep: ""
            },
            exporting: {
                enabled: false
            }
        });
        if (chartName == 'chartmicro') {
            var element = document.getElementById(chartName);
            if (typeof (element) != 'undefined' && element != null) {
                parent.chartmicro = Highcharts.chart('chartmicro', {
                    chart: {
                        type: 'pie',
                        height: 196,
                        options3d: {
                            enabled: true,
                            alpha: 45,
                            beta: 0,
                        }
                    },
                    title: {
                        text: '',
                        style: {
                            left: '0px',
                            top: '0px',
                        }
                    },
                    plotOptions: {
                        series: {
                            cursor: 'pointer',
                            events: {
                                click: function (event) {
                                    if (event.point != undefined) {
                                        parent.ApplyChartFilters(event.point['id'],true);
                                    }
                                }
                            }
                        },
                        pie: {
                            dataLabels: {
                                enabled: false,
                            },
                            innerSize: '60%',
                        }
                    },
                    series: [{
                        name: 'Reefers',
                        data: [{ y: 1, id: '' }]
                    }]
                });
            }
        }
        else if (chartName == 'chartcargo') {
            var element = document.getElementById('chartcargo');
            if (typeof (element) != 'undefined' && element != null) {
                if (isSOLogedin) {
                    parent.chartcargo = Highcharts.chart('chartcargo', {
                        chart: {
                            type: 'pie',
                            height: 196,
                            options3d: {
                                enabled: true,
                                alpha: 45,
                                beta: 0,
                            }
                        },
                        title: {
                            text: '',
                            align: 'center',
                            verticalAlign: 'middle',
                            y: 40
                        },
                        plotOptions: {
                            series: {
                                cursor: 'pointer',
                                events: {
                                    click: function (event) {
                                        if (event.point != undefined) {
                                            parent.ApplyChartCargocareFilters(event.point.category, event.point.name, event.point['color']);
                                        }
                                    }
                                }
                            },
                            pie: {
                                dataLabels: {
                                    enabled: false,
                                    distance: -50,
                                    style: {
                                        fontWeight: 'bold',
                                        color: 'white'
                                    }
                                },
                                innerSize: '60%',
                            }
                        },
                        series: [{
                            name: 'Alerts',
                            data: [{
                                name: CCLabelSevere,
                                y: self.GetSumByCCAlertData(self.state.CargoCareProfileAlertssummary.map(x => x.CCSevere)),
                                color: '#ff0000'
                            }, {
                                name: CCLabelMinor,
                                y: self.GetSumByCCAlertData(self.state.CargoCareProfileAlertssummary.map(x => x.CCMinor)), // self.state.Reefersummary.CCMinor,
                                color: '#2685cb'
                            }, {
                                name: CCLabelInformational,
                                y: self.GetSumByCCAlertData(self.state.CargoCareProfileAlertssummary.map(x => x.CCInformational)), //self.state.Reefersummary.CCInformational,
                                color: '#efb400'
                            }]
                        }]
                    });

                }
                else {

                    if (typeof (self.state.CargoCareProfileAlertssummary) != 'undefined' && self.state.CargoCareProfileAlertssummary != null && self.state.CargoCareProfileAlertssummary.length > 1) {
                        parent.chartcargo = Highcharts.chart('chartcargo', {
                            chart: {
                                renderTo: 'chartcargo',
                                reflow: true
                            },
                            title: {
                                text: '',
                            },
                            xAxis: {
                                categories: self.state.CargoCareProfileAlertssummary.map(x => x.CargoCareCustomerProfileCode)
                            },
                            yAxis: {
                                maxPadding: 1,
                                min: 0,
                                title: {
                                    text: 'Active Alert Counts'
                                },
                            },
                            plotOptions: {
                                column: {
                                    showInLegend: false,
                                    events: {
                                        click: function (event) {
                                            if (event.point != undefined) {
                                                parent.ApplyChartCargocareFilters(event.point.category, event.point.name, event.point['color']);
                                            }
                                        }
                                    }
                                },
                                pie: {
                                    dataLabels: {
                                        enabled: false,
                                    },
                                    showInLegend: false,
                                    size: '30%',
                                    center: [100, 60],
                                    events: {
                                        click: function (event) {
                                            if (event.point != undefined) {
                                                parent.ApplyChartCargocareFilters(event.point.category, event.point.name, event.point['color']);
                                            }
                                        }
                                    }
                                },
                                series: {
                                    cursor: 'pointer',
                                }
                            },
                            labels: {
                                items: [{
                                    html: 'All Alerts by Severity',
                                    style: {
                                        left: '58px',
                                        top: '0px',
                                        color: 'black'
                                    }
                                }]
                            },
                            series: [{
                                type: 'column',
                                name: CCLabelSevere,
                                color: '#ff0000',
                                data: self.state.CargoCareProfileAlertssummary.map(x => x.CCSevere)
                            }, {
                                type: 'column',
                                name: CCLabelMinor,
                                color: '#2685cb',
                                data: self.state.CargoCareProfileAlertssummary.map(x => x.CCMinor)
                            }, {
                                type: 'column',
                                name: CCLabelInformational,
                                color: '#efb400',
                                data: self.state.CargoCareProfileAlertssummary.map(x => x.CCInformational)
                            },
                            {
                                type: 'pie',
                                name: 'Alerts',
                                data: [{
                                    name: CCLabelSevere,
                                    y: self.GetSumByCCAlertData(self.state.CargoCareProfileAlertssummary.map(x => x.CCSevere)),// self.state.Reefersummary.CCSevere,
                                    color: '#ff0000'
                                }, {
                                    name: CCLabelMinor,
                                    y: self.GetSumByCCAlertData(self.state.CargoCareProfileAlertssummary.map(x => x.CCMinor)), //self.state.Reefersummary.CCMinor,
                                    color: '#2685cb'
                                }, {
                                    name: CCLabelInformational,
                                    y: self.GetSumByCCAlertData(self.state.CargoCareProfileAlertssummary.map(x => x.CCInformational)),// self.state.Reefersummary.CCInformational,
                                    color: '#efb400'
                                }],
                            }]
                        });
                        parent.chartcargo.xAxis[0].labelGroup.element.childNodes.forEach(function (label) {
                            label.style.cursor = "pointer";
                            label.onclick = function () {
                                parent.ApplyChartCargocareFilters("CCPSearch", "", "", this.textContent);
                                //alert('You clicked on ' + this.textContent);
                            }
                        });
                    } else {
                        parent.chartcargo = Highcharts.chart('chartcargo', {
                            chart: {
                                renderTo: 'chartcargo',
                            },
                            title: {
                                text: '',
                            },
                            xAxis: {
                                categories: self.state.CargoCareProfileAlertssummary.map(x => x.CargoCareCustomerProfileCode)
                            },
                            plotOptions: {
                                column: {
                                    showInLegend: false,
                                    events: {
                                        click: function (event) {
                                            if (event.point != undefined) {
                                                parent.ApplyChartCargocareFilters(event.point.category, event.point.name, event.point['color']);
                                            }
                                        }
                                    }
                                },
                                series: {
                                    cursor: 'pointer',
                                }
                            },

                            series: [{
                                type: 'column',
                                name: CCLabelSevere,
                                color: '#ff0000',
                                data: self.state.CargoCareProfileAlertssummary.map(x => x.CCSevere)
                            }, {
                                type: 'column',
                                name: CCLabelMinor,
                                color: '#2685cb',
                                data: self.state.CargoCareProfileAlertssummary.map(x => x.CCMinor)
                            }, {
                                type: 'column',
                                name: CCLabelInformational,
                                color: '#efb400',
                                data: self.state.CargoCareProfileAlertssummary.map(x => x.CCInformational)
                            },
                            ]
                        });
                        parent.chartcargo.xAxis[0].labelGroup.element.childNodes.forEach(function (label) {
                            label.style.cursor = "pointer";
                            label.onclick = function () {
                                parent.ApplyChartCargocareFilters("CCPSearch", "", "", this.textContent);
                                //alert('You clicked on ' + this.textContent);
                            }
                        });
                    }
                }
            }
        }
        else if (chartName == 'chartHistogram') {
            var element = document.getElementById('chartHistogram');
            if (typeof (element) != 'undefined' && element != null) {

                parent.chartHistogram = Highcharts.chart('chartHistogram', {
                    chart: {
                        plotBackgroundColor: null,
                        plotBorderWidth: null,
                        plotShadow: false,
                        type: 'pie',
                        height: 280
                    },
                    title: {
                        text: ''
                    },
                    tooltip: {
                        pointFormat: '{series.name}: <b>{point.percentage:.1f}%</b>'
                    },
                    plotOptions: {
                        series: {
                            cursor: 'pointer',
                            events: {
                                click: function (event) {
                                    if (event.point != undefined) {
                                        parent.ApplyChartFilters(event.point['id'],false);
                                    }
                                }
                            }
                        },
                        pie: {
                            allowPointSelect: true,
                            cursor: 'pointer',
                            dataLabels: {
                                enabled: false
                            },
                            showInLegend: true
                        }
                    },
                    series: [{
                        name: 'Reefers',
                        data: [{ y: 1, id: '' }]
                    }]
                });
            }
        }

        // parent.UpdateCharts();
        /*   }, 10);*/

    }
    /*RCNG 55 end*/

    UpdateCharts(isViaTick: any) {
        if (this.chartHistogram != undefined && this.chartHistogram != null
            && this.chartHistogram.series != undefined && this.chartHistogram.series[0] != undefined) {
            /*RCNG 141*/
            if (this.state.Reefersummary.Running == 0 && this.state.Reefersummary.Stopped == 0 && this.state.Reefersummary.MissedRunning == 0
                && this.state.Reefersummary.MissedStopped == 0) {
                /*RCNG 55 start*/
                //this.chartHistogram.destroy();
                /*RCNG 55 end*/
                $('#chartHistogram').html("<div class='fleet-temp'>No Data Available for Reefer Fleet</div>"); //WI26386 renamed Reefers to Reefer
            }
            else {
                var chartHistogram = 'chartHistogram';
                this.BindIndividualChart(chartHistogram);
            }
            this.chartHistogram.series[0].setData([
                {
                    name: 'Operational Reefers, Running',
                    id: 'Running',
                    y: this.state.Reefersummary.Running,
                    color: '#3ea538',
                    sliced: true,
                    selected: true
                }, {
                    name: 'Faulty Reefers, Possibly Shut Down',
                    id: 'Stopped',
                    y: this.state.Reefersummary.Stopped,
                    color: '#fd7800'
                },
                {
                    name: 'Reefers on Standby',
                    id: 'MissedRunning',
                    y: this.state.Reefersummary.MissedRunning,
                    color: '#615f60'
                }, {
                    name: 'Reefers Offline or Powered Down',
                    id: 'MissedStopped',
                    y: this.state.Reefersummary.MissedStopped,
                    color: '#dfdfdf'
                }
            ]);

        }

        $('#totalReefersLoader').hide();
        if (this.chartmicro != undefined && this.chartmicro != null
            && this.chartmicro.series != undefined && this.chartmicro.series[0] != undefined) {
            /*RCNG 141*/
            if (this.state.Reefersummary.MASevere == 0 && this.state.Reefersummary.MAMinor == 0) {
                /*RCNG 55 start*/
                //this.chartmicro.destroy();            
                /*RCNG 55 end*/
                $('#chartmicro').html("<div class='fleet-temp'>No Data Available for Reefers with Alarms – Fleet </div>");
            }
            else if (isViaTick == true) {
                //else {
                var chartMicro = 'chartmicro';
                this.BindIndividualChart(chartMicro);
                //   }
                this.chartmicro.series[0].setData([
                    {
                        name: ReeferAlarmLabelSevere,
                        id: 'MASevere',
                        y: this.state.Reefersummary.MASevere,
                        color: '#ff0000'
                    },
                    {
                        name: ReeferAlarmLabelMinor,
                        id: 'MAMinor',
                        y: this.state.Reefersummary.MAMinor,
                        color: '#2685cb'
                    },
                ]);

            }
            else {
                if (self.state.Filters.SelectedCargoCareProfiles != null && self.state.Filters.SelectedCargoCareProfiles != undefined
                    && self.state.Filters.SelectedCargoCareProfiles == "") {
                    var chartMicro = 'chartmicro';
                    this.BindIndividualChart(chartMicro);
                    //   }
                    this.chartmicro.series[0].setData([
                        {
                            name: ReeferAlarmLabelSevere,
                            id: 'MASevere',
                            y: this.state.Reefersummary.MASevere,
                            color: '#ff0000'
                        },
                        {
                            name: ReeferAlarmLabelMinor,
                            id: 'MAMinor',
                            y: this.state.Reefersummary.MAMinor,
                            color: '#2685cb'
                        },
                    ]);
                }
            }

        }

        $('#microAlarmLoader').hide();

        if (this.chartcargo != undefined && this.chartcargo != null
            && this.chartcargo.series != undefined && this.chartcargo.series[0] != undefined) {
            /*RCNG 141*/
            if (this.state.Reefersummary.CCSevere == 0 && this.state.Reefersummary.CCMinor == 0 && this.state.Reefersummary.CCInformational == 0 && this.state.CargoCareProfileAlertssummary != null && this.state.CargoCareProfileAlertssummary != undefined && this.state.CargoCareProfileAlertssummary.length > 0) {
                /*RCNG 55 start*/
                //this.chartcargo.destroy(); //why remove all series, while you can remove chart to free some space and resources 
                /*RCNG 55 end*/
                $('#chartcargo').html("<div class='fleet-temp'>No Data Available for CargoCare Alerts - Fleet</div>"); //WI26386 Added Alarms
                //this.chartcargo.showLoading('No data to display');
            }
            else {
                var chartcargo = 'chartcargo';
                this.BindIndividualChart(chartcargo);
            }
            //this.chartcargo.series[0].setData([
            //    {
            //        name: 'Severe',
            //        id: 'CCSevere',
            //        y: this.state.Reefersummary.CCSevere,
            //        color: '#ff0000'
            //    },
            //    {
            //        name: 'Minor',
            //        id: 'CCMinor',
            //        y: this.state.Reefersummary.CCMinor,
            //        color: '#2685cb'
            //    },
            //    {
            //        name: 'Informational',
            //        id: 'CCInformational',
            //        y: this.state.Reefersummary.CCInformational,
            //        color: '#efb400'
            //    }
            //]);

        }

        setTimeout(() => {
            $('#cargoCareLoader').hide();
        }, 200);
    }
    //start RCNG-60
    UpdateCargoChart() {
        if (this.chartcargo != undefined && this.chartcargo != null
            && this.chartcargo.series != undefined && this.chartcargo.series[0] != undefined) {
            /*RCNG 141*/
            if (this.state.Reefersummary.CCSevere == 0 && this.state.Reefersummary.CCMinor == 0 && this.state.Reefersummary.CCInformational == 0 && this.state.CargoCareProfileAlertssummary != null && this.state.CargoCareProfileAlertssummary != undefined && this.state.CargoCareProfileAlertssummary.length > 0) {
                /*RCNG 55 start*/
                //this.chartcargo.destroy(); //why remove all series, while you can remove chart to free some space and resources            


                /*RCNG 55 end*/
                $('#chartcargo').html("<div class='fleet-temp'>No Data Available for CargoCare Alerts - Fleet</div>"); //WI26386 Added Alarms
                //this.chartcargo.showLoading('No data to display');
            }
            else {
                var chartcargo = 'chartcargo';
                this.BindIndividualChart(chartcargo);
            }

            //this.chartcargo.series[0].setData([
            //    {
            //        name: 'Severe',
            //        id: 'CCSevere',
            //        y: this.state.Reefersummary.CCSevere,
            //        color: '#ff0000'
            //    },
            //    {
            //        name: 'Minor',
            //        id: 'CCMinor',
            //        y: this.state.Reefersummary.CCMinor,
            //        color: '#2685cb'
            //    },
            //    {
            //        name: 'Informational',
            //        id: 'CCInformational',
            //        y: this.state.Reefersummary.CCInformational,
            //        color: '#efb400'
            //    }
            //]);

        }

        //setTimeout(() => {
        //    $('#cargoCareLoader').hide();
        //}, 200);
    }
    UpdateMAChart() {
        if (this.chartmicro != undefined && this.chartmicro != null
            && this.chartmicro.series != undefined && this.chartmicro.series[0] != undefined) {
            /*RCNG 141*/
            if (this.state.Reefersummary.MASevere == 0 && this.state.Reefersummary.MAMinor == 0) {
                //this.chartmicro.destroy();
                $('#chartmicro').html("<div class='fleet-temp'>No Data Available for Reefers with Alarms – Fleet </div>");
            }
            else {
                var chartMicro = 'chartmicro';
                this.BindIndividualChart(chartMicro);
            }
                this.chartmicro.series[0].setData([
                    {
                        name: ReeferAlarmLabelSevere,
                        id: 'MASevere',
                        y: this.state.Reefersummary.MASevere,
                        color: '#ff0000'
                    },
                    {
                        name: ReeferAlarmLabelMinor,
                        id: 'MAMinor',
                        y: this.state.Reefersummary.MAMinor,
                        color: '#2685cb'
                    },
                ]);
            }
        
        $('#microAlarmLoader').hide();
    }

    renderAlarmWidgetIfCCPSelected(MASevere: any, MAMinor: any) {

        if (self.state.Reefersummary != null && self.state.Reefersummary != undefined) {

            var totalReeferSummary = self.state.Reefersummary;
            totalReeferSummary.MASevere = MASevere;
            totalReeferSummary.MAMinor = MAMinor;
            self.setState({ Reefersummary: totalReeferSummary }, () => {
                self.UpdateMAChart();
            });

        }
    }

    UpdateHistogramCharts() {
        if (this.chartHistogram != undefined && this.chartHistogram != null
            && this.chartHistogram.series != undefined && this.chartHistogram.series[0] != undefined) {
            /*RCNG 141*/
            if (this.state.Reefersummary.Running == 0 && this.state.Reefersummary.Stopped == 0 && this.state.Reefersummary.MissedRunning == 0
                && this.state.Reefersummary.MissedStopped == 0) {
                //this.chartHistogram.destroy();
                $('#chartHistogram').html("<div class='fleet-temp'>No Data Available for Reefer Fleet</div>"); //WI26386 renamed Reefers to Reefer
            }
            else {
                var chartHistogram = 'chartHistogram';
                this.BindIndividualChart(chartHistogram);
            }
            this.chartHistogram.series[0].setData([
                {
                    name: 'Operational Reefers, Running',
                    id: 'Running',
                    y: this.state.Reefersummary.Running,
                    color: '#3ea538',
                    sliced: true,
                    selected: true
                }, {
                    name: 'Faulty Reefers, Possibly Shut Down',
                    id: 'Stopped',
                    y: this.state.Reefersummary.Stopped,
                    color: '#fd7800'
                },
                {
                    name: 'Reefers on Standby',
                    id: 'MissedRunning',
                    y: this.state.Reefersummary.MissedRunning,
                    color: '#615f60'
                }, {
                    name: 'Reefers Offline or Powered Down',
                    id: 'MissedStopped',
                    y: this.state.Reefersummary.MissedStopped,
                    color: '#dfdfdf'
                }
            ]);


        }

        $('#totalReefersLoader').hide();
    }

    BindColdTreatmentChart() {
        var parent = this;
        setTimeout(function () {
            Highcharts.setOptions({
                lang: {
                    thousandsSep: ""
                },
                exporting: {
                    enabled: false
                }
            });
            var element = document.getElementById('chartcoldtreatment');
            if (typeof (element) != 'undefined' && element != null) {
                parent.chartColdtreatment = Highcharts.chart('chartcoldtreatment', {
                    chart: {
                        plotBackgroundColor: null,
                        plotBorderWidth: null,
                        plotShadow: false,
                        type: 'column',
                        height: 280
                    },
                    title: {
                        text: ''
                    },  
                    xAxis: {
                        type: 'category'
                    },
                    yAxis: {
                        title: {
                            text: 'Cold Treatment counts'
                        }

                    },
                    tooltip: {
                        pointFormat: ': <b>{point.y}</b>'
                    },
                    legend: {
                        enabled: false
                    },
                    plotOptions: {
                        series: {
                            cursor: 'pointer',
                            events: {
                                click: function (event) {
                                    if (event.point != undefined) {
                                        parent.ApplyChartFilters(event.point['id']);
                                    }
                                }
                            }
                        },                        
                    },
                    series: [{
                        name: 'ColdTreatment',
                        //colorByPoint: true,
                        data: [{ y: 1, id: '' }]
                    }]
                });
             }
            parent.UpdateCTCharts();
        }, 10);
    }
    //end RCNG-60
    BindGensetCharts() {
        var parent = this;
        setTimeout(function () {
            Highcharts.setOptions({
                lang: {
                    thousandsSep: ""
                },
                exporting: {
                    enabled: false
                }
            });
            var element = document.getElementById('chartGensetHistogram');
            if (typeof (element) != 'undefined' && element != null) {

                parent.chartGensetHistogram = Highcharts.chart('chartGensetHistogram', {
                    chart: {
                        plotBackgroundColor: null,
                        plotBorderWidth: null,
                        plotShadow: false,
                        type: 'pie',
                        height: 280
                    },
                    title: {
                        text: ''
                    },
                    tooltip: {
                        pointFormat: ': <b>{point.percentage:.1f}%</b>'
                    },
                    plotOptions: {
                        series: {
                            cursor: 'pointer',
                            events: {
                                click: function (event) {
                                    if (event.point != undefined) {
                                        parent.ApplyChartFiltersGenset(event.point['id']);
                                    }
                                }
                            }
                        },
                        pie: {
                            allowPointSelect: true,
                            cursor: 'pointer',
                            dataLabels: {
                                enabled: false
                            },
                            showInLegend: true
                        }
                    },
                    series: [{
                        name: 'Gensets',
                        data: [{ y: 1, id: '' }]
                    }]
                });
            }
            parent.UpdateGensetCharts();
        }, 10);
    }

    BindDryCharts() {
        var parent = this;
        setTimeout(function () {
            Highcharts.setOptions({
                lang: {
                    thousandsSep: ""
                },
                exporting: {
                    enabled: false
                }
            });
            var element = document.getElementById('chartDryHistogram');
            if (typeof (element) != 'undefined' && element != null) {

                parent.chartDryHistogram = Highcharts.chart('chartDryHistogram', {
                    chart: {
                        plotBackgroundColor: null,
                        plotBorderWidth: null,
                        plotShadow: false,
                        type: 'pie',
                        height: 248
                    },
                    title: {
                        text: ''
                    },
                    tooltip: {
                        pointFormat: ': <b>{point.percentage:.1f}%</b>'
                    },
                    plotOptions: {
                        series: {
                            cursor: 'pointer',
                            events: {
                                click: function (event) {
                                    if (event.point != undefined) {
                                        parent.ApplyChartFiltersDry(event.point['id']);
                                        //if (event.point['id'] == 'DryInGeofence' && self.state.Drysummary.InGeofence < 1000)
                                        //    parent.ApplyChartFiltersDry(event.point['id']);
                                        //else if (event.point['id'] == 'DryOutGeofence' && self.state.Drysummary.OutGeofence < 1000)
                                        //    parent.ApplyChartFiltersDry(event.point['id']);
                                        //else
                                        //    event.preventDefault();
                                    }
                                }
                            }
                        },
                        pie: {
                            allowPointSelect: true,
                            cursor: 'pointer',
                            dataLabels: {
                                enabled: false
                            },
                            showInLegend: true
                        }
                    },
                    series: [{
                        name: 'Drys',
                        data: [{ y: 1, id: '' }]
                    }]
                });
            }
            parent.UpdateDryCharts();
        }, 10);
    }

    UpdateCTCharts() {
        if (this.chartColdtreatment != undefined && this.chartColdtreatment != null
            && this.chartColdtreatment.series != undefined && this.chartColdtreatment.series[0] != undefined) {
            this.chartColdtreatment.series[0].setData([
                {
                    name: 'On Trip',
                    id: 'OnTrip',
                    y: this.state.ColdTreatmentSummary.OnTrip,
                    color: '#045976',
                }, {
                    name: 'Not Started',
                    id: 'NotStarted',
                    y: this.state.ColdTreatmentSummary.NotStarted,
                    color: '#00a8ff'
                },
                {
                    name: 'Started',
                    id: 'Started',
                    y: this.state.ColdTreatmentSummary.Started,
                    color: '#fd7800'
                },
                {
                    name: 'Restarted',
                    id: 'Restarted',
                    y: this.state.ColdTreatmentSummary.Restarted,
                    color: '#615f60'
                },
                {
                    name: 'Failed',
                    id: 'Failed',
                    y: this.state.ColdTreatmentSummary.Failed,
                    color: '#ff0000'
                },
                {
                    name: 'Successful',
                    id: 'Successful',
                    y: this.state.ColdTreatmentSummary.Successful,
                    color: '#3ea538'
                },
                {
                    name: 'Power Off',
                    id: 'PowerOff',
                    y: this.state.ColdTreatmentSummary.PowerOff,
                    color: '#dfdfdf'
                }
                
            ]);

            if (this.state.ColdTreatmentSummary.OnTrip == 0 && this.state.ColdTreatmentSummary.NotStarted == 0 && this.state.ColdTreatmentSummary.Started == 0
                && this.state.ColdTreatmentSummary.Restarted == 0 && this.state.ColdTreatmentSummary.Failed == 0 && this.state.ColdTreatmentSummary.Successful == 0
                && this.state.ColdTreatmentSummary.PowerOff == 0) {
                this.chartColdtreatment.destroy();
                $('#chartcoldtreatment').html("<div class='fleet-temp'>No Data Available for Cold Treatment</div>"); //WI26386 renamed Gensets to Genset
            }
        }

        $('#CTHeaderLoader').hide();

    }

    UpdateGensetCharts() {
        if (this.chartGensetHistogram != undefined && this.chartGensetHistogram != null
            && this.chartGensetHistogram.series != undefined && this.chartGensetHistogram.series[0] != undefined) {
            this.chartGensetHistogram.series[0].setData([
                {
                    name: 'Gensets Reporting, Switched On',
                    id: 'PowerOnReporting',
                    y: this.state.Gensetsummary.PowerOnReporting,
                    color: '#3ea538',
                    sliced: true,
                    selected: true
                }, {
                    name: 'Gensets Reporting, Switched Off',
                    id: 'PowerOffReporting',
                    y: this.state.Gensetsummary.PowerOffReporting,
                    color: '#045976'
                },
                {
                    name: 'Gensets, Last Switched On',
                    id: 'PowerOnNotReporting',
                    y: this.state.Gensetsummary.PowerOnNotReporting,
                    color: '#fd7800'
                }, {
                    name: 'Gensets, Last Switched Off',
                    id: 'PowerOffNotReporting',
                    y: this.state.Gensetsummary.PowerOffNotReporting,
                    color: '#615f60'
                }
            ]);

            if (this.state.Gensetsummary.PowerOnReporting == 0 && this.state.Gensetsummary.PowerOffReporting == 0 && this.state.Gensetsummary.PowerOnNotReporting == 0
                && this.state.Gensetsummary.PowerOffNotReporting == 0) {
                this.chartGensetHistogram.destroy();
                $('#chartGensetHistogram').html("<div class='fleet-temp'>No Data Available for Genset Fleet</div>"); //WI26386 renamed Gensets to Genset
            }
        }

        $('#totalGensetFleetLoader').hide();

    }

    UpdateDryCharts() {
        if (this.chartDryHistogram != undefined && this.chartDryHistogram != null
            && this.chartDryHistogram.series != undefined && this.chartDryHistogram.series[0] != undefined) {
            this.chartDryHistogram.series[0].setData([
                {
                    name: 'Drys Inside Geofence',
                    id: 'DryInGeofence',
                    y: this.state.Drysummary.InGeofence,
                    color: '#3ea538',
                    sliced: true,
                    selected: true
                },
                {
                    name: 'Drys Outside Geofence',
                    id: 'DryOutGeofence',
                    y: this.state.Drysummary.OutGeofence,
                    color: '#045976'
                }
            ]);

            if (this.state.Drysummary.InGeofence == 0 && this.state.Drysummary.OutGeofence == 0) {
                this.chartDryHistogram.destroy();
                $('#chartDryHistogram').html("<div class='fleet-temp'>No Data Available for Dry Fleet</div>");
            }
        }

        $('#totalDryFleetLoader').hide();

    }

    BindChassisCharts() {
        var parent = this;
        setTimeout(function () {
            Highcharts.setOptions({
                lang: {
                    thousandsSep: ""
                },
                exporting: {
                    enabled: false
                }
            });
            var element = document.getElementById('chartChassisHistogram');
            if (typeof (element) != 'undefined' && element != null) {

                parent.chartChassisHistogram = Highcharts.chart('chartChassisHistogram', {
                    chart: {
                        plotBackgroundColor: null,
                        plotBorderWidth: null,
                        plotShadow: false,
                        type: 'pie',
                        height: 280
                    },
                    title: {
                        text: ''
                    },
                    tooltip: {
                        pointFormat: ': <b>{point.percentage:.1f}%</b>'
                    },
                    plotOptions: {
                        series: {
                            cursor: 'pointer',
                            events: {
                                click: function (event) {
                                    if (event.point != undefined) {
                                        parent.ApplyChartFiltersChassis(event.point['id']);
                                    }
                                }
                            }
                        },
                        pie: {
                            allowPointSelect: true,
                            cursor: 'pointer',
                            dataLabels: {
                                enabled: false
                            },
                            showInLegend: true
                        }
                    },
                    series: [{
                        name: 'Chassis',
                        data: [{ y: 1, id: '' }]
                    }]
                });
            }
            parent.UpdateChassisCharts();
        }, 10);
    }

    UpdateChassisCharts() {
        if (this.chartChassisHistogram != undefined && this.chartChassisHistogram != null
            && this.chartChassisHistogram.series != undefined && this.chartChassisHistogram.series[0] != undefined) {
            this.chartChassisHistogram.series[0].setData([
                {
                    name: 'Chassis Powered, Inside Geofence',
                    id: 'ChassisPwrInGeofence',
                    y: this.state.Chassissummary.PwrInGeofence,
                    color: '#3ea538',
                    sliced: true,
                    selected: true
                }, {
                    name: 'Chassis Powered, Outside Geofence',
                    id: 'ChassisPwrOutGeofence',
                    y: this.state.Chassissummary.PwrOutGeofence,
                    color: '#fd7800'
                },
                {
                    name: 'Chassis Not Powered, Inside Geofence',
                    id: 'ChassisNotPwrInGeofence',
                    y: this.state.Chassissummary.NotPwrInGeofence,
                    color: '#045976'
                }, {
                    name: 'Chassis Not Powered, Outside Geofence',
                    id: 'ChassisNotPwrOutGeofence',
                    y: this.state.Chassissummary.NotPwrOutGeofence,
                    color: '#615f60'
                }
            ]);

            if (this.state.Chassissummary.PwrInGeofence == 0 && this.state.Chassissummary.PwrOutGeofence == 0 && this.state.Chassissummary.NotPwrInGeofence == 0 && this.state.Chassissummary.NotPwrOutGeofence == 0) {
                this.chartChassisHistogram.destroy();
                $('#chartChassisHistogram').html("<div class='fleet-temp'>No Data Available for Chassis Fleet</div>");
            }
        }

        $('#totalChassisFleetLoader').hide();

    }

    setModelTitle = (title) => {
        this.setState({ modelTitle: title });
    }

    setSelectedRow = (data) => {
        this.setState({ selectedItems: data });
    }

    setLastSelectedRow = (data) => {
        this.setState({ selectedItems: data });
    }

    setReeferStatusRowsLength = (data) => {
        this.setState({ CurrentReeferGridRows: data });
    }

    setDryStatusRowsLength = (data) => {
        this.setState({ CurrentDryGridRows: data });
    }


    setModelPopupHtml = (popupContent) => {
        this.setState({ popUpHtml: popupContent });
    }

    setModelTitleReport = (title) => {
        this.setState({ modelTitleReport: title });
    }
    setModelPopupHtmlReport = (popupContent) => {
        this.setState({ popUpHtmlReport: popupContent });
    }
    setModelPopupHtmlReportReeferId = (reeferId) => {
        this.setState({ ReportReeferId: reeferId });
    }
    setModelPopupHtmlPTReport = (report) => {
        this.setState({ PTReport: report });
    }

    setModelPopupHtmlTWReport = (report) => {
        this.setState({ TWReport: report });
    }

    showContextMenuModelWindow = () => {
        $('#contextMenuModel').show();
    }

    tick() {
        $('#headerLoader').show();
        $('#totalReefersLoader').show();
        $('#microAlarmLoader').show();
        $('#cargoCareLoader').show();

        this.setState({ loading: true });
        var request = RCUtils.FetchRequest(Config.ApiBaseUrl + '/api/reeferstatus/ReeferStatusSummary')
        RCUtils.fetchRetry(request)
            .then(RCUtils.handleResponse)
            .then(response => response.json() as Promise<server.ReeferStatusSummaryModel>)
            .then(data => {
                $('#headerLoader').hide();
                this.setState({ Reefersummary: data, loading: false }, () => { this.UpdateCharts(true); });
            });
    }

    GensetTick() {
        $('#GensetheaderLoader').show();
        $('#totalGensetFleetLoader').show();
        this.setState({ loading: true });
        var selectedAssetStates: any = this.state.SelectedAssetStatesTotalGensets;//RCNG-1572

        var request = RCUtils.FetchRequest(Config.ApiBaseUrl + '/api/Asset/GensetStatusSummary?AssetState=' + selectedAssetStates)
        RCUtils.fetchRetry(request)
            .then(RCUtils.handleResponse)
            .then(response => response.json() as Promise<server.GensetStatusSummaryModel>)
            .then(data => {
                $('#GensetheaderLoader').hide();
                this.setState({ Gensetsummary: data, loading: false }, () => { this.UpdateGensetCharts(); });
            });
    }

    DryTick() {
        $('#DryheaderLoader').show();
        $('#totalDryFleetLoader').show();
        this.setState({ loading: true });
        // var selectedAssetStates: any = this.state.SelectedAssetStatesCC;
        //var selectedAssetStates: any = "A"; //this.state.SelectedAssetStatesCC;
        var selectedAssetStates: any = this.state.SelectedAssetStatesTotalDrys;//RCNG-1168
        // if (selectedAssetStates == null || selectedAssetStates == "")
        //    selectedAssetStates = "A";
        var request = RCUtils.FetchRequest(Config.ApiBaseUrl + '/api/Asset/DryStatusSummary?AssetState=' + selectedAssetStates)

        //var request = RCUtils.FetchRequest(Config.ApiBaseUrl + '/api/Asset/DryStatusSummary')
        RCUtils.fetchRetry(request)
            .then(RCUtils.handleResponse)
            .then(response => response.json() as Promise<server.DryStatusSummaryModel>)
            .then(data => {
                $('#DryheaderLoader').hide();

                this.setState({ Drysummary: data, loading: false }, () => { this.UpdateDryCharts();  });
            });
    }

    ChassisTick() {
        $('#ChassisheaderLoader').show();
        $('#totalChassisFleetLoader').show();
        this.setState({ loading: true });
        var request = RCUtils.FetchRequest(Config.ApiBaseUrl + '/api/Asset/ChassisStatusSummary')
        RCUtils.fetchRetry(request)
            .then(RCUtils.handleResponse)
            .then(response => response.json() as Promise<server.ChassisStatusSummaryModel>)
            .then(data => {
                $('#ChassisheaderLoader').hide();
                this.setState({ Chassissummary: data, loading: false }, () => { this.UpdateChassisCharts(); });
            });
    }

    reeferdetailsAction(data: any, reeferFormatters: any, dataSource: any, isOpenVia: any) {
        var reeferdetails = {
            reeferData: data[0], reeferFormatter: reeferFormatters, source: dataSource, isOpenVia: isOpenVia
        };
        this.props.history.push('/reeferdetails?From=' + window.location.pathname.replace('/', ''), reeferdetails);
    }

    gensetdetailsAction(data: any, dataSource: any, isOpenVia: any) {
        var gensetdetails = {
            gensetData: data[0], source: dataSource, isOpenVia: isOpenVia
        };
        this.props.history.push('/gensetdetails?From=' + window.location.pathname.replace('/', ''), gensetdetails);
    }

    drydetailsAction(data: any, dataSource: any, isOpenVia: any) {
        var drydetails = {
            dryData: data[0], source: dataSource, isOpenVia: isOpenVia
        };
        this.props.history.push('/drydetails?From=' + window.location.pathname.replace('/', ''), drydetails);
    }

    chassisdetailsAction(data: any, dataSource: any, isOpenVia: any) {
        var chassisdetails = {
            chassisData: data[0], source: dataSource, isOpenVia: isOpenVia
        };
        this.props.history.push('/chassisdetails?From=' + window.location.pathname.replace('/', ''), chassisdetails);
    }

    reeferhistoryAction(data: any) {
        this.props.history.push('/reeferhistory?From=' + window.location.pathname.replace('/', ''), data);
    }
    reeferbookingAction(data: any) {
        this.props.history.push('/NewbookingEdit?From=' + window.location.pathname.replace('/', ''), data);
    }
    reefercreatebookingAction(data: any) {
        this.props.history.push('/Newbookingassign?From=' + window.location.pathname.replace('/', ''), data);
    }
    reeferViewbookingAction(data: any) {
        this.props.history.push('/ViewBooking?From=' + window.location.pathname.replace('/', ''), data);
    }
    dryhistoryAction(data: any) {
        this.props.history.push('/dryhistory?From=' + window.location.pathname.replace('/', ''), data);
    }

    chassishistoryAction(data: any) {
        this.props.history.push('/chassishistory?From=' + window.location.pathname.replace('/', ''), data);
    }

    gensethistoryAction(data: any) {
        var gensetdetails = {
            gensetData: data
        };
        this.props.history.push('/gensethistory?From=' + window.location.pathname.replace('/', ''), gensetdetails);
    }


    reefercommandstatusAction(data: any) {
        this.props.history.push('/reefercommands?From=' + window.location.pathname.replace('/', ''), data);
    }

    gensetcommandstatusAction(data: any) {
        this.props.history.push('/gensetcommandstatus?From=' + window.location.pathname.replace('/', ''), data);
    }

    drycommandstatusAction(data: any) {
        this.props.history.push('/drycommands?From=' + window.location.pathname.replace('/', ''), data);
    }

    chassiscommandstatusAction(data: any) {
        this.props.history.push('/chassiscommands?From=' + window.location.pathname.replace('/', ''), data);
    }


    GetLoadData(data: any) {

        return <div className='inlinediv'>{data}</div>
    }
    GetLoadCCAlertData(data: any) {
        const ccSum = data.reduce((accumulator, current) => {
            return accumulator + current;
        }, 0);
        return <div className='inlinediv'>{ccSum}</div>
    }
    GetSumByCCAlertData(data: any) {
        return data.reduce((accumulator, current) => {
            return accumulator + current;
        }, 0);
    }

    requestAssignCargoCare(data: any) {
        this.props.requestAssignCargoCare(data);
    }
    requestUnAssignCargoCare(data: any) {
        this.props.requestUnAssignCargoCare(data);
    }
    requestClearSetPoint(data: any) {
        this.props.requestClearSetPoint(data);
    }

    reeferMapAction(reeferData: any) {
        this.props.history.push('/reefermap?From=' + window.location.pathname.replace('/', ''), reeferData);
    }

    dryMapAction(dryData: any) {
        this.props.history.push('/drymap?From=' + window.location.pathname.replace('/', ''), dryData);
    }

    chassisMapAction(chassisData: any) {
        this.props.history.push('/chassismap?From=' + window.location.pathname.replace('/', ''), chassisData);
    }

    gensetMapAction(gensetData: any) {
        var gensetdetails = {
            gensetData: gensetData
        };
        this.props.history.push('/gensetmap?From=' + window.location.pathname.replace('/', ''), gensetdetails);
    }
    toggleSSRMCancel() {
        RCNGConfirmWindow.ConfirmWindow.close();
    }
   
    toggleServerSide = (el) => {
        if (this.state.EnableServerSide) {
            this.setState({ EnableServerSide: false }, () => {
                sessionStorage.setItem('SSRM', "false");
                ReeferStatusGrid.ClearReeferStatusGridData();
                if (this.state.WGSwitchAll.ReeferHistoryGrid == true)
                    ReeferHistoryGrid.ClearHistoryGridData();
                setTimeout(() => {
                    if (isLastSearchAdvanced) {
                        var isFenceAssets = false;
                        this.bindingReeferGensetDryChassisStatusGrid(this.state.PrevReeferFilters, isFenceAssets);
                    } else {
                        const prevFilterData: any = this.state.PrevReeferFilters;
                        let isEquals = isEqual(filterDefault, prevFilterData);
                        //if (prevFilterData != null && prevFilterData.SelectedCountry != null && prevFilterData.SelectedAssetTypes != null && prevFilterData.SelectedGeofence != null && prevFilterData.SelectedGeofenceInside != null
                        //    && prevFilterData.SelectedInterval != null && prevFilterData.SelectedOem != null && prevFilterData.SelectedReefer != null && prevFilterData.SelectedVesselCode != null
                        //    && prevFilterData.StatusFilters != [] && prevFilterData.CustomAttributeFilters != {} && prevFilterData.AllReefers != null && prevFilterData.SelectedBookingNumber != null)
                        if (!isEquals)
                            ReeferStatusGrid.ApplyReeferSearchFilter(this.state.PrevReeferFilters, false,false);
                    }
                }, 200);

                this.saveSSRMMode(false);
            });

        }
        else {

            this.setState({ EnableServerSide: true }, () => {
                sessionStorage.setItem('SSRM', "true");
                setTimeout(() => {
                    if (isLastSearchAdvanced) {
                        var isFenceAssets = false;
                        this.bindingReeferGensetDryChassisStatusGrid(this.state.PrevReeferFilters, isFenceAssets);
                    }
                }, 200);
                this.saveSSRMMode(true);
            });
        }
    }
    saveSSRMMode = (mode: boolean) => {
        let saveUrl = mode ? Config.ApiBaseUrl + '/api/User/SaveSSRMMode?mode=1' : Config.ApiBaseUrl + '/api/User/SaveSSRMMode?Mode=0';
        var request = RCUtils.FetchRequest(saveUrl, { method: 'GET', headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' } });
        RCUtils.fetchRetry(request)
            .then(RCUtils.handleResponse)
            .then(response => response.json() as Promise<any>)
            .then(data => {
                //silently save data, if error server will log
                //if (data)
                ////console.log('SSRM Mode saved');
            });
    }
    GetLoadReeferStatusGridData(data: any) {
        if (this.props.reeferFormatter != null && this.props.reeferFormatter != undefined) {
            if (this.props.reeferFormatter.AlarmMasterList != null && this.props.reeferFormatter.AlarmMasterList != undefined && this.props.reeferFormatter.AlarmMasterList.length > 0) {
                if (this.state.EnableServerSide) {
                    return <ReeferStatusSSRMGrid
                        totalWidgetSearch={totalWidgetSearch}//WI26412
                        hasReefer={hasReefers}
                        hasGenset={hasGensets}
                        hasDry={hasDrys}
                        hasChassis={hasChassis}
                        isServerSideEnable={this.state.EnableServerSide}
                        clearGridHeaderExtension={this.clearGridHeaderExtension.bind(this)}
                        requestAssignCargoCare={this.requestAssignCargoCare.bind(this)}
                        requestUnAssignCargoCare={this.requestUnAssignCargoCare.bind(this)}
                        requestClearSetPoint={this.requestClearSetPoint.bind(this)}
                        reeferMapAction={this.reeferMapAction.bind(this)}
                        statusFilter={this.props.searchFilters}
                        reeferdetailsAction={this.reeferdetailsAction.bind(this)}
                        reeferhistoryAction={this.reeferhistoryAction.bind(this)}
                        reeferbookingAction={this.reeferbookingAction.bind(this)}
                        reefercreatebookingAction={this.reefercreatebookingAction.bind(this)}
                        reeferViewbookingAction={this.reeferViewbookingAction.bind(this)}
                        reefercommandstatusAction={this.reefercommandstatusAction.bind(this)}
                        isResizeClicked={this.state.isFullscreen}
                        getSelectedRow={this.setSelectedRow}
                        getLastSelectedRow={this.setLastSelectedRow}
                        getCommandPopupTitle={this.setModelTitle}
                        getCommandPopupContent={this.setModelPopupHtml}
                        getCommandPopupTitleReport={this.setModelTitleReport}
                        getCommandPopupContentReport={this.setModelPopupHtmlReport}
                        getCommandPopupReportReeferId={this.setModelPopupHtmlReportReeferId}
                        getCommandPopupPTReport={this.setModelPopupHtmlPTReport}
                        getCommandPopupTWReport={this.setModelPopupHtmlTWReport}
                        onOpenCommandWindow={this.showContextMenuModelWindow}
                        loggedInUserData={this.props.loggedInUserData}
                        renderDataToEmailControl={this.renderDataToEmailControl.bind(this)}
                        renderDataGridPreferenceControl={this.renderDataGridPreferenceControl.bind(this)}
                        requestReeferAdvanceSearch={this.props.requestReeferAdvanceSearch.bind(this)} // WI 26831
                        propsReeferFormatterData={this.props.reeferFormatter}
                        customerDeviceTypeSensor={this.state.CustomerDeviceTypeSensor}
                        propsReeferData={this.props.reeferStatus}
                        reeferConfigTypes={this.props.reeferConfigTypes}
                        refApplicationParams={this.props.refApplicationParams}
                        getReeferStatusGridRows={this.setReeferStatusRowsLength}
                        CustomAttributes={this.state.CustomAttributes}
                        renderDataGridExportToExcelControl={this.renderDataGridExportToExcelControl.bind(this)}
                        renderClearSelection={this.renderClearSelectionForAllAsset.bind(this)}
                        reeferHistoryEnabled={this.state.WGSwitchAll.ReeferHistoryGrid}
                        tripWISESupportdeviceTypes={this.props.tripWISESupportdeviceTypes}
                        dashboardWidgetsSearch={this.state.DashboardWidgetsSearch}
                        dashboardPreferenceId={this.state.DashboardPreferenceId}
                        isReadOnly={this.state.IsReadOnly}
                        revisionNum={this.state.RevisionNum}
                        validateRevisionNum={this.validateRevisionNum.bind(this)}
                        sourceFrom='DashBoard'></ReeferStatusSSRMGrid>;
                } else {
                    return <ReeferStatusGrid
                        hasReefer={hasReefers}
                        hasGenset={hasGensets}
                        hasDry={hasDrys}
                        hasChassis={hasChassis}
                        isServerSideEnable={this.state.EnableServerSide}
                        clearGridHeaderExtension={this.clearGridHeaderExtension.bind(this)}
                        requestAssignCargoCare={this.requestAssignCargoCare.bind(this)}
                        requestUnAssignCargoCare={this.requestUnAssignCargoCare.bind(this)}
                        requestClearSetPoint={this.requestClearSetPoint.bind(this)}
                        reeferMapAction={this.reeferMapAction.bind(this)}
                        statusFilter={this.props.searchFilters}
                        reeferdetailsAction={this.reeferdetailsAction.bind(this)}
                        reeferhistoryAction={this.reeferhistoryAction.bind(this)}
                        reeferbookingAction={this.reeferbookingAction.bind(this)}
                        reefercreatebookingAction={this.reefercreatebookingAction.bind(this)}
                        reeferViewbookingAction={this.reeferViewbookingAction.bind(this)}
                        reefercommandstatusAction={this.reefercommandstatusAction.bind(this)}
                        isResizeClicked={this.state.isFullscreen}
                        getSelectedRow={this.setSelectedRow}
                        getLastSelectedRow={this.setLastSelectedRow}
                        getCommandPopupTitle={this.setModelTitle}
                        getCommandPopupContent={this.setModelPopupHtml}
                        getCommandPopupTitleReport={this.setModelTitleReport}
                        getCommandPopupContentReport={this.setModelPopupHtmlReport}
                        getCommandPopupReportReeferId={this.setModelPopupHtmlReportReeferId}
                        getCommandPopupPTReport={this.setModelPopupHtmlPTReport}
                        getCommandPopupTWReport={this.setModelPopupHtmlTWReport}
                        onOpenCommandWindow={this.showContextMenuModelWindow}
                        loggedInUserData={this.props.loggedInUserData}
                        renderDataToEmailControl={this.renderDataToEmailControl.bind(this)}
                        renderDataGridPreferenceControl={this.renderDataGridPreferenceControl.bind(this)}
                        requestReeferAdvanceSearch={this.props.requestReeferAdvanceSearch.bind(this)} // WI 26831
                        propsReeferFormatterData={this.props.reeferFormatter}
                        customerDeviceTypeSensor={this.state.CustomerDeviceTypeSensor}
                        propsReeferData={this.props.reeferStatus}
                        reeferConfigTypes={this.props.reeferConfigTypes}
                        refApplicationParams={this.props.refApplicationParams}
                        getReeferStatusGridRows={this.setReeferStatusRowsLength}
                        CustomAttributes={this.state.CustomAttributes}
                        renderDataGridExportToExcelControl={this.renderDataGridExportToExcelControl.bind(this)}
                        renderClearSelection={this.renderClearSelectionForAllAsset.bind(this)}
                        reeferHistoryEnabled={this.state.WGSwitchAll.ReeferHistoryGrid}
                        tripWISESupportdeviceTypes={this.props.tripWISESupportdeviceTypes}
                        dashboardWidgetsSearch={this.state.DashboardWidgetsSearch}
                        dashboardPreferenceId={this.state.DashboardPreferenceId}
                        isReadOnly={this.state.IsReadOnly}
                        revisionNum={this.state.RevisionNum}
                        validateRevisionNum={this.validateRevisionNum.bind(this)}
                        renderAlarmWidgetIfCCPSelected={this.renderAlarmWidgetIfCCPSelected}
                        sourceFrom='DashBoard'></ReeferStatusGrid>;
                }
            }
            else {
                return <div></div>;
            }
        }
        else {
            return <div></div>;
        }
    }

    openReeferTemperatureGraph(reeferData: any, reeferFormatters, historyFilters: any) {
        var graphHeaderText = reeferData[0].ReeferID.slice(0, 4).concat(' ').concat(reeferData[0].ReeferID.slice(4, 10)).concat(' ').concat(reeferData[0].ReeferID.slice(10, 11));
        this.setState({ temperatureGraphHtml: '', graphReeferId: graphHeaderText });
        this.setState({ temperatureGraphHtml: this.bindGraphHtml(reeferData, reeferFormatters, historyFilters) }, () => {
            $('#btnTriggerGraph').click();
        });
    }

    openGensetMonitorGraph(gensetData: any, historyFilters: any) {
        this.setState({ gensetMonitorGraphHtml: '', graphGensetId: gensetData[0].AssetNumber });
        this.setState({ gensetMonitorGraphHtml: this.bindGensetGraphHtml(gensetData, historyFilters) }, () => {
            $('#btnTriggerGensetGraph').click();
        });
    }

    bindGensetGraphHtml(gensetData: any, historyFilters: any) {
        return <GensetMonitorGraph gensetHistoryData={gensetData} gensetHistoryFilters={historyFilters}></GensetMonitorGraph>
    }

    bindGraphHtml(reeferData: any, reeferFormatters: any, historyFilters: any) {
        return <TemperatureGraph reeferHistoryData={reeferData} propsReeferFormatters={reeferFormatters} historySearchFilters={historyFilters}></TemperatureGraph>
    }

    GetLoadGensetStatusGridData(data: any) {
        //if (this.props.reeferFormatter != null && this.props.reeferFormatter != undefined) {
        //    if (this.props.reeferFormatter.AlertMasterList != null && this.props.reeferFormatter.AlertMasterList != undefined && this.props.reeferFormatter.AlertMasterList.length > 0) {
        return <GensetStatusGrid
            clearGridHeaderExtension={this.clearGensetGridHeaderExtension.bind(this)}
            requestAssignCargoCare={this.requestAssignCargoCare.bind(this)}
            requestUnAssignCargoCare={this.requestUnAssignCargoCare.bind(this)}
            requestClearSetPoint={this.requestClearSetPoint.bind(this)}
            gensetMapAction={this.gensetMapAction.bind(this)}
            statusFilter={this.props.searchFilters}
            gensetdetailsAction={this.gensetdetailsAction.bind(this)}
            gensethistoryAction={this.gensethistoryAction.bind(this)}
            gensetcommandstatusAction={this.gensetcommandstatusAction.bind(this)}
            isResizeClicked={this.state.isFullscreen}
            getSelectedRow={this.setSelectedRow}
            customerDeviceTypeSensor={this.state.CustomerDeviceTypeSensor}
            getLastSelectedRow={this.setLastSelectedRow}
            getCommandPopupTitle={this.setModelTitle}
            getCommandPopupContent={this.setModelPopupHtml}
            onOpenCommandWindow={this.showContextMenuModelWindow}
            loggedInUserData={this.props.loggedInUserData}
            renderDataToEmailControl={this.renderDataToEmailControl.bind(this)}
            renderDataGridPreferenceControl={this.renderDataGridPreferenceControl.bind(this)}
            propsGensetData={this.props.gensetStatus}
            requestGensetAdvanceSearch={this.props.requestGensetAdvanceSearch.bind(this)}
            CustomAttributes={this.state.CustomAttributes}
            //propsReeferFormatterData={this.props.reeferFormatter}
            renderDataGridExportToExcelControl={this.renderDataGridExportToExcelControl.bind(this)}
            renderClearSelection={this.renderClearSelectionForAllAsset.bind(this)}
            gensetHistoryEnabled={this.state.WGSwitchAll.GensetHistoryGrid}
            dashboardWidgetsSearch={this.state.DashboardWidgetsSearch}
            dashboardPreferenceId={this.state.DashboardPreferenceId}
            isReadOnly={this.state.IsReadOnly}
            revisionNum={this.state.RevisionNum}
            validateRevisionNum={this.validateRevisionNum.bind(this)}
            sourceFrom='DashBoard'></GensetStatusGrid >
        //    }
        //    else {
        //        return <div></div>;
        //    }
        //}
        //else {
        //    return <div></div>;
        //}
    }

    GetLoadReeferHistoryGridData() {
        if (this.props.reeferFormatter != null && this.props.reeferFormatter != undefined) {
            return <ReeferHistoryGrid
                reeferIdForHeader={this.setGridHeader}
                reeferparams={this.setGridHeader}
                renderDataToEmailControl={this.renderDataToEmailControl.bind(this)}
                propsReeferFormatterData={this.props.reeferFormatter}
                customerDeviceTypeSensor={this.state.CustomerDeviceTypeSensor}
                sourceFrom='DashBoard'
                renderDataGridPreferenceControl={this.renderDataGridPreferenceControl.bind(this)}
                renderDataGridExportToExcelControl={this.renderDataGridExportToExcelControl.bind(this)}
                mapEnabled={this.state.WGSwitchAll.ReeferMaps}
                graphEnabled={this.state.WGSwitchAll.ReeferTempGraph}
                dashboardWidgetsSearch={this.state.DashboardWidgetsSearch}
                dashboardPreferenceId={this.state.DashboardPreferenceId}
                isReadOnly={this.state.IsReadOnly}
                revisionNum={this.state.RevisionNum}
                validateRevisionNum={this.validateRevisionNum.bind(this)}
                openReeferTemperatureGraph={this.openReeferTemperatureGraph.bind(this)}>
            </ReeferHistoryGrid>
        }
        else {
            return <div></div>;
        }
    }

    GetLoadReeferTemperatureGraphData() {
        return <ReeferTemperatureGraph
            propsReeferFormatters={this.props.reeferFormatter}
            sourceFrom='DashBoard'>
        </ReeferTemperatureGraph>
    }

    GetLoadGensetHistoryGridData() {
        return <GensetHistoryGrid
            gensetIdForHeader={this.setGensetGridHeader}
            gensetparams={this.setGensetGridHeader}
            renderDataToEmailControl={this.renderDataToEmailControl.bind(this)}
            customerDeviceTypeSensor={this.state.CustomerDeviceTypeSensor}
            renderDataGridPreferenceControl={this.renderDataGridPreferenceControl.bind(this)}
            openGensetMonitorGraph={this.openGensetMonitorGraph.bind(this)}
            propsReeferFormatterData={this.props.reeferFormatter}
            renderDataGridExportToExcelControl={this.renderDataGridExportToExcelControl.bind(this)}
            mapEnabled={this.state.WGSwitchAll.ReeferMaps}
            dashboardWidgetsSearch={this.state.DashboardWidgetsSearch}
            dashboardPreferenceId={this.state.DashboardPreferenceId}
            isReadOnly={this.state.IsReadOnly}
            revisionNum={this.state.RevisionNum}
            validateRevisionNum={this.validateRevisionNum.bind(this)}
            sourceFrom='DashBoard'>
        </GensetHistoryGrid>
    }

    GetLoadDryStatusGridData(data: any) {
        return <DryStatusSSRMGrid
            totalWidgetSearch={totalWidgetSearch}//WI26412
            hasReefer={hasReefers}
            hasGenset={hasGensets}
            hasDry={hasDrys}
            hasChassis={hasChassis}
            clearGridHeaderExtension={this.clearDryGridHeaderExtension.bind(this)}
            requestAssignCargoCare={this.requestAssignCargoCare.bind(this)}
            requestUnAssignCargoCare={this.requestUnAssignCargoCare.bind(this)}
            requestClearSetPoint={this.requestClearSetPoint.bind(this)}
            dryMapAction={this.dryMapAction.bind(this)}
            statusFilter={this.props.searchFilters}
            drydetailsAction={this.drydetailsAction.bind(this)}
            dryhistoryAction={this.dryhistoryAction.bind(this)}
            drycommandstatusAction={this.drycommandstatusAction.bind(this)}
            isResizeClicked={this.state.isFullscreen}
            getSelectedRow={this.setSelectedRow}
            getLastSelectedRow={this.setLastSelectedRow}
            getCommandPopupTitle={this.setModelTitle}
            getCommandPopupContent={this.setModelPopupHtml}
            onOpenCommandWindow={this.showContextMenuModelWindow}
            loggedInUserData={this.props.loggedInUserData}
            propsDryData={this.props.dryStatus}
            customerDeviceTypeSensor={this.state.CustomerDeviceTypeSensor}
            renderDataToEmailControl={this.renderDataToEmailControl.bind(this)}
            renderDataGridPreferenceControl={this.renderDataGridPreferenceControl.bind(this)}
            getDryStatusGridRows={this.setDryStatusRowsLength}
            requestDryAdvanceSearch={this.props.requestDryAdvanceSearch.bind(this)}
            renderDataGridExportToExcelControl={this.renderDataGridExportToExcelControl.bind(this)}
            renderClearSelection={this.renderClearSelectionForAllAsset.bind(this)}
            dryHistoryEnabled={this.state.WGSwitchAll.DryHistoryGrid}
            dashboardWidgetsSearch={this.state.DashboardWidgetsSearch}
            dashboardPreferenceId={this.state.DashboardPreferenceId}
            isReadOnly={this.state.IsReadOnly}
            revisionNum={this.state.RevisionNum}
            validateRevisionNum={this.validateRevisionNum.bind(this)}
            sourceFrom='DashBoard'></DryStatusSSRMGrid >
    }
    GetLoadDryHistoryGridData() {
        return <DryHistoryGrid
            dryIdForHeader={this.setDryGridHeader}
            dryparams={this.setDryGridHeader}
            customerDeviceTypeSensor={this.state.CustomerDeviceTypeSensor}
            renderDataToEmailControl={this.renderDataToEmailControl.bind(this)}
            renderDataGridPreferenceControl={this.renderDataGridPreferenceControl.bind(this)}
            renderDataGridExportToExcelControl={this.renderDataGridExportToExcelControl.bind(this)}
            mapEnabled={this.state.WGSwitchAll.ReeferMaps}
            dashboardWidgetsSearch={this.state.DashboardWidgetsSearch}
            dashboardPreferenceId={this.state.DashboardPreferenceId}
            isReadOnly={this.state.IsReadOnly}
            revisionNum={this.state.RevisionNum}
            validateRevisionNum={this.validateRevisionNum.bind(this)}
            sourceFrom='DashBoard'>
        </DryHistoryGrid>
    }

    GetLoadChassisStatusGridData(data: any) {
        return <ChassisStatusGrid
            clearGridHeaderExtension={this.clearChassisGridHeaderExtension.bind(this)}
            requestAssignCargoCare={this.requestAssignCargoCare.bind(this)}
            requestUnAssignCargoCare={this.requestUnAssignCargoCare.bind(this)}
            requestClearSetPoint={this.requestClearSetPoint.bind(this)}
            chassisMapAction={this.chassisMapAction.bind(this)}
            statusFilter={this.props.searchFilters}
            chassisdetailsAction={this.chassisdetailsAction.bind(this)}
            chassishistoryAction={this.chassishistoryAction.bind(this)}
            chassiscommandstatusAction={this.chassiscommandstatusAction.bind(this)}
            isResizeClicked={this.state.isFullscreen}
            getSelectedRow={this.setSelectedRow}
            getLastSelectedRow={this.setLastSelectedRow}
            getCommandPopupTitle={this.setModelTitle}
            getCommandPopupContent={this.setModelPopupHtml}
            onOpenCommandWindow={this.showContextMenuModelWindow}
            loggedInUserData={this.props.loggedInUserData}
            propsChassisData={this.props.chassisStatus}
            customerDeviceTypeSensor={this.state.CustomerDeviceTypeSensor}
            renderDataToEmailControl={this.renderDataToEmailControl.bind(this)}
            renderDataGridPreferenceControl={this.renderDataGridPreferenceControl.bind(this)}
            requestChassisAdvanceSearch={this.props.requestChassisAdvanceSearch.bind(this)}
            renderDataGridExportToExcelControl={this.renderDataGridExportToExcelControl.bind(this)}
            renderClearSelection={this.renderClearSelectionForAllAsset.bind(this)}
            chassisHistoryEnabled={this.state.WGSwitchAll.ChassisHistoryGrid}
            dashboardWidgetsSearch={this.state.DashboardWidgetsSearch}
            dashboardPreferenceId={this.state.DashboardPreferenceId}
            isReadOnly={this.state.IsReadOnly}
            revisionNum={this.state.RevisionNum}
            validateRevisionNum={this.validateRevisionNum.bind(this)}
            sourceFrom='DashBoard'></ChassisStatusGrid >
    }
    GetLoadChassisHistoryGridData() {
        return <ChassisHistoryGrid
            chassisIdForHeader={this.setChassisGridHeader}
            chassisparams={this.setChassisGridHeader}
            renderDataToEmailControl={this.renderDataToEmailControl.bind(this)}
            customerDeviceTypeSensor={this.state.CustomerDeviceTypeSensor}
            renderDataGridPreferenceControl={this.renderDataGridPreferenceControl.bind(this)}
            renderDataGridExportToExcelControl={this.renderDataGridExportToExcelControl.bind(this)}
            mapEnabled={this.state.WGSwitchAll.ReeferMaps}
            dashboardWidgetsSearch={this.state.DashboardWidgetsSearch}
            dashboardPreferenceId={this.state.DashboardPreferenceId}
            isReadOnly={this.state.IsReadOnly}
            revisionNum={this.state.RevisionNum}
            validateRevisionNum={this.validateRevisionNum.bind(this)}
            sourceFrom='DashBoard'>
        </ChassisHistoryGrid>
    }
    GetLoadPTResultGridData() {
        return <PTResultGrid
            reeferIdForHeader={this.setGridHeader}
            reeferparams={this.setGridHeader}
            renderDataToEmailControl={this.renderDataToEmailControl.bind(this)}
            renderDataGridPreferenceControl={this.renderDataGridPreferenceControl.bind(this)}
            renderDataGridExportToExcelControl={this.renderDataGridExportToExcelControl.bind(this)}
            propsReeferFormatterData={this.props.reeferFormatter}
            getCommandPopupTitle={this.setModelTitle}
            getCommandPopupContent={this.setModelPopupHtml}
            getCommandPopupTitleReport={this.setModelTitleReport}
            getCommandPopupContentReport={this.setModelPopupHtmlReport}
            getCommandPopupReportReeferId={this.setModelPopupHtmlReportReeferId}
            getCommandPopupPTReport={this.setModelPopupHtmlPTReport}
            getCommandPopupTWReport={this.setModelPopupHtmlTWReport}
            getReeferStatusGridRows={this.state.CurrentReeferGridRows}
            loggedInUserData={this.props.loggedInUserData}
            assetState={this.state.SelectedAssetStatesPTR}//RCNG-52
            dashboardWidgetsSearch={this.state.DashboardWidgetsSearch}
            dashboardPreferenceId={this.state.DashboardPreferenceId}
            isReadOnly={this.state.IsReadOnly}
            revisionNum={this.state.RevisionNum}
            validateRevisionNum={this.validateRevisionNum.bind(this)}
            sourceFrom='DashBoard'>
        </PTResultGrid>
    }

    onBreakpointChange(breakpoint, cols) {
        // this.setState({
        // breakpoint: breakpoint,
        //cols: cols
        // });
    }

    SetLayout(layouts: any) {
        //alert(this.mainDashboarLayouts);
        // this.setState({ layouts: JSON.stringify(layouts) });
    }
    onResizeStop(layout, allLayouts) {
        if (allLayouts.i == "wgCargoCare") {
            this.chartcargo.reflow();
            // $("#chartcargo").height($("#Piechart").height());
            // $("#chartcargo").width($("#Piechart").width());
            // this.chartcargo.setSize($("#Piechart").width(), $("#Piechart").height());
            // this.chartcargo.reflow();
        }
    }

    onLayoutChange(layout, allLayouts) {
        if(this.state.IsReadOnly == true)
            return;
        var newLayout = JSON.parse(JSON.stringify(allLayouts.lg));
        var lastWidgetValue = 0;
        var lastWidgetName = '';

        if (newLayout.length == Config.TotalWidgetsCount) {
            for (var i = 0; i <= newLayout.length - 1; i++) {
                if (newLayout[i].y > lastWidgetValue) {
                    lastWidgetValue = newLayout[i].y;
                    lastWidgetName = newLayout[i].i;
                }
            }
        }

        this.setState({ layouts: allLayouts, lastWidgetName: lastWidgetName }, () => {
                setTimeout(() => { 
                    if(!isSaveLayout && this.state.IsReadOnly == false)
                        this.UpdateDashboardLayout(); 
                }, 1000); 
            });
    }

    onRemoveItem(i) {
        //alert(JSON.stringify(i));
        //this.setState({ DashBoardItems: _.reject(this.state.DashBoardItems, { Key: i.Key }) });
        //alert(JSON.stringify(this.state.items));
        if(self.state.IsReadOnly == false)
            this.toggleSwitch(i.Key);
    }

    GetItemLayout(Id, allLayouts) {
        var result = {};
        // $.each(allLayouts, function (i, n) {
        ////_.forEach(allLayouts[i], function (lvalue, lkey) {
        ////    if (lvalue.i == Id) {
        ////        result = allLayouts[i][lkey];
        ////    }
        //////});
        // });
        return result;
    }

    onResizeAdvSearchScreen(el) {
 
        if ($("#globalLoader").css('display') === 'none') {
            if (!resizeAdvSearchToggle) {
                var newHeight = "195px";
                var scrollbarHeight = "125px";
                $(".advance-search").height(newHeight);
                $(".advance-search").css("min-height", "initial");
                $(".dashboardSearch-scrollbar").height(scrollbarHeight);
                resizeAdvSearchToggle = true;
                $("#spAdvSearch").removeClass("fas fa-compress-alt gi-2x blusetext1");
                $("#spAdvSearch").addClass("fa-solid fa-expand");
                $("#spAdvSearch").attr({ "title": "Maximize" });
                var allLayouts = JSON.parse(JSON.stringify(this.state.layouts));
                var result = {};
                $.each(allLayouts, function (i, n) {
                    forEach(allLayouts[i], function (lvalue, lkey) {
                        if (lvalue.i == "wgAdvSearch") {
                            allLayouts[i][lkey].h = 6.9;
                            result = allLayouts[i][lkey];
                            self.setState({
                                layouts: allLayouts
                            });
                        }
                    });
                });
            } else {
                var newHeight = "375px";
                var scrollbarHeight = "291px";
                $(".advance-search").height(newHeight);
                $(".dashboardSearch-scrollbar").height(scrollbarHeight);
                resizeAdvSearchToggle = false;
                $("#spAdvSearch").removeClass("fa-solid fa-expand");
                $("#spAdvSearch").addClass("fas fa-compress-alt gi-2x blusetext1");
                $("#spAdvSearch").attr({ "title": "Minimize" });
                var allLayouts = JSON.parse(JSON.stringify(this.state.layouts));
                var result = {};
                $.each(allLayouts, function (i, n) {
                    forEach(allLayouts[i], function (lvalue, lkey) {
                        if (lvalue.i == "wgAdvSearch") {
                            allLayouts[i][lkey].h = 12.7;
                            result = allLayouts[i][lkey];
                            self.setState({
                                layouts: allLayouts
                            });
                        }
                    });
                });
            }
        }
    }

    onFullScreen(el, id) {

        if (this.state.isFullscreen == false) {
            this.setState({ FullscreenItem: el })
            var Oldlayouts = JSON.parse(JSON.stringify(this.state.layouts));
            var allLayouts = JSON.parse(JSON.stringify(this.state.layouts));
            gridHeight = $('#' + id).parent('.react-grid-item').height();
            $(".react-grid-item").css('height', $(window).height() - 46);
            $(".react-grid-item").css('max-height', $(window).height() - 66);
            $.each(allLayouts, function (i, n) {
                if (allLayouts[i] != undefined) {
                    forEach(allLayouts[i], function (lvalue, lkey) {
                        if (lvalue != undefined && lvalue.i != undefined) {
                            if (lvalue.i == el.Key) {
                                //allLayouts[i][lkey].h = allLayouts[i][lkey].h * 2;
                                var minWidth: any = 75;//RCNG-2670
                                var currentWidth:any = allLayouts[i][lkey].w * 2;
                                if (currentWidth < minWidth)
                                    allLayouts[i][lkey].w = minWidth;
                                else
                                    allLayouts[i][lkey].w = allLayouts[i][lkey].w * 2;
                                allLayouts[i][lkey].x = 0;
                                allLayouts[i][lkey].y = 0;
                            }
                            else {
                                allLayouts[i][lkey].h = 0;
                                allLayouts[i][lkey].w = 0;
                                allLayouts[i][lkey].x = 0;
                                allLayouts[i][lkey].y = 0;
                            }
                        }
                    });
                }
            });

            this.setState({ layouts: allLayouts, Oldlayouts: Oldlayouts }, () => this.scrolltoTop());
            $("#menuwg").hide();
            $("#menuLayout").hide();
            //this.setState({ Oldlayouts: Oldlayouts });
        }
        else {
            this.setState({ FullscreenItem: new DashBoardItem() });
            //$(".react-grid-item").css('height', 425);
            //$(".react-grid-item").css('max-height', 425);
            //this.setState({ layouts: this.state.Oldlayouts });
            //this.setState({ DashBoardItems: _.reject(this.state.DashBoardItems, { Key: "" }) });
            //alert(JSON.stringify(this.state.Oldlayouts));
            //$("#menuwg").show();

            var Oldlayouts = JSON.parse(JSON.stringify(this.state.Oldlayouts));
            var DashboardItems = JSON.parse(JSON.stringify(this.state.DashBoardItems));
            var allLayouts = JSON.parse(JSON.stringify(this.state.layouts));
            $(".react-grid-item").css('height', gridHeight);

            $.each(allLayouts, function (i, n) {
                if (allLayouts[i] != undefined) {
                    forEach(allLayouts[i], function (lvalue, lkey) {
                        if (lvalue != undefined && lvalue.i != undefined) {
                            $(".react-grid-item").css('max-height', $(window).height());

                            allLayouts[i][lkey].h = Oldlayouts[i][lkey].h;
                            allLayouts[i][lkey].w = Oldlayouts[i][lkey].w;
                            allLayouts[i][lkey].x = Oldlayouts[i][lkey].x;//RCNG-1387
                            allLayouts[i][lkey].y = Oldlayouts[i][lkey].y;//RCNG-1387
                        }
                    });
                }
            });

            this.setState({ Defaultlayouts: this.allLayouts, DashBoardItems: DashboardItems, layouts: allLayouts });//RCNG-1387
            this.setState({ DashBoardItems: reject(this.state.DashBoardItems, { Key: "" }) });

            $("#menuwg").show();
            $("#menuLayout").show();
        }
        if (el.Key == "wgReeferMap")
            ReeferCallout.CancelDrawing();
        else
            ReeferCallout.ResetMapInfobox();

        this.setState({ isFullscreen: !this.state.isFullscreen });
    }
    onFullScreenPTI(el) {
        if (this.state.isFullscreen == false) {
            this.setState({ FullscreenItem: el })
            var Oldlayouts = JSON.parse(JSON.stringify(this.state.layouts));
            var allLayouts = JSON.parse(JSON.stringify(this.state.layouts));

            $.each(allLayouts, function (i, n) {
                if (allLayouts[i] != undefined) {
                    forEach(allLayouts[i], function (lvalue, lkey) {
                        if (lvalue != undefined && lvalue.i != undefined) {
                            if (lvalue.i == el.Key) {
                                allLayouts[i][lkey].h = allLayouts[i][lkey].h * 1.4;
                                allLayouts[i][lkey].w = allLayouts[i][lkey].w * 4.5;
                                allLayouts[i][lkey].x = 0;
                                allLayouts[i][lkey].y = 0;
                            }
                            else {
                                allLayouts[i][lkey].h = 0;
                                allLayouts[i][lkey].w = 0;
                                allLayouts[i][lkey].x = 0;
                                allLayouts[i][lkey].y = 0;
                            }
                        }
                    });
                }
            });

            this.setState({ layouts: allLayouts, Oldlayouts: Oldlayouts }, () => this.scrolltoTop());
            $("#menuwg").hide();
            $("#menuLayout").hide();
            //this.setState({ Oldlayouts: Oldlayouts });
        }
        else {
            this.setState({ FullscreenItem: new DashBoardItem() });
            this.setState({ layouts: this.state.Oldlayouts });
            //this.setState({ DashBoardItems: _.reject(this.state.DashBoardItems, { Key: "" }) });
            //alert(JSON.stringify(this.state.Oldlayouts));
            $("#menuwg").show();
            $("#menuLayout").show();
        }
        if (el.Key == "wgReeferMap")
            ReeferCallout.CancelDrawing();
        else
            ReeferCallout.ResetMapInfobox();

        this.setState({ isFullscreen: !this.state.isFullscreen });
    }
    
    pinAllDashboardWidgets(pinState: any){
        this.setState({ isLayoutUpdated: true });
       
        var allLayouts = JSON.parse(JSON.stringify(this.state.layouts));
        $.each(allLayouts, function (i, n) {
            if (allLayouts[i] != undefined) {
                forEach(allLayouts[i], function (lvalue, lkey) {
                    if (lvalue != undefined && lvalue.i != undefined) {
                        allLayouts[i][lkey].static = pinState;   
                    }
                }
                );
            }
        });

        this.setState({ layouts: allLayouts, Filters: this.state.Filters });
    }

    onPinItemClick(el) {
      isSaveLayout = true;
      if(self.state.IsReadOnly == false) {
        //console.log('Pin and unpin click');
        this.setState({ isLayoutUpdated: true });
        //breakpoints = {{ lg: 1200, md: 996, sm: 768, xs: 480, xxs: 0 }}
        var itemindex = indexOf(this.state.DashBoardItems, el);
        var items = JSON.parse(JSON.stringify(this.state.DashBoardItems));
        items[itemindex].IsPinned = !el.IsPinned;
        var allLayouts = JSON.parse(JSON.stringify(this.state.layouts));
        $.each(allLayouts, function (i, n) {
            if (allLayouts[i] != undefined) {
                forEach(allLayouts[i], function (lvalue, lkey) {
                    if (lvalue != undefined && lvalue.i != undefined) {
                        if (lvalue.i == el.Key) {
                            allLayouts[i][lkey].static = !el.IsPinned;
                            allLayouts[i][lkey].isDraggable = el.IsPinned;//	RCNG-3804
                            //_.forEach(items, function (ivalue, ikey) {
                            //    if (lvalue.i == ivalue.Key) {
                            //        items[ikey].Layout = allLayouts[i][lkey];
                            //    }
                            //});
                        }
                    }
                }
                );
            }
        });

        this.setState({ layouts: allLayouts, DashBoardItems: items, Filters: this.state.Filters, }, () => {
            //console.log('pinunpinI');
            this.restoreWidgetsLoaders();
            if (hasReefers) {
                this.BindCharts();
                this.BindColdTreatmentChart();
            }
            if (hasGensets) {
                this.BindGensetCharts();
            }
            if (hasDrys) {
                this.BindDryCharts();
            }
            if (hasChassis) {
                this.BindChassisCharts();
            }
            isSaveLayout = false;//	RCNG-3804 MP - QA3 : Pin / Unpin options are not saving when user navigates from one dashboard to another dashboard layout
            isSaved = false
            if (el.Key == 'wgAdvSearch') {
                this.CreateOrUpdateDashboard();
            }
        });

        if (el.Key == 'wgAdvSearch') {
            setTimeout(() => { AdvanceSearch.onSetPreviousState(); }, 800);
        }
      }

    }

    closeModel() {
        $('#contextMenuModel').hide();
    }

    scrolltoTop() {
        $('html, body').scrollTop(0);//For scrolling to top
    }

    fireResizeManually() {
        var timeoutResizing = setTimeout(() => {
            const evt = document.createEvent('UIEvents');
            evt.initEvent('resize', true, false);
            window.dispatchEvent(evt);
        }, 301); // wait just 1 millisecond more than transition open/close dashboard notes animations
    }

    bindingReeferStatusGrid(searchState: server.ReeferSearchFilters, isFromCargoCareAlert: boolean) {
        isLastSearchAdvanced = false;  
        if (this.state.WGSwitchAll.ReeferGrid == true) {
            if (JSON.parse(sessionStorage.getItem('SSRM'))) {
                //ReeferStatusSSRMGrid.refreshToggleFilters();
                //ReeferToggleButtonsFilter.ClearToggleFilters();
                if (enableReeferStatusGrid) {
                    //var JSONstr = JSON.stringify(this.state.Filters);
                    this.props.history.push('/reeferstatus', searchState);
                }
                else {
                    ReeferStatusSSRMGrid.ClearReeferStatusGridData();
                    if (this.state.WGSwitchAll.ReeferHistoryGrid == true)
                        ReeferHistoryGrid.ClearHistoryGridData();
                    /* WI-26367 - commented and calling without wait time
                    setTimeout(() => {

                        ReeferStatusSSRMGrid.ApplyReeferSearchFilter(searchState);
                    }, 6000);
                    */
                    setTimeout(() => { //RCNG 146
                        this.ReceiveSearchLoadingIsInProgressStatusToHome(true);
                        ReeferStatusSSRMGrid.ApplyReeferSearchFilter(searchState);
                    }, 200); ////RCNG 146
                    this.setState({ Filters: searchState, PrevReeferFilters: searchState });
                }
            } else {
                ReeferStatusGrid.refreshToggleFilters();
                ReeferToggleButtonsFilter.ClearToggleFilters();
                if (enableReeferStatusGrid) {
                    //var JSONstr = JSON.stringify(this.state.Filters);
                    this.props.history.push('/reeferstatus', searchState);
                }
                else {
                    ReeferStatusGrid.ClearReeferStatusGridData();
                    if (this.state.WGSwitchAll.ReeferHistoryGrid == true)
                        ReeferHistoryGrid.ClearHistoryGridData();
                    setTimeout(() => {
                        this.ReceiveSearchLoadingIsInProgressStatusToHome(true);
                        ReeferStatusGrid.ApplyReeferSearchFilter(searchState, false, isFromCargoCareAlert);
                    }, 200);
                    this.setState({ Filters: searchState, PrevReeferFilters: searchState });
                }
            }

        }
    }

    bindingGensetStatusGrid(searchState: server.ReeferSearchFilters) {
        if (this.state.WGSwitchAll.GensetGrid == true) {
            GensetStatusGrid.refreshToggleFilters();
            GensetToggleButtonsFilter.ClearToggleFilters();
            if (enableReeferStatusGrid) {
                //var JSONstr = JSON.stringify(this.state.Filters);
                this.props.history.push('/gensetstatus', searchState);
            }
            else {
                GensetStatusGrid.ClearGensetStatusGridData();
                if (this.state.WGSwitchAll.GensetHistoryGrid == true)
                    GensetHistoryGrid.ClearHistoryGridData();
                setTimeout(() => {
                    this.ReceiveSearchLoadingIsInProgressStatusToHome(true);
                    GensetStatusGrid.ApplyGensetSearchFilter(searchState, false);
                }, 200);
                this.setState({ Filters: searchState, PrevReeferFilters: filterDefault });
            }
        }
    }

    bindingDryStatusGrid(searchState: server.ReeferSearchFilters, newSearch: any, loadState: any) {
        if (this.state.WGSwitchAll.DryGrid == true) {
            DryStatusSSRMGrid.refreshToggleFilters();
            DryStatusToggleButtonsFilter.ClearToggleFilters();
            if (enableReeferStatusGrid) {
                //var JSONstr = JSON.stringify(this.state.Filters);
                this.props.history.push('/drystatus', searchState);
            }
            else {
                DryStatusSSRMGrid.ClearDryStatusGridData();
                if (this.state.WGSwitchAll.DryHistoryGrid == true)
                    DryHistoryGrid.ClearHistoryGridData();

                setTimeout(() => {
                    this.ReceiveSearchLoadingIsInProgressStatusToHome(true);
                    DryStatusSSRMGrid.ApplyDrySearchFilter(searchState, false, newSearch, loadState);
                }, 200);
                this.setState({ Filters: searchState, PrevReeferFilters: filterDefault });
            }
        }
    }

    bindingChassisStatusGrid(searchState: server.ReeferSearchFilters) {
        if (this.state.WGSwitchAll.ChassisGrid == true) {
            ChassisStatusGrid.refreshToggleFilters();
            ChassisStatusToggleButtonsFilter.ClearToggleFilters();
            if (enableReeferStatusGrid) {
                //var JSONstr = JSON.stringify(this.state.Filters);
                this.props.history.push('/chassisstatus', searchState);
            }
            else {
                ChassisStatusGrid.ClearChassisStatusGridData();
                if (this.state.WGSwitchAll.ChassisHistoryGrid == true)
                    ChassisHistoryGrid.ClearHistoryGridData();
                setTimeout(() => {
                    this.ReceiveSearchLoadingIsInProgressStatusToHome(true);
                    ChassisStatusGrid.ApplyChassisSearchFilter(searchState, false);
                }, 200);
                this.setState({ Filters: searchState, PrevReeferFilters: filterDefault });
            }
        }
    }

    //WI-23763
    bindingReeferGensetDryChassisStatusGrid(searchState: server.ReeferSearchFilters, isFenceAssets: any) {
        totalWidgetSearch = true;//WI26412
        loaderState = false;
        setTimeout(() => {
            //isLastSearchAdvanced = true;
            if (JSON.parse(sessionStorage.getItem('SSRM')) && hasReefers == true) {
                var hasReeferFilter = searchState.SelectedAssetTypes;
                if (hasReeferFilter != null && hasReeferFilter != undefined && hasReeferFilter.length > 0) {
                    var regexp = /Reefer/gi;
                    var regexpDry = /Dry/gi;
                    if (hasReeferFilter.search(regexp) == -1) {
                        ////console.log("Does not contain Reefer");
                        if (hasReeferFilter == "Dry")
                            this.bindingDryStatusGrid(searchState, false, loaderState);
                        else {
                            loaderState = true;
                            if (hasReeferFilter.search(regexpDry) != -1)
                                this.bindingDryStatusGrid(searchState, true, loaderState);
                            this.props.requestAllAssetTypeAdvanceSearchSSRM(searchState, isFenceAssets);
                        }
                        // setTimeout(() => {
                        ReeferStatusSSRMGrid.ClearReeferStatusGridData();
                        //}, 2000);
                    } else {                       
                        var regexpDry = /Dry/gi;
                        var regexpChassis = /Chassis/gi;
                        var regexpGenset = /Genset/gi;
                        loaderState = true;
                        if (hasReeferFilter.search(regexpChassis) != -1 || hasReeferFilter.search(regexpGenset) != -1)                            
                            this.props.requestAllAssetTypeAdvanceSearchSSRM(searchState, isFenceAssets);
                        if (hasReeferFilter.search(regexpDry) != -1)
                            this.bindingDryStatusGrid(searchState, true, loaderState);
                        this.bindingReeferStatusGrid(searchState, false);
                    }
                } else {
                    loaderState = true;
                    this.props.requestAllAssetTypeAdvanceSearchSSRM(searchState, isFenceAssets, true);
                    this.bindingReeferStatusGrid(searchState, false);
                    this.bindingDryStatusGrid(searchState, true, loaderState);
                }
            }
            else {
                if (hasDrys == true) {
                    var hasDryFilter = searchState.SelectedAssetTypes;
                    if (hasDryFilter != null && hasDryFilter != undefined && hasDryFilter.length > 0) {
                        var regexp = /Dry/gi;
                        if (hasDryFilter.search(regexp) == -1) {
                            DryStatusSSRMGrid.ClearDryStatusGridData();
                        }
                    }
                    if (hasDryFilter == "Dry") {
                        loaderState = true;
                        this.props.requestAllAssetTypeAdvanceSearch(searchState, isFenceAssets, true);//RCNG 4655 Fix - issue in Asset Search when selecting the Asset type as Reefer
                        this.bindingDryStatusGrid(searchState, false, loaderState);
                    }
                    else {
                        loaderState = true;
                        this.props.requestAllAssetTypeAdvanceSearch(searchState, isFenceAssets, true);
                        if (hasDryFilter.search(regexp) != -1)//RCNG-4147
                            this.bindingDryStatusGrid(searchState, true, loaderState);
                    }
                }
                else {
                    this.props.requestAllAssetTypeAdvanceSearch(searchState, isFenceAssets, true);
                }
            }
        }, 200);
        this.setState({ Filters: searchState, isFenceAssets: isFenceAssets, PrevReeferFilters: searchState });
    }


    renderDataToEmailControl(gridData: any, colDefs: any, colDefs2: any, formName: string, parentChild: string, functionId: any, widgetId: any, gridApiParams: any,
        isIncludeRowGroup: boolean, sensorData: any) {
        this.setState({
            EmailData: gridData, ColumnDefs: colDefs, ColumnDefs2: colDefs2, ParentOrChild: parentChild,
            SourceForm: formName, FunctionID: functionId, WidgetId: widgetId, gridApiParams: gridApiParams, isIncludeRowGroup: isIncludeRowGroup, assetTypeSensors: sensorData
        }, () => { $('#dashBoardEmailPopUp').show(); });
        //this.setState({
        //    emailPopUpHtml: this.renderEmailPopUp(gridData, colDefs, formName, parentChild)
        //});

        //$('.GridToolBarParent').attr('disabled', 'disabled');
        $('#modal-backdrop-email').addClass('show');
    }

    renderDataGridPreferenceControl(functionId: any, widgetId: any, gridApiParams: any, formName: string) {
        this.setState({ gridPreferenceHtml: '', formName: formName });
        this.setState({ gridPreferenceHtml: this.bindGridPreferenceData(functionId, widgetId, gridApiParams, formName) }, () => {
            $('#btnTriggerGridPreference').click();
        });
    }

    renderDataGridExportToExcelControl(functionId: any, widgetId: any, gridApiParams: any, formName: string, gridData: any, colDefs: any, colDefs2: any, parentchild: any, sensorData: any) {
        this.setState({ ExportToExcelHTML: '' });
        this.setState({ ExportToExcelHTML: this.bindExportToExcel(functionId, widgetId, gridApiParams, formName, gridData, colDefs, colDefs2, parentchild, sensorData) }, () => {
            $('#btnTriggerExportToExcel').click();
        });
    }
    //WI-23795
    renderSearchPreferenceControl(functionId: any, gridApiParams: any, formName: string) {
        isSaveLayout = true;
        this.setState({ searchPreferenceHtml: '' });
        this.setState({ searchPreferenceHtml: this.bindSearchPreferenceData(functionId, gridApiParams, formName) }, () => {
            $('#btnTriggerSearchPreference').click();
        });
    }

    bindSearchPreferenceData(functionId: any, gridApiParams: any, formName: string) {        
        return <SearchPreferenceControl dashboardPreferenceId = {this.state.DashboardPreferenceId} saveAndCloseSearchPreferenceDialog={this.saveAndCloseSearchPreferenceModel.bind(this)}></SearchPreferenceControl>
    }
    renderClearSelectionForAllAsset() {

        ReeferHistoryGrid.ClearHistoryGridData();
        GensetHistoryGrid.ClearHistoryGridData();
        ChassisHistoryGrid.ClearHistoryGridData();
        DryHistoryGrid.ClearHistoryGridData();

        var dict = {
            "Reefers": this.props.reeferStatus,
            "Dry": this.props.dryStatus,
            "Genset": this.props.gensetStatus,
            "Chassis": this.props.chassisStatus,
        }

        this.clearGridHeaderExtension();
        this.clearGensetGridHeaderExtension();
        this.clearDryGridHeaderExtension();
        this.clearChassisGridHeaderExtension();

        ReeferStatusGrid.ClearSelection();
        ReeferStatusSSRMGrid.ClearSelection();
        GensetStatusGrid.ClearSelection();
        DryStatusSSRMGrid.ClearSelection();
        ChassisStatusGrid.ClearSelection();

        if (this.props.reeferFormatter != null)
            ReeferCallout.BindClusterMapAllAssetsPushpins(dict, 'All Assets', this.props.reeferFormatter, "");
    }

    renderSaveSearchControl() {
        this.setState({ SaveSearchHtml: '' });
        this.setState({ SaveSearchHtml: this.renderSaveSearchHtml() }, () => {
            $('#btnTriggerSaveSearch').click();
        });
    }

    renderAddGeofenceControl(formName: string, coordinates: any, currentFence: any, GeofencesData: any[]) {
        this.setState({ addGeofenceTitle: '', addGeofenceHtml: '', geofenceData: GeofencesData });
        this.setState({ addGeofenceTitle: formName, addGeofenceHtml: this.bindAddGeofenceData(formName, coordinates, currentFence, GeofencesData) }, () => {
            $('#btnTriggerAddGeofence').click();
        });
    }

    bindAddGeofenceData(formName: string, coordinates: any, currentFence: any, GeofencesData: any[]) {
        if (formName == 'Add Geofence')
            return <AddGeofence formname={formName} geofenceCoordinates={coordinates} source={"DashBoard"} closeModelDialog={self.closeToolBarGridPreferenceModel.bind(this)} />
        else if (formName == 'Edit Geofence')
            return <EditGeofence formname={formName} geofenceCoordinates={coordinates} currentFence={currentFence} geofencesData={GeofencesData} source={"DashBoard"} closeModelDialog={self.closeToolBarGridPreferenceModel.bind(this)} />
    }

    fnCancelDrawing(e) {
        ReeferCallout.CancelDrawing();
        if (this.state.addGeofenceTitle == 'Edit Geofence')
            ReeferCallout.BindGeofencePolygons(this.state.geofenceData);
    }

    bindGridPreferenceData(functionId: any, widgetId: any, gridApiParams: any, formName: string) {
        //if (formName == "ReeferStatusGrid" || formName == "ReeferHistoryGrid")
        //    return <GridPreferenceControl formname={formName} functionId={functionId} gridApiParams={gridApiParams} closeModelDialog={self.closeToolBarGridPreferenceModel.bind(this)}></GridPreferenceControl>;
        //else
        return <GridColumnPreferences formname={formName} functionId={functionId} widgetId={widgetId} dashboardWidgetsSearch={this.state.DashboardWidgetsSearch} dashboardPreferenceId = {this.state.DashboardPreferenceId}
             revisionNum={this.state.RevisionNum} gridApiParams={gridApiParams} validateRevisionNum={this.validateRevisionNum.bind(this)}
            refreshRevisionNum={this.refreshRevisionNum.bind(this)} closeModelDialog={self.closeToolBarGridPreferenceModel.bind(this)}></GridColumnPreferences>;

    }

    bindExportToExcel(functionId: any, widgetId: any, gridApiParams: any, formName: string, gridData: any, colDefs: any, colDefs2: any, parentchild: any, sensorData: any) {
        return <ExportToExcelConfirmationWindow formName={formName} functionId={functionId} widgetId={widgetId} gridApiParams={gridApiParams}
            gridData={gridData} colDefs={colDefs} colDefs2={colDefs2} parentchild={parentchild} dashboardWidgetsSearch={this.state.DashboardWidgetsSearch}
            dashboardPreferenceId = {this.state.DashboardPreferenceId} closeModelDialog={self.closeToolBarGridPreferenceModel.bind(this)} sensorData={sensorData}></ExportToExcelConfirmationWindow>
    }

    renderSaveSearchHtml() {
        return <SaveSearch />
    }

    renderEmailPopUp(gridData: any, colDefs: any, formName: string, parentChild: string) {
        return <SharedEmailPopUp gridData={gridData} colDefs={colDefs} formName={formName} parentChild={parentChild}></SharedEmailPopUp>
    }
    AssetStateChangeAllDrys(value) {
        this.setState({ SelectedAssetStatesTotalDrys: value }, () => { });
    }

    AssetStateChangeAllGensets(value) {
        this.setState({ SelectedAssetStatesTotalGensets: value }, () => { });
        if (value == "") {
            $('.widgetbgTotalGensets').parent().addClass('widgetbgZindex');
        }
    }
    /*RCNG 13*/
    AssetStateChangeMA(value) {
        this.setState({ SelectedAssetStatesMA: value }, () => { });
    }
    /*RCNG 13*/

    /*RCNG 14*/
    AssetStateChangeCC(value) {
        this.setState({ SelectedAssetStatesCC: value }, () => { });
    }
    /*RCNG 14*/

    /*RCNG 17*/
    AssetStateChangeTotalReefers(value) {
        this.setState({ SelectedAssetStatesTotalReefers: value }, () => { });
        if (value == "") {
            $('.widgetbgTotalReefers').parent().addClass('widgetbgZindex');
        }
    }
    /*RCNG 17*/

    /*    RCNG 16*/
    AssetStateChangePTR(value) {
        this.setState({ SelectedAssetStatesPTR: value }, () => { });
    }
    /*    RCNG 16*/

    createElement(el: DashBoardItem) {
        let DisplayStyle = "block";
        let IconsDisplayStyle = "block";
        if (this.state.FullscreenItem.Key != undefined && el.Key != this.state.FullscreenItem.Key) {
            DisplayStyle = "none";
        }

        if (el.Key == this.state.FullscreenItem.Key) {
            IconsDisplayStyle = "none";
        }

        let PinClasses = el.IsPinned ? 'fa-solid fa-thumbtack' : 'fa-solid fa-thumbtack fa-rotate-90 mb-2';
        let HeadeBgClasses = el.IsPinned ? 'widget-heading' : 'widget-heading';

        var assetStates = this.state.AssetStates;
        if (assetStates != undefined && assetStates != null && assetStates.length > 0) {
            var assetStatesOptions = assetStates.map(function (states) {
                return (
                    { value: states.value, label: states.label }
                );
            });
        }
        
        if (el.Key == 'wgReeferGrid') {

            return <div key="wgReeferGrid" style={{ display: DisplayStyle }}>
                <div id='wgReeferGrid' className='widget-grids'>
                    <div className={HeadeBgClasses}>
                        <div>Reefer Grid </div>
                        <div className='widget-controls ms-auto gap-3'>
                            <div className='reefer-paging'>
                            <span className='grid-paging-text me-3'>Paging :</span>
                                <div className='home-page-switch'> <Switch onClick={this.toggleServerSide.bind(this)} on={this.state.EnableServerSide} /> </div>
                            </div>
                            <div className="btn-group btn-group-sm aggrid-icons" role="group" aria-label="Small button group">
                                <button type="button" onClick={this.onRemoveItem.bind(this, el)} className={this.state.IsReadOnly == true ? "btn btn-outline-secondary disabled" : "btn btn-outline-secondary"}>    <span className='fa-solid fa-trash-xmark' style={{ display: IconsDisplayStyle }} ></span> </button>
                                <button type="button" onClick={this.onPinItemClick.bind(this, el)} className={this.state.IsReadOnly == true ? "btn btn-outline-secondary disabled" : "btn btn-outline-secondary"}>
                                    {
                                        el.Key != this.state.lastWidgetName ? <span className={PinClasses} style={{ display: IconsDisplayStyle }} ></span> :
                                            <span className={PinClasses} style={{ display: IconsDisplayStyle }}></span>
                                    }
                                </button>
                                <button type="button" onClick={this.onFullScreen.bind(this, el, 'wgReeferGrid')} className="btn btn-outline-secondary">    <span className='fa-solid fa-expand' ></span>  </button>
                            </div>

                        </div>
                    </div>
                    <div onMouseDown={e => e.stopPropagation()}>
                        <div id="" className="loader-bg"><img className="loader-img" src={animatedloader} width="80" height="80" alt='Loading' /></div>
                        <div>{this.GetLoadReeferStatusGridData(this.state.Filters)}</div>
                    </div>
                </div>
            </div>
        }

        if (el.Key == 'wgGensetGrid') {

            return <div key="wgGensetGrid" style={{ display: DisplayStyle }}>
                <div id='wgGensetGrid' className='widget-grids'>
                    <div className={HeadeBgClasses}>
                        <div>Genset Grid</div>
                        <div className='widget-controls ms-auto gap-3'>

                            <div className="btn-group btn-group-sm aggrid-icons" role="group" aria-label="Small button group">
                                <button type="button" onClick={this.onRemoveItem.bind(this, el)} className={this.state.IsReadOnly == true ? "btn btn-outline-secondary disabled" : "btn btn-outline-secondary"}>  <span className='fa-solid fa-trash-xmark' style={{ display: IconsDisplayStyle }} ></span> </button>
                                <button type="button" onClick={this.onPinItemClick.bind(this, el)} className={this.state.IsReadOnly == true ? "btn btn-outline-secondary disabled" : "btn btn-outline-secondary"}>
                                    {
                                        el.Key != this.state.lastWidgetName ? <span className={PinClasses} style={{ display: IconsDisplayStyle }} ></span> :
                                            <span className={PinClasses} style={{ display: IconsDisplayStyle }}></span>
                                    }
                                </button>
                                <button type="button" className="btn btn-outline-secondary">  <span className='fa-solid fa-expand' onClick={this.onFullScreen.bind(this, el, 'wgGensetGrid')}></span>  </button>
                            </div>
                        </div>
                    </div>
                    <div onMouseDown={e => e.stopPropagation()}>
                        <div id="" className="loader-bg"><img className="loader-img" src={animatedloader} width="80" height="80" alt='Loading' /></div>
                        <div>{this.GetLoadGensetStatusGridData(this.state.Filters)}</div>
                    </div>
                </div>
            </div>
        }

        if (el.Key == 'wgDryGrid') {
            return <div key="wgDryGrid" style={{ display: DisplayStyle }}>
                <div id='wgDryGrid' className='widget-grids'>
                    <div className={HeadeBgClasses}>
                        <div>Dry Grid</div>
                        <div className='widget-controls ms-auto gap-3'>

                            <div className="btn-group btn-group-sm aggrid-icons" role="group" aria-label="Small button group">
                                <button type="button" onClick={this.onRemoveItem.bind(this, el)} className={this.state.IsReadOnly == true ? "btn btn-outline-secondary disabled" : "btn btn-outline-secondary"}>  <span className='fa-solid fa-trash-xmark' style={{ display: IconsDisplayStyle }} ></span> </button>
                                <button type="button" onClick={this.onPinItemClick.bind(this, el)} className={this.state.IsReadOnly == true ? "btn btn-outline-secondary disabled" : "btn btn-outline-secondary"}>
                                    {
                                        el.Key != this.state.lastWidgetName ? <span className={PinClasses} style={{ display: IconsDisplayStyle }} ></span> :
                                            <span className={PinClasses} style={{ display: IconsDisplayStyle }}></span>
                                    }
                                </button>
                                <button type="button" onClick={this.onFullScreen.bind(this, el, 'wgDryGrid')} className="btn btn-outline-secondary">  <span className='fa-solid fa-expand' ></span>  </button>
                            </div>                           
                        </div>
                    </div>
                    <div onMouseDown={e => e.stopPropagation()}>
                        <div id="" className="loader-bg"><img className="loader-img" src={animatedloader} width="80" height="80" alt='Loading' /></div>
                        <div>{this.GetLoadDryStatusGridData(this.state.Filters)}</div>
                    </div>
                </div>
            </div>
        }

        if (el.Key == 'wgChassisGrid') {
            return <div key="wgChassisGrid" style={{ display: DisplayStyle }}>
                <div id='wgChassisGrid' className='widget-grids'>
                    <div className={HeadeBgClasses}>
                        <div>Chassis Grid</div>
                        <div className='widget-controls ms-auto gap-3'>

                            <div className="btn-group btn-group-sm aggrid-icons" role="group" aria-label="Small button group">
                                <button type="button" onClick={this.onRemoveItem.bind(this, el)} className={this.state.IsReadOnly == true ? "btn btn-outline-secondary disabled" : "btn btn-outline-secondary"}>   <span className='fa-solid fa-trash-xmark' style={{ display: IconsDisplayStyle }} ></span> </button>
                                <button type="button" onClick={this.onPinItemClick.bind(this, el)} className={this.state.IsReadOnly == true ? "btn btn-outline-secondary disabled" : "btn btn-outline-secondary"}>
                                    {
                                        el.Key != this.state.lastWidgetName ? <span className={PinClasses} style={{ display: IconsDisplayStyle }} ></span> :
                                            <span className={PinClasses} style={{ display: IconsDisplayStyle }}></span>
                                    }
                                </button>
                                <button type="button" onClick={this.onFullScreen.bind(this, el, 'wgChassisGrid')} className="btn btn-outline-secondary"> <span className='fa-solid fa-expand' ></span> </button>
                            </div>

                        </div>
                    </div>
                    <div onMouseDown={e => e.stopPropagation()}>
                        <div id="" className="loader-bg"><img className="loader-img" src={animatedloader} width="80" height="80" alt='Loading' /></div>
                        <div>{this.GetLoadChassisStatusGridData(this.state.Filters)}</div>
                    </div>
                </div>
            </div>
        }

        if (el.Key == 'wgReeferHistory') {

            return <div key="wgReeferHistory" style={{ display: DisplayStyle }}>
                <div id='wgReeferHistory' className='widget-grids'>
                    <div className={HeadeBgClasses} >
                        <div>Reefer History Grid  {this.state.ExtensionForGridHeader}</div>
                        <div className='widget-controls ms-auto gap-3'>

                            <div className="btn-group btn-group-sm aggrid-icons" role="group" aria-label="Small button group">
                                <button type="button" onClick={this.onRemoveItem.bind(this, el)} className={this.state.IsReadOnly == true ? "btn btn-outline-secondary disabled" : "btn btn-outline-secondary"}>     <span className='fa-solid fa-trash-xmark' style={{ display: IconsDisplayStyle }} ></span> </button>
                                <button type="button" onClick={this.onPinItemClick.bind(this, el)} className={this.state.IsReadOnly == true ? "btn btn-outline-secondary disabled" : "btn btn-outline-secondary"}>
                                    {
                                        el.Key != this.state.lastWidgetName ? <span className={PinClasses} style={{ display: IconsDisplayStyle }} ></span> :
                                            <span className={PinClasses} style={{ display: IconsDisplayStyle }}></span>
                                    }
                                </button>
                                <button type="button" onClick={this.onFullScreen.bind(this, el, 'wgReeferHistory')} className="btn btn-outline-secondary">     <span className='fa-solid fa-expand' ></span>  </button>
                            </div>

                        </div>
                    </div>
                    <div onMouseDown={e => e.stopPropagation()}>
                        <div id="" className="loader-bg"><img className="loader-img" src={animatedloader} width="80" height="80" alt='Loading' /></div>
                        <div>{this.GetLoadReeferHistoryGridData()}</div>
                    </div>
                </div>
            </div>
        }

        if (el.Key == 'wgReeferTempGraph') {

            return <div key="wgReeferTempGraph" style={{ display: DisplayStyle }}>
                <div className='widget-grids'>
                    <div className={HeadeBgClasses} >
                        <div>Reefer Monitoring Data {this.state.ExtensionForGraphHeader}</div>
                        <div className='widget-controls ms-auto gap-3'>
                            <div className="btn-group btn-group-sm aggrid-icons" role="group" aria-label="Small button group">
                                <button type="button" onClick={this.onRemoveItem.bind(this, el)} className={this.state.IsReadOnly == true ? "btn btn-outline-secondary disabled" : "btn btn-outline-secondary"}>     <span className='fa-solid fa-trash-xmark' style={{ display: IconsDisplayStyle }} ></span>  </button>

                                <button type="button" onClick={this.onPinItemClick.bind(this, el)} className={this.state.IsReadOnly == true ? "btn btn-outline-secondary disabled" : "btn btn-outline-secondary"}>
                                    {
                                        el.Key != this.state.lastWidgetName ? <span className={PinClasses} style={{ display: IconsDisplayStyle }} ></span> :
                                            <span className={PinClasses} style={{ display: IconsDisplayStyle }}></span>
                                    }
                                </button>                               
                            </div>

                        </div>
                    </div>
                    <div onMouseDown={e => e.stopPropagation()}>
                        <div id="reeferTempLoader" className="loader-bg"><img className="loader-img" src={animatedloader} width="80" height="80" alt='Loading' /></div>
                        <div className='dashboardTempGraph'>{this.GetLoadReeferTemperatureGraphData()}</div>
                    </div>
                </div>
            </div>
        }

        if (el.Key == 'wgGensetHistory') {

            return <div key="wgGensetHistory" style={{ display: DisplayStyle }}>
                <div id='wgGensetHistory' className='widget-grids'>
                    <div className={HeadeBgClasses} >
                        <div>Genset History Grid  {this.state.ExtensionForGensetGridHeader}</div>
                        <div className='widget-controls ms-auto gap-3'>

                            <div className="btn-group btn-group-sm aggrid-icons" role="group" aria-label="Small button group">
                                <button type="button" onClick={this.onRemoveItem.bind(this, el)} className={this.state.IsReadOnly == true ? "btn btn-outline-secondary disabled" : "btn btn-outline-secondary"}>  <span className='fa-solid fa-trash-xmark' style={{ display: IconsDisplayStyle }} ></span> </button>
                                <button type="button" onClick={this.onPinItemClick.bind(this, el)} className={this.state.IsReadOnly == true ? "btn btn-outline-secondary disabled" : "btn btn-outline-secondary"}>
                                    {
                                        el.Key != this.state.lastWidgetName ? <span className={PinClasses} style={{ display: IconsDisplayStyle }} ></span> :
                                            <span className={PinClasses} style={{ display: IconsDisplayStyle }}></span>
                                    }
                                </button>
                                <button type="button" onClick={this.onFullScreen.bind(this, el, 'wgGensetHistory')} className="btn btn-outline-secondary"> <span className='fa-solid fa-expand' ></span>  </button>
                            </div>                           
                        </div>
                    </div>
                    <div onMouseDown={e => e.stopPropagation()}>
                        <div id="" className="loader-bg"><img className="loader-img" src={animatedloader} width="80" height="80" alt='Loading' /></div>
                        <div>{this.GetLoadGensetHistoryGridData()}</div>
                    </div>
                </div>
            </div>
        }

        if (el.Key == 'wgDryHistory') {
            return <div key="wgDryHistory" style={{ display: DisplayStyle }}>
                <div id='wgDryHistory' className='widget-grids'>
                    <div className={HeadeBgClasses} >
                        <div>Dry History Grid  {this.state.ExtensionForDryGridHeader}</div>
                        <div className='widget-controls ms-auto gap-3'>

                            <div className="btn-group btn-group-sm aggrid-icons" role="group" aria-label="Small button group">
                                <button type="button" onClick={this.onRemoveItem.bind(this, el)} className={this.state.IsReadOnly == true ? "btn btn-outline-secondary disabled" : "btn btn-outline-secondary"}>  <span className='fa-solid fa-trash-xmark' style={{ display: IconsDisplayStyle }} ></span> </button>
                                <button type="button" onClick={this.onPinItemClick.bind(this, el)} className={this.state.IsReadOnly == true ? "btn btn-outline-secondary disabled" : "btn btn-outline-secondary"}>
                                    {
                                        el.Key != this.state.lastWidgetName ? <span className={PinClasses} style={{ display: IconsDisplayStyle }} ></span> :
                                            <span className={PinClasses} style={{ display: IconsDisplayStyle }}></span>
                                    }
                                </button>
                                <button type="button" onClick={this.onFullScreen.bind(this, el, 'wgDryHistory')} className="btn btn-outline-secondary">  <span className='fa-solid fa-expand' ></span>  </button>
                            </div>

                        </div>
                    </div>
                    <div onMouseDown={e => e.stopPropagation()}>
                        <div id="" className="loader-bg"><img className="loader-img" src={animatedloader} width="80" height="80" alt='Loading' /></div>
                        <div>{this.GetLoadDryHistoryGridData()}</div>
                    </div>
                </div>
            </div>
        }

        if (el.Key == 'wgChassisHistory') {
            return <div key="wgChassisHistory" style={{ display: DisplayStyle }}>
                <div id='wgChassisHistory' className='widget-grids'>
                    <div className={HeadeBgClasses} >
                        <div>Chassis History Grid  {this.state.ExtensionForChassisGridHeader}</div>
                        <div className='widget-controls ms-auto gap-3'>
                            <div className="btn-group btn-group-sm aggrid-icons" role="group" aria-label="Small button group">
                                <button type="button" onClick={this.onRemoveItem.bind(this, el)} className={this.state.IsReadOnly == true ? "btn btn-outline-secondary disabled" : "btn btn-outline-secondary"}>    <span className='fa-solid fa-trash-xmark' style={{ display: IconsDisplayStyle }} ></span> </button>
                                <button type="button" onClick={this.onPinItemClick.bind(this, el)} className={this.state.IsReadOnly == true ? "btn btn-outline-secondary disabled" : "btn btn-outline-secondary"}>    {
                                    el.Key != this.state.lastWidgetName ? <span className={PinClasses} style={{ display: IconsDisplayStyle }} ></span> :
                                        <span className={PinClasses} style={{ display: IconsDisplayStyle }}></span>
                                } </button>
                                <button type="button" onClick={this.onFullScreen.bind(this, el, 'wgChassisHistory')} className="btn btn-outline-secondary">    <span className='fa-solid fa-expand'></span> </button>
                            </div>
                        </div>
                    </div>
                    <div onMouseDown={e => e.stopPropagation()}>
                        <div id="" className="loader-bg"><img className="loader-img" src={animatedloader} width="80" height="80" alt='Loading' /></div>
                        <div>{this.GetLoadChassisHistoryGridData()}</div>
                    </div>
                </div>
            </div>
        }

        if (el.Key == 'wgPTResult') {

            return <div key="wgPTResult" style={{ display: DisplayStyle }}>
                <div className='widget-grids overflow-visible'>
                    <div className={HeadeBgClasses} >
                        <div>PTI Results</div>
                        <div className='widget-controls ms-auto gap-3 applySettingsPTI'>

                            <div className="btn-group btn-group-sm aggrid-icons" role="group" aria-label="Small button group">
                                <button type="button" onClick={this.onPTIWidgetClick.bind(this)} className="btn btn-outline-secondary">   <span className='fa-sharp fa-solid fa-gear-complex' data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" style={{ display: IconsDisplayStyle }} ></span> </button>

                                <div className='drop-down-state SettingsDropdown' id='drop-down-inv-pti'>
                                    <div className='AssetSettinsText'>
                                        <span className='inv-state'>Inventory State </span>
                                        <div className='invent-circle'><span className="fa-sharp fa-regular fa-xmark invclose" onClick={this.onPTIWidgetClickClose.bind(this)}></span></div>
                                    </div>
                                    <div>
                                        <Select.Creatable
                                            closeOnSelect={!this.state.stayOpen}
                                            disabled={this.state.disabled}
                                            multi
                                            onChange={this.AssetStateChangePTR.bind(this)}
                                            options={assetStatesOptions}
                                            placeholder="Inventory State"
                                            removeSelected={this.state.removeSelected}
                                            rtl={this.state.rtl}
                                            simpleValue
                                            value={this.state.SelectedAssetStatesPTR}
                                            minMenuHeight={30}
                                            maxMenuHeight={30}
                                            promptTextCreator={() => false}
                                        />
                                    </div>
                                    <div className='reeferdatesearch'>
                                        <button type='button' className='btn btn-primary float-end' id='btn_inv-pti'  onClick={this.GetPTResultsByAssetState.bind(this)}>Search</button>
                                    </div>

                                </div>

                                <button type="button" onClick={this.onRemoveItem.bind(this, el)} className={this.state.IsReadOnly == true ? "btn btn-outline-secondary disabled" : "btn btn-outline-secondary"}>  <span className='fa-solid fa-trash-xmark' style={{ display: IconsDisplayStyle }} ></span> </button>
                                <button type="button" onClick={this.onPinItemClick.bind(this, el)} className={this.state.IsReadOnly == true ? "btn btn-outline-secondary disabled" : "btn btn-outline-secondary"}>  <span className={PinClasses} style={{ display: IconsDisplayStyle }} ></span> </button>
                                <button type="button" onClick={this.onFullScreenPTI.bind(this, el)} className="btn btn-outline-secondary">  <span className='fa-solid fa-expand' ></span> </button>
                            </div>

                        </div>
                    </div>
                    <div onMouseDown={e => e.stopPropagation()}>
                        <div id="ptresultLoader" className="loader-bg"><img className="loader-img" src={animatedloader} width="80" height="80" alt='Loading' /></div>
                        <div>{this.GetLoadPTResultGridData()}</div>
                    </div>
                </div>
            </div>
        }

        if (el.Key == 'wgAdvSearch') {
            return <div key="wgAdvSearch" style={{ display: DisplayStyle }}>
                <div className='widget-grids advance-search'>
                    <div className={HeadeBgClasses}>
                        <div>Asset Search</div>
                        <div className='widget-controls ms-auto gap-3'>
                            
                            <div className="btn-group btn-group-sm aggrid-icons" role="group" aria-label="Small button group">
                                <button type="button" onClick={this.renderSearchPreferenceControl.bind(this)} className={this.state.IsReadOnly == true ? "btn btn-outline-secondary disabled" : "btn btn-outline-secondary"}>  <span className="fa-sharp fa-solid fa-gear-complex" title='Choose and Order Search Fields' id="hidePopUpBtnGridPreference" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" ></span> </button>

                                <button type="button" onClick={this.onRemoveItem.bind(this, el)} className={"btn btn-outline-secondary disabled"}>  <span className='fa-solid fa-trash-xmark' style={{ display: IconsDisplayStyle }} ></span> </button>

                                <button type="button" onClick={this.onPinItemClick.bind(this, el)} className={this.state.IsReadOnly == true ? "btn btn-outline-secondary disabled" : "btn btn-outline-secondary"}> <span className={PinClasses} style={{ display: IconsDisplayStyle }} ></span>  </button>
                            </div>

                        </div>
                    </div>
                    <div id="searchLoader" className="loader-bg"><img className="loader-img" src={animatedloader} width="50" height="50" alt='Loading' /></div>
                    <div onMouseDown={e => e.stopPropagation()}>
                        <AdvanceSearch reeferIdForHeader={this.setGridHeader} previousState={this.state.Filters} clearHistoryGridHeaders={this.clearHistoryGridHeaders.bind(this)}
                            CustomAttributes={this.state.CustomAttributes} bindingReeferGensetDryChassisStatusGrid={this.bindingReeferGensetDryChassisStatusGrid.bind(this)}
                            renderSaveSearchControl={this.renderSaveSearchControl.bind(this)} CargoCareProfiles={this.state.CargoCareProfiles}
                            SendSearchLoadingIsInProgressToHome={this.ReceiveSearchLoadingIsInProgressStatusToHome.bind(this) }
                            dashboardPreferenceId={this.state.DashboardPreferenceId}
                            isReadOnly={this.state.IsReadOnly}
                            revisionNum={this.state.RevisionNum}
                            validateRevisionNum={this.validateRevisionNum.bind(this)}
                            refreshRevisionNum={this.refreshRevisionNum.bind(this)}
                        ></AdvanceSearch>
                    </div>
                </div>
            </div>
        }

        if (el.Key == 'wgMicroalarms') {

            return <div key="wgMicroalarms" style={{ display: DisplayStyle }}>
                <div className='widget-grids'>
                    <div className={HeadeBgClasses} >
                        <div id="ReefersMAAlarmTitle"> Reefers with Alarms – Fleet </div>
                        <div className='widget-controls ms-auto gap-3 applySettingsMA'>

                            <div className="btn-group btn-group-sm aggrid-icons" role="group" aria-label="Small button group">
                                <button type="button" onClick={this.onMAWidgetClick.bind(this)} className="btn btn-outline-secondary">    <span className='fa-sharp fa-solid fa-gear-complex' data-toggle="dropdown" aria-haspopup="true"  aria-expanded="false" style={{ display: IconsDisplayStyle }} ></span>  </button>

                                <div className='drop-down-state SettingsDropdown' id='drop-down-inv-ma'>
                                    <div className='AssetSettinsText'>
                                        <span className='inv-state'>Inventory State </span>
                                        <div className='invent-circle'><span className="fa-sharp fa-regular fa-xmark invclose" onClick={this.onMAWidgetClickClose.bind(this)}></span></div>
                                    </div>
                                    <div>
                                        <Select.Creatable
                                            closeOnSelect={!this.state.stayOpen}
                                            disabled={this.state.disabled}
                                            multi
                                            onChange={this.AssetStateChangeMA.bind(this)}
                                            options={assetStatesOptions}
                                            placeholder="Inventory State"
                                            removeSelected={this.state.removeSelected}
                                            rtl={this.state.rtl}
                                            simpleValue
                                            value={this.state.SelectedAssetStatesMA}
                                            minMenuHeight={30}
                                            maxMenuHeight={30}
                                            promptTextCreator={() => false}
                                        />
                                    </div>
                                    <div className='reeferdatesearch'>
                                        <button type='button' className='btn btn-primary float-end' id='btn_inv-ma' onClick={this.ReeferStatusSummaryMA.bind(this,true)}>Search</button>
                                    </div>

                                </div>

                                <button type="button" onClick={this.onRemoveItem.bind(this, el)} className={this.state.IsReadOnly == true ? "btn btn-outline-secondary disabled" : "btn btn-outline-secondary"}>  <span className='fa-solid fa-trash-xmark' style={{ display: IconsDisplayStyle }} ></span> </button>

                                <button type="button" onClick={this.onPinItemClick.bind(this, el)} className={this.state.IsReadOnly == true ? "btn btn-outline-secondary disabled" : "btn btn-outline-secondary"}>  <span className={PinClasses} style={{ display: IconsDisplayStyle }} ></span> </button>
                            </div>

                        </div>
                    </div>
                    <div id="microAlarmLoader" className="loader-bg"><img className="loader-img" src={animatedloader} width="50" height="50" alt='Loading' /></div>
                    <div onMouseDown={e => e.stopPropagation()}>
                        <div id='chartmicro'></div>
                        <div className='Piechart-legend'>
                            <div className='High-Priority-text flex-container'> <div className='lablediv'>{ReeferAlarmLabelSevere}:</div> {this.GetLoadData(this.state.Reefersummary.MASevere)}</div>
                            <div className='Medium-Priority-text flex-container'> <div className='lablediv'> {ReeferAlarmLabelMinor}: </div> {this.GetLoadData(this.state.Reefersummary.MAMinor)}</div>
                        </div>
                    </div>
                </div>
            </div>
        }

        if (el.Key == 'wgCargoCare') {
            return <div key="wgCargoCare" style={{ display: DisplayStyle }}>
                <div className='widget-grids'>
                    <div className={HeadeBgClasses} >
                        <div>CargoCare Alerts - Fleet</div>
                        <div className='widget-controls ms-auto gap-3 applySettingsCC'>
                            
                            <div className="btn-group btn-group-sm aggrid-icons" role="group" aria-label="Small button group">
                                <button type="button" onClick={this.onCCProfileFilterClick.bind(this)} className={this.state.IsReadOnly == true ? "btn btn-outline-secondary disabled" : "btn btn-outline-secondary"}>   <span className='fa-sharp fa-solid fa-filter' data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" style={{ display: IconsDisplayStyle }}></span>   </button>                            
                                <div className='drop-down-state SettingsDropdown' id="CCProfileFilter">
                                    <div className='AssetSettinsText'>
                                        <span>Profile Filter </span>
                                        <span className="fa-sharp fa-regular fa-xmark invclose" onClick={this.onCCProfileFilterClickClose.bind(this)}></span>
                                    </div>
                                    <div className='profile-dropdown'>
                                        <label><input type="checkbox" className='profile-checkbox' id='chkSelectAllProfile'
                                            onClick={this.selectAllProfiles.bind(this)} /> Select All</label>

                                        <ul className='ps-0'>
                                            { this.renderToogleCargoCareProfiles() }                                    
                                        </ul>
                                    </div>
                                    <div className='reeferdatesearch'>
                                        <button type='button' className='btn btn-primary float-end' onClick={this.OnSubmitCargoCareFilters.bind(this,false)}>Apply</button>                                    
                                    </div>
                                </div>                                

                                <button type="button" onClick={this.onCCWidgetClick.bind(this)} className="btn btn-outline-secondary">   <span className='fa-sharp fa-solid fa-gear-complex' data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" style={{ display: IconsDisplayStyle }}></span>   </button>
                                <div className='drop-down-state SettingsDropdown' id='drop-down-inv-cc'>
                                    <div className='AssetSettinsText'>
                                        <span className='inv-state'>Inventory State Filter </span>
                                        <div className='invent-circle'><span className="fa-sharp fa-regular fa-xmark invclose" onClick={this.onCCWidgetClickClose.bind(this)}></span></div>
                                    </div>
                                    <div>
                                        <Select.Creatable
                                            closeOnSelect={!this.state.stayOpen}
                                            disabled={this.state.disabled}
                                            multi
                                            onChange={this.AssetStateChangeCC.bind(this)}
                                            options={assetStatesOptions}
                                            placeholder="Inventory State"
                                            removeSelected={this.state.removeSelected}
                                            rtl={this.state.rtl}
                                            simpleValue
                                            value={this.state.SelectedAssetStatesCC}
                                            minMenuHeight={30}
                                            maxMenuHeight={30}
                                            promptTextCreator={() => false}
                                        />
                                    </div>
                                    <div className='reeferdatesearch'>
                                        <button type='button' className='btn btn-primary float-end' id='btn_inv-cc' onClick={this.ReeferStatusSummaryCC.bind(this)}>Search</button>
                                    </div>

                                </div>

                                <button type="button" onClick={this.onRemoveItem.bind(this, el)} className={this.state.IsReadOnly == true ? "btn btn-outline-secondary disabled" : "btn btn-outline-secondary"}>  <span className='fa-solid fa-trash-xmark' style={{ display: IconsDisplayStyle }} ></span>  </button>

                                <button type="button" onClick={this.onPinItemClick.bind(this, el)} className={this.state.IsReadOnly == true ? "btn btn-outline-secondary disabled" : "btn btn-outline-secondary"}>  <span className={PinClasses} style={{ display: IconsDisplayStyle }} ></span>  </button>
                            </div>                           
                        </div>
                    </div>
                    <div id="cargoCareLoader" className="loader-bg"><img className="loader-img" src={animatedloader} width="50" height="50" alt='Loading' /></div>
                    <div onMouseDown={e => e.stopPropagation()}>
                        <div id='chartcargo'></div>
                        <div className='Piechart-legend bottom-48'>

                            <div className='High-Priority-text flex-container'> <div className='lablediv'> {CCLabelSevere}: </div>{this.GetLoadCCAlertData(self.state.CargoCareProfileAlertssummary.map(x => x.CCSevere))}</div>
                            <div className='Medium-Priority-text flex-container'> <div className='lablediv'> {CCLabelMinor}: </div>{this.GetLoadCCAlertData(self.state.CargoCareProfileAlertssummary.map(x => x.CCMinor))}</div>
                            <div className='Low-Priority-text flex-container'> <div className='lablediv'> {CCLabelInformational}: </div> {this.GetLoadCCAlertData(self.state.CargoCareProfileAlertssummary.map(x => x.CCInformational))}</div>

                        </div>
                    </div>
                </div>
            </div>
        }

        if (el.Key == 'wgHistogram') {

            return <div key="wgHistogram" style={{ display: DisplayStyle }}>

                <div className='widget-grids'>
                    <div className={HeadeBgClasses} >
                        <div>Reefer Fleet Overview</div>
                        <div className='widget-controls ms-auto gap-3 applySettingsTotalReefers'>

                            <div className="btn-group btn-group-sm aggrid-icons" role="group" aria-label="Small button group">
                                <button type="button" onClick={this.onFleetOverviewClick.bind(this)} className="btn btn-outline-secondary">   <span className='fa-sharp fa-solid fa-gear-complex' data-toggle="dropdown" aria-haspopup="true"  aria-expanded="false" style={{ display: IconsDisplayStyle }}></span>  </button>

                                <div className='drop-down-state SettingsDropdown' id='drop-down-inv-fleet-overview'>
                                    <div className='AssetSettinsText'>
                                        <span className='inv-state'>Inventory State </span>
                                        <div className='invent-circle'> <span className="fa-sharp fa-regular fa-xmark invclose" onClick={this.onFleetOverviewClickClose.bind(this)}></span> </div>
                                    </div>
                                    <div>
                                        <Select.Creatable
                                            closeOnSelect={!this.state.stayOpen}
                                            disabled={this.state.disabled}
                                            multi
                                            onChange={this.AssetStateChangeTotalReefers.bind(this)}
                                            options={assetStatesOptions}
                                            placeholder="Inventory State"
                                            removeSelected={this.state.removeSelected}
                                            rtl={this.state.rtl}
                                            simpleValue
                                            value={this.state.SelectedAssetStatesTotalReefers}
                                            minMenuHeight={30}
                                            maxMenuHeight={30}
                                            promptTextCreator={() => false}
                                        />
                                    </div>
                                    <div className='reeferdatesearch'>
                                        <button type='button' className='btn btn-primary float-end' id='btn_inv-fleet-overview'  onClick={this.TotalReeferStatusSummary.bind(this,true)}>Search</button>
                                    </div>
                                </div>

                                <button type="button" onClick={this.onRemoveItem.bind(this, el)} className={this.state.IsReadOnly == true ? "btn btn-outline-secondary disabled" : "btn btn-outline-secondary"}>   <span className='fa-solid fa-trash-xmark' style={{ display: IconsDisplayStyle }} ></span> </button>

                                <button type="button" onClick={this.onPinItemClick.bind(this, el)} className={this.state.IsReadOnly == true ? "btn btn-outline-secondary disabled" : "btn btn-outline-secondary"}> <span className={PinClasses} style={{ display: IconsDisplayStyle }} ></span> </button>
                            </div>


                        </div>
                    </div>
                    <div id="totalReefersLoader" className="loader-bg"><img className="loader-img" src={animatedloader} width="50" height="50" alt='Loading' /></div>
                    <div onMouseDown={e => e.stopPropagation()}>
                        <div id='chartHistogram'></div>
                        <div className='row'>
                            <div className='col-lg-6 maroontext pl-35'></div>
                            <div className='col-lg-6 blusetext1'></div>
                        </div>
                    </div>
                </div>
            </div>
        }

        if (el.Key == 'wgGensetHistogram') {

            return <div key="wgGensetHistogram" style={{ display: DisplayStyle }}>

                <div className='widget-grids'>
                    <div className={HeadeBgClasses} >
                        <div>Genset Fleet Overview</div>
                        <div className='widget-controls ms-auto gap-3'>

                            <div className="btn-group btn-group-sm aggrid-icons" role="group" aria-label="Small button group">
                                <button type="button" onClick={this.onGFOWidgetClick.bind(this)} className="btn btn-outline-secondary">      <span className='fa-sharp fa-solid fa-gear-complex' data-toggle="dropdown" aria-haspopup="true"  aria-expanded="false" style={{ display: IconsDisplayStyle }}></span>  </button>

                                <div className='drop-down-state SettingsDropdown' id='drop-down-inv-GFO'>
                                    <div className='AssetSettinsText'>
                                        <span className='inv-state'>Inventory State </span>
                                        <div className='invent-circle'> <span className="fa-sharp fa-regular fa-xmark invclose" onClick={this.onGFOWidgetClickClose.bind(this)}></span> </div>
                                    </div>
                                    <div>
                                        <Select.Creatable
                                            closeOnSelect={!this.state.stayOpen}
                                            disabled={this.state.disabled}
                                            multi
                                            onChange={this.AssetStateChangeAllGensets.bind(this)}
                                            options={assetStatesOptions}
                                            placeholder="Inventory State"
                                            removeSelected={this.state.removeSelected}
                                            rtl={this.state.rtl}
                                            simpleValue
                                            value={this.state.SelectedAssetStatesTotalGensets}
                                            minMenuHeight={30}
                                            maxMenuHeight={30}
                                            promptTextCreator={() => false}
                                        />
                                    </div>
                                    <div className='reeferdatesearch'>
                                        <button type='button' className='btn btn-primary float-end' id='btn_inv-GFO' onClick={this.TotalGensetStatusSummary.bind(this,true)}>Search</button>
                                    </div>

                                </div>

                                <button type="button" onClick={this.onRemoveItem.bind(this, el)} className={this.state.IsReadOnly == true ? "btn btn-outline-secondary disabled" : "btn btn-outline-secondary"}>   <span className='fa-solid fa-trash-xmark' style={{ display: IconsDisplayStyle }} ></span> </button>

                                <button type="button" onClick={this.onPinItemClick.bind(this, el)} className={this.state.IsReadOnly == true ? "btn btn-outline-secondary disabled" : "btn btn-outline-secondary"}>  <span className={PinClasses} style={{ display: IconsDisplayStyle }} ></span> </button>
                            </div>


                        </div>
                    </div>
                    <div id="totalGensetFleetLoader" className="loader-bg"><img className="loader-img" src={animatedloader} width="50" height="50" alt='Loading' /></div>
                    <div onMouseDown={e => e.stopPropagation()}>
                        <div id='chartGensetHistogram'></div>
                        <div className='row'>
                            <div className='col-lg-6 maroontext pl-35'></div>
                            <div className='col-lg-6 blusetext1'></div>
                        </div>
                    </div>
                </div>
            </div>
        }

        if (el.Key == 'wgDryHistogram') {
            return <div key="wgDryHistogram" style={{ display: DisplayStyle }}>

                <div className='widget-grids'>
                    <div className={HeadeBgClasses} >
                        <div>Dry Fleet Overview</div>
                        <div className='widget-controls ms-auto gap-3 applySettingsCC'>

                            <div className="btn-group btn-group-sm aggrid-icons" role="group" aria-label="Small button group">
                                <button type="button" onClick={this.onDFOWidgetClick.bind(this)} className="btn btn-outline-secondary">     <span className='fa-sharp fa-solid fa-gear-complex' data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" style={{ display: IconsDisplayStyle }}></span> </button>
                                <div className='drop-down-state SettingsDropdown' id='drop-down-inv-DFO'>
                                    <div className='AssetSettinsText'>
                                        <span className='inv-state'>Inventory State</span>
                                        <div className='invent-circle'> <span className="fa-sharp fa-regular fa-xmark invclose" onClick={this.onDFOWidgetClickClose.bind(this)}></span> </div>
                                    </div>
                                    <div>
                                        <Select.Creatable
                                            closeOnSelect={!this.state.stayOpen}
                                            disabled={this.state.disabled}
                                            multi
                                            onChange={this.AssetStateChangeAllDrys.bind(this)}
                                            options={assetStatesOptions}
                                            placeholder="Inventory State"
                                            removeSelected={this.state.removeSelected}
                                            rtl={this.state.rtl}
                                            simpleValue
                                            value={this.state.SelectedAssetStatesTotalDrys}
                                            minMenuHeight={30}
                                            maxMenuHeight={30}
                                            promptTextCreator={() => false}
                                        />
                                    </div>
                                    <div className='reeferdatesearch'>
                                        <button type='button' className='btn btn-primary float-end' id='btn_inv-DFO' onClick={this.TotalDryStatusSummary.bind(this,true)}>Search</button>
                                    </div>

                                </div>
                                <button type="button" onClick={this.onRemoveItem.bind(this, el)} className={this.state.IsReadOnly == true ? "btn btn-outline-secondary disabled" : "btn btn-outline-secondary"}>    <span className='fa-solid fa-trash-xmark' style={{ display: IconsDisplayStyle }} ></span>  </button>

                                <button type="button" onClick={this.onPinItemClick.bind(this, el)} className={this.state.IsReadOnly == true ? "btn btn-outline-secondary disabled" : "btn btn-outline-secondary"}>  <span className={PinClasses} style={{ display: IconsDisplayStyle }} ></span>  </button>
                            </div>

                           
                        </div>
                    </div>
                    <div id="totalDryFleetLoader" className="loader-bg"><img className="loader-img" src={animatedloader} width="50" height="50" alt='Loading' /></div>
                    <div onMouseDown={e => e.stopPropagation()}>
                        <div id='chartDryHistogram'></div>
                        <div className='row'>
                            <div className='col-lg-6 maroontext pl-35'></div>
                            <div className='col-lg-6 blusetext1'></div>
                        </div>
                    </div>
                </div>
            </div>
        }

        if (el.Key == 'wgChassisHistogram') {
            return <div key="wgChassisHistogram" style={{ display: DisplayStyle }}>

                <div className='widget-grids'>
                    <div className={HeadeBgClasses} >
                        <div>Chassis Fleet Overview</div>
                        <div className='widget-controls ms-auto gap-3'>

                            <div className="btn-group btn-group-sm aggrid-icons" role="group" aria-label="Small button group">
                                <button type="button" onClick={this.onRemoveItem.bind(this, el)} className={this.state.IsReadOnly == true ? "btn btn-outline-secondary disabled" : "btn btn-outline-secondary"}>    <span className='fa-solid fa-trash-xmark' style={{ display: IconsDisplayStyle }} ></span>  </button>
                                <button type="button" onClick={this.onPinItemClick.bind(this, el)} className={this.state.IsReadOnly == true ? "btn btn-outline-secondary disabled" : "btn btn-outline-secondary"}>    <span className={PinClasses} style={{ display: IconsDisplayStyle }} ></span>  </button>
                            </div>                           
                           
                        </div>
                    </div>
                    <div id="totalChassisFleetLoader" className="loader-bg"><img className="loader-img" src={animatedloader} width="50" height="50" alt='Loading' /></div>
                    <div onMouseDown={e => e.stopPropagation()}>
                        <div id='chartChassisHistogram'></div>
                        <div className='row'>
                            <div className='col-lg-6 maroontext pl-35'></div>
                            <div className='col-lg-6 blusetext1'></div>
                        </div>
                    </div>
                </div>
            </div>
        }

        if (el.Key == 'wgAllreefers') {

            return <div key="wgAllreefers" style={{ display: DisplayStyle }}>
                <div className='widget-box widgetbgTotalReefers'>
                    <div className={HeadeBgClasses}>
                        <div>Total Reefers : {this.state.Reefersummary.AllReefer} </div>
                        <div className='widget-controls ms-auto gap-3 widget-applySettingsTotalReefers'>

                            <div className="btn-group btn-group-sm aggrid-icons" role="group" aria-label="Small button group">
                                <button type="button" onClick={this.onAllReefersClick.bind(this)} className="btn btn-outline-secondary">  <span className='fa-sharp fa-solid fa-gear-complex' data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" style={{ display: IconsDisplayStyle }}></span></button>
                                <div className='drop-down-state SettingsDropdown HideClearAll' id='drop-down-inv'>
                                    <div className='AssetSettinsText'>
                                        <span className='inv-state'>Inventory State</span>
                                        <div className='invent-circle'> <span className="fa-sharp fa-regular fa-xmark invclose" onClick={this.onAllReefersClickClose.bind(this)}></span> </div>
                                    </div>
                                    <div onClick={this.handleWidgetCheckTotalReefers.bind(this)}>
                                        <Select.Creatable
                                            closeOnSelect={!this.state.stayOpen}
                                            disabled={this.state.disabled}
                                            multi
                                            onChange={this.AssetStateChangeTotalReefers.bind(this)}
                                            options={assetStatesOptions}
                                            placeholder="Inventory State"
                                            removeSelected={this.state.removeSelected}
                                            rtl={this.state.rtl}
                                            simpleValue
                                            value={this.state.SelectedAssetStatesTotalReefers}
                                            minMenuHeight={30}
                                            maxMenuHeight={30}
                                            promptTextCreator={() => false}
                                        />
                                    </div>
                                    <div className='reeferdatesearch'>
                                        <button type='button' className='btn btn-primary float-end' id='btn_inv-TR' onClick={this.TotalReeferStatusSummary.bind(this,false)}>Search</button>
                                    </div>
                                </div>

                                <button type="button" onClick={this.onRemoveItem.bind(this, el)} className={this.state.IsReadOnly == true ? "btn btn-outline-secondary disabled" : "btn btn-outline-secondary"}>  <span className='fa-solid fa-trash-xmark' style={{ display: IconsDisplayStyle }}></span></button>
                                <button type="button" onClick={this.onPinItemClick.bind(this, el)} className={this.state.IsReadOnly == true ? "btn btn-outline-secondary disabled" : "btn btn-outline-secondary"}> <span className={PinClasses} style={{ display: IconsDisplayStyle }} ></span> </button>
                            </div>

                        </div>
                    </div>
                    <div id="headerLoader" className="loader-bg"><img className="loader-img" src={animatedloader} width="50" height="50" alt='Loading' /></div>
                    <div onMouseDown={e => e.stopPropagation()} className='p-2'>

                        <div className="row gx-2">
                            <div className="col-6 col-sm-6 col-md-3 col-lg-3 col-xl-3">
                                <div className='rect-box hand' onClick={this.ApplyChartFilters.bind(this, 'Running',false)}>
                                    <div className='rectbgcolor-box green'>
                                        <i className="fas fa-power-off"></i>
                                    </div>
                                    <div>
                                        <div className='rectboxtitle-text greenText1'>{this.GetLoadData(this.state.Reefersummary.Running)}</div>
                                        <div className='rectbox-infotext greenText1'>Running and Operational</div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-6 col-sm-6 col-md-3 col-lg-3 col-xl-3">
                                <div className='rect-box hand' onClick={this.ApplyChartFilters.bind(this, 'MissedRunning',false)}>
                                    <div className='rectbgcolor-box greybg'>
                                        <i className="fas fa-power-off"></i>
                                    </div>
                                    <div>
                                        <div className='rectboxtitle-text greytext'>{this.GetLoadData(this.state.Reefersummary.MissedRunning)}</div>
                                        <div className='rectbox-infotext greytext'>On Standby</div>
                                    </div>
                                </div>

                            </div>
                            <div className="col-6 col-sm-6 col-md-3 col-lg-3 col-xl-3">
                                <div className='rect-box hand' onClick={this.ApplyChartFilters.bind(this, 'Stopped',false)}>
                                    <div className='rectbgcolor-box orange'>
                                        <i className="fas fa-power-off"></i>
                                    </div>
                                    <div>
                                        <div className='rectboxtitle-text orangetext1'>{this.GetLoadData(this.state.Reefersummary.Stopped)}</div>
                                        <div className='rectbox-infotext orangetext1'>Shut Down or Faulty</div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-6 col-sm-6 col-md-3 col-lg-3 col-xl-3">
                                <div className='rect-box hand' onClick={this.ApplyChartFilters.bind(this, 'MissedStopped',false)}>
                                    <div className='rectbgcolor-box LightGrey'>
                                        <i className="fas fa-horizontal-rule"></i>
                                    </div>
                                    <div>
                                        <div className='rectboxtitle-text greytext'>{this.GetLoadData(this.state.Reefersummary.MissedStopped)}</div>
                                        <div className='rectbox-infotext greytext'>Offline or Powered Down</div>

                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        }

        if (el.Key == 'wgColdTreatment') {

            return <div key="wgColdTreatment" style={{ display: DisplayStyle }}>
                <div className='widget-grids'>
                    <div className={HeadeBgClasses}>
                        <div>Cold Treatment</div>
                            <div className='widget-controls ms-auto gap-3 applySettingsCC'> 
                            <div className="btn-group btn-group-sm aggrid-icons" role="group" aria-label="Small button group">
                                <button type="button" onClick={this.onCTProfileFilterClick.bind(this)} className={this.state.IsReadOnly == true ? "btn btn-outline-secondary disabled" : "btn btn-outline-secondary"}>   <span className='fa-sharp fa-solid fa-filter' data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" style={{ display: IconsDisplayStyle }}></span>   </button>                            
                                <div className='drop-down-state SettingsDropdown' id="CTProfileFilter">
                                    <div className='AssetSettinsText'>
                                        <span>Profile Filter </span>
                                        <span className="fa-sharp fa-regular fa-xmark invclose" onClick={this.onCTProfileFilterClickClose.bind(this)}></span>
                                    </div>
                                    <div className='profile-dropdown'>
                                        <label><input type="checkbox" className='profile-checkbox' id='chkSelectAllCTProfile'
                                            onClick={this.selectAllCTProfiles.bind(this)} /> Select All</label>

                                        <ul className='ps-0'>
                                            { this.renderToogleCargoCareCTProfiles() }                                    
                                        </ul>
                                    </div>
                                    <div className='reeferdatesearch'>
                                        <button type='button' className='btn btn-primary float-end' onClick={this.OnSubmitCTFilters.bind(this,false)}>Apply</button>                                    
                                    </div>
                                </div>   
                             
                                <button type="button" onClick={this.onRemoveItem.bind(this, el)} className={this.state.IsReadOnly == true ? "btn btn-outline-secondary disabled" : "btn btn-outline-secondary"}>  <span className='fa-solid fa-trash-xmark' style={{ display: IconsDisplayStyle }}></span></button>
                                <button type="button" onClick={this.onPinItemClick.bind(this, el)} className={this.state.IsReadOnly == true ? "btn btn-outline-secondary disabled" : "btn btn-outline-secondary"}> <span className={PinClasses} style={{ display: IconsDisplayStyle }} ></span> </button>
                            </div>
                        </div>
                    </div>
                    <div id="CTHeaderLoader" className="loader-bg"><img className="loader-img" src={animatedloader} width="50" height="50" alt='Loading' /></div>
                    <div onMouseDown={e => e.stopPropagation()}>
                        <div id='chartcoldtreatment' className='mt-50'></div>
                    </div>
                </div>
            </div>
        }

        if (el.Key == 'wgAllGensets') {

            return <div key="wgAllGensets" style={{ display: DisplayStyle }}>
                <div className='widget-box widgetbgTotalGensets'>
                    <div className={HeadeBgClasses}>
                        <div>Total Gensets : {this.state.Gensetsummary.AllGensets} </div>
                        <div className='widget-controls ms-auto gap-3'>


                            <div className="btn-group btn-group-sm aggrid-icons" role="group" aria-label="Small button group">
                                <button type="button" onClick={this.onTGWidgetClick.bind(this)} className="btn btn-outline-secondary">    <span className='fa-sharp fa-solid fa-gear-complex' data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" style={{ display: IconsDisplayStyle }}></span> </button>
                                <div className='drop-down-state SettingsDropdown HideClearAll' id='drop-down-inv-TG'>
                                    <div className='AssetSettinsText'>
                                        <span className='inv-state'>Inventory State</span>
                                        <div className='invent-circle'> <span className="fa-sharp fa-regular fa-xmark invclose" onClick={this.onTGWidgetClickClose.bind(this)}></span> </div>
                                    </div>
                                    <div onClick={this.handleWidgetCheckTotalGensets.bind(this)}>
                                        <Select.Creatable
                                            closeOnSelect={!this.state.stayOpen}
                                            disabled={this.state.disabled}
                                            multi
                                            onChange={this.AssetStateChangeAllGensets.bind(this)}
                                            options={assetStatesOptions}
                                            placeholder="Inventory State"
                                            removeSelected={this.state.removeSelected}
                                            rtl={this.state.rtl}
                                            simpleValue
                                            value={this.state.SelectedAssetStatesTotalGensets}
                                            minMenuHeight={30}
                                            maxMenuHeight={30}
                                            promptTextCreator={() => false}
                                        />
                                    </div>
                                    <div className='reeferdatesearch'>
                                        <button type='button' className='btn btn-primary float-end' id='btn_inv-TG' onClick={this.TotalGensetStatusSummary.bind(this,false)}>Search</button>
                                    </div>

                                </div>

                                <button type="button" onClick={this.onRemoveItem.bind(this, el)} className={this.state.IsReadOnly == true ? "btn btn-outline-secondary disabled" : "btn btn-outline-secondary"}>   <span className='fa-solid fa-trash-xmark' style={{ display: IconsDisplayStyle }} ></span> </button>
                                <button type="button" onClick={this.onPinItemClick.bind(this, el)} className={this.state.IsReadOnly == true ? "btn btn-outline-secondary disabled" : "btn btn-outline-secondary"}>    <span className={PinClasses} style={{ display: IconsDisplayStyle }} ></span> </button>
                            </div>

                        </div>
                    </div>
                    <div id="GensetheaderLoader" className="loader-bg"><img className="loader-img" src={animatedloader} width="50" height="50" alt='Loading' /></div>
                    <div onMouseDown={e => e.stopPropagation()} className="p-2">
                        <div className='row gx-2'>
                            <div className='col-6 col-sm-6 col-md-3 col-lg-3 col-xl-3'>
                                <div className='rect-box hand' onClick={this.ApplyChartFiltersGenset.bind(this, 'PowerOnReporting',false)}>
                                    <div className='rectbgcolor-box green'>
                                        <img src={GRPO} className='dashimg-width img-responsive center-block' alt='Responsive image' />
                                    </div>
                                    <div>
                                        <div className='rectboxtitle-text greenText1'>{this.GetLoadData(this.state.Gensetsummary.PowerOnReporting)}</div>
                                        <div className='rectbox-infotext greenText1'> Reporting, Switched On</div>

                                    </div>
                                </div>
                            </div>
                            <div className='col-6 col-sm-6 col-md-3 col-lg-3 col-xl-3'>
                                <div className='rect-box hand' onClick={this.ApplyChartFiltersGenset.bind(this, 'PowerOnNotReporting',false)}>
                                    <div className='rectbgcolor-box orange'>
                                        <img src={GLON} className='dashimg-width img-responsive center-block' alt='Responsive image' />
                                    </div>
                                    <div>
                                        <div className='rectboxtitle-text orangetext1'>{this.GetLoadData(this.state.Gensetsummary.PowerOnNotReporting)}</div>
                                        <div className='rectbox-infotext orangetext1'> Last Switched On</div>
                                    </div>
                                </div>
                            </div>
                            <div className='col-6 col-sm-6 col-md-3 col-lg-3 col-xl-3'>
                                <div className='rect-box hand' onClick={this.ApplyChartFiltersGenset.bind(this, 'PowerOffReporting',false)}>
                                    <div className='rectbgcolor-box blue'>
                                        <img src={GRPOFF} className='dashimg-width img-responsive center-block' alt='Responsive image' />
                                    </div>
                                    <div>
                                        <div className='rectboxtitle-text blusetext1'>{this.GetLoadData(this.state.Gensetsummary.PowerOffReporting)}</div>
                                        <div className='rectbox-infotext blusetext1'> Reporting, Switched Off</div>
                                    </div>
                                </div>
                            </div>
                            <div className='col-6 col-sm-6 col-md-3 col-lg-3 col-xl-3'>
                                <div className='rect-box hand' onClick={this.ApplyChartFiltersGenset.bind(this, 'PowerOffNotReporting',false)}>
                                    <div className='rectbgcolor-box greybg'>
                                        <img src={GLPO} className='dashimg-width img-responsive center-block' alt='Responsive image' />
                                    </div>
                                    <div>
                                        <div className='rectboxtitle-text greytext'>{this.GetLoadData(this.state.Gensetsummary.PowerOffNotReporting)}</div>
                                        <div className='rectbox-infotext greytext'> Last Switched Off</div>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        }

        if (el.Key == 'wgAllDrys') {
            return <div key="wgAllDrys" style={{ display: DisplayStyle }}>
                <div className='widget-box'>
                    <div className={HeadeBgClasses}>
                        <div>Total Drys : {this.state.Drysummary.AllDrys} </div>

                        <div className='widget-controls applySettingsCC ms-auto gap-3'>


                            <div className="btn-group btn-group-sm aggrid-icons" role="group" aria-label="Small button group">
                                <button type="button" onClick={this.onTDWidgetClick.bind(this)} className="btn btn-outline-secondary">    <span className='fa-sharp fa-solid fa-gear-complex' data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" style={{ display: IconsDisplayStyle }}></span>  </button>

                                <div className='drop-down-state SettingsDropdown' id='drop-down-inv-TD'>
                                    <div className='AssetSettinsText'>
                                        <span className='inv-state'>Inventory State</span>
                                        <div className='invent-circle'> <span className="fa-sharp fa-regular fa-xmark invclose" onClick={this.onTDWidgetClickClose.bind(this)}></span> </div>
                                    </div>
                                    <div>
                                        <Select.Creatable
                                            closeOnSelect={!this.state.stayOpen}
                                            disabled={this.state.disabled}
                                            multi
                                            onChange={this.AssetStateChangeAllDrys.bind(this)}
                                            options={assetStatesOptions}
                                            placeholder="Inventory State"
                                            removeSelected={this.state.removeSelected}
                                            rtl={this.state.rtl}
                                            simpleValue
                                            value={this.state.SelectedAssetStatesTotalDrys}
                                            minMenuHeight={30}
                                            maxMenuHeight={30}
                                            promptTextCreator={() => false}
                                        />
                                    </div>
                                    <div className='reeferdatesearch'>
                                        <button type='button' className='btn btn-primary float-end' id='btn_inv-TD' onClick={this.TotalDryStatusSummary.bind(this,false)}>Search</button>
                                    </div>

                                </div>

                                <button type="button" onClick={this.onRemoveItem.bind(this, el)} className={this.state.IsReadOnly == true ? "btn btn-outline-secondary disabled" : "btn btn-outline-secondary"}>    <span className='fa-solid fa-trash-xmark' style={{ display: IconsDisplayStyle }} ></span> </button>
                                <button type="button" onClick={this.onPinItemClick.bind(this, el)} className={this.state.IsReadOnly == true ? "btn btn-outline-secondary disabled" : "btn btn-outline-secondary"}>     <span className={PinClasses} style={{ display: IconsDisplayStyle }} ></span>  </button>
                            </div>

                           
                        </div>
                    </div>
                    <div id="DryheaderLoader" className="loader-bg"><img className="loader-img" src={animatedloader} width="50" height="50" alt='Loading' /></div>
                    <div onMouseDown={e => e.stopPropagation()} className='p-2'>
                        <div className='row gy-2'>
                            <div className='col-12' id="DryInsideGeofenceMain">
                                <div className='rect-box hand' onClick={this.ApplyChartFiltersDry.bind(this, 'DryInGeofence',false)}>
                                    <div className='rectbgcolordry-box green'>
                                        <img src={TotalDryInsideGeofence} className='chassisimg img-responsive center-block' alt='Responsive image' />
                                    </div>
                                    <div>
                                        <div className='rectboxtitle-text greenText1'>{this.GetLoadData(this.state.Drysummary.InGeofence)}</div>
                                        <div className='rectbox-infotext greenText1'> Inside Geofence</div>
                                    </div>
                                </div>
                            </div>
                            <div className='col-12' id="DryOutsideGeofenceMain">
                                <div className='rect-box hand' onClick={this.ApplyChartFiltersDry.bind(this, 'DryOutGeofence',false)}>
                                    <div className='rectbgcolordry-box blue'>
                                        <img src={TotalDryOutSideGeofence} className='dryimg img-responsive center-block' alt='Responsive image' />
                                    </div>
                                    <div>
                                        <div className='rectboxtitle-text blusetext1'>{this.GetLoadData(this.state.Drysummary.OutGeofence)}</div>
                                        <div className='rectbox-infotext blusetext1'> Outside Geofence</div>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        }

        if (el.Key == 'wgAllChassis') {
            return <div key="wgAllChassis" style={{ display: DisplayStyle }}>
                <div className='widget-box'>
                    <div className={HeadeBgClasses}>
                        <div>Total Chassis : {this.state.Chassissummary.AllChassis} </div>
                        <div className='widget-controls ms-auto gap-3'>

                            <div className="btn-group btn-group-sm aggrid-icons" role="group" aria-label="Small button group">                               
                                <button type="button" onClick={this.onRemoveItem.bind(this, el)} className={this.state.IsReadOnly == true ? "btn btn-outline-secondary disabled" : "btn btn-outline-secondary"}>    <span className='fa-solid fa-trash-xmark' style={{ display: IconsDisplayStyle }} ></span>  </button>
                                <button type="button" onClick={this.onPinItemClick.bind(this, el)} className={this.state.IsReadOnly == true ? "btn btn-outline-secondary disabled" : "btn btn-outline-secondary"}>    <span className={PinClasses} style={{ display: IconsDisplayStyle }} ></span>  </button>
                            </div>

                        </div>
                    </div>
                    <div id="ChassisheaderLoader" className="loader-bg"><img className="loader-img" src={animatedloader} width="50" height="50" alt='Loading' /></div>
                    <div onMouseDown={e => e.stopPropagation()} className="p-2">
                        <div className='row gx-2'>
                            <div className='col-6 col-sm-6 col-md-3 col-lg-3 col-xl-3'>
                                <div className='rect-box hand' onClick={this.ApplyChartFiltersChassis.bind(this, 'ChassisPwrInGeofence',false)}>
                                    <div className='rectbgcolor-box green'>
                                        <img src={PoweredInGeofence} className='chassisimg img-responsive center-block' alt='Responsive image' />
                                    </div>
                                    <div>
                                        <div className='rectboxtitle-text greenText1'>{this.GetLoadData(this.state.Chassissummary.PwrInGeofence)}</div>
                                        <div className='rectbox-infotext greenText1' title='Powered, Inside Geofence'> Powered, Inside Geofence </div>
                                        <div className='linktext greenText1 hide'><a href='javascript:void(0)' className='greenText1' onClick={this.ApplyChartFiltersChassis.bind(this, 'ChassisPwrInGeofence')}> See Details </a></div>
                                    </div>
                                </div>

                            </div>
                            <div className='col-6 col-sm-6 col-md-3 col-lg-3 col-xl-3'>
                                <div className='rect-box hand' onClick={this.ApplyChartFiltersChassis.bind(this, 'ChassisPwrOutGeofence',false)}>
                                    <div className='rectbgcolor-box orange'>
                                        <img src={PoweredNotInGeofence} className='chassisimg img-responsive center-block' alt='Responsive image' />
                                    </div>
                                    <div>
                                        <div className='rectboxtitle-text orangetext1'>{this.GetLoadData(this.state.Chassissummary.PwrOutGeofence)}</div>
                                        <div className='rectbox-infotext orangetext1' title='Powered, Outside Geofence'> Powered, Outside Geofence</div>
                                    </div>
                                </div>
                            </div>
                            <div className='col-6 col-sm-6 col-md-3 col-lg-3 col-xl-3'>
                                <div className='rect-box hand' onClick={this.ApplyChartFiltersChassis.bind(this, 'ChassisNotPwrInGeofence',false)}>
                                    <div className='rectbgcolor-box blue'>
                                        <img src={NotPoweredInGeofence} className='chassisimg img-responsive center-block' alt='Responsive image' />
                                    </div>
                                    <div>
                                        <div className='rectboxtitle-text blusetext1'>{this.GetLoadData(this.state.Chassissummary.NotPwrInGeofence)}</div>
                                        <div className='rectbox-infotext blusetext1' title='Not Powered, Inside Geofence'> Not Powered, Inside Geofence </div>
                                    </div>
                                </div>
                            </div>
                            <div className='col-6 col-sm-6 col-md-3 col-lg-3 col-xl-3'>
                                <div className='rect-box hand' onClick={this.ApplyChartFiltersChassis.bind(this, 'ChassisNotPwrOutGeofence',false)}>
                                    <div className='rectbgcolor-box greybg'>
                                        <img src={NotPoweredNotInGeofence} className='chassisimg img-responsive center-block' alt='Responsive image' />
                                    </div>
                                    <div>
                                        <div className='rectboxtitle-text greytext'>{this.GetLoadData(this.state.Chassissummary.NotPwrOutGeofence)}</div>
                                        <div className='rectbox-infotext greytext' title='Not Powered, Outside Geofence'> Not Powered, Outside Geofence </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        }

        if (el.Key == 'wgReeferMap') {
            return <div key="wgReeferMap" style={{ display: DisplayStyle }}>
                <div id='wgReeferMap' className='widget-grids'>
                    <div className={HeadeBgClasses} >
                        <div>Asset Map</div>
                        <div className='widget-controls ms-auto gap-3'>

                            <div className="btn-group btn-group-sm aggrid-icons" role="group" aria-label="Small button group">
                                <button type="button" onClick={this.onRemoveItem.bind(this, el)} className={"btn btn-outline-secondary disabled"}>    <span className='fa-solid fa-trash-xmark' style={{ display: IconsDisplayStyle }} ></span>  </button>
                                <button type="button" onClick={this.onPinItemClick.bind(this, el)} className={this.state.IsReadOnly == true ? "btn btn-outline-secondary disabled" : "btn btn-outline-secondary"}>
                                    {
                                    el.Key != this.state.lastWidgetName ? <span className={PinClasses} style={{ display: IconsDisplayStyle }} ></span> :
                                        <span className={PinClasses} style={{ display: IconsDisplayStyle }}></span>
                                    }
                                </button>
                                <button type="button" onClick={this.onFullScreen.bind(this, el, 'wgReeferMap')}  className="btn btn-outline-secondary">    <span className='fa-solid fa-expand' ></span>  </button>
                            </div>

                        </div>
                    </div>
                    <div onMouseDown={e => e.stopPropagation()}>
                        <ReeferMap getCommandPopupContentReport={this.setModelPopupHtmlReport}
                            isFenceAssets={this.state.isFenceAssets}
                            gridType={this.props.gridType}
                            eventsRefresh={this.props.eventsRefreshed}
                            allAssetStatusData={this.props.allAssetStatus}
                            propsReeferFormatterData={this.props.reeferFormatter}
                            renderAddGeofenceControl={this.renderAddGeofenceControl.bind(this)}
                            getCommandPopupReportReeferId={this.setModelPopupHtmlReportReeferId}
                            getCommandPopupPTReport={this.setModelPopupHtmlPTReport}
                            getCommandPopupTitleReport={this.setModelTitleReport}></ReeferMap>
                    </div>
                </div>
            </div>
        }
    }

    onAddItem() {

    }

    ReceiveSearchLoadingIsInProgressStatusToHome(SearchLoadingIsInProgress, CCPCodes: any) { //rcng-4141
        if (self.state.WGSwitchAll.MicroaAlarms) {
            var divReefersMAAlarmTitle = document.getElementById("ReefersMAAlarmTitle");
            if (CCPCodes != "" && CCPCodes != undefined && CCPCodes != null) {
                if (divReefersMAAlarmTitle != null) {
                    divReefersMAAlarmTitle.innerText = ("Reefers with Alarms - " + CCPCodes).length > 30 ? ("Reefers with Alarms - " + CCPCodes).substring(0, 26) + "..."
                        : ("Reefers with Alarms - " + CCPCodes);
                    divReefersMAAlarmTitle.title = ("Reefers with Alarms - " + CCPCodes);
                }
            }
            else {
                if (divReefersMAAlarmTitle != null) {
                    divReefersMAAlarmTitle.innerText = "Reefers with Alarms – Fleet";
                }
            }

            this.setState({ ...this.state, SearchLoadingIsInProgress: SearchLoadingIsInProgress });
        }
    }

    downloadPTReport() {
        if (window.navigator.msSaveOrOpenBlob) { // for IE and Edge
            var blob = new Blob([this.state.PTReport], {
                type: "text/plain;charset=utf-8"
            });
            window.navigator.msSaveBlob(blob, 'PT_' + this.state.ReportReeferId + '.htm');
        } else {
            var element = document.createElement('a');
            element.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(this.state.PTReport));
            element.setAttribute('download', 'PT_' + this.state.ReportReeferId + '.htm');
            element.style.display = 'none';
            document.body.appendChild(element);
            element.click();
            document.body.removeChild(element);
        }
    }

    closeToolBarEmailModel() {
        $('#dashBoardEmailPopUp').hide();
        $('#modal-backdrop-email').removeClass('show');
        
    }
    saveAndCloseSearchPreferenceModel() {

        var data = AdvanceSearch.RefreshSearchControls();

    }
    closeToolBarGridPreferenceModel() {
        ($("[data-bs-dismiss=modal]") as any).trigger({ type: "click" });
    }

    printPTReport() {
        var divToPrint = document.getElementById("printData");
        var newWin = window.open("");
        newWin.document.write(divToPrint.innerHTML);
        newWin.document.close();
        newWin.print();
        newWin.close();
    }

    downloadTWReport() {
        if (window.navigator.msSaveOrOpenBlob) { // for IE and Edge
            var blob = new Blob([this.state.TWReport], {
                type: "text/plain;charset=utf-8"
            });
            window.navigator.msSaveBlob(blob, 'TripWISEReport_' + this.state.ReportReeferId + '.htm');
        } else {
            var element = document.createElement('a');
            element.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(this.state.TWReport));
            element.setAttribute('download', 'TripWISEReport_' + this.state.ReportReeferId + '.htm');
            element.style.display = 'none';
            document.body.appendChild(element);
            element.click();
            document.body.removeChild(element);
        }
    }
    printTWReport() {
        var divToPrint = document.getElementById("printDataTW");
        var newWin = window.open("");
        newWin.document.write(divToPrint.innerHTML);
        newWin.document.close();
        newWin.print();
        newWin.close();
    }
    
    renderToogleCargoCareProfiles() {
        var cargoCareProfiles = this.state.CargoCareProfiles;
        if (cargoCareProfiles != undefined && cargoCareProfiles != null && cargoCareProfiles.length > 0) {
            //var cargoCareProfilesHtml = "";
            var renderCargoCareProfilesHtml: any[] = [];
            $.each(this.state.CargoCareProfiles, (index, item) => {
                var cargoCareProfilesHtml = <li className='dropdown-item d-flex' > 
                    <label>
                        <input id={"chk_" + item.CargoCareCustomerProfileCode} className="profile-checkbox" type="checkbox" name="chkProfile" value={item.CargoCareCustomerProfileCode}
                            onChange={this.OnChangeCargoCareFilter.bind(this, item.CargoCareCustomerProfileCode,true)} />
                        {item.CargoCareCustomerProfileCode} </label>
                     </li>
                renderCargoCareProfilesHtml.push(cargoCareProfilesHtml);
            });
            //<span className="ms-2"> {item.CargoCareCustomerProfileCode} </span> 
            return renderCargoCareProfilesHtml;
        }
                
    }
    
    
    renderToogleCargoCareCTProfiles() {
        var cargoCareProfiles = this.state.CargoCareProfiles;
        if (cargoCareProfiles != undefined && cargoCareProfiles != null && cargoCareProfiles.length > 0) {
            //var cargoCareProfilesHtml = "";
            var renderCargoCareCTProfilesHtml: any[] = [];
            $.each(this.state.CargoCareProfiles, (index, item) => {
                var cargoCareProfilesHtml = <li className='dropdown-item d-flex' > 
                    <label>
                        <input id={"chk_" + item.CargoCareCustomerProfileID} className="profile-checkbox" type="checkbox" name="chkCTProfile" value={item.CargoCareCustomerProfileID}
                            onChange={this.OnChangeCargoCareCTFilter.bind(this, item.CargoCareCustomerProfileID,true)} />
                        {item.CargoCareCustomerProfileCode} </label>
                     </li>
                renderCargoCareCTProfilesHtml.push(cargoCareProfilesHtml);
            });
            //<span className="ms-2"> {item.CargoCareCustomerProfileCode} </span> 
            return renderCargoCareCTProfilesHtml;
        }
                
    }
    selectAllProfiles() {
        isSaveLayout = true;
        let checkboxes = document.getElementsByName('chkProfile');
        let chkSelectAll = document.getElementById("chkSelectAllProfile");

        var CCPSelected: any[] = this.state.CargoCareProfilesSelected;
        CCPSelected = [];

        for (var i = 0, n = checkboxes.length; i < n; i++) {
            if (chkSelectAll.checked === true) {
                checkboxes[i].checked = true;
                CCPSelected.push(checkboxes[i].value);                
            }
            else if (chkSelectAll.checked === false) {
                checkboxes[i].checked = false;
            }
        }

        this.setState({ CargoCareProfilesSelected: CCPSelected });
    }

    selectAllCTProfiles() {
        isSaveLayout = true;
        let checkboxes = document.getElementsByName('chkCTProfile');
        let chkSelectAll = document.getElementById("chkSelectAllCTProfile");

        var CCPCTSelected: any[] = this.state.CargoCareCTProfilesSelected;
        CCPCTSelected = [];

        for (var i = 0, n = checkboxes.length; i < n; i++) {
            if (chkSelectAll.checked === true) {
                checkboxes[i].checked = true;
                CCPCTSelected.push(checkboxes[i].value);                
            }
            else if (chkSelectAll.checked === false) {
                checkboxes[i].checked = false;
            }
        }

        this.setState({ CargoCareCTProfilesSelected: CCPCTSelected });
    }

    OnChangeCargoCareFilter(ccProfileCode: any, isViaEvent: boolean, obj: any) {
        isSaveLayout = true;
        var cargoCareProfilesSelected: any[] = this.state.CargoCareProfilesSelected.length > 0 ? this.state.CargoCareProfilesSelected : this.state.CargoCareProfilesSelectedDefault;
        var profileCheck: any;
        let chkSelectAll = document.getElementById("chkSelectAllProfile");
        let checkboxes = document.getElementsByName('chkProfile');
        //console.log("OnChangeCargoCareFilter: "+isSaveLayout);
        var numberOfCheckboxes = $("input:checkbox[name=chkProfile]").length;
        var numberOfCheckboxesChecked = $("input:checkbox[name=chkProfile]:checked").length;

        if (isViaEvent === true)
            profileCheck = obj.currentTarget.checked;
        else
            profileCheck = obj.checked;

        $(obj).prop('checked', profileCheck);
        if (profileCheck) {
            if (this.state.CargoCareProfilesSelected.length == 0)
                cargoCareProfilesSelected = [];
            if (!cargoCareProfilesSelected.includes(ccProfileCode)) {
                cargoCareProfilesSelected.push(ccProfileCode);

            }
            if (numberOfCheckboxes == numberOfCheckboxesChecked)
                chkSelectAll.checked = true;

        }
        else {
            if (cargoCareProfilesSelected.length > 0) {
                var profileExists = cargoCareProfilesSelected.filter(x => x == ccProfileCode);
                if (profileExists == profileExists) {
                    cargoCareProfilesSelected.splice($.inArray(ccProfileCode, cargoCareProfilesSelected), 1);

                    if (numberOfCheckboxes == numberOfCheckboxesChecked)
                        chkSelectAll.checked = true;
                    else
                        chkSelectAll.checked = false
                }
            }
        }
        self.setState({ CargoCareProfilesSelected: cargoCareProfilesSelected });
    }

    OnChangeCargoCareCTFilter(ccProfileId: any, isViaEvent: boolean, obj: any) {
        isSaveLayout = true;
        var cargoCareCTProfilesSelected: any[] = this.state.CargoCareCTProfilesSelected.length > 0 ? this.state.CargoCareCTProfilesSelected : [];// To do
        var profileCheck: any;
        let chkSelectAll = document.getElementById("chkSelectAllCTProfile");
        let checkboxes = document.getElementsByName('chkCTProfile');
        //console.log("OnChangeCargoCareFilter: "+isSaveLayout);
        var numberOfCheckboxes = $("input:checkbox[name=chkCTProfile]").length;
        var numberOfCheckboxesChecked = $("input:checkbox[name=chkCTProfile]:checked").length;

        if (isViaEvent === true)
            profileCheck = obj.currentTarget.checked;
        else
            profileCheck = obj.checked;

        $(obj).prop('checked', profileCheck);
        if (profileCheck) {
            if (this.state.CargoCareCTProfilesSelected.length == 0)
                cargoCareCTProfilesSelected = [];
            if (!cargoCareCTProfilesSelected.includes(ccProfileId)) {
                cargoCareCTProfilesSelected.push(ccProfileId);

            }
            if (numberOfCheckboxes == numberOfCheckboxesChecked)
                chkSelectAll.checked = true;

        }
        else {
            if (cargoCareCTProfilesSelected.length > 0) {
                var profileExists = cargoCareCTProfilesSelected.filter(x => x == ccProfileId);
                if (profileExists == profileExists) {
                    cargoCareCTProfilesSelected.splice($.inArray(ccProfileId, cargoCareCTProfilesSelected), 1);

                    if (numberOfCheckboxes == numberOfCheckboxesChecked)
                        chkSelectAll.checked = true;
                    else
                        chkSelectAll.checked = false
                }
            }
        }
        self.setState({ CargoCareCTProfilesSelected: cargoCareCTProfilesSelected });
    }


    BindCargoCareProfileFilters(){        
        var ccProfilesData: any = self.state.DefaultCargoCareProfileAlertssummary.map(x => x.CargoCareCustomerProfileCode);
        let loopOnce = 0;
        forEach(ccProfilesData, function (value, key) {
            //$('#chk_'+ value).checked = true;
            if(self.state.CargoCareProfilesSelected.length == 0){
                /*var chkprofileId:any='chk_'+value;
                $("input[id='" + chkprofileId + "']").prop('checked', true);*/

                let numberOfCheckboxesChecked = $("input:checkbox[name=chkProfile]:checked").length;
                loopOnce++;

                if (numberOfCheckboxesChecked == 0 && loopOnce ==1) {

                    self.GetUserCCPProfileFiltersWhenAllUncheked();

                }
            }
            else   {
                var cargoCareProfile:any = self.state.CargoCareProfilesSelected.filter(x => x == value);
                if(cargoCareProfile.length>0){
                    var chkprofileId:any='chk_'+value;
                    $("input[id='"+chkprofileId+"']").prop('checked', true);
                }
                else
                    {
                        var chkprofileId:any='chk_'+value;
                        $("input[id='"+chkprofileId+"']").prop('checked', false);
                }
            }
        });

            let chkSelectAll = document.getElementById("chkSelectAllProfile");
            let checkboxes = document.getElementsByName('chkProfile');

            var numberOfCheckboxes = $("input:checkbox[name=chkProfile]").length;
            var numberOfCheckboxesChecked = $("input:checkbox[name=chkProfile]:checked").length;

            if (numberOfCheckboxes == numberOfCheckboxesChecked)
                chkSelectAll.checked = true;
            else
                chkSelectAll.checked = false

        self.setState({ CargoCareProfilesSelectedDefault: ccProfilesData });
    }

    OnSubmitCTFilters(isFromClose: boolean){
        isSaveLayout = true;
        var filterCCProfileAlertssummary:any[] =[];
        var selectedCTProfileId: any = self.state.CargoCareCTProfilesSelected;
        if (selectedCTProfileId.length == 0 && isFromClose==false) {
            //PopupWindow.showErrorMessage('Error', "Please select at least one profile.");//RCNG-61
            //return;
            selectedCTProfileId = "0";
        }
        $('#globalLoader').show();
        
        var url = Config.ApiBaseUrl + '/api/reeferstatus/ReeferStatusSummaryCT?CCPProfile=' + selectedCTProfileId;
        var request = RCUtils.FetchRequest(url, { method: 'GET', headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' } });

        fetch(request)
            .then(RCUtils.handleError)
            .then(response => response.json() as Promise<server.CTUnitSummaryModel>)
            .then(data => {
                $('#CTProfileFilter').css("display", "none");
                $('#globalLoader').hide();
                this.setState({ ColdTreatmentSummary: data, loading: false }, () => {
                    if (!this.state.CTStateEnabled && data.OnTrip > 0)
                        this.BindColdTreatmentChart();
                    this.UpdateCTCharts();
                    //$('#CTHeaderLoader').hide();
                });
                if (data.OnTrip == 0)
                    this.setState({ CTStateEnabled: false });
                else
                    this.setState({ CTStateEnabled: true });
            });
    }
    
    OnSubmitCargoCareFilters(isFromClose: boolean){
        isSaveLayout = true;
        var filterCCProfileAlertssummary:any[] =[];
        var selectedCargoCareProfiles: any = self.state.CargoCareProfilesSelected;
        if (selectedCargoCareProfiles.length == 0 && isFromClose==false) {
            PopupWindow.showErrorMessage('Error', "Please select at least one profile.");//RCNG-61           
            return;
        }
        $('#globalLoader').show();
          forEach(selectedCargoCareProfiles, function (value, key) {
               var selectedCCProfiles = self.state.DefaultCargoCareProfileAlertssummary.filter(x => x.CargoCareCustomerProfileCode == value);
                if(selectedCCProfiles.length>0){
                    filterCCProfileAlertssummary.push(selectedCCProfiles[0]);
                }
          });
          $('#CCProfileFilter').css("display", "none");
          this.setState({ CargoCareProfileAlertssummary: filterCCProfileAlertssummary }, () => {
                        this.SaveCargoCareProfileFilters();
                        this.UpdateCargoChart();
                        //this.UpdateCharts();
                        this.setState({ loading: false });
           });  
             
    }
    renderToogleSwitchHtml() {
      
        var toogleHtml = <div id="divToggle"  className='dropdown-menu dropdown-menu-end set-default-layout' >

            <div className='d-flex gap-2 px-2 pb-2'>
                <ul className="list-group">
                    <li className="list-group-item">General</li>
                    <li className={"list-group-item d-flex "}>
                        <div className="vstack gap-2">
                            <div className='widgetSettingsCircle black-color'> <i className="fas fa-search-plus"></i> </div>
                            <div className='widzetText'> Asset Search </div>
                        </div>
                        <Switch className={"disabled"} onClick={this.toggleSwitch.bind(this, 'wgAdvSearch')} on={this.state.WGSwitchAll.AdvancedSearch} />
                    </li>
                    <li className={"list-group-item d-flex "}>
                        <div className="vstack gap-2">
                            <div className='widgetSettingsCircle black-color'> <i className="fas fa-map-marked-alt"></i> </div>
                            <div className='widzetText'> Asset Map </div>
                        </div>
                        <Switch className={"disabled"} onClick={this.toggleSwitch.bind(this, 'wgReeferMap')} on={this.state.WGSwitchAll.ReeferMaps} />
                    </li>

                </ul>
                {hasChassis == true ?
                    <ul className="list-group">
                        <li className="list-group-item">Chassis</li>
                        <li className={"list-group-item d-flex " + UserRights.checkMenuItemVisibility('231')}>
                            <div className="vstack gap-2">
                                <div className='widgetSettingsCircle goldColor'>  <img src={Chassis} className='img-responsive chassis_svg' alt='ChassisSettings' /> </div>
                                <div className='widzetText'>Total Chassis</div>
                            </div>
                            <Switch className={this.state.IsReadOnly == true ? "disabled" : ""} onClick={this.toggleSwitch.bind(this, 'wgAllChassis')} on={this.state.WGSwitchAll.TotalChassis} />
                        </li>
                        <li className={"list-group-item d-flex " + UserRights.checkMenuItemVisibility('232')}>
                            <div className="vstack gap-2">
                                <div className='widgetSettingsCircle goldColor'> <i className="fas fa-th"></i> </div>
                                <div className='widzetText'>Chassis Grid</div>
                            </div>
                            <Switch className={this.state.IsReadOnly == true ? "disabled" : ""} onClick={this.toggleSwitch.bind(this, 'wgChassisGrid')} on={this.state.WGSwitchAll.ChassisGrid} />
                        </li>
                        <li className={"list-group-item d-flex " + UserRights.checkMenuItemVisibility('233')}>
                            <div className="vstack gap-2">
                                <div className='widgetSettingsCircle goldColor'> <i className="fas fa-history"></i> </div>
                                <div className='widzetText'>Chassis History</div>
                            </div>
                            <Switch className={this.state.IsReadOnly == true ? "disabled" : ""} onClick={this.toggleSwitch.bind(this, 'wgChassisHistory')} on={this.state.WGSwitchAll.ChassisHistoryGrid} />
                        </li>
                        <li className={"list-group-item d-flex " + UserRights.checkMenuItemVisibility('234')}>
                            <div className="vstack gap-2">
                                <div className='widgetSettingsCircle goldColor'> <i className="fas fa-chart-pie"></i> </div>
                                <div className='widzetText'>Chassis Fleet</div>
                            </div>
                            <Switch className={this.state.IsReadOnly == true ? "disabled" : ""} onClick={this.toggleSwitch.bind(this, 'wgChassisHistogram')} on={this.state.WGSwitchAll.ChassisHistogram} />
                        </li>
                    </ul>
                    : ""
                }
                {hasDrys == true ?
                    <ul className="list-group">
                        <li className="list-group-item">Dry</li>
                        <li className={"list-group-item d-flex " + UserRights.checkMenuItemVisibility('227')}>
                            <div className="vstack gap-2">
                                <div className='widgetSettingsCircle purple-color'>  <img src={DrySettings} className='img-responsive' alt='DrySettings' /> </div>
                                <div className='widzetText'> Total Drys </div>
                            </div>
                            <Switch className={this.state.IsReadOnly == true ? "disabled" : ""} onClick={this.toggleSwitch.bind(this, 'wgAllDrys')} on={this.state.WGSwitchAll.TotalDrys} />
                        </li>
                        <li className={"list-group-item d-flex " + UserRights.checkMenuItemVisibility('228')}>
                            <div className="vstack gap-2">
                                <div className='widgetSettingsCircle purple-color'> <i className="fas fa-th"></i> </div>
                                <div className='widzetText'>Dry Grid</div>
                            </div>
                            <Switch className={this.state.IsReadOnly == true ? "disabled" : ""} onClick={this.toggleSwitch.bind(this, 'wgDryGrid')} on={this.state.WGSwitchAll.DryGrid} />
                        </li>
                        <li className={"list-group-item d-flex " + UserRights.checkMenuItemVisibility('229')}>
                            <div className="vstack gap-2">
                                <div className='widgetSettingsCircle purple-color'> <i className="fas fa-history"></i> </div>
                                <div className='widzetText'> Dry History </div>
                            </div>
                            <Switch className={this.state.IsReadOnly == true ? "disabled" : ""} onClick={this.toggleSwitch.bind(this, 'wgDryHistory')} on={this.state.WGSwitchAll.DryHistoryGrid} />
                        </li>
                        <li className={"list-group-item d-flex " + UserRights.checkMenuItemVisibility('230')}>
                            <div className="vstack gap-2">
                                <div className='widgetSettingsCircle purple-color'> <i className="fas fa-chart-pie"></i> </div>
                                <div className='widzetText'>Dry Fleet</div>
                            </div>
                            <Switch className={this.state.IsReadOnly == true ? "disabled" : ""} onClick={this.toggleSwitch.bind(this, 'wgDryHistogram')} on={this.state.WGSwitchAll.DryHistogram} />
                        </li>
                    </ul>
                    : ""
                }
                {hasGensets == true ?
                    <ul className="list-group">
                        <li className="list-group-item">Genset</li>
                        <li className={"list-group-item d-flex " + UserRights.checkMenuItemVisibility('235')}>
                            <div className="vstack gap-2">
                                <div className='widgetSettingsCircle blue-color'> <img src={GensetSettings} className='img-responsive' alt='GensetSettings' /> </div>
                                <div className='widzetText'>Total Gensets</div>
                            </div>
                            <Switch className={this.state.IsReadOnly == true ? "disabled" : ""} onClick={this.toggleSwitch.bind(this, 'wgAllGensets')} on={this.state.WGSwitchAll.TotalGensets} />
                        </li>
                        <li className={"list-group-item d-flex " + UserRights.checkMenuItemVisibility('236')}>
                            <div className="vstack gap-2">
                                <div className='widgetSettingsCircle blue-color'> <i className="fas fa-th"></i> </div>
                                <div className='widzetText'> Genset Grid </div>
                            </div>
                            <Switch className={this.state.IsReadOnly == true ? "disabled" : ""} onClick={this.toggleSwitch.bind(this, 'wgGensetGrid')} on={this.state.WGSwitchAll.GensetGrid} />
                        </li>
                        <li className={"list-group-item d-flex " + UserRights.checkMenuItemVisibility('237')}>
                            <div className="vstack gap-2">
                                <div className='widgetSettingsCircle blue-color'> <i className="fas fa-history"></i> </div>
                                <div className='widzetText'> Genset History </div>
                            </div>
                            <Switch className={this.state.IsReadOnly == true ? "disabled" : ""} onClick={this.toggleSwitch.bind(this, 'wgGensetHistory')} on={this.state.WGSwitchAll.GensetHistoryGrid} />
                        </li>
                        <li className={"list-group-item d-flex " + UserRights.checkMenuItemVisibility('238')}>
                            <div className="vstack gap-2">
                                <div className='widgetSettingsCircle blue-color'> <i className="fas fa-chart-pie"></i> </div>
                                <div className='widzetText'> Genset Fleet </div>
                            </div>
                            <Switch className={this.state.IsReadOnly == true ? "disabled" : ""} onClick={this.toggleSwitch.bind(this, 'wgGensetHistogram')} on={this.state.WGSwitchAll.GensetHistogram} />
                        </li>
                    </ul>
                    : ""
                }
                {hasReefers == true ?
                    <ul className="list-group DynamicTotalReefersHeight">
                        <li className="list-group-item">Reefer</li>
                        <li className={"list-group-item d-flex " + UserRights.checkMenuItemVisibility('239')}>
                            <div className="vstack gap-2">
                                <div className='widgetSettingsCircle green-color'> <img src={ReeferSettings} className='img-responsive' alt='ReeferSettings' /> </div>
                                <div className='widzetText'> Total Reefers </div>
                            </div>
                            <Switch className={this.state.IsReadOnly == true ? "disabled" : ""} onClick={this.toggleSwitch.bind(this, 'wgAllreefers')} on={this.state.WGSwitchAll.TotalReefers} />
                        </li>
                        <li className={"list-group-item d-flex " + UserRights.checkMenuItemVisibility('271')}>
                            <div className="vstack gap-2">
                                <div className='widgetSettingsCircle green-color'><i class="fa-solid fa-temperature-snow"></i></div>
                                <div className='widzetText'> Cold Treatment </div>
                            </div>
                            <Switch className={this.state.IsReadOnly == true ? "disabled" : ""} onClick={this.toggleSwitch.bind(this, 'wgColdTreatment')} on={this.state.WGSwitchAll.ColdTreatment} />
                        </li>
                        <li className={"list-group-item d-flex " + UserRights.checkMenuItemVisibility('240')}>
                            <div className="vstack gap-2">
                                <div className='widgetSettingsCircle green-color'> <i className="fas fa-th"></i> </div>
                                <div className='widzetText'> Reefer Grid </div>
                            </div>
                            <Switch className={this.state.IsReadOnly == true ? "disabled" : ""} onClick={this.toggleSwitch.bind(this, 'wgReeferGrid')} on={this.state.WGSwitchAll.ReeferGrid} />
                        </li>
                        <li className={"list-group-item d-flex " + UserRights.checkMenuItemVisibility('241')}>
                            <div className="vstack gap-2">
                                <div className='widgetSettingsCircle green-color'> <i className="fas fa-history"></i> </div>
                                <div className='widzetText'> Reefer History </div>
                            </div>
                            <Switch className={this.state.IsReadOnly == true ? "disabled" : ""} onClick={this.toggleSwitch.bind(this, 'wgReeferHistory')} on={this.state.WGSwitchAll.ReeferHistoryGrid} />
                        </li>
                        <li className={"list-group-item d-flex " + UserRights.checkMenuItemVisibility('242')}>
                            <div className="vstack gap-2">
                                <div className='widgetSettingsCircle green-color'> <i className="fas fa-chart-pie"></i> </div>
                                <div className='widzetText'> Reefer Fleet </div>
                            </div>
                            <Switch className={this.state.IsReadOnly == true ? "disabled" : ""} onClick={this.toggleSwitch.bind(this, 'wgHistogram')} on={this.state.WGSwitchAll.Histogram} />
                        </li>
                        <li className={"list-group-item d-flex " + UserRights.checkMenuItemVisibility('243')}>
                            <div className="vstack gap-2">
                                <div className='widgetSettingsCircle green-color'> <i className="fas fa-analytics"></i> </div>
                                <div className='widzetText'> Reefer Graph </div>
                            </div>
                            <Switch className={this.state.IsReadOnly == true ? "disabled" : ""} onClick={this.toggleSwitch.bind(this, 'wgReeferTempGraph')} on={this.state.WGSwitchAll.ReeferTempGraph} />
                        </li>
                        <li className={"list-group-item d-flex " + UserRights.checkMenuItemVisibility('244')}>
                            <div className="vstack gap-2">
                                <div className='widgetSettingsCircle green-color'> <i className="fas fa-clipboard-check"></i> </div>
                                <div className='widzetText'> PTI Results </div>
                            </div>
                            <Switch className={this.state.IsReadOnly == true ? "disabled" : ""} onClick={this.toggleSwitch.bind(this, 'wgPTResult')} on={this.state.WGSwitchAll.PTResultGrid} />
                        </li>
                        <li className={"list-group-item d-flex " + UserRights.checkMenuItemVisibility('245')}>
                            <div className="vstack gap-2">
                                <div className='widgetSettingsCircle green-color'> <i className="fas fa-bell"></i> </div>
                                <div className='widzetText'> Reefer Alarms </div>
                            </div>
                            <Switch className={this.state.IsReadOnly == true ? "disabled" : ""} onClick={this.toggleSwitch.bind(this, 'wgMicroalarms')} on={this.state.WGSwitchAll.MicroaAlarms} />
                        </li>
                        <li className={"list-group-item d-flex " + UserRights.checkMenuItemVisibility('246')}>
                            <div className="vstack gap-2">
                                <div className='widgetSettingsCircle green-color'> <i className="fas fa-bell-plus"></i> </div>
                                <div className='widzetText'> CargoCare </div>
                            </div>
                            <Switch className={this.state.IsReadOnly == true ? "disabled" : ""} onClick={this.toggleSwitch.bind(this, 'wgCargoCare')} on={this.state.WGSwitchAll.CargoCare} />
                        </li>
                    </ul>
                    : ""
                }


            </div>

            <button type='button' id="btn_DefaultLayOut" className={this.state.IsReadOnly == true ? "btn btn-primary btn-dashboard float-end disabled" : "btn btn-primary btn-dashboard float-end"} onClick={this.LoadPreferencesToDefault.bind(this)}>Set Default Layout</button>
        </div>;

            return toogleHtml;
 
    }

    //SetDryWidgetState() {
        //if (this.state.Drysummary.OutGeofence >= 1000) {
        //    $('#DryOutsideGeofenceMain').addClass('disable-wizard-tablist');
        //}
        //else {
        //    $('#DryOutsideGeofenceMain').removeClass('disable-wizard-tablist');
        //}

        //if (this.state.Drysummary.InGeofence >= 1000) {
        //    $('#DryInsideGeofenceMain').addClass('disable-wizard-tablist');
        //}
        //else {
        //    $('#DryInsideGeofenceMain').removeClass('disable-wizard-tablist');
        //}
    //}
    
    ShowTogglePopup(){//RCNG-2322
        $("#tooglePopupSettings").show();
    }

    LayoutPreferenceChange(dashboardPreferenceId: any, dashboardPreferenceName: any) {
        isSaveLayout = true;
        //var Value: string = event.currentTarget.value;
        this.setState({
            LayoutPreference: dashboardPreferenceName
        });
        
        self.ReloadLayoutPreferences(dashboardPreferenceId);
    }

    ReloadLayoutPreferences(dashboardPreferenceId:any) {
        $("#btnSaveSearch").click();
        $('#globalLoader').show();        
        var dashboardLayouts: any = this.state.DashboardLayouts;
        if (dashboardLayouts != null && dashboardLayouts.length > 0)
        {
            //this.setState({ DashboardLayouts: data.DashboardLayouts });
            var LayoutPreferences: any = dashboardLayouts.filter(x => x.DashboardPreferenceId == dashboardPreferenceId);
            if (LayoutPreferences[0].PreferenceData != "" && LayoutPreferences[0].PreferenceData != null) {                         
                self.applyLayoutPreferences(LayoutPreferences[0].PreferenceData, LayoutPreferences[0].DashboardPreferenceId, LayoutPreferences[0].IsReadOnly, LayoutPreferences[0].RevisionNum);
            }
        }
        //var request = RCUtils.FetchRequest(Config.ApiBaseUrl + '/api/User/GetUserDashboardLayouts');
        //fetch(request)
        //    .then(RCUtils.handleError)
        //    .then(response => response.json() as Promise<any[]>)
        //    .then(data => {
        //        if(data.DashboardLayouts != null && data.DashboardLayouts.length > 0)
        //        {                    
        //            this.setState({ DashboardLayouts: data.DashboardLayouts });
        //            var LayoutPreferences: any = data.DashboardLayouts.filter(x => x.DashboardPreferenceId == dashboardPreferenceId);
        //            if (LayoutPreferences[0].PreferenceData != "" && LayoutPreferences[0].PreferenceData != null) {                         
        //                self.applyLayoutPreferences(LayoutPreferences[0].PreferenceData, LayoutPreferences[0].DashboardPreferenceId, LayoutPreferences[0].IsReadOnly, LayoutPreferences[0].RevisionNum);
        //            }
        //        }
        //        //this.setState({ DashboardWidgetsSearch: data.DashboardWidgetsSearch });
        // });
    }

    onDeleteConfirmation(dashboardPreferenceId: any, isCustomerDashboard: any, searchName: any) {
        //if(isCustomerDashboard != true) {
            var confirmationMessage = "";
        confirmationMessage = "Are you sure you want to delete <i>" + searchName + "</i> dashboard?";
            RCNGConfirmWindow.ConfirmWindow.showConfirmBox(confirmationMessage, this.DeleteUserLayoutConfirm.bind(this, dashboardPreferenceId), this.closeConfirmation.bind(this));
        //}
    }
    
    OnCheckDefaultConfirmation(dashboardPreferenceId: any, searchName: any) {        
        var confirmationMessage = "";
        confirmationMessage = "Are you sure you want to make <i>" + searchName + "</i> as default dashboard?";
        RCNGConfirmWindow.ConfirmWindow.showConfirmBox(confirmationMessage, this.CheckDefaultLayout.bind(this, dashboardPreferenceId), this.closeConfirmation.bind(this));
        
    }

    CheckDefaultLayout(dashboardPreferenceId: any) {
        $('#globalLoader').show();
        var url = Config.ApiBaseUrl + '/api/MyProfile/SaveMyDefaultLayout';
        var layoutData = { DashboardPreferenceId: dashboardPreferenceId, PreferenceType: 'DL'  };
        var request = RCUtils.FetchRequest(url, { method: 'POST', body: JSON.stringify(layoutData), headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' } });
           fetch(request)
            .then(RCUtils.handleError)
            .then(response => response.json())
            .then(data => {                
                sessionStorage.setItem('DashboardPreferenceId', dashboardPreferenceId);
                self.ReloadLayoutsData("Dashboard updated successfully.", dashboardPreferenceId, "");
            }).catch(err => {
                $('#globalLoader').hide();
                PopupWindow.showErrorMessage("Error", "Error Occurred. Please try again.")
            });
    }

    closeConfirmation() {
        RCNGConfirmWindow.ConfirmWindow.close();
    }

    DeleteUserLayoutConfirm(dashboardPreferenceId: any) {
        var layoutPreferences: any = this.state.DashboardLayouts;
        if(layoutPreferences.length == 1) {
             PopupWindow.showErrorMessage('Error', "Dashboard cannot be deleted. At least one Dashboard must exist.");           
                return;
        }
        $('#globalLoader').show();
        var url = Config.ApiBaseUrl + '/api/User/DeleteUserLayout';
        var preferencedata = { DashboardPreferenceId: dashboardPreferenceId, PreferenceData: '' };
        var request = RCUtils.FetchRequest(url, { method: 'POST', body: JSON.stringify(preferencedata), headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' } });
        fetch(request)
            .then(RCUtils.handleError)
            .then(response => response.json())
            .then(data => {
                self.ReloadLayoutsData("Dashboard deleted successfully.", 0, "");   
            });
    }

    onEditConfirmation(dashboardPreferenceId: any, isCustomerDashboard: any)
    {
        //if(isCustomerDashboard != true) {
            var layoutPreferences: any = this.state.DashboardLayouts.filter(x => x.DashboardPreferenceId == dashboardPreferenceId);
            NavMenu.setEditLayout(layoutPreferences, dashboardPreferenceId, "Edit");
        //}
    }

    onCreateNewDashboardLayout(param1: any, param2: any, param3: any) {
        NavMenu.setNewLayout("New");
    }
    
    onDragLayout(layout, allLayouts){
        isSaveLayout = false;
    }

    public render() {
        var layoutNamesList = this.state.DashboardLayouts;
        if (layoutNamesList != undefined && layoutNamesList != null && layoutNamesList.length > 0) {
            var layoutNamesListOptions = layoutNamesList.map(function (userLayout) {
                var searchName = userLayout.PreferenceName;
                return (
                    <li className={userLayout.IsDefault == true ? "dropdown-item layout-edit-delete layout-highlight": "dropdown-item layout-edit-delete"} >
                        <table className='w-100 dashboard-table'>
                            <tbody>
                                <tr>                                   
                                    <td className='one'><div className='layout-name' onClick={self.LayoutPreferenceChange.bind(self, userLayout.DashboardPreferenceId, userLayout.PreferenceName)}> <i className={userLayout.IsCustomerDashboard == true ? "fa-solid fa-users" : "fa-solid fa-user user-icon"}></i> <a href="javascript:void(0);" data-value={userLayout.PreferenceName} title={searchName} >{searchName}</a> </div></td>
                                    <td className='two'>
                                      {/*  <input className="form-check-input" type="radio" name="flexRadioDefault" id="flexRadioDefault1" checked={userLayout.IsDefault} onClick={self.OnCheckDefaultLayout.bind(self, userLayout.DashboardPreferenceId)} />*/}
                                        <span className="fa-solid fa-circle-check" onClick={self.OnCheckDefaultConfirmation.bind(self, userLayout.DashboardPreferenceId, searchName)}></span>
                                    </td>
                                    <td className='three'>
                                        <div className={userLayout.IsCustomerDashboard == true ? '' + UserRights.checkVisibility('263') : ''}><span className='fa-solid fa-pencil' onClick={self.onEditConfirmation.bind(self, userLayout.DashboardPreferenceId, userLayout.IsCustomerDashboard)} title='edit'> </span> </div>
                                    </td>
                                    <td className='four'><div className={userLayout.IsCustomerDashboard == true ? '' + UserRights.checkVisibility('264') : ''}><span className='fa-solid fa-trash-xmark' onClick={self.onDeleteConfirmation.bind(self, userLayout.DashboardPreferenceId, userLayout.IsCustomerDashboard, searchName)} title='delete'> </span> </div></td>
                                </tr>
                            </tbody>
                        </table>
                    </li>                    
                );
            });
        }
        let newLayout = JSON.parse(JSON.stringify(this.state.layouts));
        var toogleSwitchHtml = this.renderToogleSwitchHtml();
        //newLayout.x += 2;
        let Vcontents = this.state.loading
            ? <p><em>Loading...</em></p>
            : <p><em>Loaded</em></p>
        return <div id='homepage-grid-container'>
            <li className='nav-item' id='menuwg'>
                <a className="nav-link btn dropdown-toggle" id="lnktoggle" href="#" role="button" data-bs-toggle="dropdown" aria-expanded="false" data-bs-auto-close="false">
                    <span className='fa-sharp fa-solid fa-gear-complex' id="Spgear"></span>
                </a>
                {toogleSwitchHtml}
            </li>

            <div className="d-flex me-2" id="menuLayout">
                <div className="dropdown flex-grow-1 saved-searches me-2">
                    <button className="btn-outline-secondary dropdown-toggle btn-sm rounded-top" id="btnSaveSearch" type="button" data-bs-toggle="dropdown" data-bs-auto-close="outside" aria-expanded="false">
                    {this.state.LayoutPreference}
                </button>
                <ul className="dropdown-menu py-2" id='create-dashboard-new'>
                    <li className='dropdown-item text-center'><a href="javascript:void(0);" data-value={"New"} onClick={this.onCreateNewDashboardLayout.bind(self, "New", 0)}>{"<< Create New Dashboard >>"}</a></li>
                    {layoutNamesListOptions}
                </ul>      
                </div>

                <div className=''>
                    <i className="fa fa-info-circle information-circle" aria-hidden="true" data-tip='' data-for='tooltipDashboard'>
                    </i>
                    <ReactTooltip id='tooltipDashboard' place="bottom">

                        <div className=''>
                            <ul className='ps-3 layout-info py-2 mb-0'>
                                <li>A Dashboard is a customized view of the Maritime platform Home page.</li>
                                <li className=''>A Dashboard includes a widget layout, grid column preferences, CargoCare Alerts widget filters, and a default search (if any).</li>

                                <li className='mt-2'>To create a new Dashboard, select the existing Dashboard that most closely meets your new Dashboard’s layout, and then from the Dashboard list, select Create New Dashboard . In the dialog box,
                                    enter a Dashboard name and choose whether it will be a Company or User Dashboard (you can also choose to make the Dashboard read-only),
                                    and then click Save. The new Dashboard will be created by copying the selected Dashboard.</li>

                                <li className='mt-2'>To start with the same Dashboard each time you sign in, from the Dashboard list, click icon (<span className='fa-regular fa-circle-check mx-1'></span>).</li>

                                <li className=''> To change a Dashboard name and/or mark a Dashboard as read-only, from the Dashboard list, click icon (<span className='fa-solid fa-pencil mx-1'></span>).</li>

                                <li className='mt-2'>To delete a Dashboard, from the Dashboard list, click icon (<span className='fa-solid fa-trash-xmark mx-1'></span>). </li>

                                <li className='mt-2'>Unless the active Dashboard is read-only, changes to the widget layout, grid preferences, and CargoCare Alerts filters are saved immediately to the active Dashboard.</li>

                            </ul>

                        </div>

                    </ReactTooltip>

                </div>
            </div>

            <ResponsiveReactGridLayout className="layout"
                //{...this.props}
                layouts={newLayout}
                breakpoints={{ lg: 1200, md: 996, sm: 768, xs: 480, xxs: 0 }}
                cols={{ lg: 50, md: 10, sm: 6, xs: 4, xxs: 2 }}
                rowHeight={20}
                onResizeStop={this.onResizeStop.bind(this)}
                onDrag={this.onDragLayout.bind(this)}
                onLayoutChange={this.onLayoutChange.bind(this)} onBreakpointChange={this.onBreakpointChange}>
                {map(this.state.DashBoardItems, (el) => this.createElement(el))}
            </ResponsiveReactGridLayout>
            <div className="modal fade" id="contextMenuModel" role="dialog">
                <div className="modal-dialog modal-lg">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">{this.state.modelTitle}</h5>
                            <button type="button" className="btn-close" data-bs-dismiss="modal">&times;</button>

                        </div>
                        <div className="modal-body">
                            {this.state.popUpHtml}
                        </div>
                    </div>
                </div>
            </div>
            <div className="modal fade" id="contextMenuModelReport" role="dialog">
                <div className="modal-dialog modal-lg">
                    <div className="modal-content">
                        <div className="modal-header" id="contextMenuModelHeader">
                            <h5 className="modal-title">{this.state.modelTitleReport}</h5>
                            <button type="button" className="btn-close" data-bs-dismiss="modal">&times;</button>
                        </div>
                        <div className="modal-body ptr-report">
                            <div className='aggrid-icons-bg'>
                                <div className="btn-group aggrid-icons">
                                    <button type="button" id="hidePopUpBtn" title='Download' className="btn btn-outline-secondary" onClick={this.downloadPTReport.bind(this)}><span className='fa fa-download'></span></button>
                                    <button type="button" id="hidePopUpBtn" title='Print' className="btn btn-outline-secondary" onClick={this.printPTReport.bind(this)}><span className='fa fa-print'></span></button>
                                </div>
                            </div>
                            {this.state.popUpHtmlReport}
                        </div>
                    </div>
                </div>
            </div>
            <button id="btnTriggerReport" data-bs-toggle="modal" className='hidden' data-bs-target="#contextMenuModelReport" />
            <div className='hidden ptr-report' id="printData"><div dangerouslySetInnerHTML={{ __html: this.state.PTReport }} />
            </div>

            <div className="modal fade" id="contextMenuModelReportTW" role="dialog">
                <div className="modal-dialog modal-lg">
                    <div className="modal-content">
                        <div className="modal-header" id="contextMenuModelHeader">
                            <h5 className="modal-title">{this.state.modelTitleReport}</h5>
                            <button type="button" className="btn-close" data-bs-dismiss="modal">&times;</button>

                        </div>
                        <div className="modal-body ptr-report ptr-report-table">
                            <div className='aggrid-icons-bg'>
                                <div className="btn-group aggrid-icons">
                                    <button type="button" id="hidePopUpBtn" title='Download' className="btn btn-outline-secondary" onClick={this.downloadTWReport.bind(this)}><span className='fa fa-download'></span></button>
                                    <button type="button" id="hidePopUpBtn" title='Print' className="btn btn-outline-secondary" onClick={this.printTWReport.bind(this)}><span className='fa fa-print'></span></button>
                                </div>
                            </div>
                            {this.state.popUpHtmlReport}
                        </div>
                    </div>
                </div>
            </div>
            <button id="btnTriggerReportTW" data-bs-toggle="modal" className='hidden' data-bs-target="#contextMenuModelReportTW" />
            <div className='hidden ptr-report' id="printDataTW"><div dangerouslySetInnerHTML={{ __html: this.state.TWReport }} />
            </div>
            <div className='modal-backdrop opacity-50 hide' id='modal-backdrop-email'></div>
            <div className="modal" role="dialog" id="dashBoardEmailPopUp">
                <div className="modal-dialog modal-lg" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">Email</h5>
                            <button type="button" className="btn-close" aria-label="Close" onClick={this.closeToolBarEmailModel.bind(this)}><span aria-hidden="true">&times;</span></button>

                        </div>
                        <div className="modal-body">
                            <EmailControlExcelPreference reeferStatusResult={self.state.EmailData} columnDefinition={self.state.ColumnDefs}
                                colDefs2={self.state.ColumnDefs2} parentchild={self.state.ParentOrChild}
                                formName={self.state.SourceForm} FunctionID={this.state.FunctionID} dashboardPreferenceId = {this.state.DashboardPreferenceId}
                                widgetId={this.state.WidgetId} dashboardWidgetsSearch={this.state.DashboardWidgetsSearch} gridApiParams={this.state.gridApiParams}
                                isIncludeRowGroup={this.state.isIncludeRowGroup} sensorData={this.state.assetTypeSensors} />

                        </div>
                    </div>
                </div>
            </div>
            <button id="btnTriggerGridPreference" data-bs-toggle="modal" className='hidden' data-bs-target="#dashBoardGridPreferencePopUp">GridPreference</button>
            <div className={"DragandDropControlUI modal fade"} role="dialog" id="dashBoardGridPreferencePopUp">
                <div className="modal-dialog modal-lg" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">Grid Preference</h5>
                            <button type="button" className="btn-close" data-bs-dismiss="modal">&times;</button>

                        </div>
                        <div className="modal-body">
                            {this.state.gridPreferenceHtml}
                        </div>
                    </div>
                </div>
            </div>
            <button id="btnTriggerExportToExcel" data-bs-toggle="modal" className='hidden' data-bs-target="#dashBoardExportToExcelPopUp">ExportToExcel</button>
            <div className="modal fade" role="dialog" id="dashBoardExportToExcelPopUp">
                <div className="modal-dialog modal-lg" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">Export To Excel</h5>
                            <button type="button" className="btn-close" data-bs-dismiss="modal">&times;</button>

                        </div>
                        <div className="modal-body">
                            {this.state.ExportToExcelHTML}
                        </div>
                    </div>
                </div>
            </div>
            <button id="btnTriggerSearchPreference" data-bs-toggle="modal" className='hidden' data-bs-target="#dashBoardSearchPreferencePopUp">SearchPreference</button>
            <div className="modal DragandDropControlUI fade" role="dialog" id="dashBoardSearchPreferencePopUp">
                <div className="modal-dialog modal-lg" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">Choose and Order Search Fields</h5>
                            <button type="button" className="btn-close" data-bs-dismiss="modal">&times;</button>

                        </div>
                        <div className="modal-body">
                            {this.state.searchPreferenceHtml}
                        </div>
                    </div>
                </div>
            </div>
            <button id="btnTriggerGensetGraph" data-bs-toggle="modal" className='hidden' data-bs-target="#gensetMonitorGraphModel">ShowGraph</button>
            <div className="modal fade" id="gensetMonitorGraphModel" role="dialog">
                <div className="modal-dialog modal-lg TempGraph">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">Genset Monitoring Data - {this.state.graphGensetId}</h5>
                            <button type="button" className="btn-close" data-bs-dismiss="modal">&times;</button>
                        </div>
                        <div className="modal-body">
                            {this.state.gensetMonitorGraphHtml}
                        </div>
                    </div>
                </div>
            </div>
            <button id="btnTriggerGraph" data-bs-toggle="modal" className='hidden' data-bs-target="#temperatureGraphModel">ShowGraph</button>
            <div className="modal fade" id="temperatureGraphModel" role="dialog">
                <div className="modal-dialog modal-lg TempGraph">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">Reefer Monitoring Data - {this.state.graphReeferId}</h5>
                            <button type="button" className="btn-close" data-bs-dismiss="modal">&times;</button>

                        </div>
                        <div className="modal-body">
                            {this.state.temperatureGraphHtml}
                        </div>
                    </div>
                </div>
            </div>
            <button id="btnTriggerAddGeofence" data-bs-toggle="modal" className='hidden' data-bs-target="#dashBoardMapAddGeofencePopUp">GridPreference</button>
            <div className="modal fade" role="dialog" id="dashBoardMapAddGeofencePopUp">
                <div className="modal-dialog modal-lg" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">{this.state.addGeofenceTitle}</h5>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" onClick={this.fnCancelDrawing.bind(this)}>&times;</button>

                        </div>
                        <div className="modal-body">
                            {this.state.addGeofenceHtml}
                        </div>
                    </div>
                </div>
            </div>
            <button id="btnTriggerSaveSearch" data-bs-toggle="modal" data-bs-target="#SaveSearchPopUpId" className='hidden'>SaveSearch</button>
            <div className="modal fade" role="dialog" id="SaveSearchPopUpId" aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div className="modal-dialog modal-lg" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h1 className="modal-title fs-5">Saved Searches</h1>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <div className="modal-body">
                            {this.state.SaveSearchHtml}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    }
}

class WGSwitch {
    AdvancedSearch: boolean = false;
    AdvancedGensetSearch: boolean = false;
    TotalReefers: boolean = false;
    ColdTreatment: boolean = false;
    TotalGensets: boolean = false;
    ReeferMaps: boolean = false;
    ReeferGrid: boolean = false;
    GensetGrid: boolean = false;
    ReeferHistoryGrid: boolean = false;
    ReeferTempGraph: boolean = false;
    GensetHistoryGrid: boolean = false;
    PTResultGrid: boolean = false;
    MicroaAlarms: boolean = false;
    CargoCare: boolean = false;
    Histogram: boolean = false;
    GensetHistogram: boolean = false;
    TotalDrys: boolean = false;
    DryGrid: boolean = false;
    DryHistoryGrid: boolean = false;
    DryHistogram: boolean = false;
    TotalChassis: boolean = false;
    ChassisGrid: boolean = false;
    ChassisHistoryGrid: boolean = false;
    ChassisHistogram: boolean = false;
}

class DashBoardItem {
    Key: any;
    Layout: any;
    Enabled: boolean = false;
    IsVisible: boolean = true;
    IsFullscreen: boolean = false;
    IsPinned?: boolean;
}

interface ReeferMasterStatus {
    UnitRCDAssociationHistoryID: number,
    LastParentEventID: number,
    ParentEventID: number,
    UnitMasterID: number,
    UnitPrefix: string,
    UnitNumber: string,
    ReeferID: string,
    UnitEventID: number,
    AlarmsList: string,
    CCAlarms: string,
    CCSeverityLevel: string,
    MicroAlarms: string,
    MASeverityLevel: string,
    UnitUSDAHistoryID: number,
    USDA1Temp: number,
    USDA2Temp: number,
    USDA3Temp: number,
    Cargo4Temp: number,
    O2Setpoint: number,
    CO2Setpoint: number,
    RunningMode: string,
    URH_UnitReadingsHistoryID: number,
    Humidity: number,
    UnitTypeCd: string,
    AmbientTemp: number,
    CompressorSuctionTemp: number,
    CompressorDischargeTemp: number,
    ReturnTemp1: number,
    SupplyTemp1: number,
    SupplyTemp2: number,
    ReturnTemp2: number,
    EvaporatorTemp: number,
    NumberOfAlarmsInQue: number,
    DischargePressure: number,
    CompositeSuctionPressure: number,
    VentPositionSensorCMH: number,
    PretripTestStateID: any,
    SetPoint: number,
    O2Reading: number,
    CO2Reading: number,
    TotalCurrentDraw: number,
    LowSpeedEvaporatorFanOutPut: string,
    HighSpeedEvaporatorFanOutPut: string,
    CondenserFanOutPut: string,
    HumiditySetpoint: number,
    SoftwareRevision: string,
    ControllerSerialNumber: string,
    CompressorFrequency: number,
    CondenserTemperature: number,
    CondenserPressure: number,
    HeaterOnTime: number,
    EvaporatorExpansionValveOpening: number,
    LineFrequency: number,
    DataLoggerDtm: string,
    TimeToDefrost: number,
    CurrentPhaseA: number,
    CurrentPhaseB: number,
    CurrentPhaseC: number,
    ThreePhaseCurrent: string,
    ReturnTempLongAvg: number,
    AmbientTempLongAvg: number,
    CompositeSuctionPressureLongAvg: number,
    DischargePressureLongAvg: number,
    SupplyTemperatureLongAvg: number,
    ReturnTemperatureLongAvg: number,
    CompressorSuctionTempLongAvg: number,
    CompressorCondensorTempLongAvg: number,
    RCDEventID: number,
    R_EventMasterID: number,
    R_ParentEventID: number,
    RCDMasterID: number,
    RCDMasterHistoryID: number,
    RCDGSMPositionHistoryID: number,
    RCDLocationHistoryID: number,
    RCDGPSPositionHistoryID: number,
    RCDStateReportedHistoryID: number,
    RCDAlarmSummaryHistoryID: number,
    R_EventDTTM: string,
    RunState: number,
    R_RCDStateReportedHistoryID: number,
    IsAcceptableACVoltage: boolean,
    IsAcceptableBatteryVoltage: boolean,
    BatteryVoltage: number,
    RCDPowerSourceCd: string,
    ReeferACPowerLevel: number,
    ReeferOEMTypeCd: string,
    LineVoltage1: number,
    LineVoltage2: number,
    LineVoltage3: number,
    DeviceTemp: number,
    LastUnitEventID: number,
    EventMasterID: number,
    EventDTTM: any,
    ModifiedDTTM: any,
    U_UnitAlarmSummaryHistoryID: number,
    UnitControlEventID: number,
    C_EventDTTM: any,
    C_EventMasterID: number,
    C_ParentEventID: number,
    UnitVesselOperationsID: any,
    UnitCargoCareID: any,
    C_UnitAlarmSummaryHistoryID: any,
    Status: any,
    IsOnVessel: any,
    IsCargoCare: any,
    C_ModifiedDTTM: any,
    GeofenceName: string,
    RCDID: string,
    RCDFirmwareVersion: string,
    RCDBootloaderVersion: string,
    RCDMeshFirmwareVersion: string,
    RevisionNum: number,
    GPSLatitude: number,
    GPSLongitude: number,
    GPSLastLock: number,
    GPSCoords: string
    GPSLockState: string,
    IsInsideGeofence: boolean,
    Geofence: string,
    ActiveCommands: boolean,
    PendingCommands: boolean,
    ErrorCommands: boolean,
    CustomerAccessGroupIDList: string,
    TowerBaseStationID: number,
    TowerLocalizationAreaCode: number,
    MNC: number,
    SuctionModulationValveOpening: number,
    HotGasValveOpening: number,
    EconomizerValveOpening: number,
    RSSI: number,
    MSISDN: string,
    SIM_IMSI: string,
    ICCID: string,
    CompressorEvaporatorTempLongAvg: number,
    CompressorDischargeTempLongAvg: number,
    CountryCd: string,
    CountryName: string,
    UnitEventDTTM: any,
    PowerProfileCd: string,
    NotReportingFlag: number,
    PowerStateIsActive: boolean,
    PtiRunning: boolean,
    ControllerSerialNumberChgFlag: boolean,
    IsActiveAssociation: boolean,
    IsReeferCommunicationEstablished: boolean,
    UnitSettingsHistoryID: number,
    RCDReportingInterval: number,
    ReeferConfigTypeCd: string,
    Street: string,
    City: string,
    State: string,
    Zip: string,
    CustomerID: number,
    CustomerName: string,
    RCDRfrComErr: boolean,
    VesselID: string,
    VoyageID: string,
    PortOfDestination: string,
    PortOfDeparture: string,
    TripId: number,
    TripStatusCd: string,
    TripStatusCdAndDFlag: string,
    DeviationFlg: boolean,
    TripDefStatusDsc: string,
    TripNameAndStatus: string,
    TripRouteWaypointId: number,
    BookedTemperature: number,
    BookingNumber: string,
    TemperatureUnit: string,
    CommentExists: number
}
class EmailFields {
    SelectedTo: string;
    SelectedFrom: string;
    SelectedSubject: string;
    SelectedAttachment: string;
    SelectedMessage: string;
}


enum ReeferStatusEnum {
    AllReefer = 0,
    Running = 1,
    Stopped = 2,
    MissedRunning = 3,
    MissedStopped = 4,
    AllMicroAlaram = 5,
    MASevere = 6,
    MAMinor = 7,
    AllCargoCare = 8,
    CCSevere = 9,
    CCMinor = 10,
    CCInformational = 11,
    PowerOnReporting = 12,
    PowerOnNotReporting = 13,
    PowerOffReporting = 14,
    PowerOffNotReporting = 15,
    DryInGeofence = 16,
    DryOutGeofence = 17,
    ChassisPwrInGeofence = 18,
    ChassisPwrOutGeofence = 19,
    ChassisNotPwrInGeofence = 20,
    ChassisNotPwrOutGeofence = 21,
    OnTrip=22,
    NotStarted=23,
    Started=24,
    Restarted=25,
    Failed=26,
    Successful=27,
    PowerOff=28
}

export default connect(
    (state: ApplicationState) => ({ ...state.userDetails, ...state.home }), // Selects which state properties are merged into the component's props
    HomeStore.actionCreators                 // Selects which action creators are merged into the component's props
)(Home as any)